/* eslint-disable */
import type { DocumentTypeDecoration } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = T | null | undefined;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T,
> = { [_ in K]?: never };
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never;
    };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  /** A calendar day, as yyyy-MM-dd. */
  Date: { input: string; output: string };
  Instant: { input: string; output: string };
  JSON: { input: Record<string, unknown>; output: Record<string, unknown> };
  Long: { input: number; output: number };
};

export type AddBuyListToCartResult = {
  __typename?: 'AddBuyListToCartResult';
  /** Null when every item was skipped. */
  cart?: Maybe<Cart>;
  skippedItems: Array<SkippedOrderItem>;
};

export const AddOnBillingUnit = {
  BaseUom: 'BASE_UOM',
  Bl: 'BL',
  BlStdContainer: 'BL_STD_CONTAINER',
  Container: 'CONTAINER',
  ContainerEquiv: 'CONTAINER_EQUIV',
  FlatrackContainer: 'FLATRACK_CONTAINER',
  PercentMaterialValue: 'PERCENT_MATERIAL_VALUE',
  Truckload: 'TRUCKLOAD',
} as const;

export type AddOnBillingUnit =
  (typeof AddOnBillingUnit)[keyof typeof AddOnBillingUnit];
export type AddTradingPartnersToProductComparisonResult = {
  __typename?: 'AddTradingPartnersToProductComparisonResult';
  /** Sellers that were not in the comparison before; the other configurations were already in it. */
  addedOrganizationIds: Array<Scalars['ID']['output']>;
  configurations: Array<SellerProductConfiguration>;
};

export type AddTradingPartnersToProductInput = {
  organizationIds: Array<Scalars['ID']['input']>;
  platformProductId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * Lengths to add each seller against, one configuration per seller per length. Every id must
   * exist and belong to platformProductId. Null or empty adds against the product's first length
   * only, which is enough to make the seller visible in the unfiltered comparison.
   */
  platformProductLengthIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type AdditionalItem = {
  __typename?: 'AdditionalItem';
  id: Scalars['ID']['output'];
  platformProductsLength: PlatformProductLength;
  quantity: Quantity;
  sellerProductConfiguration: SellerProductConfiguration;
  stockHealth?: Maybe<InventoryStockHealth>;
  unitPrice: UnitPrice;
  weeksCovered?: Maybe<Scalars['Float']['output']>;
};

export type AdditionalItemQuantityArgs = {
  mode?: InputMaybe<QuantityModeInput>;
};

export type Address = {
  __typename?: 'Address';
  addressLine1: Scalars['String']['output'];
  addressLine2?: Maybe<Scalars['String']['output']>;
  city: Scalars['String']['output'];
  country: Scalars['String']['output'];
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type AddressSuggestion = {
  __typename?: 'AddressSuggestion';
  placeId: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

export type AdminJobOutboxEntry = {
  __typename?: 'AdminJobOutboxEntry';
  attempts: Scalars['Int']['output'];
  failedAt?: Maybe<Scalars['Instant']['output']>;
  id: Scalars['ID']['output'];
  lastError?: Maybe<Scalars['String']['output']>;
  payload: Scalars['String']['output'];
  payloadType: Scalars['String']['output'];
};

export type AdminPlatformProduct = {
  __typename?: 'AdminPlatformProduct';
  code?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lengths: Array<AdminPlatformProductLength>;
  name: Scalars['String']['output'];
  /** The product's stored bundle size. Null when none is set. */
  piecesPerBundle?: Maybe<Scalars['Int']['output']>;
  standardUnitsCode: UnitCode;
  /** Platform-wide truck volumes, sorted by vehicle name. */
  vehicleCapacities: Array<AdminVehicleCapacity>;
};

export type AdminPlatformProductLength = {
  __typename?: 'AdminPlatformProductLength';
  id: Scalars['ID']['output'];
  inventoryOnly: Scalars['Boolean']['output'];
  isNominal: Scalars['Boolean']['output'];
  lengthDisplayValue: Scalars['String']['output'];
};

export type AdminVehicleCapacity = {
  __typename?: 'AdminVehicleCapacity';
  /** How much of the product one load of this vehicle holds, in the product's standard unit. */
  capacity: Quantity;
  transportVehicle: TransportVehicle;
};

export type BuyList = {
  __typename?: 'BuyList';
  /** ISO-8601 calendar date, YYYY-MM-DD. */
  expectedShipDate: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  initiatingUser: User;
  /** How many product lengths are on the list. Counted in the database, so listings can show it without selecting items. */
  itemCount: Scalars['Int']['output'];
  items: Array<BuyListItem>;
  location: Location;
  /** Free-text note the buyer entered when creating the list. Null when the buyer left it blank. */
  note?: Maybe<Scalars['String']['output']>;
  status: BuyListStatus;
  tallies: Array<BuyListTally>;
  /** How many tallies are on the list. Counted in the database. */
  tallyCount: Scalars['Int']['output'];
  transportVehicle: TransportVehicle;
};

export type BuyListFilterInput = {
  buyerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  match?: InputMaybe<BuyListMatchInput>;
};

export type BuyListItem = {
  __typename?: 'BuyListItem';
  /** Draft buyer carts in the buy list's organization that hold this product length and ship to the buy list's location, one entry per buyer. Empty unless the viewer belongs to that organization. */
  carts: Array<BuyListItemCart>;
  /**
   * Bundle size this item is bought in: the buyer's override when set, else the product default.
   * Zero when neither is configured.
   */
  effectivePiecesPerBundle: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  /** The buyer's bundle size for this item, or null when the product default applies. */
  piecesPerBundleOverride?: Maybe<Scalars['Int']['output']>;
  platformProductsLength: PlatformProductLength;
  /** Defaults to the buyer's preferred unit for the product's category. */
  quantity: Quantity;
};

export type BuyListItemQuantityArgs = {
  mode?: InputMaybe<QuantityModeInput>;
};

export type BuyListItemCart = {
  __typename?: 'BuyListItemCart';
  buyer: User;
  /** Summed across the buyer's matching draft carts. Defaults to the viewer's preferred unit for the product's category. */
  quantity: Quantity;
};

export type BuyListItemCartQuantityArgs = {
  mode?: InputMaybe<QuantityModeInput>;
};

/** One chosen buy list item, and how much of it to request or add to a cart. */
export type BuyListItemSelectionInput = {
  buyListItemId: Scalars['ID']['input'];
  /** Defaults to the buy list quantity in the UI, but any positive quantity is allowed. */
  quantity: QuantityInput;
};

export type BuyListMatchInput = {
  and?: InputMaybe<Array<BuyListMatchInput>>;
  locationId?: InputMaybe<IdOperatorInput>;
  not?: InputMaybe<BuyListMatchInput>;
  or?: InputMaybe<Array<BuyListMatchInput>>;
  platformProductIds?: InputMaybe<IdCollectionOperatorInput>;
  status?: InputMaybe<BuyListStatusOperatorInput>;
  transportVehicleId?: InputMaybe<IdOperatorInput>;
};

export const BuyListStatus = {
  Closed: 'CLOSED',
  Fulfilled: 'FULFILLED',
  Open: 'OPEN',
} as const;

export type BuyListStatus = (typeof BuyListStatus)[keyof typeof BuyListStatus];
export type BuyListStatusOperatorInput = {
  in?: InputMaybe<Array<BuyListStatus>>;
  notIn?: InputMaybe<Array<BuyListStatus>>;
};

export type BuyListTally = {
  bundles: Array<BuyListTallyBundle>;
  id: Scalars['ID']['output'];
  platformProduct: PlatformProduct;
  quantity: Quantity;
};

export type BuyListTallyQuantityArgs = {
  mode?: InputMaybe<QuantityModeInput>;
};

export type BuyListTallyBundle = {
  __typename?: 'BuyListTallyBundle';
  bundleCount: Scalars['Int']['output'];
  platformProductsLength: PlatformProductLength;
  quantity: Quantity;
};

export type BuyListTallyBundleQuantityArgs = {
  mode?: InputMaybe<QuantityModeInput>;
};

export const BuyListTallyKind = {
  Canned: 'CANNED',
  Random: 'RANDOM',
} as const;

export type BuyListTallyKind =
  (typeof BuyListTallyKind)[keyof typeof BuyListTallyKind];
/** One tally on a buy list to add to a cart or to send in a request for quote. */
export type BuyListTallySelectionInput = {
  buyListTallyId: Scalars['ID']['input'];
  /** Canned tallies only. Null uses the buy list's tally count. Rejected for a random tally. */
  tallyCount?: InputMaybe<Scalars['Int']['input']>;
};

/** A colleague the buy list team picker can offer: a buyer in the caller's organization who has not been deactivated. */
export type BuyListTeamCandidate = {
  __typename?: 'BuyListTeamCandidate';
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastName: Scalars['String']['output'];
  status: UserStatus;
};

export type BuyerInventoryConfiguration = {
  __typename?: 'BuyerInventoryConfiguration';
  id: Scalars['ID']['output'];
  location: Location;
  organization: Organization;
  platformProductsLength: PlatformProductLength;
  targetWeeksCovered: Scalars['Float']['output'];
  usageRatePerWeek: Quantity;
  usageRatePerWeekInPieces: Scalars['Int']['output'];
  weeksCoveredBeforeMonitor: Scalars['Float']['output'];
  weeksCoveredBeforeUrgent: Scalars['Float']['output'];
};

export type BuyerInventoryFiltersInput = {
  and?: InputMaybe<Array<BuyerInventoryFiltersInput>>;
  branchCode?: InputMaybe<StringOperatorInput>;
  length?: InputMaybe<StringOperatorInput>;
  location?: InputMaybe<StringOperatorInput>;
  locationId?: InputMaybe<IdOperatorInput>;
  locationIds?: InputMaybe<IdCollectionOperatorInput>;
  not?: InputMaybe<BuyerInventoryFiltersInput>;
  or?: InputMaybe<Array<BuyerInventoryFiltersInput>>;
  productCode?: InputMaybe<StringOperatorInput>;
  productName?: InputMaybe<StringOperatorInput>;
  properties?: InputMaybe<Array<PropertyFilterInput>>;
  status?: InputMaybe<InventoryStockHealthOperatorInput>;
  stock?: InputMaybe<NumberOperatorInput>;
  usageRatePerWeek?: InputMaybe<NumberOperatorInput>;
};

export type BuyerNegotiatedPrice = {
  __typename?: 'BuyerNegotiatedPrice';
  buyingOrganization: Organization;
  price: Money;
};

export type CannedBuyListTally = BuyListTally & {
  __typename?: 'CannedBuyListTally';
  /** The canned tally's bundles times tallyCount. */
  bundles: Array<BuyListTallyBundle>;
  cannedTally: PlatformProductCannedTally;
  id: Scalars['ID']['output'];
  platformProduct: PlatformProduct;
  quantity: Quantity;
  /** How many canned tallies. */
  tallyCount: Scalars['Int']['output'];
};

export type CannedBuyListTallyQuantityArgs = {
  mode?: InputMaybe<QuantityModeInput>;
};

export type CannedTallyLengthBreakdown = {
  __typename?: 'CannedTallyLengthBreakdown';
  actualLengthInches: Scalars['Int']['output'];
  bundles: Scalars['Float']['output'];
  ft: Scalars['Int']['output'];
  hasInventory: Scalars['Boolean']['output'];
  platformProductsLengthId?: Maybe<Scalars['ID']['output']>;
  pricePerBundle?: Maybe<Money>;
};

export type CannedTallySellerGroup = {
  __typename?: 'CannedTallySellerGroup';
  avgPrice: Scalars['Float']['output'];
  currency: Currency;
  currencySymbol: Scalars['String']['output'];
  facility: Facility;
  hasAnyPricedLength: Scalars['Boolean']['output'];
  hasBestPrice: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  leadTimeDays?: Maybe<Scalars['Int']['output']>;
  lengthBreakdown: Array<CannedTallyLengthBreakdown>;
  priceUnit: UnitCode;
  sellerName: Scalars['String']['output'];
  totalBundles: Scalars['Float']['output'];
};

export type CannedTallySellerGroupFilterInput = {
  deliveryMode?: InputMaybe<DeliveryMode>;
  destinationLocationId?: InputMaybe<Scalars['ID']['input']>;
};

export type Cart = {
  __typename?: 'Cart';
  currency?: Maybe<Currency>;
  deliveryAddress?: Maybe<DeliveryAddress>;
  deliveryMethod?: Maybe<DeliveryMethod>;
  id: Scalars['ID']['output'];
  incoTerm?: Maybe<LogisticsIncoterm>;
  incotermAddressDestination?: Maybe<Scalars['String']['output']>;
  incotermDischarge?: Maybe<LogisticsIncoterm>;
  incotermLoading?: Maybe<LogisticsIncoterm>;
  isFromQuote: Scalars['Boolean']['output'];
  isInternational: Scalars['Boolean']['output'];
  items?: Maybe<Array<OrderItem>>;
  /** The recipients who acted on this order. The buyer cannot remove them. */
  lockedRecipientIds: Array<Scalars['ID']['output']>;
  parentOrder?: Maybe<Order>;
  portOfDischarge?: Maybe<Port>;
  portOfLoading?: Maybe<Port>;
  /** The seller contact the order goes to. Null when none is chosen or the chosen one is no longer an active seller contact. Required before the order is placed. */
  primaryContact?: Maybe<User>;
  /** True when placing the order requires its MSR purchase order dates. */
  purchaseOrderDatesRequired: Scalars['Boolean']['output'];
  /** The seller contacts the buyer chose to notify. The order-placed emails go to the active ones. The primary contact is always one of them. */
  recipients: Array<User>;
  /** Who the buyer contacts about this cart: the cart's recipients still among the selling organization's seller contacts; else the buyer's remembered contacts still among them; else all its seller contacts. */
  sellerContacts: Array<User>;
  sellerOrganizationFacility: Facility;
  sellingOrganization: Organization;
  shippingLocation: Location;
  shippingRoute?: Maybe<ShippingRoute>;
  tarp: Scalars['Boolean']['output'];
  transportVehicle?: Maybe<TransportVehicle>;
};

export type CartFilterInput = {
  locationId?: InputMaybe<Scalars['ID']['input']>;
  sellerOrganizationFacilityId?: InputMaybe<Scalars['ID']['input']>;
};

export type CartShippingCost = {
  __typename?: 'CartShippingCost';
  cartId: Scalars['ID']['output'];
  deliveryCost?: Maybe<Money>;
  pickupCost?: Maybe<Money>;
};

/** One length a catalog product can be added on, with the product's own PlatformProductLength for it. */
export type CatalogLengthOption = {
  __typename?: 'CatalogLengthOption';
  length: Length;
  platformProductLength: PlatformProductLength;
};

export type Chat = {
  __typename?: 'Chat';
  archived: Scalars['Boolean']['output'];
  buyingOrganization: Organization;
  createdAt: Scalars['Instant']['output'];
  createdByUser?: Maybe<User>;
  email?: Maybe<ChatEmail>;
  id: Scalars['ID']['output'];
  internal: Scalars['Boolean']['output'];
  order: Order;
  orderReference?: Maybe<OrderReference>;
  sellingOrganization: Organization;
  title?: Maybe<Scalars['String']['output']>;
  type: ChatType;
};

export type ChatEmail = {
  __typename?: 'ChatEmail';
  htmlBody: Scalars['String']['output'];
  recipientTo?: Maybe<Scalars['String']['output']>;
  status: OutboundEmailStatus;
  subject: Scalars['String']['output'];
};

export const ChatType = {
  MsrPurchaseOrderSeller: 'MSR_PURCHASE_ORDER_SELLER',
  OrderCancelledBuyer: 'ORDER_CANCELLED_BUYER',
  OrderConfirmedBuyer: 'ORDER_CONFIRMED_BUYER',
  OrderConfirmedInternalBuyer: 'ORDER_CONFIRMED_INTERNAL_BUYER',
  OrderConfirmedInternalSeller: 'ORDER_CONFIRMED_INTERNAL_SELLER',
  OrderConfirmedLogisticsProvider: 'ORDER_CONFIRMED_LOGISTICS_PROVIDER',
  OrderPlacedBuyer: 'ORDER_PLACED_BUYER',
  OrderPlacedSeller: 'ORDER_PLACED_SELLER',
  OrderPlacedSellerReminder: 'ORDER_PLACED_SELLER_REMINDER',
  PackingListCreatedBuyer: 'PACKING_LIST_CREATED_BUYER',
  PackingListUpdatedBuyer: 'PACKING_LIST_UPDATED_BUYER',
  PriceNegotiationDeclinedBuyer: 'PRICE_NEGOTIATION_DECLINED_BUYER',
  ShipmentReminderSeller: 'SHIPMENT_REMINDER_SELLER',
} as const;

export type ChatType = (typeof ChatType)[keyof typeof ChatType];
export type ContactInput = {
  email: Scalars['String']['input'];
  employeeId?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  role: UserRole;
};

export type CopyOrderToCartResult = {
  __typename?: 'CopyOrderToCartResult';
  cart?: Maybe<Cart>;
  skippedItems: Array<SkippedOrderItem>;
};

export const CopyToCartSkipReason = {
  CurrencyMismatch: 'CURRENCY_MISMATCH',
  ItemCouldNotBeCopied: 'ITEM_COULD_NOT_BE_COPIED',
  NotPricedBySeller: 'NOT_PRICED_BY_SELLER',
  ProductNoLongerAvailable: 'PRODUCT_NO_LONGER_AVAILABLE',
  TallyConflictsWithCart: 'TALLY_CONFLICTS_WITH_CART',
  TallyItemNotSupported: 'TALLY_ITEM_NOT_SUPPORTED',
  TallyVehicleMismatch: 'TALLY_VEHICLE_MISMATCH',
} as const;

export type CopyToCartSkipReason =
  (typeof CopyToCartSkipReason)[keyof typeof CopyToCartSkipReason];
export type CreateOrganizationInput = {
  name: Scalars['String']['input'];
};

/** One length to ask about, how much of it to request, and optional target prices in the request's currency. */
export type CreateRequestForQuoteItemInput = {
  deliveryPrice?: InputMaybe<MoneyInput>;
  pickupPrice?: InputMaybe<MoneyInput>;
  platformProductLengthId: Scalars['ID']['input'];
  quantity: QuantityInput;
};

export type CreateShippingAddOnInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  billingUnit: AddOnBillingUnit;
  category: Scalars['String']['input'];
  cost: MoneyInput;
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type CreateShippingRouteInput = {
  addOnIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  additionalCostsPerContainer?: InputMaybe<MoneyInput>;
  additionalCostsPerShipment?: InputMaybe<MoneyInput>;
  category?: InputMaybe<Scalars['String']['input']>;
  destinationDeliveryId?: InputMaybe<Scalars['ID']['input']>;
  expirationDate?: InputMaybe<Scalars['Instant']['input']>;
  forwarder?: InputMaybe<Scalars['String']['input']>;
  forwarderEmail?: InputMaybe<Scalars['String']['input']>;
  freeDays?: InputMaybe<Scalars['Int']['input']>;
  freightCost?: InputMaybe<MoneyInput>;
  gassingCost?: InputMaybe<MoneyInput>;
  incotermDischarge?: InputMaybe<LogisticsIncoterm>;
  incotermLoading?: InputMaybe<LogisticsIncoterm>;
  notes?: InputMaybe<Scalars['String']['input']>;
  originDeliveryId?: InputMaybe<Scalars['ID']['input']>;
  portOfDischargeId: Scalars['ID']['input'];
  portOfLoadingId: Scalars['ID']['input'];
  status?: InputMaybe<ShippingRouteStatus>;
  terminalHandlingCharge?: InputMaybe<MoneyInput>;
  transitDays?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateTenantAdminInput = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
};

export type CreateTenantUserInput = {
  email: Scalars['String']['input'];
  employeeId?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  role: UserRole;
};

export const Currency = {
  Cad: 'CAD',
  Eur: 'EUR',
  Gbp: 'GBP',
  Usd: 'USD',
} as const;

export type Currency = (typeof Currency)[keyof typeof Currency];
export type CurrencyOperatorInput = {
  eq?: InputMaybe<Currency>;
  neq?: InputMaybe<Currency>;
};

/** A physical delivery point: structured address, freeform text, coordinates, or any combination. */
export type DeliveryAddress = {
  __typename?: 'DeliveryAddress';
  addressLine1?: Maybe<Scalars['String']['output']>;
  addressLine2?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type DeliveryAddressInput = {
  addressLine1?: InputMaybe<Scalars['String']['input']>;
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export const DeliveryMethod = {
  DoorToDoor: 'DOOR_TO_DOOR',
  DoorToPort: 'DOOR_TO_PORT',
  PortToDoor: 'PORT_TO_DOOR',
  PortToPort: 'PORT_TO_PORT',
} as const;

export type DeliveryMethod =
  (typeof DeliveryMethod)[keyof typeof DeliveryMethod];
export type DeliveryMethodOperatorInput = {
  eq?: InputMaybe<DeliveryMethod>;
  neq?: InputMaybe<DeliveryMethod>;
};

export const DeliveryMode = {
  Delivered: 'DELIVERED',
  Pickup: 'PICKUP',
} as const;

export type DeliveryMode = (typeof DeliveryMode)[keyof typeof DeliveryMode];
export const DocumentKind = {
  InventoryOffer: 'INVENTORY_OFFER',
  ProgramPriceSheet: 'PROGRAM_PRICE_SHEET',
} as const;

export type DocumentKind = (typeof DocumentKind)[keyof typeof DocumentKind];
export const DocumentType = {
  BillOfLading: 'BILL_OF_LADING',
  CertificateOfOrigin: 'CERTIFICATE_OF_ORIGIN',
  CommercialInvoice: 'COMMERCIAL_INVOICE',
  FumigationCertificate: 'FUMIGATION_CERTIFICATE',
  HeatTreatmentKdCertificate: 'HEAT_TREATMENT_KD_CERTIFICATE',
  Other: 'OTHER',
  PackingList: 'PACKING_LIST',
  PhytosanitaryCertificate: 'PHYTOSANITARY_CERTIFICATE',
} as const;

export type DocumentType = (typeof DocumentType)[keyof typeof DocumentType];
export type DutyCost = {
  __typename?: 'DutyCost';
  active: Scalars['Boolean']['output'];
  adCvdDescription?: Maybe<Scalars['String']['output']>;
  adCvdRate?: Maybe<Scalars['Float']['output']>;
  adCvdType?: Maybe<Scalars['String']['output']>;
  conditional: Scalars['Boolean']['output'];
  createdAt?: Maybe<Scalars['Instant']['output']>;
  currencyCode?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dutyAdValoremRate?: Maybe<Scalars['Float']['output']>;
  dutySpecificRate?: Maybe<Scalars['Float']['output']>;
  dutySpecificUnit?: Maybe<Scalars['String']['output']>;
  gspEligible: Scalars['Boolean']['output'];
  htsNumber: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  originCountryCode?: Maybe<Scalars['String']['output']>;
  section301Rate?: Maybe<Scalars['Float']['output']>;
  softwoodLumberFeeCbm?: Maybe<Scalars['Float']['output']>;
  softwoodLumberFeeMbf?: Maybe<Scalars['Float']['output']>;
  updatedAt?: Maybe<Scalars['Instant']['output']>;
};

export type EmailDeliveryEvent = {
  __typename?: 'EmailDeliveryEvent';
  bounceSubType?: Maybe<Scalars['String']['output']>;
  bounceType?: Maybe<Scalars['String']['output']>;
  diagnosticCode?: Maybe<Scalars['String']['output']>;
  eventType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  occurredAt: Scalars['Instant']['output'];
  reason?: Maybe<Scalars['String']['output']>;
  recipient?: Maybe<Scalars['String']['output']>;
};

export const EmailDeliveryOutcome = {
  Bounced: 'BOUNCED',
  Complained: 'COMPLAINED',
  Delayed: 'DELAYED',
  Delivered: 'DELIVERED',
  Pending: 'PENDING',
  Rejected: 'REJECTED',
} as const;

export type EmailDeliveryOutcome =
  (typeof EmailDeliveryOutcome)[keyof typeof EmailDeliveryOutcome];
export type EmailDeliveryTrace = {
  __typename?: 'EmailDeliveryTrace';
  attempts: Scalars['Int']['output'];
  createdAt: Scalars['Instant']['output'];
  deliveryOutcome: EmailDeliveryOutcome;
  deliveryOutcomeAt?: Maybe<Scalars['Instant']['output']>;
  emailType: Scalars['String']['output'];
  events: Array<EmailDeliveryEvent>;
  id: Scalars['ID']['output'];
  lastError?: Maybe<Scalars['String']['output']>;
  recipientCc: Array<Scalars['String']['output']>;
  recipientTo: Scalars['String']['output'];
  sentAt?: Maybe<Scalars['Instant']['output']>;
  sesMessageId?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  subject: Scalars['String']['output'];
};

export type EmailDeliveryTraceFilter = {
  createdAfter?: InputMaybe<Scalars['Instant']['input']>;
  createdBefore?: InputMaybe<Scalars['Instant']['input']>;
  deliveryOutcome?: InputMaybe<EmailDeliveryOutcome>;
  emailType?: InputMaybe<OutboundEmailType>;
  recipient?: InputMaybe<Scalars['String']['input']>;
  sesMessageId?: InputMaybe<Scalars['String']['input']>;
};

export type EnumOperatorInput = {
  eq?: InputMaybe<Scalars['String']['input']>;
  neq?: InputMaybe<Scalars['String']['input']>;
};

/**
 * A vendor document that the extraction pipeline has read. Items are suggestions with a
 * verdict, never inventory.
 */
export type ExtractedDocument = {
  __typename?: 'ExtractedDocument';
  ambiguities: Array<Scalars['String']['output']>;
  coveredPositionCount: Scalars['Int']['output'];
  createdAt: Scalars['Instant']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  documentDate?: Maybe<Scalars['String']['output']>;
  documentKind: DocumentKind;
  expectedPositionCount: Scalars['Int']['output'];
  failureReason?: Maybe<ExtractionFailureReason>;
  id: Scalars['ID']['output'];
  items: Array<ExtractedDocumentItem>;
  notes: Array<Scalars['String']['output']>;
  originalFilename?: Maybe<Scalars['String']['output']>;
  priceBasis?: Maybe<Scalars['String']['output']>;
  sourceFormat: SourceFormat;
  status: ExtractionStatus;
  units: Array<ExtractionUnitProgress>;
  vendorName?: Maybe<Scalars['String']['output']>;
};

export type ExtractedDocumentItem = {
  __typename?: 'ExtractedDocumentItem';
  ambiguities: Array<Scalars['String']['output']>;
  /**
   * The first value the model claimed for this item, in the order its document kind declares its
   * value fields. Set for every verdict; for a CONTRADICTED item it is the value that disagreed.
   */
  claimedValue?: Maybe<Scalars['String']['output']>;
  confidence?: Maybe<Scalars['String']['output']>;
  /** The file the item was read from; an email's items include its attachments' items. */
  documentId: Scalars['ID']['output'];
  /**
   * The fields the model returned for this item: the ones its document kind declares first, in
   * that order, then any it returned that the kind does not declare. A declared field the model
   * left out is absent.
   */
  fields: Array<ExtractedField>;
  /**
   * The labels that govern the claimed cell, such as "2x4 #1 12'", when the check judged the claim
   * by those rather than by a value it read. Set for a CONTRADICTED item whose labels disagree and
   * for a NO_ANCHOR item that has labels above it.
   */
  governingLabels?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  positionKey: Scalars['String']['output'];
  provenance?: Maybe<Scalars['String']['output']>;
  /**
   * A second model's reading of a rejected item: AGREES means the source supports the claim
   * and the check could not follow the layout; DISAGREES confirms the extraction is wrong.
   * It orders review; it never publishes.
   */
  secondOpinion?: Maybe<SecondOpinion>;
  secondOpinionReason?: Maybe<Scalars['String']['output']>;
  unitLabel: Scalars['String']['output'];
  verdict: ExtractionVerdict;
  /**
   * The value the source holds at the claimed position, when the check could read one there.
   * A NO_CELL item carries it when the cell exists but the detector never offered the position,
   * and null when the position is not in the source at all.
   */
  verifiedValue?: Maybe<Scalars['String']['output']>;
};

export type ExtractedField = {
  __typename?: 'ExtractedField';
  name: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export const ExtractionFailureReason = {
  Abandoned: 'ABANDONED',
  LimitExceeded: 'LIMIT_EXCEEDED',
  ModelPartial: 'MODEL_PARTIAL',
  ModelUnavailable: 'MODEL_UNAVAILABLE',
  ReadFailed: 'READ_FAILED',
  UnexpectedError: 'UNEXPECTED_ERROR',
  UnreadableFile: 'UNREADABLE_FILE',
  UnsupportedScanned: 'UNSUPPORTED_SCANNED',
} as const;

export type ExtractionFailureReason =
  (typeof ExtractionFailureReason)[keyof typeof ExtractionFailureReason];
export const ExtractionStatus = {
  Complete: 'COMPLETE',
  Failed: 'FAILED',
  Inferring: 'INFERRING',
  NeedsReview: 'NEEDS_REVIEW',
  Pending: 'PENDING',
  Reading: 'READING',
  Verifying: 'VERIFYING',
  WaitingChildren: 'WAITING_CHILDREN',
} as const;

export type ExtractionStatus =
  (typeof ExtractionStatus)[keyof typeof ExtractionStatus];
/**
 * A unit key is unique only within one document, and a parent answers with its attachments' units
 * folded in, so documentId and sourceFilename say which file each unit came from.
 */
export type ExtractionUnitProgress = {
  __typename?: 'ExtractionUnitProgress';
  attemptCount: Scalars['Int']['output'];
  coveredPositionCount: Scalars['Int']['output'];
  documentId: Scalars['ID']['output'];
  expectedPositionCount: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  representation: SourceRepresentation;
  sourceFilename?: Maybe<Scalars['String']['output']>;
  status: UnitStatus;
  unitKey: Scalars['String']['output'];
};

export const ExtractionVerdict = {
  Contradicted: 'CONTRADICTED',
  NoAnchor: 'NO_ANCHOR',
  NoCell: 'NO_CELL',
  Unverified: 'UNVERIFIED',
  Verified: 'VERIFIED',
} as const;

export type ExtractionVerdict =
  (typeof ExtractionVerdict)[keyof typeof ExtractionVerdict];
export type Facility = {
  __typename?: 'Facility';
  address: Address;
  code?: Maybe<Scalars['String']['output']>;
  faxNumber?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  locations: Array<Location>;
  nearestPort?: Maybe<Port>;
  organization: Organization;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  shippingRates: Array<FacilityShippingRate>;
  transportVehicles: Array<TransportVehicle>;
};

export type FacilityFiltersInput = {
  scope?: InputMaybe<FacilityScope>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type FacilityInput = {
  addressLine1: Scalars['String']['input'];
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  code?: InputMaybe<Scalars['String']['input']>;
  country: Scalars['String']['input'];
  faxNumber?: InputMaybe<Scalars['String']['input']>;
  nearestPortId?: InputMaybe<Scalars['ID']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  zipCode: Scalars['String']['input'];
};

export const FacilityScope = {
  All: 'ALL',
  Mine: 'MINE',
} as const;

export type FacilityScope = (typeof FacilityScope)[keyof typeof FacilityScope];
export type FacilityShippingRate = {
  __typename?: 'FacilityShippingRate';
  disabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  rateCurrency: Currency;
  ratePerMbf?: Maybe<Scalars['Float']['output']>;
  shippingRate: ShippingRate;
};

export type FeatureFlag = {
  __typename?: 'FeatureFlag';
  enabled: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export const FilterOperator = {
  Contains: 'contains',
  EndsWith: 'endsWith',
  Eq: 'eq',
  Gt: 'gt',
  Gte: 'gte',
  Lt: 'lt',
  Lte: 'lte',
  Neq: 'neq',
  NotContain: 'notContain',
  StartsWith: 'startsWith',
} as const;

export type FilterOperator =
  (typeof FilterOperator)[keyof typeof FilterOperator];
export const FilterView = {
  BuyLists: 'BUY_LISTS',
  Comparison: 'COMPARISON',
  Inventory: 'INVENTORY',
  MyBuyLists: 'MY_BUY_LISTS',
  Orders: 'ORDERS',
  Pricing: 'PRICING',
  RequestsForQuote: 'REQUESTS_FOR_QUOTE',
} as const;

export type FilterView = (typeof FilterView)[keyof typeof FilterView];
export type IdCollectionOperatorInput = {
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  notIn?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type IdOperatorInput = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  neq?: InputMaybe<Scalars['ID']['input']>;
};

export type ImportMappingColumnInput = {
  header: Scalars['String']['input'];
  samples: Array<Scalars['String']['input']>;
};

export type ImportMappingFieldInput = {
  key: Scalars['String']['input'];
  label: Scalars['String']['input'];
};

export type InstantOperatorInput = {
  gt?: InputMaybe<Scalars['Instant']['input']>;
  gte?: InputMaybe<Scalars['Instant']['input']>;
  lt?: InputMaybe<Scalars['Instant']['input']>;
  lte?: InputMaybe<Scalars['Instant']['input']>;
};

export type InternationalShippingInput = {
  deliveryMethod?: InputMaybe<DeliveryMethod>;
  incotermAddressDestination?: InputMaybe<Scalars['String']['input']>;
  incotermDischarge?: InputMaybe<LogisticsIncoterm>;
  incotermLoading?: InputMaybe<LogisticsIncoterm>;
  portOfDischargeId?: InputMaybe<Scalars['ID']['input']>;
  portOfLoadingId?: InputMaybe<Scalars['ID']['input']>;
  shippingRouteId?: InputMaybe<Scalars['ID']['input']>;
};

export type Inventory = {
  __typename?: 'Inventory';
  availableStock: Quantity;
  availableStockInPieces: Scalars['Int']['output'];
  buyerInventoryConfiguration?: Maybe<BuyerInventoryConfiguration>;
  id: Scalars['ID']['output'];
  inboundStock: Quantity;
  inboundStockInPieces: Scalars['Int']['output'];
  location: Location;
  onHandStock: Quantity;
  onHandStockInPieces: Scalars['Int']['output'];
  onOrderStock: Quantity;
  onOrderStockInPieces: Scalars['Int']['output'];
  organization: Organization;
  platformProductsLength: PlatformProductLength;
  quantity: Quantity;
  requestedStock: Quantity;
  requestedStockInPieces: Scalars['Int']['output'];
  stockInPieces: Scalars['Int']['output'];
};

export type InventoryQuantityArgs = {
  mode?: InputMaybe<QuantityModeInput>;
};

/**
 * Availability of one product+length at one of the group facility's locations. inventory is null
 * when the location has no record for the combo ("Not Stocked"). Scoped to the expanded group's
 * facility and not affected by the queue's active filters.
 */
export type InventoryGroupLocation = {
  __typename?: 'InventoryGroupLocation';
  inventory?: Maybe<Inventory>;
  location: Location;
};

/**
 * One priority-buy-queue group: a facility x product+length combo, with stock and usage
 * aggregated across the facility's filter-matching inventory rows. targetInventory is the
 * group's most urgent child row. id is facilityId_platformProductsLengthId.
 */
export type InventoryPriorityGroup = {
  __typename?: 'InventoryPriorityGroup';
  avgUsageRatePerWeek: Quantity;
  facility: Facility;
  id: Scalars['ID']['output'];
  platformProductsLength: PlatformProductLength;
  targetInventory: Inventory;
  totalAvailableStock: Quantity;
  totalInboundStock: Quantity;
  totalOnHandStock: Quantity;
  totalOnOrderStock: Quantity;
  totalRequestedStock: Quantity;
  totalStock: Quantity;
};

export const InventoryStockHealth = {
  Critical: 'CRITICAL',
  Healthy: 'HEALTHY',
  Low: 'LOW',
} as const;

export type InventoryStockHealth =
  (typeof InventoryStockHealth)[keyof typeof InventoryStockHealth];
export type InventoryStockHealthOperatorInput = {
  eq?: InputMaybe<InventoryStockHealth>;
  neq?: InputMaybe<InventoryStockHealth>;
};

export type Length = {
  __typename?: 'Length';
  actualLengthInches: Scalars['Float']['output'];
  aliases?: Maybe<Array<LengthAlias>>;
  displayValue: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  nominalLengthInches?: Maybe<Scalars['Float']['output']>;
};

export type LengthAlias = {
  __typename?: 'LengthAlias';
  displayValue: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type LengthWithStock = {
  __typename?: 'LengthWithStock';
  length: Length;
  stockInPieces: Scalars['Float']['output'];
};

export type Location = {
  __typename?: 'Location';
  branchCode?: Maybe<Scalars['String']['output']>;
  code: Scalars['String']['output'];
  facility: Facility;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  organization: Organization;
};

export type LocationFiltersInput = {
  scope?: InputMaybe<LocationScope>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type LocationInput = {
  branchCode?: InputMaybe<Scalars['String']['input']>;
  code: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export const LocationScope = {
  All: 'ALL',
  Mine: 'MINE',
} as const;

export type LocationScope = (typeof LocationScope)[keyof typeof LocationScope];
export const LogisticsIncoterm = {
  Cfr: 'CFR',
  Cif: 'CIF',
  Dap: 'DAP',
  DapCombo: 'DAP_COMBO',
  Ddp: 'DDP',
  DdpCombo: 'DDP_COMBO',
  Exw: 'EXW',
  Fca: 'FCA',
  FcaCombo: 'FCA_COMBO',
  Fob: 'FOB',
} as const;

export type LogisticsIncoterm =
  (typeof LogisticsIncoterm)[keyof typeof LogisticsIncoterm];
export type LogisticsIncotermOperatorInput = {
  eq?: InputMaybe<LogisticsIncoterm>;
  neq?: InputMaybe<LogisticsIncoterm>;
};

export type LumberGrade = {
  __typename?: 'LumberGrade';
  code: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type LumberSpecies = {
  __typename?: 'LumberSpecies';
  code: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type MarketAvailability = {
  __typename?: 'MarketAvailability';
  leadTimeMax: Scalars['Int']['output'];
  leadTimeMin: Scalars['Int']['output'];
  listingsCount: Scalars['Float']['output'];
  priceMax?: Maybe<Money>;
  priceMin?: Maybe<Money>;
  sellersCount: Scalars['Float']['output'];
  totalStock: Quantity;
};

export type Money = {
  __typename?: 'Money';
  amount: Scalars['Float']['output'];
  currency: Currency;
};

export type MoneyInput = {
  amount: Scalars['Float']['input'];
  currency: Currency;
};

export type MoneyRange = {
  __typename?: 'MoneyRange';
  max: Money;
  min: Money;
};

/** Who may change a field of an MSR purchase order. */
export const MsrFieldEditability = {
  /** The buyer sets it when placing the order. */
  BuyerInput: 'BUYER_INPUT',
  /** MSR works it out. */
  Calculated: 'CALCULATED',
  /** Sent to MSR from the order itself, so the order is where to change it. */
  FromOrder: 'FROM_ORDER',
  /** The MSR integration doesn't set it. */
  MsrLimitation: 'MSR_LIMITATION',
} as const;

export type MsrFieldEditability =
  (typeof MsrFieldEditability)[keyof typeof MsrFieldEditability];
/** An incoterm MSR accepts on a purchase order. */
export const MsrIncoTerm = {
  Cfr: 'CFR',
  Cif: 'CIF',
  Dap: 'DAP',
  Ddp: 'DDP',
  Fas: 'FAS',
  Fca: 'FCA',
  Fob: 'FOB',
} as const;

export type MsrIncoTerm = (typeof MsrIncoTerm)[keyof typeof MsrIncoTerm];
/** Where an MSR incoterm location comes from when the buyer leaves it blank. */
export const MsrIncoTermLocation = {
  DeliveryAddress: 'DELIVERY_ADDRESS',
  /** The base term of a combo incoterm, sent with an empty location. */
  None: 'NONE',
  PortOfDischarge: 'PORT_OF_DISCHARGE',
  ShipFromAddress: 'SHIP_FROM_ADDRESS',
} as const;

export type MsrIncoTermLocation =
  (typeof MsrIncoTermLocation)[keyof typeof MsrIncoTermLocation];
/** An MSR incoterm the buyer may pick: one with the same ship terms as the order's discharge incoterm (international) or incoterm. MSR's ship terms follow the pick. */
export type MsrIncoTermOption = {
  __typename?: 'MsrIncoTermOption';
  code: MsrIncoTerm;
  defaultLocation: MsrIncoTermLocation;
  /** The order's own incoterm, used when the buyer picks none. */
  isDefault: Scalars['Boolean']['output'];
};

export type MsrPurchaseOrder = {
  __typename?: 'MsrPurchaseOrder';
  fields: Array<MsrPurchaseOrderField>;
  items: Array<MsrPurchaseOrderItem>;
};

export type MsrPurchaseOrderEmail = {
  __typename?: 'MsrPurchaseOrderEmail';
  createdAt: Scalars['Instant']['output'];
  id: Scalars['ID']['output'];
  recipientTo: Scalars['String']['output'];
  /** The buyer who sent it. */
  requestedBy?: Maybe<User>;
  sentAt?: Maybe<Scalars['Instant']['output']>;
  status: OutboundEmailStatus;
};

export type MsrPurchaseOrderField = {
  __typename?: 'MsrPurchaseOrderField';
  editability: MsrFieldEditability;
  /** The field's name in MSR's purchase order. */
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type MsrPurchaseOrderInput = {
  /** MSR code of the buyer. Defaults to the placing buyer's own code. Free text, up to 50 characters. */
  buyerCode?: InputMaybe<Scalars['String']['input']>;
  cashContract?: Scalars['Boolean']['input'];
  /** Imports only, ignored otherwise. One of msrIncoTerms for the order. Defaults to the order's own incoterm, or none for a pickup. */
  incoTerms?: InputMaybe<MsrIncoTerm>;
  /** Imports only, ignored otherwise. Free text, up to 255 characters. Defaults by the incoterm's defaultLocation. */
  incoTermsLoc?: InputMaybe<Scalars['String']['input']>;
  isImport?: Scalars['Boolean']['input'];
  /** Whole days, 0 to 10000. */
  numDaysIntransit?: InputMaybe<Scalars['Int']['input']>;
  /** MSR code of who placed the order. Free text, up to 50 characters. */
  orderedByCode?: InputMaybe<Scalars['String']['input']>;
  /** The day the order will be ready at the mill. */
  readyAtMill?: InputMaybe<Scalars['Date']['input']>;
  /** One of msrUnitTypes for the order's transport vehicle. Defaults to that vehicle's default unit type. */
  unitType?: InputMaybe<Scalars['String']['input']>;
};

/** The buyer's MSR purchase order choices as stored when the order was placed. */
export type MsrPurchaseOrderInputsView = {
  __typename?: 'MsrPurchaseOrderInputsView';
  /** Null when the order was placed without a buyer code; MSR then gets the order buyer's own code. */
  buyerCode?: Maybe<Scalars['String']['output']>;
  cashContract: Scalars['Boolean']['output'];
  incoTerms?: Maybe<MsrIncoTerm>;
  /** Empty for the base term of a combo incoterm. */
  incoTermsLoc?: Maybe<Scalars['String']['output']>;
  isImport: Scalars['Boolean']['output'];
  numDaysIntransit?: Maybe<Scalars['Int']['output']>;
  orderedByCode?: Maybe<Scalars['String']['output']>;
  readyAtMill?: Maybe<Scalars['Date']['output']>;
  unitType?: Maybe<Scalars['String']['output']>;
};

export type MsrPurchaseOrderItem = {
  __typename?: 'MsrPurchaseOrderItem';
  fields: Array<MsrPurchaseOrderField>;
};

export type MsrPurchaseOrderPrintOptionsInput = {
  prices: Scalars['Boolean']['input'];
  shipTo: Scalars['Boolean']['input'];
  shippingInstructions: Scalars['Boolean']['input'];
  weight: Scalars['Boolean']['input'];
};

/** A trailer or container kind MSR accepts as a purchase order's unit type. */
export type MsrUnitType = {
  __typename?: 'MsrUnitType';
  code: Scalars['String']['output'];
  description: Scalars['String']['output'];
  /** The unit type used when the buyer picks none: the vehicle's own, else its ship via's. */
  isDefault: Scalars['Boolean']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Seller accepts the buyer's counter-offer as its own offer. The buyer still accepts the quote to order it. */
  acceptCounterQuote: Quote;
  acceptQuote: Quote;
  /** Awards the selected quote items, creating one DRAFT order per selling organization. */
  acceptQuoteItems: Array<Order>;
  /** Adds the chosen buy list items and tallies to the buyer's cart for one seller facility and Ship-to Location. Items and tallies that cannot be added are skipped and returned with a reason. The buy list does not change. */
  addBuyListToCart: AddBuyListToCartResult;
  /** Sets the quantity for a product and length on the buy list, replacing the quantity if that product and length is already on the list. */
  addProductToBuyList: BuyList;
  addRequestForQuoteItem: RequestForQuoteItem;
  addRequestForQuoteItems: Array<RequestForQuoteItem>;
  addRequestForQuoteToCart: Cart;
  addTradingPartnersToProductComparison: AddTradingPartnersToProductComparisonResult;
  addTransportVehiclesToFacility: Facility;
  /** Buyer archives a quote with no ordered lines. Once every quote on a sent request is archived, the request is archived too. Archiving is final. */
  archiveQuote: Quote;
  /** Buyer archives a sent request. Unanswered quotes are archived and answered ones are frozen. Archiving is final. */
  archiveRequestForQuote: RequestForQuote;
  assignCurrentUserToLocation: Location;
  cancelOrder?: Maybe<Order>;
  changeTenantUserTradeRole: User;
  /** Buyer sets the primary contact of a placed order that has no active primary contact or no active recipient. The contact becomes a recipient. No email is sent. */
  chooseOrderPrimaryContact: Order;
  /** Buyer chooses the quote's primary contact and the other seller contacts to notify. Contacts with no invitation yet get one. Refused once the quote is fully ordered. */
  chooseQuoteContacts: Quote;
  clearActiveFilter: UserPreferences;
  clearAnonymousFilter: UserPreferences;
  confirmOrder?: Maybe<Order>;
  confirmShipmentReceipt: Order;
  copyOrderToCart: CopyOrderToCartResult;
  /** Counter an open quote with new terms. Either side may counter the other's outstanding offer. */
  counterQuote: Quote;
  createBuyList: BuyList;
  createContact: User;
  createOrganization: Organization;
  /** Creates and submits a request for quote for the chosen lengths, inviting the chosen seller contacts to quote on every length. */
  createRequestForQuote: RequestForQuote;
  /** Creates and submits requests for quote for the chosen items and tallies on a buy list: one for the items and one for each tally. Each request invites the chosen seller contacts. */
  createRequestForQuoteFromBuyList: Array<RequestForQuote>;
  createShippingAddOn: ShippingAddOn;
  createShippingRoute: ShippingRoute;
  createTenantAdmin: User;
  createTenantUser: User;
  customizePlatformShippingAddOn: ShippingAddOn;
  deactivateTenantUser: User;
  declinePriceNegotiation?: Maybe<Order>;
  declinePriceNegotiationRequest: PriceNegotiation;
  declineQuote: Quote;
  deleteFacility: Scalars['Boolean']['output'];
  deleteFilter: Scalars['Boolean']['output'];
  deleteLocation: Scalars['Boolean']['output'];
  deleteOrderDocument: Scalars['Boolean']['output'];
  deleteSellerList: Scalars['Boolean']['output'];
  deleteShippingAddOn: Scalars['Boolean']['output'];
  deleteShippingRoute: Scalars['Boolean']['output'];
  /** Buyer emails the MSR purchase order PDF to the chosen seller contacts of the order's selling organization. */
  emailMsrPurchaseOrder: Scalars['Boolean']['output'];
  ensurePlatformProductLength: PlatformProductLength;
  fulfillRequestForQuote: RequestForQuote;
  hidePlatformShippingAddOn: ShippingAddOn;
  hideShippingAddOn: ShippingAddOn;
  hideShippingAddOnCategory: Scalars['Int']['output'];
  /** Validates a product import and returns the changes it makes. With dryRun true nothing is written; otherwise the import is applied in one transaction, or not at all if any row is invalid. */
  importPlatformProducts: PlatformProductImportResult;
  importSellerInventory: SellerImportResult;
  packItem: PackingListItem;
  placeOrder?: Maybe<Order>;
  postQuoteComment: QuoteComment;
  proposeSellerImportMapping: Scalars['JSON']['output'];
  publishPackingList: Scalars['Boolean']['output'];
  reactivateTenantUser: User;
  receiveOrder?: Maybe<Order>;
  rememberSellerImportColumnMapping: SellerImportColumnMapping;
  removeBuyerMargin: Scalars['Boolean']['output'];
  removeCannedTallyItems?: Maybe<Cart>;
  /** Removes the line for the product length from the buyer's cart, including a cart built from a quote award. Returns null when the cart is left empty and deleted. */
  removeCartItem?: Maybe<Cart>;
  removePackedItem: Scalars['Boolean']['output'];
  /** Removes a product and length from the buy list. Returns the updated list. */
  removeProductFromBuyList: BuyList;
  /** tallyPlatformProductId can be omitted for a cart built from a quote, where the quoted tally product is used; a cart with no quote requires it. */
  removeRandomTally?: Maybe<Cart>;
  /** Removes a tally from the buy list. Returns the updated list. */
  removeTallyFromBuyList: BuyList;
  removeTradingPartnersFromProductComparison: Array<Scalars['ID']['output']>;
  removeTransportVehiclesFromFacility: Facility;
  renameFilter: UserFilter;
  requestPriceNegotiation?: Maybe<Scalars['Boolean']['output']>;
  requestShippingRoute: ShippingRoute;
  requestTallyPriceNegotiation?: Maybe<Scalars['Boolean']['output']>;
  resendOrderPlacedEmail: Scalars['Boolean']['output'];
  resendTenantUserInvite: User;
  respondToPriceNegotiationInApp: PriceNegotiation;
  resubmitBlockedOrder?: Maybe<Order>;
  retryFailedJobOutboxEntry: AdminJobOutboxEntry;
  revertBlockedOrderToDraft?: Maybe<Order>;
  saveFilter: UserFilter;
  savePackingList: Array<PackingListItem>;
  /** Creates the list when id is null, otherwise renames it and sets its visible members and contacts in one transaction. Members and contacts that the caller can no longer see are kept, except that `useDefaultContacts: true` removes all saved contacts of that member. */
  saveSellerList: SellerList;
  sendPlatformTestEmail: EmailDeliveryTrace;
  setActiveFilter: UserPreferences;
  setBuyerMargin: SellerProductBuyerMargin;
  /** Sets the count for a canned tally on the buy list, replacing the count if that tally is already on the list. */
  setCannedTallyOnBuyList: BuyList;
  setCartItemBuyCode?: Maybe<Cart>;
  setPlatformProductLengthInventoryOnly: AdminPlatformProductLength;
  /** Sets a product's bundle size. */
  setPlatformProductPiecesPerBundle: AdminPlatformProduct;
  /** Sets a product's platform-wide capacity for a vehicle. The capacity must be in the product's standard unit. */
  setPlatformProductVehicleCapacity: AdminVehicleCapacity;
  /** Sets the random tally of a product in the buyer's cart for the seller facility, replacing the random-tally lines the product already has there. Each bundle names a length; the product length is created when the product does not have it yet. A length the random tally already holds keeps its line's prices; each new line takes the seller's visible price for its length, or no price when the seller has none. Rejected when a length is already in the cart as a plain line or as part of a canned tally. */
  setRandomTallyInCart?: Maybe<Cart>;
  /** Sets the random tally for a product on the buy list, replacing its bundles if the product already has one. Each bundle names a length; the product length is created when the product does not have it yet. */
  setRandomTallyOnBuyList: BuyList;
  setSellerProductPrice?: Maybe<SellerProductPrice>;
  setTenantUserRole: User;
  shipOrder?: Maybe<Order>;
  startUfpInventoryRun: UfpInventoryRun;
  submitQuoteItemEdits: Quote;
  submitRequestForQuote: RequestForQuote;
  syncOrderWithExternalVendor: Order;
  unassignUserFromLocation: Location;
  unhideShippingAddOn: ShippingAddOn;
  /**
   * Sets the buy list's status. Only the buyer who created the list can change it; anyone else gets
   * NOT_FOUND. Setting the current status again returns the list unchanged. Reopening fails with
   * extensions.code "open-buy-list-exists" when that buyer already has an open list for the same
   * location and expected ship date.
   */
  updateBuyListStatus: BuyList;
  updateCart?: Maybe<Cart>;
  updateCartDeliveryAddress?: Maybe<Cart>;
  updateCartTarp?: Maybe<Cart>;
  updateCartTransport?: Maybe<Cart>;
  updateContact: User;
  updateFilter: UserFilter;
  updateMyBuyerCode: TradingPartner;
  updateMySellerCode: TradingPartner;
  updateOrderNotificationEmails: Organization;
  updateOrganizationContact: Organization;
  updateProductPreferredUnitFilters: UserPreferences;
  updatePurchaseOrderNumber?: Maybe<Order>;
  updateShippingAddOn: ShippingAddOn;
  updateShippingRoute: ShippingRoute;
  updateTenantUser: User;
  updateUserPreferences: UserPreferences;
  upsertBuyerInventoryConfiguration?: Maybe<BuyerInventoryConfiguration>;
  upsertFacility: Facility;
  upsertFacilityShippingRates: Array<FacilityShippingRate>;
  upsertInventory?: Maybe<Inventory>;
  upsertLocation: Location;
  upsertProductVehicleCapacity: PlatformProductVehicleCapacity;
  upsertRequestForQuote: RequestForQuote;
  upsertSellerInventory?: Maybe<Inventory>;
  upsertSellerProductConfiguration?: Maybe<SellerProductConfiguration>;
};

export type MutationAcceptCounterQuoteArgs = {
  quoteId: Scalars['ID']['input'];
};

export type MutationAcceptQuoteArgs = {
  id: Scalars['ID']['input'];
};

export type MutationAcceptQuoteItemsArgs = {
  quoteItemIds: Array<Scalars['ID']['input']>;
};

export type MutationAddBuyListToCartArgs = {
  buyListId: Scalars['ID']['input'];
  items?: Array<BuyListItemSelectionInput>;
  locationId: Scalars['ID']['input'];
  sellerOrganizationFacilityId: Scalars['ID']['input'];
  tallies?: Array<BuyListTallySelectionInput>;
  transportVehicleId?: InputMaybe<Scalars['ID']['input']>;
};

export type MutationAddProductToBuyListArgs = {
  buyListId: Scalars['ID']['input'];
  clearPiecesPerBundleOverride?: InputMaybe<Scalars['Boolean']['input']>;
  piecesPerBundleOverride?: InputMaybe<Scalars['Int']['input']>;
  platformProductsLengthId: Scalars['ID']['input'];
  quantity: QuantityInput;
};

export type MutationAddRequestForQuoteItemArgs = {
  deliveryPrice?: InputMaybe<MoneyInput>;
  numberOfBundles?: InputMaybe<Scalars['Long']['input']>;
  pickupPrice?: InputMaybe<MoneyInput>;
  piecesPerBundle?: InputMaybe<Scalars['Int']['input']>;
  platformProductLengthId: Scalars['ID']['input'];
  quantityInPieces?: InputMaybe<Scalars['Long']['input']>;
  requestForQuoteId: Scalars['ID']['input'];
};

export type MutationAddRequestForQuoteItemsArgs = {
  items: Array<RequestForQuoteItemInput>;
  replace?: InputMaybe<Scalars['Boolean']['input']>;
  requestForQuoteId: Scalars['ID']['input'];
};

export type MutationAddRequestForQuoteToCartArgs = {
  facilityId: Scalars['ID']['input'];
  recipientUserIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  requestForQuoteId: Scalars['ID']['input'];
};

export type MutationAddTradingPartnersToProductComparisonArgs = {
  input: AddTradingPartnersToProductInput;
};

export type MutationAddTransportVehiclesToFacilityArgs = {
  facilityId: Scalars['ID']['input'];
  transportVehicleIds: Array<Scalars['ID']['input']>;
};

export type MutationArchiveQuoteArgs = {
  quoteId: Scalars['ID']['input'];
};

export type MutationArchiveRequestForQuoteArgs = {
  id: Scalars['ID']['input'];
};

export type MutationAssignCurrentUserToLocationArgs = {
  locationId: Scalars['ID']['input'];
};

export type MutationCancelOrderArgs = {
  id: Scalars['ID']['input'];
  note: Scalars['String']['input'];
};

export type MutationChangeTenantUserTradeRoleArgs = {
  role: UserRole;
  userId: Scalars['ID']['input'];
};

export type MutationChooseOrderPrimaryContactArgs = {
  orderId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type MutationChooseQuoteContactsArgs = {
  primaryContactUserId: Scalars['ID']['input'];
  quoteId: Scalars['ID']['input'];
  recipientUserIds: Array<Scalars['ID']['input']>;
};

export type MutationClearActiveFilterArgs = {
  perspective: TradePerspective;
  view?: InputMaybe<FilterView>;
};

export type MutationClearAnonymousFilterArgs = {
  perspective: TradePerspective;
  view?: InputMaybe<FilterView>;
};

export type MutationConfirmOrderArgs = {
  deliveryEndDate?: InputMaybe<Scalars['Instant']['input']>;
  deliveryStartDate?: InputMaybe<Scalars['Instant']['input']>;
  id: Scalars['ID']['input'];
  shippedDate?: InputMaybe<Scalars['Instant']['input']>;
};

export type MutationConfirmShipmentReceiptArgs = {
  subOrderId: Scalars['ID']['input'];
};

export type MutationCopyOrderToCartArgs = {
  orderId: Scalars['ID']['input'];
};

export type MutationCounterQuoteArgs = {
  input: SubmitQuoteItemEditsInput;
  quoteId: Scalars['ID']['input'];
};

export type MutationCreateBuyListArgs = {
  expectedShipDate: Scalars['String']['input'];
  locationId: Scalars['ID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  transportVehicleId: Scalars['ID']['input'];
};

export type MutationCreateContactArgs = {
  input: ContactInput;
};

export type MutationCreateOrganizationArgs = {
  input: CreateOrganizationInput;
};

export type MutationCreateRequestForQuoteArgs = {
  currency: Currency;
  items: Array<CreateRequestForQuoteItemInput>;
  leadTimeDays?: InputMaybe<Scalars['Int']['input']>;
  sellerInvitations: Array<SellerInvitationInput>;
  shippingLocationId: Scalars['ID']['input'];
};

export type MutationCreateRequestForQuoteFromBuyListArgs = {
  buyListId: Scalars['ID']['input'];
  items?: Array<BuyListItemSelectionInput>;
  sellerInvitations: Array<SellerInvitationInput>;
  tallies?: Array<BuyListTallySelectionInput>;
};

export type MutationCreateShippingAddOnArgs = {
  input: CreateShippingAddOnInput;
};

export type MutationCreateShippingRouteArgs = {
  input: CreateShippingRouteInput;
};

export type MutationCreateTenantAdminArgs = {
  input: CreateTenantAdminInput;
};

export type MutationCreateTenantUserArgs = {
  input: CreateTenantUserInput;
};

export type MutationCustomizePlatformShippingAddOnArgs = {
  input: UpdateShippingAddOnInput;
  platformAddOnId: Scalars['ID']['input'];
};

export type MutationDeactivateTenantUserArgs = {
  userId: Scalars['ID']['input'];
};

export type MutationDeclinePriceNegotiationArgs = {
  orderId: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type MutationDeclinePriceNegotiationRequestArgs = {
  id: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type MutationDeclineQuoteArgs = {
  quoteId: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type MutationDeleteFacilityArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteFilterArgs = {
  id: Scalars['ID']['input'];
  perspective: TradePerspective;
  view?: InputMaybe<FilterView>;
};

export type MutationDeleteLocationArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteOrderDocumentArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteSellerListArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteShippingAddOnArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteShippingRouteArgs = {
  id: Scalars['ID']['input'];
};

export type MutationEmailMsrPurchaseOrderArgs = {
  contactIds: Array<Scalars['ID']['input']>;
  orderId: Scalars['ID']['input'];
  printOptions?: InputMaybe<MsrPurchaseOrderPrintOptionsInput>;
};

export type MutationEnsurePlatformProductLengthArgs = {
  lengthId: Scalars['ID']['input'];
  platformProductId: Scalars['ID']['input'];
};

export type MutationFulfillRequestForQuoteArgs = {
  id: Scalars['ID']['input'];
};

export type MutationHidePlatformShippingAddOnArgs = {
  platformAddOnId: Scalars['ID']['input'];
};

export type MutationHideShippingAddOnArgs = {
  id: Scalars['ID']['input'];
};

export type MutationHideShippingAddOnCategoryArgs = {
  category: Scalars['String']['input'];
};

export type MutationImportPlatformProductsArgs = {
  dryRun: Scalars['Boolean']['input'];
  input: PlatformProductImportInput;
};

export type MutationImportSellerInventoryArgs = {
  rows: Array<SellerImportRowInput>;
};

export type MutationPackItemArgs = {
  orderId: Scalars['ID']['input'];
  platformProductLengthId: Scalars['ID']['input'];
  price?: InputMaybe<Scalars['Float']['input']>;
  quantity: QuantityInput;
};

export type MutationPlaceOrderArgs = {
  dueByDate?: InputMaybe<Scalars['Date']['input']>;
  incoTerm: LogisticsIncoterm;
  internationalShipping?: InputMaybe<InternationalShippingInput>;
  locationId: Scalars['ID']['input'];
  msrPurchaseOrderInput?: InputMaybe<MsrPurchaseOrderInput>;
  orderId: Scalars['ID']['input'];
  primaryContactUserId?: InputMaybe<Scalars['ID']['input']>;
  promiseDate?: InputMaybe<Scalars['Date']['input']>;
  recipientUserIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  shipWeekDate?: InputMaybe<Scalars['Date']['input']>;
  tarp?: InputMaybe<Scalars['Boolean']['input']>;
  transportVehicleId: Scalars['ID']['input'];
};

export type MutationPostQuoteCommentArgs = {
  body: Scalars['String']['input'];
  quoteId: Scalars['ID']['input'];
};

export type MutationProposeSellerImportMappingArgs = {
  columns: Array<ImportMappingColumnInput>;
  fields: Array<ImportMappingFieldInput>;
};

export type MutationPublishPackingListArgs = {
  orderId: Scalars['ID']['input'];
};

export type MutationReactivateTenantUserArgs = {
  userId: Scalars['ID']['input'];
};

export type MutationReceiveOrderArgs = {
  id: Scalars['ID']['input'];
};

export type MutationRememberSellerImportColumnMappingArgs = {
  headerSignature: Scalars['String']['input'];
  mapping: Scalars['JSON']['input'];
};

export type MutationRemoveBuyerMarginArgs = {
  buyingOrganizationId: Scalars['ID']['input'];
  platformProductLengthId: Scalars['ID']['input'];
};

export type MutationRemoveCannedTallyItemsArgs = {
  cartId: Scalars['ID']['input'];
  tallyPlatformProductId: Scalars['ID']['input'];
};

export type MutationRemoveCartItemArgs = {
  cartId: Scalars['ID']['input'];
  platformProductLengthId: Scalars['ID']['input'];
};

export type MutationRemovePackedItemArgs = {
  orderId: Scalars['ID']['input'];
  platformProductLengthId: Scalars['ID']['input'];
};

export type MutationRemoveProductFromBuyListArgs = {
  buyListId: Scalars['ID']['input'];
  platformProductsLengthId: Scalars['ID']['input'];
};

export type MutationRemoveRandomTallyArgs = {
  cartId: Scalars['ID']['input'];
  tallyPlatformProductId?: InputMaybe<Scalars['ID']['input']>;
};

export type MutationRemoveTallyFromBuyListArgs = {
  buyListId: Scalars['ID']['input'];
  buyListTallyId: Scalars['ID']['input'];
};

export type MutationRemoveTradingPartnersFromProductComparisonArgs = {
  input: RemoveTradingPartnersFromProductComparisonInput;
};

export type MutationRemoveTransportVehiclesFromFacilityArgs = {
  facilityId: Scalars['ID']['input'];
  transportVehicleIds: Array<Scalars['ID']['input']>;
};

export type MutationRenameFilterArgs = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type MutationRequestPriceNegotiationArgs = {
  buyerNote?: InputMaybe<Scalars['String']['input']>;
  platformProductLengthIds: Array<Scalars['ID']['input']>;
  recipientUserIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  sellingOrganizationIds: Array<Scalars['ID']['input']>;
  targetPrice?: InputMaybe<MoneyInput>;
};

export type MutationRequestShippingRouteArgs = {
  input: CreateShippingRouteInput;
};

export type MutationRequestTallyPriceNegotiationArgs = {
  buyerNote?: InputMaybe<Scalars['String']['input']>;
  platformProductCannedTallyIds: Array<Scalars['ID']['input']>;
  recipientUserIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  sellingOrganizationIds: Array<Scalars['ID']['input']>;
  targetPrice?: InputMaybe<MoneyInput>;
  unit: UnitCode;
};

export type MutationResendOrderPlacedEmailArgs = {
  orderId: Scalars['ID']['input'];
};

export type MutationResendTenantUserInviteArgs = {
  userId: Scalars['ID']['input'];
};

export type MutationRespondToPriceNegotiationInAppArgs = {
  id: Scalars['ID']['input'];
  input: RespondToPriceNegotiationInput;
};

export type MutationResubmitBlockedOrderArgs = {
  id: Scalars['ID']['input'];
};

export type MutationRetryFailedJobOutboxEntryArgs = {
  id: Scalars['ID']['input'];
};

export type MutationRevertBlockedOrderToDraftArgs = {
  id: Scalars['ID']['input'];
};

export type MutationSaveFilterArgs = {
  filterData: Scalars['JSON']['input'];
  name: Scalars['String']['input'];
  perspective: TradePerspective;
};

export type MutationSavePackingListArgs = {
  items: Array<PackItemInput>;
  notes?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['ID']['input'];
};

export type MutationSaveSellerListArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  members: Array<SellerListMemberInput>;
  name: Scalars['String']['input'];
};

export type MutationSendPlatformTestEmailArgs = {
  input: SendPlatformTestEmailInput;
};

export type MutationSetActiveFilterArgs = {
  filterId: Scalars['ID']['input'];
  perspective: TradePerspective;
  view?: InputMaybe<FilterView>;
};

export type MutationSetBuyerMarginArgs = {
  buyingOrganizationId: Scalars['ID']['input'];
  marginRate: Scalars['Float']['input'];
  platformProductLengthId: Scalars['ID']['input'];
};

export type MutationSetCannedTallyOnBuyListArgs = {
  buyListId: Scalars['ID']['input'];
  cannedTallyId: Scalars['ID']['input'];
  tallyCount: Scalars['Int']['input'];
};

export type MutationSetCartItemBuyCodeArgs = {
  buyCode?: InputMaybe<Scalars['String']['input']>;
  cartId: Scalars['ID']['input'];
  platformProductLengthId: Scalars['ID']['input'];
};

export type MutationSetPlatformProductLengthInventoryOnlyArgs = {
  inventoryOnly: Scalars['Boolean']['input'];
  platformProductLengthId: Scalars['ID']['input'];
};

export type MutationSetPlatformProductPiecesPerBundleArgs = {
  piecesPerBundle: Scalars['Int']['input'];
  platformProductId: Scalars['ID']['input'];
};

export type MutationSetPlatformProductVehicleCapacityArgs = {
  capacity: QuantityInput;
  platformProductId: Scalars['ID']['input'];
  transportVehicleId: Scalars['ID']['input'];
};

export type MutationSetRandomTallyInCartArgs = {
  bundles: Array<RandomTallyBundleInput>;
  locationId: Scalars['ID']['input'];
  parentOrderId?: InputMaybe<Scalars['ID']['input']>;
  platformProductId: Scalars['ID']['input'];
  sellerOrganizationFacilityId: Scalars['ID']['input'];
};

export type MutationSetRandomTallyOnBuyListArgs = {
  bundles: Array<RandomTallyBundleInput>;
  buyListId: Scalars['ID']['input'];
  platformProductId: Scalars['ID']['input'];
};

export type MutationSetSellerProductPriceArgs = {
  input: SellerProductPriceInput;
};

export type MutationSetTenantUserRoleArgs = {
  role: UserRole;
  userId: Scalars['ID']['input'];
};

export type MutationShipOrderArgs = {
  deliveryEndDate?: InputMaybe<Scalars['Instant']['input']>;
  deliveryStartDate: Scalars['Instant']['input'];
  id: Scalars['ID']['input'];
  shippedDate: Scalars['Instant']['input'];
};

export type MutationStartUfpInventoryRunArgs = {
  input: StartUfpInventoryRunInput;
};

export type MutationSubmitQuoteItemEditsArgs = {
  input: SubmitQuoteItemEditsInput;
  quoteId: Scalars['ID']['input'];
};

export type MutationSubmitRequestForQuoteArgs = {
  id: Scalars['ID']['input'];
  sellerInvitations: Array<SellerInvitationInput>;
};

export type MutationSyncOrderWithExternalVendorArgs = {
  id: Scalars['ID']['input'];
};

export type MutationUnassignUserFromLocationArgs = {
  locationId: Scalars['ID']['input'];
};

export type MutationUnhideShippingAddOnArgs = {
  id: Scalars['ID']['input'];
};

export type MutationUpdateBuyListStatusArgs = {
  buyListId: Scalars['ID']['input'];
  status: BuyListStatus;
};

export type MutationUpdateCartArgs = {
  locationId: Scalars['ID']['input'];
  parentOrderId?: InputMaybe<Scalars['ID']['input']>;
  piecesPerBundle?: InputMaybe<Scalars['Int']['input']>;
  platformProductInputFilter: PlatformProductInputFilter;
  quantity?: InputMaybe<QuantityInput>;
  sellerOrganizationFacilityId: Scalars['ID']['input'];
  suggestedPrice?: InputMaybe<Scalars['Float']['input']>;
};

export type MutationUpdateCartDeliveryAddressArgs = {
  cartId: Scalars['ID']['input'];
  deliveryAddress?: InputMaybe<DeliveryAddressInput>;
};

export type MutationUpdateCartTarpArgs = {
  cartId: Scalars['ID']['input'];
  tarp: Scalars['Boolean']['input'];
};

export type MutationUpdateCartTransportArgs = {
  cartId: Scalars['ID']['input'];
  incoTerm: LogisticsIncoterm;
  internationalShipping?: InputMaybe<InternationalShippingInput>;
  transportVehicleId?: InputMaybe<Scalars['ID']['input']>;
};

export type MutationUpdateContactArgs = {
  id: Scalars['ID']['input'];
  input: UpdateContactInput;
};

export type MutationUpdateFilterArgs = {
  filterData: Scalars['JSON']['input'];
  id: Scalars['ID']['input'];
};

export type MutationUpdateMyBuyerCodeArgs = {
  buyerOrganizationId: Scalars['ID']['input'];
  code?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateMySellerCodeArgs = {
  code?: InputMaybe<Scalars['String']['input']>;
  sellerOrganizationId: Scalars['ID']['input'];
};

export type MutationUpdateOrderNotificationEmailsArgs = {
  input: OrderNotificationEmailsInput;
};

export type MutationUpdateOrganizationContactArgs = {
  input: OrganizationContactInput;
  organizationId: Scalars['ID']['input'];
};

export type MutationUpdateProductPreferredUnitFiltersArgs = {
  filters: Array<ProductPreferredUnitFilterInput>;
};

export type MutationUpdatePurchaseOrderNumberArgs = {
  id: Scalars['ID']['input'];
  purchaseOrderNumber: Scalars['String']['input'];
};

export type MutationUpdateShippingAddOnArgs = {
  id: Scalars['ID']['input'];
  input: UpdateShippingAddOnInput;
};

export type MutationUpdateShippingRouteArgs = {
  id: Scalars['ID']['input'];
  input: UpdateShippingRouteInput;
};

export type MutationUpdateTenantUserArgs = {
  input: UpdateTenantUserInput;
  userId: Scalars['ID']['input'];
};

export type MutationUpdateUserPreferencesArgs = {
  preferences: UserPreferenceInput;
};

export type MutationUpsertBuyerInventoryConfigurationArgs = {
  locationId: Scalars['ID']['input'];
  platformProductsLengthId: Scalars['ID']['input'];
  targetWeeksCovered?: InputMaybe<Scalars['Float']['input']>;
  usageRatePerWeek: QuantityInput;
  weeksCoveredBeforeMonitor?: InputMaybe<Scalars['Float']['input']>;
  weeksCoveredBeforeUrgent?: InputMaybe<Scalars['Float']['input']>;
};

export type MutationUpsertFacilityArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  input: FacilityInput;
};

export type MutationUpsertFacilityShippingRatesArgs = {
  facilityId: Scalars['ID']['input'];
  shippingRates: Array<ShippingRateInput>;
};

export type MutationUpsertInventoryArgs = {
  locationId: Scalars['ID']['input'];
  platformProductsLengthId: Scalars['ID']['input'];
  quantity: QuantityInput;
};

export type MutationUpsertLocationArgs = {
  facilityId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  input: LocationInput;
};

export type MutationUpsertProductVehicleCapacityArgs = {
  capacity: QuantityInput;
  platformProductLengthId: Scalars['ID']['input'];
  transportVehicleId: Scalars['ID']['input'];
};

export type MutationUpsertRequestForQuoteArgs = {
  deliveryPriceForTally?: InputMaybe<MoneyInput>;
  leadTimeDays?: InputMaybe<Scalars['Int']['input']>;
  pickupPriceForTally?: InputMaybe<MoneyInput>;
  shippingLocationId?: InputMaybe<Scalars['ID']['input']>;
  tallyPlatformProductId?: InputMaybe<Scalars['ID']['input']>;
  useTallyPrice?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationUpsertSellerInventoryArgs = {
  locationId: Scalars['ID']['input'];
  platformProductsLengthId: Scalars['ID']['input'];
  quantity: QuantityInput;
};

export type MutationUpsertSellerProductConfigurationArgs = {
  facilityId?: InputMaybe<Scalars['ID']['input']>;
  platformProductLengthId: Scalars['ID']['input'];
  scope?: InputMaybe<SellerProductConfigurationScope>;
  sellerProductConfigurationInput: SellerProductConfigurationInput;
};

export type NumberOperatorInput = {
  eq?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  neq?: InputMaybe<Scalars['Float']['input']>;
};

export type Order = {
  __typename?: 'Order';
  awaitingPurchaseOrderNumber: Scalars['Boolean']['output'];
  blockMessages: Array<OrderBlockMessage>;
  buyer: User;
  /** The buyer while still active, else null. */
  buyerContact?: Maybe<User>;
  buyingOrganization: Organization;
  /** True when the viewer's buying organization can choose a primary contact for this placed order: it has no active primary contact or no active recipient. */
  canChoosePrimaryContact: Scalars['Boolean']['output'];
  canManuallySyncWithMsr: Scalars['Boolean']['output'];
  /** False once the order is an MSR purchase order. MSR keeps that PO, so the order can't go back to a draft. */
  canReturnToDraft: Scalars['Boolean']['output'];
  /** True when the viewer is the buyer, the buying organization has the MSR integration and a sync has stored the MSR purchase order, so its PDF is available. */
  canViewMsrPurchaseOrder: Scalars['Boolean']['output'];
  cancellationNote?: Maybe<Scalars['String']['output']>;
  cancelledBy?: Maybe<User>;
  /** The user who confirmed the order. */
  confirmedBy?: Maybe<User>;
  confirmedDate?: Maybe<Scalars['Instant']['output']>;
  createdAt: Scalars['Instant']['output'];
  currency?: Maybe<Currency>;
  /**
   * The buyer's Delivery Address override when set (any viewer); else the
   * sub-order upstream-seller drop-ship channel; else null.
   */
  deliveryAddress?: Maybe<DeliveryAddress>;
  deliveryEndDate?: Maybe<Scalars['Instant']['output']>;
  deliveryMethod?: Maybe<DeliveryMethod>;
  deliveryStartDate?: Maybe<Scalars['Instant']['output']>;
  documents: Array<OrderDocument>;
  dueByDate?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  incoTerm?: Maybe<LogisticsIncoterm>;
  incotermAddressDestination?: Maybe<Scalars['String']['output']>;
  incotermDischarge?: Maybe<LogisticsIncoterm>;
  incotermLoading?: Maybe<LogisticsIncoterm>;
  isBrokered: Scalars['Boolean']['output'];
  isInternational: Scalars['Boolean']['output'];
  items: Array<OrderItem>;
  /** Every field of the order's MSR purchase order, as last fetched. Null for the seller and until the first fetch. */
  msrPurchaseOrder?: Maybe<MsrPurchaseOrder>;
  /** The MSR purchase order emails buyers of the buying organization sent, newest first. Empty unless canViewMsrPurchaseOrder. */
  msrPurchaseOrderEmails: Array<MsrPurchaseOrderEmail>;
  /** The buyer's own MSR purchase order choices from checkout. Null for the seller and when the buyer made none. */
  msrPurchaseOrderInputs?: Maybe<MsrPurchaseOrderInputsView>;
  /** When MSR's purchase order was last fetched. Null until the first fetch. */
  msrSyncedAt?: Maybe<Scalars['Instant']['output']>;
  parentOrder?: Maybe<Order>;
  portOfDischarge?: Maybe<Port>;
  portOfLoading?: Maybe<Port>;
  /** The seller contact the order goes to. Null when none is chosen or the chosen one is no longer an active seller contact. */
  primaryContact?: Maybe<User>;
  /** The MSR purchase order dates. The buyer sets them at checkout. While the order is pending seller confirmation or confirmed, a sync replaces each date MSR sends, when all dates stay in shipping order. */
  promiseDate?: Maybe<Scalars['Date']['output']>;
  purchaseOrderNumber?: Maybe<Scalars['String']['output']>;
  receivedDate?: Maybe<Scalars['Instant']['output']>;
  seller?: Maybe<User>;
  /**
   * Who the buyer contacts about this order. A placed order: its recipients who are active
   * seller contacts, the people the order emails go to; no one when it has none. A draft:
   * the primary contact while still an active seller contact; else the buyer's remembered
   * contacts among the active seller contacts, else all of them. Empty for the selling side.
   */
  sellerContacts: Array<User>;
  sellingOrganization: Organization;
  sellingOrganizationFacility: Facility;
  shipWeekDate?: Maybe<Scalars['Date']['output']>;
  shipments: Array<OrderShipment>;
  /** The user who shipped the order. Null when the auto-ship job shipped it or the shipper is not known. */
  shippedBy?: Maybe<User>;
  shippedDate?: Maybe<Scalars['Instant']['output']>;
  shippingFee?: Maybe<Money>;
  shippingLocation?: Maybe<Location>;
  shippingRoute?: Maybe<ShippingRoute>;
  shippingRouteSnapshot?: Maybe<OrderShippingRouteSnapshot>;
  status: OrderStatus;
  subOrders: Array<Order>;
  tarp: Scalars['Boolean']['output'];
  transportVehicle?: Maybe<TransportVehicle>;
  updatedAt?: Maybe<Scalars['Instant']['output']>;
  viewerPerspective: TradePerspective;
};

export type OrderBlockMessage = {
  __typename?: 'OrderBlockMessage';
  createdAt: Scalars['Instant']['output'];
  id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  processedAt?: Maybe<Scalars['Instant']['output']>;
};

export type OrderDocument = {
  __typename?: 'OrderDocument';
  createdAt: Scalars['Instant']['output'];
  documentType: DocumentType;
  fileSizeBytes: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  mimeType: Scalars['String']['output'];
  organization: Organization;
  originalFilename: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['Instant']['output']>;
  uploadType: UploadType;
};

export type OrderFiltersInput = {
  and?: InputMaybe<Array<OrderFiltersInput>>;
  buyerId?: InputMaybe<Scalars['ID']['input']>;
  buyerOrganization?: InputMaybe<StringOperatorInput>;
  currency?: InputMaybe<CurrencyOperatorInput>;
  deliveryMethod?: InputMaybe<DeliveryMethodOperatorInput>;
  deliveryWindowEnd?: InputMaybe<InstantOperatorInput>;
  deliveryWindowStart?: InputMaybe<InstantOperatorInput>;
  finalDeliveryLocation?: InputMaybe<StringOperatorInput>;
  incoterm?: InputMaybe<LogisticsIncotermOperatorInput>;
  itemCount?: InputMaybe<NumberOperatorInput>;
  not?: InputMaybe<OrderFiltersInput>;
  or?: InputMaybe<Array<OrderFiltersInput>>;
  orderDate?: InputMaybe<InstantOperatorInput>;
  plant?: InputMaybe<StringOperatorInput>;
  product?: InputMaybe<StringOperatorInput>;
  purchaseOrderNumber?: InputMaybe<StringOperatorInput>;
  sellerOrganization?: InputMaybe<StringOperatorInput>;
  shipDate?: InputMaybe<InstantOperatorInput>;
  total?: InputMaybe<NumberOperatorInput>;
};

export type OrderItem = {
  __typename?: 'OrderItem';
  buyCode?: Maybe<Scalars['String']['output']>;
  /**
   * Set only when this line belongs to a real canned-tally recipe. Null for a random-tally
   * line, even though it still sets tallyPlatformProduct to group with its siblings.
   */
  cannedTally?: Maybe<PlatformProductCannedTally>;
  /** Recorded delivery price (non-EXW), null when no pickup/delivery price split is set for this line. */
  deliveryPrice?: Maybe<Money>;
  /** Price per individual piece derived from deliveryPrice; null when no pickup/delivery price split is set or standard unit is PCS. */
  deliveryPricePerPiece?: Maybe<Money>;
  /**
   * Bundle size this line is ordered in: the buyer's per-line override when set, else the size
   * stored at placement, else the product's current size. Zero when none is configured.
   */
  effectivePiecesPerBundle: Scalars['Int']['output'];
  effectivePrice?: Maybe<Money>;
  /** Recorded pickup price (EXW), null when no pickup/delivery price split is set for this line. */
  pickupPrice?: Maybe<Money>;
  /** Price per individual piece derived from pickupPrice; null when no pickup/delivery price split is set or standard unit is PCS. */
  pickupPricePerPiece?: Maybe<Money>;
  /** The buyer's per-line override, or null when the size stored at placement or the product's current size applies. */
  piecesPerBundleOverride?: Maybe<Scalars['Int']['output']>;
  platformProductsLengths: PlatformProductLength;
  price?: Maybe<Money>;
  /** Price per individual piece derived from the order's recorded price (null when standard unit is already PCS). */
  pricePerPiece?: Maybe<Money>;
  quantity: Quantity;
  suggestedPrice?: Maybe<Money>;
  /** Price per individual piece derived from the buyer's suggested price; null when no suggestion exists or standard unit is PCS. */
  suggestedPricePerPiece?: Maybe<Money>;
  tallyPlatformProduct?: Maybe<PlatformProduct>;
};

export type OrderItemQuantityArgs = {
  mode?: InputMaybe<QuantityModeInput>;
};

/**
 * Internal addresses that receive a copy of the order confirmation. Null unless the caller belongs
 * to this organisation. Either field may be null; one address configured is used for both order
 * types.
 */
export type OrderNotificationEmails = {
  __typename?: 'OrderNotificationEmails';
  domestic?: Maybe<Scalars['String']['output']>;
  international?: Maybe<Scalars['String']['output']>;
};

export type OrderNotificationEmailsInput = {
  domestic?: InputMaybe<Scalars['String']['input']>;
  international?: InputMaybe<Scalars['String']['input']>;
};

export type OrderReference = {
  __typename?: 'OrderReference';
  order: Order;
  revision: Scalars['Long']['output'];
};

export type OrderShipment = {
  __typename?: 'OrderShipment';
  deliveryEndDate?: Maybe<Scalars['Instant']['output']>;
  deliveryStartDate?: Maybe<Scalars['Instant']['output']>;
  id: Scalars['ID']['output'];
  incotermAddressDestination?: Maybe<Scalars['String']['output']>;
  items: Array<OrderItem>;
  packingListItems: Array<PackingListItem>;
  portOfDischarge?: Maybe<Port>;
  receivedDate?: Maybe<Scalars['Instant']['output']>;
  shippedDate?: Maybe<Scalars['Instant']['output']>;
  status: OrderStatus;
};

export type OrderShippingRouteSnapshot = {
  __typename?: 'OrderShippingRouteSnapshot';
  additionalCostsPerContainer?: Maybe<Money>;
  additionalCostsPerShipment?: Maybe<Money>;
  createdAt: Scalars['Instant']['output'];
  forwarder?: Maybe<Scalars['String']['output']>;
  forwarderEmail?: Maybe<Scalars['String']['output']>;
  freightCost?: Maybe<Money>;
  gassingCost?: Maybe<Money>;
  id: Scalars['ID']['output'];
  terminalHandlingCharge?: Maybe<Money>;
  transitDays?: Maybe<Scalars['Int']['output']>;
};

export const OrderStatus = {
  Blocked: 'BLOCKED',
  Cancelled: 'CANCELLED',
  Confirmed: 'CONFIRMED',
  Delivered: 'DELIVERED',
  Draft: 'DRAFT',
  PendingSellerConfirmation: 'PENDING_SELLER_CONFIRMATION',
  Shipped: 'SHIPPED',
} as const;

export type OrderStatus = (typeof OrderStatus)[keyof typeof OrderStatus];
export type OrderStatusCount = {
  __typename?: 'OrderStatusCount';
  blocked: Scalars['Int']['output'];
  cancelled: Scalars['Int']['output'];
  confirmed: Scalars['Int']['output'];
  delivered: Scalars['Int']['output'];
  draft: Scalars['Int']['output'];
  pendingSellerConfirmation: Scalars['Int']['output'];
  pendingSellerConfirmationWithReminders: Scalars['Int']['output'];
  shipped: Scalars['Int']['output'];
};

export type Organization = {
  __typename?: 'Organization';
  /** The current seller's own code for this organization as a buyer, or null if not set / the viewer cannot sell. Traders buy and sell. */
  buyingOrganizationCode?: Maybe<Scalars['String']['output']>;
  defaultCurrency: Currency;
  facilities: Array<Facility>;
  faxNumber?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  msrSyncEnabled: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  notificationPreference: Array<User>;
  orderNotificationEmails?: Maybe<OrderNotificationEmails>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  sellerContacts: Array<User>;
  /** The current buyer's own code for this organization as a seller, or null if not set / the viewer cannot buy. Traders buy and sell. */
  sellingOrganizationCode?: Maybe<Scalars['String']['output']>;
  tenantAdmins: Array<User>;
  /** All users of the organization, including contacts. */
  users: Array<User>;
};

export type OrganizationContactInput = {
  faxNumber?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationFilterInput = {
  and?: InputMaybe<Array<OrganizationFilterInput>>;
  name?: InputMaybe<StringOperatorInput>;
  not?: InputMaybe<OrganizationFilterInput>;
  or?: InputMaybe<Array<OrganizationFilterInput>>;
};

export const OutboundEmailStatus = {
  Failed: 'FAILED',
  Pending: 'PENDING',
  Sent: 'SENT',
} as const;

export type OutboundEmailStatus =
  (typeof OutboundEmailStatus)[keyof typeof OutboundEmailStatus];
export const OutboundEmailType = {
  MsrPurchaseOrderSeller: 'MSR_PURCHASE_ORDER_SELLER',
  OrderCancelledBuyer: 'ORDER_CANCELLED_BUYER',
  OrderConfirmedBuyer: 'ORDER_CONFIRMED_BUYER',
  OrderConfirmedInternal: 'ORDER_CONFIRMED_INTERNAL',
  OrderConfirmedLogisticsProvider: 'ORDER_CONFIRMED_LOGISTICS_PROVIDER',
  OrderPlacedBuyer: 'ORDER_PLACED_BUYER',
  OrderPlacedSeller: 'ORDER_PLACED_SELLER',
  PackingListCreatedBuyer: 'PACKING_LIST_CREATED_BUYER',
  PackingListUpdatedBuyer: 'PACKING_LIST_UPDATED_BUYER',
  PlatformTest: 'PLATFORM_TEST',
  PriceNegotiationDeclinedBuyer: 'PRICE_NEGOTIATION_DECLINED_BUYER',
  PriceNegotiationRequestedSeller: 'PRICE_NEGOTIATION_REQUESTED_SELLER',
  QuoteCounteredSeller: 'QUOTE_COUNTERED_SELLER',
  QuoteSellerAnsweredBuyer: 'QUOTE_SELLER_ANSWERED_BUYER',
  RequestForQuoteSeller: 'REQUEST_FOR_QUOTE_SELLER',
  ShipmentReminderSeller: 'SHIPMENT_REMINDER_SELLER',
} as const;

export type OutboundEmailType =
  (typeof OutboundEmailType)[keyof typeof OutboundEmailType];
export type PackItemInput = {
  piecesPerBundleOverride?: InputMaybe<Scalars['Int']['input']>;
  platformProductLengthId: Scalars['ID']['input'];
  price?: InputMaybe<Scalars['Float']['input']>;
  quantity: QuantityInput;
};

export type PackingList = {
  __typename?: 'PackingList';
  createdAt: Scalars['Instant']['output'];
  id: Scalars['ID']['output'];
  items: Array<PackingListItem>;
  notes?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Instant']['output']>;
};

export type PackingListItem = {
  __typename?: 'PackingListItem';
  createdAt: Scalars['Instant']['output'];
  id: Scalars['ID']['output'];
  /**
   * Bundle size this line is packed in, overriding the product default. Null means the product
   * default still applies.
   */
  piecesPerBundleOverride?: Maybe<Scalars['Int']['output']>;
  platformProductsLengths: PlatformProductLength;
  price: Money;
  quantity: Quantity;
  updatedAt?: Maybe<Scalars['Instant']['output']>;
};

export type PackingListItemQuantityArgs = {
  mode?: InputMaybe<QuantityModeInput>;
};

export type PageInput = {
  page: Scalars['Int']['input'];
  size: Scalars['Int']['input'];
};

export type PagedAdditionalItems = {
  __typename?: 'PagedAdditionalItems';
  content: Array<AdditionalItem>;
  paging: Paging;
};

export type PagedAdminJobOutboxEntries = {
  __typename?: 'PagedAdminJobOutboxEntries';
  content: Array<AdminJobOutboxEntry>;
  paging: Paging;
};

export type PagedAdminPlatformProducts = {
  __typename?: 'PagedAdminPlatformProducts';
  content: Array<AdminPlatformProduct>;
  paging: Paging;
};

export type PagedBuyLists = {
  __typename?: 'PagedBuyLists';
  content: Array<BuyList>;
  paging: Paging;
};

export type PagedCannedTallySellerGroup = {
  __typename?: 'PagedCannedTallySellerGroup';
  content: Array<CannedTallySellerGroup>;
  paging: Paging;
};

/**
 * One page of catalog length options. paging.totalElements counts every length matching the search,
 * not just this page.
 */
export type PagedCatalogLengthOptions = {
  __typename?: 'PagedCatalogLengthOptions';
  content: Array<CatalogLengthOption>;
  paging: Paging;
};

export type PagedEmailDeliveryTraces = {
  __typename?: 'PagedEmailDeliveryTraces';
  content: Array<EmailDeliveryTrace>;
  paging: Paging;
};

export type PagedFacilities = {
  __typename?: 'PagedFacilities';
  content: Array<Facility>;
  paging: Paging;
};

export type PagedInventory = {
  __typename?: 'PagedInventory';
  content: Array<Maybe<Inventory>>;
  paging: Paging;
};

export type PagedInventoryPriorityGroups = {
  __typename?: 'PagedInventoryPriorityGroups';
  content: Array<InventoryPriorityGroup>;
  paging: Paging;
};

export type PagedLocations = {
  __typename?: 'PagedLocations';
  content: Array<Location>;
  paging: Paging;
};

export type PagedOrders = {
  __typename?: 'PagedOrders';
  content: Array<Order>;
  paging: Paging;
};

export type PagedOrganizations = {
  __typename?: 'PagedOrganizations';
  content: Array<Organization>;
  paging: Paging;
};

export type PagedPlatformProductLength = {
  __typename?: 'PagedPlatformProductLength';
  content: Array<Maybe<PlatformProductLength>>;
  paging: Paging;
};

export type PagedPriceNegotiations = {
  __typename?: 'PagedPriceNegotiations';
  content: Array<PriceNegotiation>;
  paging: Paging;
};

/**
 * One page of product length options, for pickers that show a slice at a time and filter as the user
 * types. paging.totalElements counts every length matching the search, not just this page.
 */
export type PagedProductLengthOptions = {
  __typename?: 'PagedProductLengthOptions';
  content: Array<ProductLengthOption>;
  paging: Paging;
};

export type PagedQuote = {
  __typename?: 'PagedQuote';
  content: Array<Quote>;
  paging: Paging;
};

export type PagedRequestForQuotes = {
  __typename?: 'PagedRequestForQuotes';
  content: Array<RequestForQuote>;
  paging: Paging;
};

export type PagedSellerProductConfiguration = {
  __typename?: 'PagedSellerProductConfiguration';
  content: Array<Maybe<SellerProductConfiguration>>;
  paging: Paging;
};

export type PagedSellerProductInventoryForBuyer = {
  __typename?: 'PagedSellerProductInventoryForBuyer';
  content: Array<Maybe<SellerProductInventoryForBuyer>>;
  paging: Paging;
  /**
   * Only populated on page 0 (null on later pages). Same value for every page of a given
   * filter set, so cache the page-0 response rather than re-reading this field per page.
   */
  recommendedPrice?: Maybe<Money>;
  /**
   * Only populated on page 0 (0 on later pages). Same value for every page of a given
   * filter set, so cache the page-0 response rather than re-reading this field per page.
   */
  recommendedPriceCount: Scalars['Int']['output'];
  /**
   * Only populated on page 0 (0 on later pages). Same value for every page of a given
   * filter set, so cache the page-0 response rather than re-reading this field per page.
   */
  sellersCount: Scalars['Int']['output'];
};

export type PagedSellerVendorInventoryGroup = {
  __typename?: 'PagedSellerVendorInventoryGroup';
  content: Array<SellerVendorInventoryGroup>;
  paging: Paging;
  /**
   * Always null: no frontend consumer reads this field for the vendor-group query, so the
   * backend no longer computes it. Kept for schema compatibility.
   */
  recommendedPrice?: Maybe<Money>;
  /**
   * Always 0: no frontend consumer reads this field for the vendor-group query, so the
   * backend no longer computes it. Kept for schema compatibility.
   */
  recommendedPriceCount: Scalars['Int']['output'];
  /**
   * Only populated on page 0 (0 on later pages). Same value for every page of a given
   * filter set, so cache the page-0 response rather than re-reading this field per page.
   */
  sellersCount: Scalars['Int']['output'];
};

export type PagedShippingRoutes = {
  __typename?: 'PagedShippingRoutes';
  content: Array<ShippingRoute>;
  paging: Paging;
};

export type PagedUniqueProductWithSellers = {
  __typename?: 'PagedUniqueProductWithSellers';
  content: Array<Maybe<UniqueProductWithSellers>>;
  paging: Paging;
};

export type PaginatedSellerProductInventory = {
  __typename?: 'PaginatedSellerProductInventory';
  content: Array<Maybe<SellerProductInventory>>;
  paging: Paging;
};

export type Paging = {
  __typename?: 'Paging';
  number: Scalars['Int']['output'];
  size: Scalars['Int']['output'];
  totalElements: Scalars['Int']['output'];
  totalElementsIncludingHidden?: Maybe<Scalars['Int']['output']>;
  totalPages: Scalars['Int']['output'];
};

export type PlatformProduct = {
  __typename?: 'PlatformProduct';
  actualLengthInches?: Maybe<Scalars['Float']['output']>;
  actualThicknessInches?: Maybe<Scalars['Float']['output']>;
  actualWidthInches?: Maybe<Scalars['Float']['output']>;
  category: PlatformProductCategory;
  code?: Maybe<Scalars['String']['output']>;
  constructionCode?: Maybe<Scalars['String']['output']>;
  finishCode?: Maybe<Scalars['String']['output']>;
  harmonizedCode?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lengths?: Maybe<Array<Maybe<Length>>>;
  materialCode?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  nominalThicknessInches?: Maybe<Scalars['Float']['output']>;
  nominalWidthInches?: Maybe<Scalars['Float']['output']>;
  piecesPerBundle: Quantity;
  platformProductVehicleCapacities?: Maybe<
    Array<Maybe<PlatformProductVehicleCapacity>>
  >;
  properties?: Maybe<Scalars['JSON']['output']>;
  standardUnitsCode: UnitCode;
  type?: Maybe<Scalars['String']['output']>;
  /** How many of the product's standard units one truckload holds. */
  unitsPerTruckload?: Maybe<Scalars['Float']['output']>;
};

export type PlatformProductCannedTalliesForOrganization = {
  __typename?: 'PlatformProductCannedTalliesForOrganization';
  organizationId: Scalars['ID']['output'];
  tallies: Array<PlatformProductCannedTally>;
};

export type PlatformProductCannedTally = {
  __typename?: 'PlatformProductCannedTally';
  bundles: Array<TallyBundle>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  platformProduct: PlatformProduct;
};

export const PlatformProductCategory = {
  LinealProducts: 'LINEAL_PRODUCTS',
  Lumber: 'LUMBER',
  Panels: 'PANELS',
  Specialty: 'SPECIALTY',
} as const;

export type PlatformProductCategory =
  (typeof PlatformProductCategory)[keyof typeof PlatformProductCategory];
export type PlatformProductCategoryOption = {
  __typename?: 'PlatformProductCategoryOption';
  label: Scalars['String']['output'];
  value: PlatformProductCategory;
};

export const PlatformProductImportAction = {
  Create: 'CREATE',
  Unchanged: 'UNCHANGED',
  Update: 'UPDATE',
} as const;

export type PlatformProductImportAction =
  (typeof PlatformProductImportAction)[keyof typeof PlatformProductImportAction];
export type PlatformProductImportChange = {
  __typename?: 'PlatformProductImportChange';
  action: PlatformProductImportAction;
  addedCapacities: Array<Scalars['String']['output']>;
  addedLengths: Array<Scalars['String']['output']>;
  code: Scalars['String']['output'];
  conflicts: Array<PlatformProductImportConflict>;
  createdFields: Array<PlatformProductImportFieldValue>;
};

export type PlatformProductImportConflict = {
  __typename?: 'PlatformProductImportConflict';
  currentValue: Scalars['String']['output'];
  field: Scalars['String']['output'];
  importedValue: Scalars['String']['output'];
};

export type PlatformProductImportFieldValue = {
  __typename?: 'PlatformProductImportFieldValue';
  field: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type PlatformProductImportInput = {
  fileName: Scalars['String']['input'];
  headers: Array<Scalars['String']['input']>;
  /** Each row's number in the file, counting blank rows, so errors point at the file's rows when blank rows were dropped. Without it, rows are numbered in order from 2. */
  rowNumbers?: InputMaybe<Array<Scalars['Int']['input']>>;
  rows: Array<Array<Scalars['String']['input']>>;
};

export type PlatformProductImportResult = {
  __typename?: 'PlatformProductImportResult';
  fileErrors: Array<Scalars['String']['output']>;
  importId?: Maybe<Scalars['ID']['output']>;
  products: Array<PlatformProductImportChange>;
  rowErrors: Array<PlatformProductImportRowError>;
};

export type PlatformProductImportRowError = {
  __typename?: 'PlatformProductImportRowError';
  code: Scalars['String']['output'];
  messages: Array<Scalars['String']['output']>;
  /** The row's number from rowNumbers when sent, otherwise its position with the header as row 1. */
  rowNumber: Scalars['Int']['output'];
};

export type PlatformProductInputFilter = {
  id: Scalars['ID']['input'];
  tally: Scalars['Boolean']['input'];
};

export type PlatformProductLength = {
  __typename?: 'PlatformProductLength';
  id: Scalars['ID']['output'];
  inventoryOnly?: Maybe<Scalars['Boolean']['output']>;
  isNominal?: Maybe<Scalars['Boolean']['output']>;
  latestPriceMax?: Maybe<Money>;
  latestPriceMid?: Maybe<Money>;
  latestPriceMin?: Maybe<Money>;
  length: Length;
  lengthDisplayValue: Scalars['String']['output'];
  /** The current seller's own org-level price for this length. Null for buyer requests. */
  myPrice?: Maybe<SellerProductPrice>;
  piecesPerBf?: Maybe<Scalars['Float']['output']>;
  piecesPerCbm?: Maybe<Scalars['Float']['output']>;
  piecesPerLf?: Maybe<Scalars['Float']['output']>;
  piecesPerMbf?: Maybe<Scalars['Float']['output']>;
  piecesPerMsf?: Maybe<Scalars['Float']['output']>;
  piecesPerSf?: Maybe<Scalars['Float']['output']>;
  platformProduct: PlatformProduct;
  platformProductVehicleCapacities?: Maybe<
    Array<Maybe<PlatformProductVehicleCapacity>>
  >;
};

export type PlatformProductVehicleCapacity = {
  __typename?: 'PlatformProductVehicleCapacity';
  capacity: Quantity;
  id: Scalars['ID']['output'];
  isOrganizationOverride: Scalars['Boolean']['output'];
  transportVehicle: TransportVehicle;
};

export type Port = {
  __typename?: 'Port';
  active: Scalars['Boolean']['output'];
  city?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Instant']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  type: PortType;
  updatedAt?: Maybe<Scalars['Instant']['output']>;
};

export const PortType = {
  Cy: 'CY',
  Door: 'DOOR',
  Ramp: 'RAMP',
  Seaport: 'SEAPORT',
} as const;

export type PortType = (typeof PortType)[keyof typeof PortType];
export type PriceNegotiation = {
  __typename?: 'PriceNegotiation';
  buyerNote?: Maybe<Scalars['String']['output']>;
  buyingOrganization: Organization;
  createdAt: Scalars['Instant']['output'];
  createdBy: User;
  currentSellerListPrice?: Maybe<Money>;
  id: Scalars['ID']['output'];
  offerCurrency: Currency;
  offeredPrice?: Maybe<Money>;
  platformProductCannedTally?: Maybe<PlatformProductCannedTally>;
  platformProductLength?: Maybe<PlatformProductLength>;
  recipients: Array<User>;
  sellerNote?: Maybe<Scalars['String']['output']>;
  sellingOrganization: Organization;
  status: PriceNegotiationStatus;
  tallyRecipe?: Maybe<Array<PriceNegotiationTallyRecipeLine>>;
  targetPrice?: Maybe<Money>;
  unit: UnitCode;
  updatedAt?: Maybe<Scalars['Instant']['output']>;
};

export const PriceNegotiationStatus = {
  Accepted: 'ACCEPTED',
  Declined: 'DECLINED',
  Pending: 'PENDING',
} as const;

export type PriceNegotiationStatus =
  (typeof PriceNegotiationStatus)[keyof typeof PriceNegotiationStatus];
export type PriceNegotiationStatusCount = {
  __typename?: 'PriceNegotiationStatusCount';
  responded: Scalars['Int']['output'];
  waiting: Scalars['Int']['output'];
};

export type PriceNegotiationTallyRecipeLine = {
  __typename?: 'PriceNegotiationTallyRecipeLine';
  bundleCount: Scalars['Int']['output'];
  lengthLabel: Scalars['String']['output'];
  piecesPerBundle: Scalars['Int']['output'];
};

export type ProductDimension = {
  __typename?: 'ProductDimension';
  nominalThicknessInches?: Maybe<Scalars['Float']['output']>;
  nominalWidthInches?: Maybe<Scalars['Float']['output']>;
};

export type ProductFilterInput = {
  search?: InputMaybe<Scalars['String']['input']>;
};

/**
 * One length a product can be picked on, paired with this product's own PlatformProductLength
 * for that length when one already exists (null when the product hasn't been configured with that
 * length yet).
 */
export type ProductLengthOption = {
  __typename?: 'ProductLengthOption';
  length: Length;
  platformProductLength?: Maybe<PlatformProductLength>;
};

export type ProductPreferredUnitFilter = {
  __typename?: 'ProductPreferredUnitFilter';
  category: PlatformProductCategory;
  unit: UnitCode;
};

export type ProductPreferredUnitFilterInput = {
  category: PlatformProductCategory;
  unit: UnitCode;
};

export type ProductProperty = {
  __typename?: 'ProductProperty';
  code?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type ProductPropertyKey = {
  __typename?: 'ProductPropertyKey';
  description?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  isArray: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
};

export type ProductPropertyKeyWithValues = {
  __typename?: 'ProductPropertyKeyWithValues';
  description?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  isArray: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  values: Array<ProductPropertyValue>;
};

export type ProductPropertyValue = {
  __typename?: 'ProductPropertyValue';
  displayValue: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type PropertyFilterInput = {
  key: Scalars['String']['input'];
  operator: StringOperatorInput;
};

export type Quantity = {
  __typename?: 'Quantity';
  unit: UnitCode;
  value: Scalars['Float']['output'];
};

export type QuantityInput = {
  unit: UnitCode;
  value: Scalars['Float']['input'];
};

export type QuantityModeInput = {
  mode: QuantityUnitMode;
  unit?: InputMaybe<UnitCode>;
};

export const QuantityUnitMode = {
  Specific: 'SPECIFIC',
  Standard: 'STANDARD',
  Stored: 'STORED',
  UserPreferred: 'USER_PREFERRED',
} as const;

export type QuantityUnitMode =
  (typeof QuantityUnitMode)[keyof typeof QuantityUnitMode];
export type Query = {
  __typename?: 'Query';
  acceptedPriceNegotiations: Array<PriceNegotiation>;
  additionalProductsFromSeller: PagedAdditionalItems;
  adminSearchPlatformProducts: PagedAdminPlatformProducts;
  allUniqueProductInventoryLocationsForBuyer: Array<Location>;
  availableProducts: PagedSellerProductConfiguration;
  /** A single buy list, readable by any buyer in the owning location's organization. */
  buyList: BuyList;
  /** Active locations across the caller's organization, ordered by code. Feeds the buy list location picker. */
  buyListLocations: Array<Location>;
  buyListProducts: Array<PlatformProduct>;
  /** Requests for quote sent from a buy list, newest first. */
  buyListRequestForQuotes: PagedRequestForQuotes;
  /** Buyers in the caller's organization, excluding deactivated ones, ordered by last then first name. */
  buyListTeamCandidates: Array<BuyListTeamCandidate>;
  buyerInventoriesByProductAndLocation: Array<Maybe<Inventory>>;
  buyerInventory: PagedInventory;
  buyerInventoryByProductAndLocation?: Maybe<Inventory>;
  buyerInventoryGroupLocations: Array<InventoryGroupLocation>;
  buyerInventoryPriorityGroups: PagedInventoryPriorityGroups;
  buyerMargins: Array<SellerProductBuyerMargin>;
  buyerNegotiatedPrices: Array<BuyerNegotiatedPrice>;
  buyerOrdersCount: OrderStatusCount;
  buyerOrdersWithChats?: Maybe<Array<Order>>;
  buyerPriceNegotiationCounts: PriceNegotiationStatusCount;
  buyerPriceNegotiations: PagedPriceNegotiations;
  buyerProductInventory: Inventory;
  calculateShipDates: ShipDateCalculation;
  /**
   * Paged, searchable form of cannedTallyLengthsForCategory, ordered by actual length ascending.
   * search matches a length's display aliases and its actual inches, case-insensitively; null or
   * blank means no filter, so the picker can list every candidate before the user types.
   */
  cannedTallyCandidateLengths: PagedProductLengthOptions;
  cannedTallyLengthsForCategory: Array<ProductLengthOption>;
  cannedTallySellerGroupsForBuyer: PagedCannedTallySellerGroup;
  cart?: Maybe<Cart>;
  carts?: Maybe<Array<Cart>>;
  /** Lengths a buyer can add a catalog product on: the product's own purchasable lengths, shortest first. */
  catalogLengths: PagedCatalogLengthOptions;
  chats?: Maybe<Array<Chat>>;
  currentUser: User;
  draftRequestForQuote?: Maybe<RequestForQuote>;
  dutyCost?: Maybe<DutyCost>;
  dutyCostByHts?: Maybe<DutyCost>;
  dutyCosts: Array<DutyCost>;
  emailDeliveryTraces: PagedEmailDeliveryTraces;
  extractedDocument?: Maybe<ExtractedDocument>;
  failedJobOutboxEntries: PagedAdminJobOutboxEntries;
  featureFlags: Array<FeatureFlag>;
  findAvailableUniqueProductsWithSellers: PagedUniqueProductWithSellers;
  lengths?: Maybe<Array<Length>>;
  linkedOrganizationUsers: Array<User>;
  locations?: Maybe<Array<Location>>;
  logisticsIncoterms: Array<LogisticsIncoterm>;
  /** Pass the cart's incotermDischarge for an international order. */
  msrIncoTerms: Array<MsrIncoTermOption>;
  /** Unit types MSR accepts for the transport vehicle's ship via, the vehicle's default first. */
  msrUnitTypes: Array<MsrUnitType>;
  /** Products on the caller's own buy lists of every status, ordered by code. Feeds the My lists product filter. */
  myBuyListProducts: Array<PlatformProduct>;
  /** The caller's own buy lists, earliest expected ship date first. Only OPEN lists unless match names a status anywhere in its tree. */
  myBuyLists: PagedBuyLists;
  myBuyers: Array<TradingPartner>;
  myQuotes: PagedQuote;
  /** The products, sellers and creators found on the caller's organization's sent requests for quote, to filter myRequestForQuotes by. */
  myRequestForQuoteFilterOptions: RequestForQuoteFilterOptions;
  /** The caller's own organization's sent requests for quote, newest first. needsResponse splits them into pending (no seller has responded yet) and quoted (every other sent request). Archived requests are left out unless archived includes them or asks for them only; filters narrows the rest. */
  myRequestForQuotes: PagedRequestForQuotes;
  mySellerLists: Array<SellerList>;
  mySellers: Array<TradingPartner>;
  order?: Maybe<Order>;
  orderDocumentPresignedUrl: Scalars['String']['output'];
  orders: PagedOrders;
  organization?: Maybe<Organization>;
  organizationFacilities: Array<Facility>;
  organizationFacilitiesPage: PagedFacilities;
  organizationLocationsPage: PagedLocations;
  organizations: PagedOrganizations;
  organizationsByIds: Array<Organization>;
  packingList?: Maybe<PackingList>;
  pendingPriceNegotiations: Array<PriceNegotiation>;
  platformProduct?: Maybe<PlatformProduct>;
  platformProductCannedTallies: Array<PlatformProductCannedTally>;
  platformProductCannedTalliesByOrganizationIds: Array<PlatformProductCannedTalliesForOrganization>;
  platformProductCategories: Array<PlatformProductCategoryOption>;
  platformProductDimensions: Array<ProductDimension>;
  platformProducts?: Maybe<Array<PlatformProduct>>;
  platformProductsLengthsForProduct?: Maybe<Array<PlatformProductLength>>;
  port?: Maybe<Port>;
  ports: Array<Port>;
  productPropertyKeys: Array<ProductPropertyKey>;
  productPropertyKeysWithValues: Array<ProductPropertyKeyWithValues>;
  productPropertyValues: Array<ProductPropertyValue>;
  quote?: Maybe<Quote>;
  quoteComments: Array<QuoteComment>;
  quotesForRequestForQuote: Array<Quote>;
  requestForQuote?: Maybe<RequestForQuote>;
  requestForQuotes: Array<RequestForQuote>;
  resolveAddress?: Maybe<ResolvedAddress>;
  reverseGeocode?: Maybe<ResolvedAddress>;
  /** All catalog products with the current seller's org-level price, for the Pricing tab. */
  sellerCatalogPrices: PagedPlatformProductLength;
  sellerImportColumnMappings: Array<SellerImportColumnMapping>;
  sellerInventoryProductLengthsByPlatformProduct?: Maybe<
    Array<PlatformProductLength>
  >;
  sellerLowStockProducts: Array<SellerProductConfiguration>;
  sellerOrdersCount: OrderStatusCount;
  sellerOrdersWithChats?: Maybe<Array<Order>>;
  sellerPriceNegotiation: PriceNegotiation;
  sellerPriceNegotiationCounts: PriceNegotiationStatusCount;
  sellerPriceNegotiations: PagedPriceNegotiations;
  sellerProduct?: Maybe<SellerProductConfiguration>;
  sellerProductInventories: PaginatedSellerProductInventory;
  sellerProductInventoriesForBuyer: PagedSellerProductInventoryForBuyer;
  sellerProductInventory?: Maybe<SellerProductInventory>;
  sellerVendorInventoryGroupsForBuyer: PagedSellerVendorInventoryGroup;
  shippingAddOn?: Maybe<ShippingAddOn>;
  shippingAddOnCategories: Array<Scalars['String']['output']>;
  shippingAddOns: Array<ShippingAddOn>;
  shippingCost?: Maybe<ShippingCost>;
  shippingRates: Array<ShippingRate>;
  shippingRoute?: Maybe<ShippingRoute>;
  shippingRouteCategories: Array<Scalars['String']['output']>;
  shippingRoutes: PagedShippingRoutes;
  shippingSoon: Array<Order>;
  suggestAddresses: Array<AddressSuggestion>;
  /** Buy lists belonging to other buyers in the owning location's organization, earliest expected ship date first. Only OPEN lists unless filter.match names a status anywhere in its tree. */
  teamBuyLists: PagedBuyLists;
  tradingPartnerOrganizationsForBuyer: PagedOrganizations;
  transportVehicle?: Maybe<TransportVehicle>;
  transportVehicles: Array<TransportVehicle>;
  ufpInventoryRun?: Maybe<UfpInventoryRun>;
  /** A short-lived link that downloads the response exactly as UFP sent it. */
  ufpInventoryRunRawResponseUrl: Scalars['String']['output'];
  ufpInventoryRunResult: UfpInventoryRunResult;
  uniqueLocationsWithInventory: Array<Location>;
  units: Array<Unit>;
  userFilters: Array<UserFilter>;
  userPreferences: UserPreferences;
  users?: Maybe<Array<User>>;
};

export type QueryAcceptedPriceNegotiationsArgs = {
  platformProductId: Scalars['ID']['input'];
};

export type QueryAdditionalProductsFromSellerArgs = {
  orderId: Scalars['ID']['input'];
  pageInput: PageInput;
};

export type QueryAdminSearchPlatformProductsArgs = {
  pageInput: PageInput;
  search: Scalars['String']['input'];
};

export type QueryAvailableProductsArgs = {
  pageInput: PageInput;
};

export type QueryBuyListArgs = {
  id: Scalars['ID']['input'];
};

export type QueryBuyListRequestForQuotesArgs = {
  buyListId: Scalars['ID']['input'];
  pageInput: PageInput;
};

export type QueryBuyerInventoriesByProductAndLocationArgs = {
  lengthIds: Array<Scalars['ID']['input']>;
  locationId: Scalars['ID']['input'];
  platformProductId: Scalars['ID']['input'];
};

export type QueryBuyerInventoryArgs = {
  filters?: InputMaybe<BuyerInventoryFiltersInput>;
  includeInventoryLengths?: InputMaybe<Scalars['Boolean']['input']>;
  pageInput: PageInput;
  sort?: InputMaybe<Array<SortInput>>;
};

export type QueryBuyerInventoryByProductAndLocationArgs = {
  lengthId: Scalars['ID']['input'];
  locationId: Scalars['ID']['input'];
  platformProductId: Scalars['ID']['input'];
};

export type QueryBuyerInventoryGroupLocationsArgs = {
  facilityId: Scalars['ID']['input'];
  platformProductsLengthId: Scalars['ID']['input'];
};

export type QueryBuyerInventoryPriorityGroupsArgs = {
  filters?: InputMaybe<BuyerInventoryFiltersInput>;
  includeInventoryLengths?: InputMaybe<Scalars['Boolean']['input']>;
  pageInput: PageInput;
  sort?: InputMaybe<Array<SortInput>>;
};

export type QueryBuyerMarginsArgs = {
  platformProductLengthId: Scalars['ID']['input'];
};

export type QueryBuyerNegotiatedPricesArgs = {
  platformProductLengthId: Scalars['ID']['input'];
};

export type QueryBuyerPriceNegotiationsArgs = {
  pageInput: PageInput;
  status?: InputMaybe<Array<PriceNegotiationStatus>>;
};

export type QueryBuyerProductInventoryArgs = {
  id: Scalars['ID']['input'];
};

export type QueryCalculateShipDatesArgs = {
  orderId: Scalars['ID']['input'];
};

export type QueryCannedTallyCandidateLengthsArgs = {
  pageInput: PageInput;
  platformProductId: Scalars['ID']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};

export type QueryCannedTallyLengthsForCategoryArgs = {
  platformProductId: Scalars['ID']['input'];
};

export type QueryCannedTallySellerGroupsForBuyerArgs = {
  comparisonFilters?: InputMaybe<SellerComparisonFiltersInput>;
  filter?: InputMaybe<CannedTallySellerGroupFilterInput>;
  pageInput: PageInput;
  platformProductId: Scalars['ID']['input'];
  sort?: InputMaybe<Array<SortInput>>;
  tallyName?: InputMaybe<Scalars['String']['input']>;
  transportVehicleId: Scalars['ID']['input'];
};

export type QueryCartArgs = {
  id: Scalars['ID']['input'];
};

export type QueryCartsArgs = {
  filter?: InputMaybe<CartFilterInput>;
};

export type QueryCatalogLengthsArgs = {
  pageInput: PageInput;
  platformProductId: Scalars['ID']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};

export type QueryChatsArgs = {
  orderId: Scalars['ID']['input'];
};

export type QueryDraftRequestForQuoteArgs = {
  shippingLocationId: Scalars['ID']['input'];
  tallyPlatformProductId: Scalars['ID']['input'];
};

export type QueryDutyCostArgs = {
  id: Scalars['ID']['input'];
};

export type QueryDutyCostByHtsArgs = {
  htsNumber: Scalars['String']['input'];
};

export type QueryDutyCostsArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryEmailDeliveryTracesArgs = {
  filter?: InputMaybe<EmailDeliveryTraceFilter>;
  pageInput: PageInput;
};

export type QueryExtractedDocumentArgs = {
  id: Scalars['ID']['input'];
};

export type QueryFailedJobOutboxEntriesArgs = {
  pageInput: PageInput;
};

export type QueryFindAvailableUniqueProductsWithSellersArgs = {
  filters?: InputMaybe<UniqueProductFiltersInput>;
  pageInput: PageInput;
};

export type QueryMsrIncoTermsArgs = {
  incoTerm: LogisticsIncoterm;
  incotermDischarge?: InputMaybe<LogisticsIncoterm>;
};

export type QueryMsrUnitTypesArgs = {
  transportVehicleId: Scalars['ID']['input'];
};

export type QueryMyBuyListsArgs = {
  match?: InputMaybe<BuyListMatchInput>;
  pageInput: PageInput;
  sort?: InputMaybe<Array<SortInput>>;
};

export type QueryMyQuotesArgs = {
  needsResponse?: InputMaybe<Scalars['Boolean']['input']>;
  pageInput: PageInput;
  sort?: InputMaybe<Array<SortInput>>;
};

export type QueryMyRequestForQuotesArgs = {
  archived?: InputMaybe<RequestForQuoteArchivedFilter>;
  filters?: InputMaybe<RequestForQuoteFiltersInput>;
  needsResponse?: InputMaybe<Scalars['Boolean']['input']>;
  pageInput: PageInput;
};

export type QueryOrderArgs = {
  id: Scalars['ID']['input'];
};

export type QueryOrderDocumentPresignedUrlArgs = {
  id: Scalars['ID']['input'];
};

export type QueryOrdersArgs = {
  filters?: InputMaybe<OrderFiltersInput>;
  pageInput: PageInput;
  perspective: TradePerspective;
  status?: InputMaybe<OrderStatus>;
};

export type QueryOrganizationArgs = {
  id: Scalars['ID']['input'];
};

export type QueryOrganizationFacilitiesPageArgs = {
  filters?: InputMaybe<FacilityFiltersInput>;
  pageInput: PageInput;
};

export type QueryOrganizationLocationsPageArgs = {
  filters?: InputMaybe<LocationFiltersInput>;
  pageInput: PageInput;
};

export type QueryOrganizationsArgs = {
  filter?: InputMaybe<OrganizationFilterInput>;
  pageInput: PageInput;
};

export type QueryOrganizationsByIdsArgs = {
  ids: Array<Scalars['ID']['input']>;
};

export type QueryPackingListArgs = {
  orderId: Scalars['ID']['input'];
};

export type QueryPendingPriceNegotiationsArgs = {
  platformProductId: Scalars['ID']['input'];
};

export type QueryPlatformProductArgs = {
  id: Scalars['ID']['input'];
};

export type QueryPlatformProductCannedTalliesArgs = {
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  platformProductId: Scalars['ID']['input'];
  transportVehicleId: Scalars['ID']['input'];
};

export type QueryPlatformProductCannedTalliesByOrganizationIdsArgs = {
  organizationIds: Array<Scalars['ID']['input']>;
  platformProductId: Scalars['ID']['input'];
  transportVehicleId: Scalars['ID']['input'];
};

export type QueryPlatformProductsArgs = {
  filter?: InputMaybe<ProductFilterInput>;
};

export type QueryPlatformProductsLengthsForProductArgs = {
  platformProductId: Scalars['ID']['input'];
};

export type QueryPortArgs = {
  id: Scalars['ID']['input'];
};

export type QueryPortsArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<PortType>;
};

export type QueryProductPropertyKeysArgs = {
  category: PlatformProductCategory;
};

export type QueryProductPropertyKeysWithValuesArgs = {
  category: PlatformProductCategory;
};

export type QueryProductPropertyValuesArgs = {
  category: PlatformProductCategory;
  key: Scalars['String']['input'];
};

export type QueryQuoteArgs = {
  id: Scalars['ID']['input'];
};

export type QueryQuoteCommentsArgs = {
  quoteId: Scalars['ID']['input'];
};

export type QueryQuotesForRequestForQuoteArgs = {
  requestForQuoteId: Scalars['ID']['input'];
};

export type QueryRequestForQuoteArgs = {
  id: Scalars['ID']['input'];
};

export type QueryResolveAddressArgs = {
  text: Scalars['String']['input'];
};

export type QueryReverseGeocodeArgs = {
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
};

export type QuerySellerCatalogPricesArgs = {
  filters?: InputMaybe<SellerCatalogPriceFiltersInput>;
  pageInput: PageInput;
};

export type QuerySellerInventoryProductLengthsByPlatformProductArgs = {
  platformProductId: Scalars['ID']['input'];
};

export type QuerySellerPriceNegotiationArgs = {
  id: Scalars['ID']['input'];
};

export type QuerySellerPriceNegotiationCountsArgs = {
  assignedToMe?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QuerySellerPriceNegotiationsArgs = {
  assignedToMe?: InputMaybe<Scalars['Boolean']['input']>;
  pageInput: PageInput;
  status?: InputMaybe<Array<PriceNegotiationStatus>>;
};

export type QuerySellerProductArgs = {
  id: Scalars['ID']['input'];
};

export type QuerySellerProductInventoriesArgs = {
  filters?: InputMaybe<SellerProductFiltersInput>;
  pageInput: PageInput;
};

export type QuerySellerProductInventoriesForBuyerArgs = {
  comparisonFilters?: InputMaybe<SellerComparisonFiltersInput>;
  filter?: InputMaybe<SellerInventoryForBuyerFilterInput>;
  pageInput: PageInput;
  sort?: InputMaybe<Array<SortInput>>;
};

export type QuerySellerProductInventoryArgs = {
  id: Scalars['ID']['input'];
};

export type QuerySellerVendorInventoryGroupsForBuyerArgs = {
  comparisonFilters?: InputMaybe<SellerComparisonFiltersInput>;
  filter?: InputMaybe<SellerInventoryForBuyerFilterInput>;
  pageInput: PageInput;
  sort?: InputMaybe<Array<SortInput>>;
};

export type QueryShippingAddOnArgs = {
  id: Scalars['ID']['input'];
};

export type QueryShippingAddOnsArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryShippingCostArgs = {
  cartId: Scalars['ID']['input'];
};

export type QueryShippingRouteArgs = {
  id: Scalars['ID']['input'];
};

export type QueryShippingRoutesArgs = {
  filter?: InputMaybe<ShippingRouteFilterInput>;
  pageInput: PageInput;
  sort?: InputMaybe<Array<SortInput>>;
};

export type QueryShippingSoonArgs = {
  daysAhead?: InputMaybe<Scalars['Int']['input']>;
};

export type QuerySuggestAddressesArgs = {
  query: Scalars['String']['input'];
};

export type QueryTeamBuyListsArgs = {
  filter?: InputMaybe<BuyListFilterInput>;
  pageInput: PageInput;
  sort?: InputMaybe<Array<SortInput>>;
};

export type QueryTradingPartnerOrganizationsForBuyerArgs = {
  excludeOrganizationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  filter?: InputMaybe<OrganizationFilterInput>;
  onlyOrganizationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  pageInput: PageInput;
};

export type QueryTransportVehicleArgs = {
  id: Scalars['ID']['input'];
};

export type QueryUfpInventoryRunArgs = {
  id: Scalars['ID']['input'];
};

export type QueryUfpInventoryRunRawResponseUrlArgs = {
  id: Scalars['ID']['input'];
};

export type QueryUfpInventoryRunResultArgs = {
  id: Scalars['ID']['input'];
};

export type QueryUserFiltersArgs = {
  perspective: TradePerspective;
};

export type QueryUsersArgs = {
  filter?: InputMaybe<UserFilterInput>;
};

export type Quote = {
  __typename?: 'Quote';
  accepted: Scalars['Boolean']['output'];
  createdAt: Scalars['Instant']['output'];
  currency?: Maybe<Currency>;
  id: Scalars['ID']['output'];
  items: Array<QuoteItem>;
  leadTimeDays?: Maybe<Scalars['Int']['output']>;
  /** The recipients who acted on this quote. The buyer cannot remove them. Empty for viewers outside the buying organization. */
  lockedRecipientIds: Array<Scalars['ID']['output']>;
  needsSellerResponse: Scalars['Boolean']['output'];
  /** The party whose answer the quote waits for; a draft awaits its seller. Null once the negotiation is over. */
  negotiationAwaitingParty?: Maybe<QuoteRoundParty>;
  offeredDeliveryPriceForTally?: Maybe<Money>;
  offeredPickupPriceForTally?: Maybe<Money>;
  order?: Maybe<Order>;
  /** The seller contact the order from this quote goes to. Null when none is chosen or the chosen one is no longer an active seller contact. Required before the quote is ordered. */
  primaryContact?: Maybe<User>;
  /** The named seller contacts who are still active seller contacts, who are the people the quote emails go to. Empty for viewers outside the buying organization. */
  recipients: Array<User>;
  requestForQuote: RequestForQuote;
  /** Every offer, counter-offer and decline on this quote, oldest first. */
  rounds: Array<QuoteRound>;
  sellingOrganization: Organization;
  sellingOrganizationFacility?: Maybe<Facility>;
  status: QuoteStatus;
  submittedAt?: Maybe<Scalars['Instant']['output']>;
  updatedAt?: Maybe<Scalars['Instant']['output']>;
};

export type QuoteComment = {
  __typename?: 'QuoteComment';
  authorName: Scalars['String']['output'];
  authorOrganization: Organization;
  body: Scalars['String']['output'];
  createdAt: Scalars['Instant']['output'];
  id: Scalars['ID']['output'];
};

export type QuoteItem = {
  __typename?: 'QuoteItem';
  id: Scalars['ID']['output'];
  offeredDeliveryPrice?: Maybe<Money>;
  offeredPickupPrice?: Maybe<Money>;
  order?: Maybe<Order>;
  piecesPerBundle?: Maybe<Scalars['Int']['output']>;
  platformProductsLength: PlatformProductLength;
  quantityInPieces: Scalars['Long']['output'];
  status: QuoteItemStatus;
};

export type QuoteItemOverrideInput = {
  offeredDeliveryPrice?: InputMaybe<MoneyInput>;
  offeredPickupPrice?: InputMaybe<MoneyInput>;
  piecesPerBundle?: InputMaybe<Scalars['Int']['input']>;
  platformProductLengthId: Scalars['ID']['input'];
  quantityInBundles: Scalars['Long']['input'];
  quoteItemId?: InputMaybe<Scalars['ID']['input']>;
};

export const QuoteItemStatus = {
  NeedsProcessing: 'NEEDS_PROCESSING',
  ReadyToShip: 'READY_TO_SHIP',
} as const;

export type QuoteItemStatus =
  (typeof QuoteItemStatus)[keyof typeof QuoteItemStatus];
/** One recorded offer, counter-offer or decline on a quote. */
export type QuoteRound = {
  __typename?: 'QuoteRound';
  /** Empty when the author's user record is gone. */
  authorName: Scalars['String']['output'];
  createdAt: Scalars['Instant']['output'];
  declineReason?: Maybe<Scalars['String']['output']>;
  declined: Scalars['Boolean']['output'];
  deliveryPriceForTally?: Maybe<Money>;
  items: Array<QuoteRoundItem>;
  leadTimeDays?: Maybe<Scalars['Int']['output']>;
  party: QuoteRoundParty;
  pickupPriceForTally?: Maybe<Money>;
  roundNumber: Scalars['Int']['output'];
};

export type QuoteRoundItem = {
  __typename?: 'QuoteRoundItem';
  deliveryPrice?: Maybe<Money>;
  pickupPrice?: Maybe<Money>;
  /** The bundle size the round's line was offered in. Null when the round did not record one. */
  piecesPerBundle?: Maybe<Scalars['Int']['output']>;
  platformProductsLength: PlatformProductLength;
  quantityInPieces: Scalars['Long']['output'];
};

export const QuoteRoundParty = {
  Buyer: 'BUYER',
  Seller: 'SELLER',
} as const;

export type QuoteRoundParty =
  (typeof QuoteRoundParty)[keyof typeof QuoteRoundParty];
export const QuoteStatus = {
  Accepted: 'ACCEPTED',
  /** The buyer stopped waiting for this seller. No one can act on the quote any more. */
  Archived: 'ARCHIVED',
  Declined: 'DECLINED',
  InProgress: 'IN_PROGRESS',
  PartiallyAccepted: 'PARTIALLY_ACCEPTED',
  Submitted: 'SUBMITTED',
} as const;

export type QuoteStatus = (typeof QuoteStatus)[keyof typeof QuoteStatus];
export type QuoteTallyPriceEditInput = {
  currency: Currency;
  offeredDeliveryPriceForTally?: InputMaybe<MoneyInput>;
  offeredPickupPriceForTally?: InputMaybe<MoneyInput>;
  useTallyPrice: Scalars['Boolean']['input'];
};

export type RandomBuyListTally = BuyListTally & {
  __typename?: 'RandomBuyListTally';
  /** The buyer's bundles. */
  bundles: Array<BuyListTallyBundle>;
  id: Scalars['ID']['output'];
  platformProduct: PlatformProduct;
  quantity: Quantity;
};

export type RandomBuyListTallyQuantityArgs = {
  mode?: InputMaybe<QuantityModeInput>;
};

export type RandomTallyBundleInput = {
  bundleCount: Scalars['Int']['input'];
  lengthId: Scalars['ID']['input'];
};

export type RemoveTradingPartnersFromProductComparisonInput = {
  organizationIds: Array<Scalars['ID']['input']>;
  platformProductId?: InputMaybe<Scalars['ID']['input']>;
  platformProductLengthIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type RequestForQuote = {
  __typename?: 'RequestForQuote';
  /** The buy list this request was built from, or null when it came from the order builder. */
  buyList?: Maybe<BuyList>;
  buyingOrganization: Organization;
  /** The canned tally the request is for. Null for a random tally or for items. */
  cannedTally?: Maybe<PlatformProductCannedTally>;
  /** How many of the canned tally the request is for. Null without a canned tally. */
  cannedTallyCount?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['Instant']['output'];
  /** The buyer who raised this request, visible to the buying side and any seller whose organization quoted it. Null for requests created before this was recorded, for other viewers, and once the buyer is disabled. */
  createdByUser?: Maybe<User>;
  /** The buyer's display name, readable by any seller, even once the buyer is disabled. */
  createdByUserName?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Currency>;
  deliveryPriceForTally?: Maybe<Money>;
  /** True when the request uses its tally price, or every item has its own price. */
  fullyPriced: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  items: Array<RequestForQuoteItem>;
  leadTimeDays?: Maybe<Scalars['Int']['output']>;
  pickupPriceForTally?: Maybe<Money>;
  /** One quote request per invited selling organization. */
  quotes: Array<Quote>;
  shippingLocation?: Maybe<Location>;
  status: RequestForQuoteStatus;
  tallyPlatformProduct?: Maybe<PlatformProduct>;
  /** The transport vehicle from this request's buy list. Null for a request raised in the order builder. */
  transportVehicle?: Maybe<TransportVehicle>;
  updatedAt?: Maybe<Scalars['Instant']['output']>;
  useTallyPrice: Scalars['Boolean']['output'];
};

export const RequestForQuoteArchivedFilter = {
  Include: 'INCLUDE',
  Only: 'ONLY',
} as const;

export type RequestForQuoteArchivedFilter =
  (typeof RequestForQuoteArchivedFilter)[keyof typeof RequestForQuoteArchivedFilter];
export type RequestForQuoteCreatorOption = {
  __typename?: 'RequestForQuoteCreatorOption';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type RequestForQuoteFilterOptions = {
  __typename?: 'RequestForQuoteFilterOptions';
  /** Users who created the requests for quote. */
  creators: Array<RequestForQuoteCreatorOption>;
  /** Whether the organization has any archived requests for quote. */
  hasArchivedRequests: Scalars['Boolean']['output'];
  /** Whether the organization has any sent requests for quote. */
  hasSentRequests: Scalars['Boolean']['output'];
  /** Products requested on the requests for quote. */
  products: Array<PlatformProduct>;
  /** Sellers that the requests for quote were sent to. */
  sellers: Array<Organization>;
};

export type RequestForQuoteFiltersInput = {
  and?: InputMaybe<Array<RequestForQuoteFiltersInput>>;
  createdByUserIds?: InputMaybe<IdCollectionOperatorInput>;
  hasAcceptedQuote?: InputMaybe<Scalars['Boolean']['input']>;
  hasArchivedQuote?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<RequestForQuoteFiltersInput>;
  or?: InputMaybe<Array<RequestForQuoteFiltersInput>>;
  platformProductIds?: InputMaybe<IdCollectionOperatorInput>;
  sellingOrganizationIds?: InputMaybe<IdCollectionOperatorInput>;
};

export type RequestForQuoteItem = {
  __typename?: 'RequestForQuoteItem';
  deliveryPrice?: Maybe<Money>;
  /** The buyer's bundle size when set, else the product default. Zero when neither is configured. */
  effectivePiecesPerBundle: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  pickupPrice?: Maybe<Money>;
  piecesPerBundle?: Maybe<Scalars['Int']['output']>;
  platformProductsLength: PlatformProductLength;
  quantityInPieces: Scalars['Long']['output'];
};

export type RequestForQuoteItemInput = {
  deliveryPrice?: InputMaybe<MoneyInput>;
  numberOfBundles?: InputMaybe<Scalars['Long']['input']>;
  pickupPrice?: InputMaybe<MoneyInput>;
  piecesPerBundle?: InputMaybe<Scalars['Int']['input']>;
  platformProductLengthId: Scalars['ID']['input'];
  quantityInPieces?: InputMaybe<Scalars['Long']['input']>;
};

export const RequestForQuoteStatus = {
  AllQuotesDeclined: 'ALL_QUOTES_DECLINED',
  AllQuotesReceived: 'ALL_QUOTES_RECEIVED',
  /** The buyer closed the request. Unanswered quotes are archived and answered ones are frozen. */
  Archived: 'ARCHIVED',
  Fulfilled: 'FULFILLED',
  InProgress: 'IN_PROGRESS',
  PartialQuotesReceived: 'PARTIAL_QUOTES_RECEIVED',
  PendingSellerResponse: 'PENDING_SELLER_RESPONSE',
} as const;

export type RequestForQuoteStatus =
  (typeof RequestForQuoteStatus)[keyof typeof RequestForQuoteStatus];
export type ResolvedAddress = {
  __typename?: 'ResolvedAddress';
  addressLine1?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type RespondToPriceNegotiationInput = {
  offeredPrice: Scalars['Float']['input'];
  sellerNote?: InputMaybe<Scalars['String']['input']>;
};

export const SecondOpinion = {
  Agrees: 'AGREES',
  Disagrees: 'DISAGREES',
  Unavailable: 'UNAVAILABLE',
  Unsure: 'UNSURE',
} as const;

export type SecondOpinion = (typeof SecondOpinion)[keyof typeof SecondOpinion];
export type SellerCatalogPriceFiltersInput = {
  and?: InputMaybe<Array<SellerCatalogPriceFiltersInput>>;
  category?: InputMaybe<StringOperatorInput>;
  length?: InputMaybe<StringOperatorInput>;
  nominalThicknessInches?: InputMaybe<NumberOperatorInput>;
  nominalWidthInches?: InputMaybe<NumberOperatorInput>;
  not?: InputMaybe<SellerCatalogPriceFiltersInput>;
  or?: InputMaybe<Array<SellerCatalogPriceFiltersInput>>;
  productCode?: InputMaybe<StringOperatorInput>;
  productName?: InputMaybe<StringOperatorInput>;
  properties?: InputMaybe<Array<PropertyFilterInput>>;
};

export type SellerComparisonFiltersInput = {
  and?: InputMaybe<Array<SellerComparisonFiltersInput>>;
  not?: InputMaybe<SellerComparisonFiltersInput>;
  or?: InputMaybe<Array<SellerComparisonFiltersInput>>;
  sellerName?: InputMaybe<StringOperatorInput>;
};

/**
 * An organization's remembered mapping of source headers to target fields for a file shape,
 * keyed by headerSignature (an order-independent, case-insensitive digest of the file's headers).
 */
export type SellerImportColumnMapping = {
  __typename?: 'SellerImportColumnMapping';
  headerSignature: Scalars['String']['output'];
  mapping: Scalars['JSON']['output'];
};

export type SellerImportResult = {
  __typename?: 'SellerImportResult';
  failed: Array<SellerImportRowError>;
  imported: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type SellerImportRowError = {
  __typename?: 'SellerImportRowError';
  messages: Array<Scalars['String']['output']>;
  rowId: Scalars['Int']['output'];
};

export type SellerImportRowInput = {
  criticalStockLevel?: InputMaybe<QuantityInput>;
  leadTimeDays?: InputMaybe<Scalars['Int']['input']>;
  lengthInches: Scalars['Float']['input'];
  locationCode: Scalars['String']['input'];
  lowStockLevel?: InputMaybe<QuantityInput>;
  minimumOrderQuantity?: InputMaybe<QuantityInput>;
  platformProductId: Scalars['ID']['input'];
  replenishmentRatePerWeek?: InputMaybe<QuantityInput>;
  rowId: Scalars['Int']['input'];
  stock?: InputMaybe<QuantityInput>;
  unit?: InputMaybe<UnitCode>;
};

export type SellerInventoryForBuyerFilterInput = {
  deliveryMode?: InputMaybe<DeliveryMode>;
  destinationLocationId?: InputMaybe<Scalars['ID']['input']>;
  facilityId?: InputMaybe<Scalars['ID']['input']>;
  includeInventoryLengths?: InputMaybe<Scalars['Boolean']['input']>;
  platformProductId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * Lengths to restrict the comparison to. Null and empty both mean "every length" — the buyer's
   * unfiltered view sends an empty list — so this cannot express "no lengths". At most 200 ids.
   */
  platformProductLengthIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  sellerOrganizationId?: InputMaybe<Scalars['ID']['input']>;
};

/** Invites a selling organization. An empty recipientUserIds invites the organization without notifying anyone. Recipients who are not active seller contacts of the organization are left out. */
export type SellerInvitationInput = {
  /** Optional. Contact-based invitations leave it null. */
  facilityId?: InputMaybe<Scalars['ID']['input']>;
  recipientUserIds: Array<Scalars['ID']['input']>;
  sellingOrganizationId: Scalars['ID']['input'];
};

/** A buyer user's private, named set of trading partners, applied when requesting quotes or adding sellers in the order builder. */
export type SellerList = {
  __typename?: 'SellerList';
  id: Scalars['ID']['output'];
  /** Members that are still trading partners of the owner's organization. */
  members: Array<SellerListMember>;
  name: Scalars['String']['output'];
};

export type SellerListMember = {
  __typename?: 'SellerListMember';
  /** Saved contacts that are still seller contacts of the seller. Empty means use defaults on apply. */
  contacts: Array<User>;
  seller: Organization;
};

export type SellerListMemberInput = {
  /** Ids that are not current seller contacts of this seller are ignored. */
  contactUserIds: Array<Scalars['ID']['input']>;
  sellingOrganizationId: Scalars['ID']['input'];
  /** Removes all saved contacts of this seller so the seller's defaults apply. Must be false when contactUserIds is not empty. */
  useDefaultContacts: Scalars['Boolean']['input'];
};

export type SellerProductBuyerMargin = {
  __typename?: 'SellerProductBuyerMargin';
  buyingOrganization: Organization;
  id: Scalars['ID']['output'];
  marginRate: Scalars['Float']['output'];
  pricePerUnit?: Maybe<Money>;
};

export type SellerProductConfiguration = {
  __typename?: 'SellerProductConfiguration';
  criticalStockLevel: Quantity;
  facility?: Maybe<Facility>;
  health?: Maybe<InventoryStockHealth>;
  id: Scalars['ID']['output'];
  internalNotes?: Maybe<Scalars['String']['output']>;
  landedUnitPrice: UnitPrice;
  lowStockLevel: Quantity;
  minimumOrderQuantity: Quantity;
  organization: Organization;
  platformProductLength: PlatformProductLength;
  price?: Maybe<SellerProductPrice>;
  readyToShipDays: Scalars['Int']['output'];
  replenishmentRatePerWeek: Quantity;
  scope: SellerProductConfigurationScope;
  status?: Maybe<SellerProductStatus>;
  unit: UnitCode;
};

export type SellerProductConfigurationCriticalStockLevelArgs = {
  mode?: InputMaybe<QuantityModeInput>;
};

export type SellerProductConfigurationLowStockLevelArgs = {
  mode?: InputMaybe<QuantityModeInput>;
};

export type SellerProductConfigurationMinimumOrderQuantityArgs = {
  mode?: InputMaybe<QuantityModeInput>;
};

export type SellerProductConfigurationReplenishmentRatePerWeekArgs = {
  mode?: InputMaybe<QuantityModeInput>;
};

export type SellerProductConfigurationInput = {
  criticalStockLevel?: InputMaybe<QuantityInput>;
  internalNotes?: InputMaybe<Scalars['String']['input']>;
  lowStockLevel?: InputMaybe<QuantityInput>;
  minimumOrderQuantity?: InputMaybe<QuantityInput>;
  readyToShipDays?: InputMaybe<Scalars['Int']['input']>;
  replenishmentRatePerWeek: QuantityInput;
  status?: InputMaybe<SellerProductStatus>;
  unit?: InputMaybe<UnitCode>;
};

export const SellerProductConfigurationScope = {
  Facility: 'FACILITY',
  Organization: 'ORGANIZATION',
} as const;

export type SellerProductConfigurationScope =
  (typeof SellerProductConfigurationScope)[keyof typeof SellerProductConfigurationScope];
export type SellerProductFiltersInput = {
  and?: InputMaybe<Array<SellerProductFiltersInput>>;
  category?: InputMaybe<StringOperatorInput>;
  length?: InputMaybe<StringOperatorInput>;
  locationId?: InputMaybe<IdOperatorInput>;
  nominalThicknessInches?: InputMaybe<NumberOperatorInput>;
  nominalWidthInches?: InputMaybe<NumberOperatorInput>;
  not?: InputMaybe<SellerProductFiltersInput>;
  or?: InputMaybe<Array<SellerProductFiltersInput>>;
  pricePerUnit?: InputMaybe<NumberOperatorInput>;
  productCode?: InputMaybe<StringOperatorInput>;
  productName?: InputMaybe<StringOperatorInput>;
  properties?: InputMaybe<Array<PropertyFilterInput>>;
  readyToShipDays?: InputMaybe<NumberOperatorInput>;
  replenishmentRatePerWeek?: InputMaybe<NumberOperatorInput>;
  status?: InputMaybe<InventoryStockHealthOperatorInput>;
  stock?: InputMaybe<NumberOperatorInput>;
  visibility?: InputMaybe<StringOperatorInput>;
};

export type SellerProductInventory = {
  __typename?: 'SellerProductInventory';
  id: Scalars['ID']['output'];
  location: Location;
  organization: Organization;
  platformProductsLength: PlatformProductLength;
  quantity: Quantity;
  sellerProductConfiguration?: Maybe<SellerProductConfiguration>;
  unitPrice?: Maybe<UnitPrice>;
};

export type SellerProductInventoryQuantityArgs = {
  mode?: InputMaybe<QuantityModeInput>;
};

export type SellerProductInventoryForBuyer = {
  __typename?: 'SellerProductInventoryForBuyer';
  deliveredShippingRate?: Maybe<Money>;
  facility: Facility;
  id: Scalars['ID']['output'];
  pickupShippingRate?: Maybe<Money>;
  platformProductsLength: PlatformProductLength;
  quantity?: Maybe<Quantity>;
  sellerProductConfiguration?: Maybe<SellerProductConfiguration>;
  unitPrice?: Maybe<UnitPrice>;
  unitPriceBreakdown?: Maybe<UnitPriceBreakdown>;
};

export type SellerProductInventoryForBuyerDeliveredShippingRateArgs = {
  destinationLocationId?: InputMaybe<Scalars['ID']['input']>;
};

export type SellerProductInventoryForBuyerPickupShippingRateArgs = {
  destinationLocationId?: InputMaybe<Scalars['ID']['input']>;
};

export type SellerProductInventoryForBuyerQuantityArgs = {
  mode?: InputMaybe<QuantityModeInput>;
};

export type SellerProductPrice = {
  __typename?: 'SellerProductPrice';
  currencyCode: Currency;
  id: Scalars['ID']['output'];
  margin?: Maybe<Scalars['Float']['output']>;
  materialCost?: Maybe<Money>;
  organization: Organization;
  platformProductLength: PlatformProductLength;
  pricePerPiece?: Maybe<Money>;
  pricePerUnit?: Maybe<Money>;
  unit: UnitCode;
};

export type SellerProductPriceInput = {
  clearPrice?: InputMaybe<Scalars['Boolean']['input']>;
  currencyCode?: InputMaybe<Currency>;
  margin?: InputMaybe<Scalars['Float']['input']>;
  materialCost?: InputMaybe<Scalars['Float']['input']>;
  platformProductLengthId: Scalars['ID']['input'];
  unit?: InputMaybe<UnitCode>;
};

export const SellerProductStatus = {
  Inactive: 'INACTIVE',
  VisibleToBuyers: 'VISIBLE_TO_BUYERS',
  VisibleToMyBuyers: 'VISIBLE_TO_MY_BUYERS',
} as const;

export type SellerProductStatus =
  (typeof SellerProductStatus)[keyof typeof SellerProductStatus];
export type SellerVendorInventoryGroup = {
  __typename?: 'SellerVendorInventoryGroup';
  facilityCount: Scalars['Int']['output'];
  /**
   * True when at least one facility in this group has a price, even if priceRange is null because
   * the group's facilities disagree on currency.
   */
  hasPricedFacility: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  minReadyToShipDays?: Maybe<Scalars['Int']['output']>;
  organization: Organization;
  platformProductsLength: PlatformProductLength;
  priceRange?: Maybe<MoneyRange>;
  totalStock?: Maybe<Quantity>;
};

export type SendPlatformTestEmailInput = {
  recipient: Scalars['String']['input'];
};

export type ShipDateCalculation = {
  __typename?: 'ShipDateCalculation';
  deliveryEndDate?: Maybe<Scalars['Instant']['output']>;
  deliveryStartDate?: Maybe<Scalars['Instant']['output']>;
  shippedDate?: Maybe<Scalars['Instant']['output']>;
};

export type ShippingAddOn = {
  __typename?: 'ShippingAddOn';
  active: Scalars['Boolean']['output'];
  billingUnit: AddOnBillingUnit;
  category: Scalars['String']['output'];
  cost: Scalars['Float']['output'];
  createdAt?: Maybe<Scalars['Instant']['output']>;
  currency: Currency;
  description?: Maybe<Scalars['String']['output']>;
  hidden: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isPlatformCustomization: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  organizationId?: Maybe<Scalars['ID']['output']>;
  updatedAt?: Maybe<Scalars['Instant']['output']>;
};

export type ShippingCost = {
  __typename?: 'ShippingCost';
  cartId: Scalars['ID']['output'];
  deliveryCost?: Maybe<Money>;
  pickupCost?: Maybe<Money>;
};

export type ShippingRate = {
  __typename?: 'ShippingRate';
  distanceInMileMax?: Maybe<Scalars['Int']['output']>;
  distanceInMileMin: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  shippingDaysMax: Scalars['Int']['output'];
  shippingDaysMin: Scalars['Int']['output'];
  zone: Scalars['String']['output'];
};

export type ShippingRateInput = {
  rateCurrency: Currency;
  ratePerMbf?: InputMaybe<Scalars['Float']['input']>;
  shippingRateId: Scalars['ID']['input'];
};

export type ShippingRoute = {
  __typename?: 'ShippingRoute';
  addOns: Array<ShippingAddOn>;
  additionalCostsPerContainer?: Maybe<Money>;
  additionalCostsPerShipment?: Maybe<Money>;
  category?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Instant']['output']>;
  destinationDelivery?: Maybe<Port>;
  expirationDate?: Maybe<Scalars['Instant']['output']>;
  forwarder?: Maybe<Scalars['String']['output']>;
  forwarderEmail?: Maybe<Scalars['String']['output']>;
  freeDays?: Maybe<Scalars['Int']['output']>;
  freightCost?: Maybe<Money>;
  gassingCost?: Maybe<Money>;
  hasForwarderContact: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  incotermDischarge?: Maybe<LogisticsIncoterm>;
  incotermLoading?: Maybe<LogisticsIncoterm>;
  notes?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['ID']['output']>;
  originDelivery?: Maybe<Port>;
  portOfDischarge: Port;
  portOfLoading: Port;
  requestedByUser?: Maybe<User>;
  status: ShippingRouteStatus;
  terminalHandlingCharge?: Maybe<Money>;
  transitDays?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['Instant']['output']>;
};

export type ShippingRouteFilterInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  incotermDischarge?: InputMaybe<LogisticsIncoterm>;
  incotermLoading?: InputMaybe<LogisticsIncoterm>;
  organizationOnly?: InputMaybe<Scalars['Boolean']['input']>;
  portOfDischargeId?: InputMaybe<Scalars['ID']['input']>;
  portOfLoadingId?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<ShippingRouteStatus>;
};

export const ShippingRouteStatus = {
  Active: 'ACTIVE',
  Inactive: 'INACTIVE',
  Requested: 'REQUESTED',
  RequestDenied: 'REQUEST_DENIED',
} as const;

export type ShippingRouteStatus =
  (typeof ShippingRouteStatus)[keyof typeof ShippingRouteStatus];
export type SkippedOrderItem = {
  __typename?: 'SkippedOrderItem';
  productName: Scalars['String']['output'];
  reason: CopyToCartSkipReason;
  /** How many canned tallies. Null for a random tally and for a plain line. */
  tallyCount?: Maybe<Scalars['Int']['output']>;
  /** Set when the skipped line is a buy list tally. */
  tallyKind?: Maybe<BuyListTallyKind>;
  /** The canned tally's name. Null for a random tally and for a plain line. */
  tallyName?: Maybe<Scalars['String']['output']>;
};

export const SortDirection = {
  Asc: 'ASC',
  Desc: 'DESC',
} as const;

export type SortDirection = (typeof SortDirection)[keyof typeof SortDirection];
export type SortInput = {
  direction?: InputMaybe<SortDirection>;
  field: Scalars['String']['input'];
};

export const SourceFormat = {
  Eml: 'EML',
  Pdf: 'PDF',
  Xlsx: 'XLSX',
} as const;

export type SourceFormat = (typeof SourceFormat)[keyof typeof SourceFormat];
export const SourceRepresentation = {
  EmailLines: 'EMAIL_LINES',
  PdfCoordinates: 'PDF_COORDINATES',
  PdfTable: 'PDF_TABLE',
  SpreadsheetCells: 'SPREADSHEET_CELLS',
} as const;

export type SourceRepresentation =
  (typeof SourceRepresentation)[keyof typeof SourceRepresentation];
export type StartUfpInventoryRunInput = {
  apiVersion: Scalars['Int']['input'];
  branchCodes: Array<Scalars['String']['input']>;
  weeksToLookBack: Scalars['Int']['input'];
};

export type StringOperatorInput = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  neq?: InputMaybe<Scalars['String']['input']>;
  notContain?: InputMaybe<Scalars['String']['input']>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type SubmitQuoteItemEditsInput = {
  itemOverrides: Array<QuoteItemOverrideInput>;
  leadTimeDays: Scalars['Int']['input'];
  sellingOrganizationFacilityId?: InputMaybe<Scalars['ID']['input']>;
  submit: Scalars['Boolean']['input'];
  tallyPrice: QuoteTallyPriceEditInput;
};

export type TallyBundle = {
  __typename?: 'TallyBundle';
  bundleCount: Scalars['Int']['output'];
  platformProductsLength: PlatformProductLength;
};

export const TradePerspective = {
  Buying: 'BUYING',
  Selling: 'SELLING',
} as const;

export type TradePerspective =
  (typeof TradePerspective)[keyof typeof TradePerspective];
export type TradingPartner = {
  __typename?: 'TradingPartner';
  buyingOrganizationCode?: Maybe<Scalars['String']['output']>;
  organizationId: Scalars['ID']['output'];
  organizationName: Scalars['String']['output'];
  sellingOrganizationCode?: Maybe<Scalars['String']['output']>;
};

export type TransportVehicle = {
  __typename?: 'TransportVehicle';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  vehicleType: VehicleType;
};

export const UfpInventoryItemOutcome = {
  AmbiguousBlankLength: 'AMBIGUOUS_BLANK_LENGTH',
  Matched: 'MATCHED',
  UnknownLength: 'UNKNOWN_LENGTH',
  UnknownProduct: 'UNKNOWN_PRODUCT',
  UnparseableLength: 'UNPARSEABLE_LENGTH',
  WouldCreateLength: 'WOULD_CREATE_LENGTH',
} as const;

export type UfpInventoryItemOutcome =
  (typeof UfpInventoryItemOutcome)[keyof typeof UfpInventoryItemOutcome];
export type UfpInventoryRun = {
  __typename?: 'UfpInventoryRun';
  apiVersion: Scalars['Int']['output'];
  branchCodes: Array<Scalars['String']['output']>;
  failureDetail?: Maybe<Scalars['String']['output']>;
  finishedAt?: Maybe<Scalars['Instant']['output']>;
  id: Scalars['ID']['output'];
  queuedAt: Scalars['Instant']['output'];
  startedAt?: Maybe<Scalars['Instant']['output']>;
  status: UfpInventoryRunStatus;
  ufpHttpStatus?: Maybe<Scalars['Int']['output']>;
  weeksToLookBack: Scalars['Int']['output'];
};

export type UfpInventoryRunItem = {
  __typename?: 'UfpInventoryRunItem';
  availablePcs?: Maybe<Scalars['Float']['output']>;
  avgWeeklyUsagePcs?: Maybe<Scalars['Float']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  inboundPcs?: Maybe<Scalars['Float']['output']>;
  length?: Maybe<Scalars['String']['output']>;
  lengthName?: Maybe<Scalars['String']['output']>;
  onOrderPcs?: Maybe<Scalars['Float']['output']>;
  outcome: UfpInventoryItemOutcome;
  platformProductLengthId?: Maybe<Scalars['ID']['output']>;
  productCode?: Maybe<Scalars['String']['output']>;
  productName?: Maybe<Scalars['String']['output']>;
  requestedPcs?: Maybe<Scalars['Float']['output']>;
};

export type UfpInventoryRunLocation = {
  __typename?: 'UfpInventoryRunLocation';
  asOfTimestampUtc?: Maybe<Scalars['String']['output']>;
  branchCode?: Maybe<Scalars['String']['output']>;
  items: Array<UfpInventoryRunItem>;
  locationCode?: Maybe<Scalars['String']['output']>;
  matchedLocations: Array<UfpInventoryRunMatchedLocation>;
};

export type UfpInventoryRunMatchedLocation = {
  __typename?: 'UfpInventoryRunMatchedLocation';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  organizationName: Scalars['String']['output'];
};

export type UfpInventoryRunResult = {
  __typename?: 'UfpInventoryRunResult';
  /** Null when UFP answered successfully with something other than a list of locations. */
  locations?: Maybe<Array<UfpInventoryRunLocation>>;
};

export const UfpInventoryRunStatus = {
  Failed: 'FAILED',
  Queued: 'QUEUED',
  Running: 'RUNNING',
  Succeeded: 'SUCCEEDED',
} as const;

export type UfpInventoryRunStatus =
  (typeof UfpInventoryRunStatus)[keyof typeof UfpInventoryRunStatus];
export type UniqueProductFiltersInput = {
  and?: InputMaybe<Array<UniqueProductFiltersInput>>;
  category?: InputMaybe<StringOperatorInput>;
  locationId?: InputMaybe<IdOperatorInput>;
  name?: InputMaybe<StringOperatorInput>;
  nominalThicknessInches?: InputMaybe<NumberOperatorInput>;
  nominalWidthInches?: InputMaybe<NumberOperatorInput>;
  not?: InputMaybe<UniqueProductFiltersInput>;
  or?: InputMaybe<Array<UniqueProductFiltersInput>>;
  properties?: InputMaybe<Array<PropertyFilterInput>>;
  stockLevel?: InputMaybe<NumberOperatorInput>;
  type?: InputMaybe<StringOperatorInput>;
};

export type UniqueProductWithSellers = {
  __typename?: 'UniqueProductWithSellers';
  id: Scalars['ID']['output'];
  landedPriceRange?: Maybe<MoneyRange>;
  lengths?: Maybe<Array<Maybe<Length>>>;
  marketAvailability?: Maybe<MarketAvailability>;
  platformProduct: PlatformProduct;
};

export type Unit = {
  __typename?: 'Unit';
  category: Scalars['String']['output'];
  code: Scalars['String']['output'];
  factorToCbm?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
};

export const UnitCode = {
  Bf: 'BF',
  Cbm: 'CBM',
  Lf: 'LF',
  Mbf: 'MBF',
  Msf: 'MSF',
  Pcs: 'PCS',
  Sf: 'SF',
  Tallies: 'TALLIES',
} as const;

export type UnitCode = (typeof UnitCode)[keyof typeof UnitCode];
export type UnitPrice = {
  __typename?: 'UnitPrice';
  price?: Maybe<Money>;
  unit: UnitCode;
};

export type UnitPriceBreakdown = {
  __typename?: 'UnitPriceBreakdown';
  addOns?: Maybe<Money>;
  domesticFreight?: Maybe<Money>;
  duties?: Maybe<Money>;
  logisticsAvailable: Scalars['Boolean']['output'];
  oceanFreight?: Maybe<Money>;
  productCost?: Maybe<Money>;
  total?: Maybe<Money>;
  unit: UnitCode;
};

export const UnitStatus = {
  Failed: 'FAILED',
  Inferring: 'INFERRING',
  Pending: 'PENDING',
  Short: 'SHORT',
  Verified: 'VERIFIED',
} as const;

export type UnitStatus = (typeof UnitStatus)[keyof typeof UnitStatus];
export type UpdateContactInput = {
  email: Scalars['String']['input'];
  employeeId?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  role: UserRole;
};

export type UpdateShippingAddOnInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  billingUnit?: InputMaybe<AddOnBillingUnit>;
  category?: InputMaybe<Scalars['String']['input']>;
  cost?: InputMaybe<MoneyInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateShippingRouteInput = {
  addOnIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  additionalCostsPerContainer?: InputMaybe<MoneyInput>;
  additionalCostsPerShipment?: InputMaybe<MoneyInput>;
  category?: InputMaybe<Scalars['String']['input']>;
  expirationDate?: InputMaybe<Scalars['Instant']['input']>;
  forwarder?: InputMaybe<Scalars['String']['input']>;
  forwarderEmail?: InputMaybe<Scalars['String']['input']>;
  freeDays?: InputMaybe<Scalars['Int']['input']>;
  freightCost?: InputMaybe<MoneyInput>;
  gassingCost?: InputMaybe<MoneyInput>;
  incotermDischarge?: InputMaybe<LogisticsIncoterm>;
  incotermLoading?: InputMaybe<LogisticsIncoterm>;
  notes?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ShippingRouteStatus>;
  terminalHandlingCharge?: InputMaybe<MoneyInput>;
  transitDays?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateTenantUserInput = {
  employeeId?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export const UploadType = {
  BuyerUpload: 'BUYER_UPLOAD',
  SellerUpload: 'SELLER_UPLOAD',
} as const;

export type UploadType = (typeof UploadType)[keyof typeof UploadType];
export type User = {
  __typename?: 'User';
  employeeId?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastEditedAt?: Maybe<Scalars['Instant']['output']>;
  lastEditedBy?: Maybe<User>;
  lastName: Scalars['String']['output'];
  locations?: Maybe<Array<Location>>;
  organization?: Maybe<Organization>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  role: UserRole;
  status: UserStatus;
};

export type UserFilter = {
  __typename?: 'UserFilter';
  createdAt: Scalars['Instant']['output'];
  filterData: Scalars['JSON']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['Instant']['output']>;
};

export type UserFilterInput = {
  externalId?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<UserRole>;
};

export type UserPreferenceFilter = {
  __typename?: 'UserPreferenceFilter';
  connector?: Maybe<Scalars['String']['output']>;
  field: Scalars['String']['output'];
  operator: FilterOperator;
  value: Scalars['String']['output'];
};

export type UserPreferenceFilterInput = {
  connector?: InputMaybe<Scalars['String']['input']>;
  field: Scalars['String']['input'];
  operator: FilterOperator;
  value: Scalars['String']['input'];
};

export type UserPreferenceInput = {
  buyListFilter?: InputMaybe<Scalars['JSON']['input']>;
  buyListTeamMemberIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  buyerAnonymousFilter?: InputMaybe<Scalars['JSON']['input']>;
  buyerComparisonAnonymousFilter?: InputMaybe<Scalars['JSON']['input']>;
  buyerInventoryColumnOrder?: InputMaybe<Array<Scalars['String']['input']>>;
  buyerInventoryFilters?: InputMaybe<Array<UserPreferenceFilterInput>>;
  buyerInventoryGroupedColumnOrder?: InputMaybe<
    Array<Scalars['String']['input']>
  >;
  buyerInventorySelectedBranchCode?: InputMaybe<Scalars['String']['input']>;
  buyerInventorySelectedLocationId?: InputMaybe<Scalars['String']['input']>;
  buyerOrdersAnonymousFilter?: InputMaybe<Scalars['JSON']['input']>;
  buyerRequestForQuotesAnonymousFilter?: InputMaybe<Scalars['JSON']['input']>;
  category?: InputMaybe<PlatformProductCategory>;
  myBuyListFilter?: InputMaybe<Scalars['JSON']['input']>;
  pricesAndAvailabilityColumnOrder?: InputMaybe<
    Array<Scalars['String']['input']>
  >;
  pricesAndAvailabilityGroupedColumnOrder?: InputMaybe<
    Array<Scalars['String']['input']>
  >;
  productPreferredUnitFilters?: InputMaybe<
    Array<ProductPreferredUnitFilterInput>
  >;
  randomTallyUseTallyPrice?: InputMaybe<Scalars['Boolean']['input']>;
  sellerAnonymousFilter?: InputMaybe<Scalars['JSON']['input']>;
  sellerInventoryColumnOrder?: InputMaybe<Array<Scalars['String']['input']>>;
  sellerOrdersAnonymousFilter?: InputMaybe<Scalars['JSON']['input']>;
  sellerPricingAnonymousFilter?: InputMaybe<Scalars['JSON']['input']>;
  sellerPricingColumnOrder?: InputMaybe<Array<Scalars['String']['input']>>;
  sellerProductFilters?: InputMaybe<Array<UserPreferenceFilterInput>>;
  sellerProductSelectedLocationId?: InputMaybe<Scalars['String']['input']>;
};

export type UserPreferences = {
  __typename?: 'UserPreferences';
  buyListFilter?: Maybe<Scalars['JSON']['output']>;
  buyListTeamMemberIds?: Maybe<Array<Scalars['ID']['output']>>;
  buyerActiveFilterId?: Maybe<Scalars['ID']['output']>;
  buyerAnonymousFilter?: Maybe<Scalars['JSON']['output']>;
  buyerBuyListsActiveFilterId?: Maybe<Scalars['ID']['output']>;
  buyerComparisonActiveFilterId?: Maybe<Scalars['ID']['output']>;
  buyerComparisonAnonymousFilter?: Maybe<Scalars['JSON']['output']>;
  buyerInventoryColumnOrder?: Maybe<Array<Scalars['String']['output']>>;
  buyerInventoryFilters?: Maybe<Array<UserPreferenceFilter>>;
  buyerInventoryGroupedColumnOrder?: Maybe<Array<Scalars['String']['output']>>;
  buyerInventorySelectedBranchCode?: Maybe<Scalars['String']['output']>;
  buyerInventorySelectedLocationId?: Maybe<Scalars['String']['output']>;
  buyerOrdersActiveFilterId?: Maybe<Scalars['ID']['output']>;
  buyerOrdersAnonymousFilter?: Maybe<Scalars['JSON']['output']>;
  buyerRequestForQuotesActiveFilterId?: Maybe<Scalars['ID']['output']>;
  buyerRequestForQuotesAnonymousFilter?: Maybe<Scalars['JSON']['output']>;
  category?: Maybe<PlatformProductCategory>;
  myBuyListFilter?: Maybe<Scalars['JSON']['output']>;
  myBuyListsActiveFilterId?: Maybe<Scalars['ID']['output']>;
  pricesAndAvailabilityColumnOrder?: Maybe<Array<Scalars['String']['output']>>;
  pricesAndAvailabilityGroupedColumnOrder?: Maybe<
    Array<Scalars['String']['output']>
  >;
  productPreferredUnitFilters?: Maybe<Array<ProductPreferredUnitFilter>>;
  randomTallyUseTallyPrice?: Maybe<Scalars['Boolean']['output']>;
  sellerActiveFilterId?: Maybe<Scalars['ID']['output']>;
  sellerAnonymousFilter?: Maybe<Scalars['JSON']['output']>;
  sellerInventoryColumnOrder?: Maybe<Array<Scalars['String']['output']>>;
  sellerOrdersActiveFilterId?: Maybe<Scalars['ID']['output']>;
  sellerOrdersAnonymousFilter?: Maybe<Scalars['JSON']['output']>;
  sellerPricingActiveFilterId?: Maybe<Scalars['ID']['output']>;
  sellerPricingAnonymousFilter?: Maybe<Scalars['JSON']['output']>;
  sellerPricingColumnOrder?: Maybe<Array<Scalars['String']['output']>>;
  sellerProductFilters?: Maybe<Array<UserPreferenceFilter>>;
  sellerProductSelectedLocationId?: Maybe<Scalars['String']['output']>;
};

export const UserRole = {
  Buyer: 'BUYER',
  PlatformAdmin: 'PLATFORM_ADMIN',
  Seller: 'SELLER',
  TenantAdmin: 'TENANT_ADMIN',
  Trader: 'TRADER',
} as const;

export type UserRole = (typeof UserRole)[keyof typeof UserRole];
export const UserStatus = {
  Active: 'ACTIVE',
  ContactOnly: 'CONTACT_ONLY',
  Disabled: 'DISABLED',
  Invited: 'INVITED',
} as const;

export type UserStatus = (typeof UserStatus)[keyof typeof UserStatus];
export const VehicleType = {
  DomesticRail: 'DOMESTIC_RAIL',
  DomesticTruck: 'DOMESTIC_TRUCK',
  InternationalContainer: 'INTERNATIONAL_CONTAINER',
} as const;

export type VehicleType = (typeof VehicleType)[keyof typeof VehicleType];
export type CurrentUserQueryVariables = Exact<{ [key: string]: never }>;

export type CurrentUserQuery = {
  __typename?: 'Query';
  currentUser: {
    __typename?: 'User';
    externalId?: string | null;
    firstName: string;
    id: string;
    lastName: string;
    role: UserRole;
    locations?: Array<{
      __typename?: 'Location';
      id: string;
      code: string;
      name: string;
      branchCode?: string | null;
      facility: {
        __typename?: 'Facility';
        id: string;
        code?: string | null;
        address: {
          __typename?: 'Address';
          addressLine1: string;
          addressLine2?: string | null;
          city: string;
          region?: string | null;
          zipCode?: string | null;
          country: string;
        };
        transportVehicles: Array<{
          __typename?: 'TransportVehicle';
          id: string;
          name: string;
          vehicleType: VehicleType;
        }>;
      };
    }> | null;
    organization?: {
      __typename?: 'Organization';
      id: string;
      name: string;
      defaultCurrency: Currency;
      orderNotificationEmails?: {
        __typename?: 'OrderNotificationEmails';
        domestic?: string | null;
        international?: string | null;
      } | null;
    } | null;
  };
};

export type GetUserPreferencesQueryVariables = Exact<{ [key: string]: never }>;

export type GetUserPreferencesQuery = {
  __typename?: 'Query';
  userPreferences: {
    __typename?: 'UserPreferences';
    category?: PlatformProductCategory | null;
    buyerInventorySelectedLocationId?: string | null;
    buyerInventorySelectedBranchCode?: string | null;
    sellerProductSelectedLocationId?: string | null;
    buyerInventoryColumnOrder?: Array<string> | null;
    buyerInventoryGroupedColumnOrder?: Array<string> | null;
    sellerInventoryColumnOrder?: Array<string> | null;
    sellerPricingColumnOrder?: Array<string> | null;
    pricesAndAvailabilityColumnOrder?: Array<string> | null;
    pricesAndAvailabilityGroupedColumnOrder?: Array<string> | null;
    buyerActiveFilterId?: string | null;
    sellerActiveFilterId?: string | null;
    buyerAnonymousFilter?: Record<string, unknown> | null;
    sellerAnonymousFilter?: Record<string, unknown> | null;
    buyerOrdersActiveFilterId?: string | null;
    sellerOrdersActiveFilterId?: string | null;
    buyerOrdersAnonymousFilter?: Record<string, unknown> | null;
    sellerOrdersAnonymousFilter?: Record<string, unknown> | null;
    buyerComparisonActiveFilterId?: string | null;
    buyerComparisonAnonymousFilter?: Record<string, unknown> | null;
    sellerPricingActiveFilterId?: string | null;
    sellerPricingAnonymousFilter?: Record<string, unknown> | null;
    buyListTeamMemberIds?: Array<string> | null;
    buyerBuyListsActiveFilterId?: string | null;
    buyListFilter?: Record<string, unknown> | null;
    myBuyListsActiveFilterId?: string | null;
    myBuyListFilter?: Record<string, unknown> | null;
    buyerRequestForQuotesActiveFilterId?: string | null;
    buyerRequestForQuotesAnonymousFilter?: Record<string, unknown> | null;
    randomTallyUseTallyPrice?: boolean | null;
    sellerProductFilters?: Array<{
      __typename?: 'UserPreferenceFilter';
      field: string;
      operator: FilterOperator;
      value: string;
      connector?: string | null;
    }> | null;
    buyerInventoryFilters?: Array<{
      __typename?: 'UserPreferenceFilter';
      field: string;
      operator: FilterOperator;
      value: string;
      connector?: string | null;
    }> | null;
    productPreferredUnitFilters?: Array<{
      __typename?: 'ProductPreferredUnitFilter';
      category: PlatformProductCategory;
      unit: UnitCode;
    }> | null;
  };
};

export type UpdateUserPreferencesMutationVariables = Exact<{
  preferences: UserPreferenceInput;
}>;

export type UpdateUserPreferencesMutation = {
  __typename?: 'Mutation';
  updateUserPreferences: {
    __typename?: 'UserPreferences';
    category?: PlatformProductCategory | null;
    buyerInventorySelectedLocationId?: string | null;
    buyerInventorySelectedBranchCode?: string | null;
    sellerProductSelectedLocationId?: string | null;
    buyerInventoryColumnOrder?: Array<string> | null;
    buyerInventoryGroupedColumnOrder?: Array<string> | null;
    sellerInventoryColumnOrder?: Array<string> | null;
    sellerPricingColumnOrder?: Array<string> | null;
    pricesAndAvailabilityColumnOrder?: Array<string> | null;
    pricesAndAvailabilityGroupedColumnOrder?: Array<string> | null;
    buyerActiveFilterId?: string | null;
    sellerActiveFilterId?: string | null;
    buyerAnonymousFilter?: Record<string, unknown> | null;
    sellerAnonymousFilter?: Record<string, unknown> | null;
    buyerOrdersActiveFilterId?: string | null;
    sellerOrdersActiveFilterId?: string | null;
    buyerOrdersAnonymousFilter?: Record<string, unknown> | null;
    sellerOrdersAnonymousFilter?: Record<string, unknown> | null;
    buyerComparisonActiveFilterId?: string | null;
    buyerComparisonAnonymousFilter?: Record<string, unknown> | null;
    sellerPricingActiveFilterId?: string | null;
    sellerPricingAnonymousFilter?: Record<string, unknown> | null;
    buyListTeamMemberIds?: Array<string> | null;
    buyerBuyListsActiveFilterId?: string | null;
    buyListFilter?: Record<string, unknown> | null;
    myBuyListsActiveFilterId?: string | null;
    myBuyListFilter?: Record<string, unknown> | null;
    buyerRequestForQuotesActiveFilterId?: string | null;
    buyerRequestForQuotesAnonymousFilter?: Record<string, unknown> | null;
    randomTallyUseTallyPrice?: boolean | null;
    sellerProductFilters?: Array<{
      __typename?: 'UserPreferenceFilter';
      field: string;
      operator: FilterOperator;
      value: string;
      connector?: string | null;
    }> | null;
    buyerInventoryFilters?: Array<{
      __typename?: 'UserPreferenceFilter';
      field: string;
      operator: FilterOperator;
      value: string;
      connector?: string | null;
    }> | null;
    productPreferredUnitFilters?: Array<{
      __typename?: 'ProductPreferredUnitFilter';
      category: PlatformProductCategory;
      unit: UnitCode;
    }> | null;
  };
};

export type UpdateProductPreferredUnitFiltersMutationVariables = Exact<{
  filters:
    Array<ProductPreferredUnitFilterInput> | ProductPreferredUnitFilterInput;
}>;

export type UpdateProductPreferredUnitFiltersMutation = {
  __typename?: 'Mutation';
  updateProductPreferredUnitFilters: {
    __typename?: 'UserPreferences';
    productPreferredUnitFilters?: Array<{
      __typename?: 'ProductPreferredUnitFilter';
      category: PlatformProductCategory;
      unit: UnitCode;
    }> | null;
  };
};

export type GetUserFiltersQueryVariables = Exact<{
  perspective: TradePerspective;
}>;

export type GetUserFiltersQuery = {
  __typename?: 'Query';
  userFilters: Array<{
    __typename?: 'UserFilter';
    id: string;
    name: string;
    filterData: Record<string, unknown>;
    createdAt: string;
  }>;
};

export type SaveFilterMutationVariables = Exact<{
  name: Scalars['String']['input'];
  filterData: Scalars['JSON']['input'];
  perspective: TradePerspective;
}>;

export type SaveFilterMutation = {
  __typename?: 'Mutation';
  saveFilter: {
    __typename?: 'UserFilter';
    id: string;
    name: string;
    filterData: Record<string, unknown>;
    createdAt: string;
  };
};

export type SetActiveFilterMutationVariables = Exact<{
  filterId: Scalars['ID']['input'];
  perspective: TradePerspective;
  view?: InputMaybe<FilterView>;
}>;

export type SetActiveFilterMutation = {
  __typename?: 'Mutation';
  setActiveFilter: {
    __typename?: 'UserPreferences';
    buyerActiveFilterId?: string | null;
    sellerActiveFilterId?: string | null;
    buyerOrdersActiveFilterId?: string | null;
    sellerOrdersActiveFilterId?: string | null;
    buyerComparisonActiveFilterId?: string | null;
    sellerPricingActiveFilterId?: string | null;
    buyerBuyListsActiveFilterId?: string | null;
    myBuyListsActiveFilterId?: string | null;
    buyerRequestForQuotesActiveFilterId?: string | null;
  };
};

export type ClearActiveFilterMutationVariables = Exact<{
  perspective: TradePerspective;
  view?: InputMaybe<FilterView>;
}>;

export type ClearActiveFilterMutation = {
  __typename?: 'Mutation';
  clearActiveFilter: {
    __typename?: 'UserPreferences';
    buyerActiveFilterId?: string | null;
    sellerActiveFilterId?: string | null;
    buyerOrdersActiveFilterId?: string | null;
    sellerOrdersActiveFilterId?: string | null;
    buyerComparisonActiveFilterId?: string | null;
    sellerPricingActiveFilterId?: string | null;
    buyerBuyListsActiveFilterId?: string | null;
    myBuyListsActiveFilterId?: string | null;
    buyerRequestForQuotesActiveFilterId?: string | null;
  };
};

export type ClearAnonymousFilterMutationVariables = Exact<{
  perspective: TradePerspective;
  view?: InputMaybe<FilterView>;
}>;

export type ClearAnonymousFilterMutation = {
  __typename?: 'Mutation';
  clearAnonymousFilter: {
    __typename?: 'UserPreferences';
    buyerAnonymousFilter?: Record<string, unknown> | null;
    sellerAnonymousFilter?: Record<string, unknown> | null;
    buyerActiveFilterId?: string | null;
    sellerActiveFilterId?: string | null;
    buyerOrdersAnonymousFilter?: Record<string, unknown> | null;
    sellerOrdersAnonymousFilter?: Record<string, unknown> | null;
    buyerOrdersActiveFilterId?: string | null;
    sellerOrdersActiveFilterId?: string | null;
    buyerComparisonAnonymousFilter?: Record<string, unknown> | null;
    buyerComparisonActiveFilterId?: string | null;
    sellerPricingActiveFilterId?: string | null;
    sellerPricingAnonymousFilter?: Record<string, unknown> | null;
    buyListFilter?: Record<string, unknown> | null;
    buyerBuyListsActiveFilterId?: string | null;
    myBuyListFilter?: Record<string, unknown> | null;
    myBuyListsActiveFilterId?: string | null;
    buyerRequestForQuotesAnonymousFilter?: Record<string, unknown> | null;
    buyerRequestForQuotesActiveFilterId?: string | null;
  };
};

export type RenameFilterMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
}>;

export type RenameFilterMutation = {
  __typename?: 'Mutation';
  renameFilter: {
    __typename?: 'UserFilter';
    id: string;
    name: string;
    filterData: Record<string, unknown>;
    createdAt: string;
  };
};

export type UpdateFilterMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  filterData: Scalars['JSON']['input'];
}>;

export type UpdateFilterMutation = {
  __typename?: 'Mutation';
  updateFilter: {
    __typename?: 'UserFilter';
    id: string;
    name: string;
    filterData: Record<string, unknown>;
    createdAt: string;
  };
};

export type DeleteFilterMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  perspective: TradePerspective;
  view?: InputMaybe<FilterView>;
}>;

export type DeleteFilterMutation = {
  __typename?: 'Mutation';
  deleteFilter: boolean;
};

export type BuyListItemSummaryFragment = {
  __typename?: 'BuyListItem';
  id: string;
  effectivePiecesPerBundle: number;
  quantity: { __typename?: 'Quantity'; value: number; unit: UnitCode };
  platformProductsLength: {
    __typename?: 'PlatformProductLength';
    id: string;
    lengthDisplayValue: string;
    isNominal?: boolean | null;
    length: {
      __typename?: 'Length';
      nominalLengthInches?: number | null;
      actualLengthInches: number;
    };
    platformProduct: {
      __typename?: 'PlatformProduct';
      code?: string | null;
      name: string;
      nominalWidthInches?: number | null;
      actualWidthInches?: number | null;
      nominalThicknessInches?: number | null;
      actualThicknessInches?: number | null;
      actualLengthInches?: number | null;
      piecesPerBundle: {
        __typename?: 'Quantity';
        value: number;
        unit: UnitCode;
      };
    };
  };
} & { ' $fragmentName'?: 'BuyListItemSummaryFragment' };

export type MyBuyListsQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  size: Scalars['Int']['input'];
  match?: InputMaybe<BuyListMatchInput>;
  sort?: InputMaybe<Array<SortInput> | SortInput>;
}>;

export type MyBuyListsQuery = {
  __typename?: 'Query';
  myBuyLists: {
    __typename?: 'PagedBuyLists';
    paging: {
      __typename?: 'Paging';
      totalElements: number;
      totalPages: number;
      number: number;
      size: number;
    };
    content: Array<{
      __typename?: 'BuyList';
      id: string;
      expectedShipDate: string;
      note?: string | null;
      status: BuyListStatus;
      itemCount: number;
      tallyCount: number;
      location: {
        __typename?: 'Location';
        id: string;
        code: string;
        name: string;
        facility: {
          __typename?: 'Facility';
          id: string;
          code?: string | null;
          address: {
            __typename?: 'Address';
            addressLine1: string;
            addressLine2?: string | null;
            city: string;
            region?: string | null;
            zipCode?: string | null;
          };
        };
      };
      transportVehicle: {
        __typename?: 'TransportVehicle';
        id: string;
        name: string;
      };
      items: Array<
        { __typename?: 'BuyListItem' } & {
          ' $fragmentRefs'?: {
            BuyListItemSummaryFragment: BuyListItemSummaryFragment;
          };
        }
      >;
    }>;
  };
};

export type MyBuyListTargetsQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  size: Scalars['Int']['input'];
}>;

export type MyBuyListTargetsQuery = {
  __typename?: 'Query';
  myBuyLists: {
    __typename?: 'PagedBuyLists';
    paging: {
      __typename?: 'Paging';
      totalElements: number;
      totalPages: number;
      number: number;
      size: number;
    };
    content: Array<{
      __typename?: 'BuyList';
      id: string;
      expectedShipDate: string;
      note?: string | null;
      status: BuyListStatus;
      location: {
        __typename?: 'Location';
        id: string;
        code: string;
        name: string;
        facility: {
          __typename?: 'Facility';
          id: string;
          code?: string | null;
          address: {
            __typename?: 'Address';
            addressLine1: string;
            addressLine2?: string | null;
            city: string;
            region?: string | null;
            zipCode?: string | null;
          };
        };
      };
      transportVehicle: {
        __typename?: 'TransportVehicle';
        id: string;
        name: string;
      };
      items: Array<{
        __typename?: 'BuyListItem';
        id: string;
        effectivePiecesPerBundle: number;
        platformProductsLength: {
          __typename?: 'PlatformProductLength';
          id: string;
        };
        quantity: { __typename?: 'Quantity'; value: number; unit: UnitCode };
      }>;
    }>;
  };
};

export type TeamBuyListsQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  size: Scalars['Int']['input'];
  filter?: InputMaybe<BuyListFilterInput>;
  sort?: InputMaybe<Array<SortInput> | SortInput>;
}>;

export type TeamBuyListsQuery = {
  __typename?: 'Query';
  teamBuyLists: {
    __typename?: 'PagedBuyLists';
    paging: {
      __typename?: 'Paging';
      totalElements: number;
      totalPages: number;
      number: number;
      size: number;
    };
    content: Array<{
      __typename?: 'BuyList';
      id: string;
      expectedShipDate: string;
      note?: string | null;
      status: BuyListStatus;
      itemCount: number;
      tallyCount: number;
      initiatingUser: {
        __typename?: 'User';
        id: string;
        firstName: string;
        lastName: string;
      };
      location: {
        __typename?: 'Location';
        id: string;
        code: string;
        name: string;
        facility: {
          __typename?: 'Facility';
          id: string;
          code?: string | null;
          address: {
            __typename?: 'Address';
            addressLine1: string;
            addressLine2?: string | null;
            city: string;
            region?: string | null;
            zipCode?: string | null;
          };
        };
      };
      transportVehicle: {
        __typename?: 'TransportVehicle';
        id: string;
        name: string;
      };
      items: Array<
        { __typename?: 'BuyListItem' } & {
          ' $fragmentRefs'?: {
            BuyListItemSummaryFragment: BuyListItemSummaryFragment;
          };
        }
      >;
    }>;
  };
};

export type BuyListQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type BuyListQuery = {
  __typename?: 'Query';
  buyList: {
    __typename?: 'BuyList';
    id: string;
    expectedShipDate: string;
    note?: string | null;
    status: BuyListStatus;
    initiatingUser: {
      __typename?: 'User';
      id: string;
      firstName: string;
      lastName: string;
    };
    location: {
      __typename?: 'Location';
      id: string;
      code: string;
      name: string;
      facility: {
        __typename?: 'Facility';
        id: string;
        code?: string | null;
        address: {
          __typename?: 'Address';
          addressLine1: string;
          addressLine2?: string | null;
          city: string;
          region?: string | null;
          zipCode?: string | null;
        };
      };
    };
    transportVehicle: {
      __typename?: 'TransportVehicle';
      id: string;
      name: string;
    };
    items: Array<{
      __typename?: 'BuyListItem';
      id: string;
      effectivePiecesPerBundle: number;
      piecesPerBundleOverride?: number | null;
      platformProductsLength: {
        __typename?: 'PlatformProductLength';
        id: string;
        lengthDisplayValue: string;
        isNominal?: boolean | null;
        latestPriceMid?: {
          __typename?: 'Money';
          amount: number;
          currency: Currency;
        } | null;
        length: {
          __typename?: 'Length';
          nominalLengthInches?: number | null;
          actualLengthInches: number;
        };
        platformProduct: {
          __typename?: 'PlatformProduct';
          code?: string | null;
          name: string;
          category: PlatformProductCategory;
          standardUnitsCode: UnitCode;
          nominalWidthInches?: number | null;
          actualWidthInches?: number | null;
          nominalThicknessInches?: number | null;
          actualThicknessInches?: number | null;
          actualLengthInches?: number | null;
          piecesPerBundle: {
            __typename?: 'Quantity';
            value: number;
            unit: UnitCode;
          };
        };
      };
      quantity: { __typename?: 'Quantity'; value: number; unit: UnitCode };
      carts: Array<{
        __typename?: 'BuyListItemCart';
        buyer: {
          __typename?: 'User';
          id: string;
          firstName: string;
          lastName: string;
        };
        quantity: { __typename?: 'Quantity'; value: number; unit: UnitCode };
      }>;
    }>;
    tallies: Array<
      | {
          __typename: 'CannedBuyListTally';
          tallyCount: number;
          id: string;
          cannedTally: {
            __typename?: 'PlatformProductCannedTally';
            id: string;
            name: string;
          };
          platformProduct: {
            __typename?: 'PlatformProduct';
            id: string;
            code?: string | null;
            name: string;
            standardUnitsCode: UnitCode;
            piecesPerBundle: {
              __typename?: 'Quantity';
              value: number;
              unit: UnitCode;
            };
          };
          quantity: { __typename?: 'Quantity'; value: number; unit: UnitCode };
          bundles: Array<{
            __typename?: 'BuyListTallyBundle';
            bundleCount: number;
            quantity: {
              __typename?: 'Quantity';
              value: number;
              unit: UnitCode;
            };
            platformProductsLength: {
              __typename?: 'PlatformProductLength';
              id: string;
              lengthDisplayValue: string;
              isNominal?: boolean | null;
              length: {
                __typename?: 'Length';
                id: string;
                nominalLengthInches?: number | null;
                actualLengthInches: number;
              };
              platformProduct: {
                __typename?: 'PlatformProduct';
                id: string;
                nominalWidthInches?: number | null;
                actualWidthInches?: number | null;
                nominalThicknessInches?: number | null;
                actualThicknessInches?: number | null;
                actualLengthInches?: number | null;
                piecesPerBundle: {
                  __typename?: 'Quantity';
                  value: number;
                  unit: UnitCode;
                };
              };
            };
          }>;
        }
      | {
          __typename: 'RandomBuyListTally';
          id: string;
          platformProduct: {
            __typename?: 'PlatformProduct';
            id: string;
            code?: string | null;
            name: string;
            standardUnitsCode: UnitCode;
            piecesPerBundle: {
              __typename?: 'Quantity';
              value: number;
              unit: UnitCode;
            };
          };
          quantity: { __typename?: 'Quantity'; value: number; unit: UnitCode };
          bundles: Array<{
            __typename?: 'BuyListTallyBundle';
            bundleCount: number;
            quantity: {
              __typename?: 'Quantity';
              value: number;
              unit: UnitCode;
            };
            platformProductsLength: {
              __typename?: 'PlatformProductLength';
              id: string;
              lengthDisplayValue: string;
              isNominal?: boolean | null;
              length: {
                __typename?: 'Length';
                id: string;
                nominalLengthInches?: number | null;
                actualLengthInches: number;
              };
              platformProduct: {
                __typename?: 'PlatformProduct';
                id: string;
                nominalWidthInches?: number | null;
                actualWidthInches?: number | null;
                nominalThicknessInches?: number | null;
                actualThicknessInches?: number | null;
                actualLengthInches?: number | null;
                piecesPerBundle: {
                  __typename?: 'Quantity';
                  value: number;
                  unit: UnitCode;
                };
              };
            };
          }>;
        }
    >;
  };
};

export type BuyListQuoteComparisonQueryVariables = Exact<{
  buyListId: Scalars['ID']['input'];
  page: Scalars['Int']['input'];
  size: Scalars['Int']['input'];
}>;

export type BuyListQuoteComparisonQuery = {
  __typename?: 'Query';
  buyListRequestForQuotes: {
    __typename?: 'PagedRequestForQuotes';
    paging: { __typename?: 'Paging'; totalElements: number };
    content: Array<{
      __typename?: 'RequestForQuote';
      id: string;
      status: RequestForQuoteStatus;
      createdAt: string;
      createdByUserName?: string | null;
      leadTimeDays?: number | null;
      useTallyPrice: boolean;
      currency?: Currency | null;
      cannedTallyCount?: number | null;
      cannedTally?: {
        __typename?: 'PlatformProductCannedTally';
        id: string;
        name: string;
      } | null;
      tallyPlatformProduct?: {
        __typename?: 'PlatformProduct';
        id: string;
        name: string;
        standardUnitsCode: UnitCode;
        piecesPerBundle: {
          __typename?: 'Quantity';
          value: number;
          unit: UnitCode;
        };
      } | null;
      shippingLocation?: {
        __typename?: 'Location';
        id: string;
        name: string;
        code: string;
        facility: {
          __typename?: 'Facility';
          id: string;
          address: {
            __typename?: 'Address';
            addressLine1: string;
            addressLine2?: string | null;
            city: string;
            region?: string | null;
            zipCode?: string | null;
            country: string;
          };
        };
      } | null;
      pickupPriceForTally?: {
        __typename?: 'Money';
        amount: number;
        currency: Currency;
      } | null;
      deliveryPriceForTally?: {
        __typename?: 'Money';
        amount: number;
        currency: Currency;
      } | null;
      items: Array<{
        __typename?: 'RequestForQuoteItem';
        id: string;
        quantityInPieces: number;
        piecesPerBundle?: number | null;
        pickupPrice?: {
          __typename?: 'Money';
          amount: number;
          currency: Currency;
        } | null;
        deliveryPrice?: {
          __typename?: 'Money';
          amount: number;
          currency: Currency;
        } | null;
        platformProductsLength: {
          __typename?: 'PlatformProductLength';
          id: string;
          lengthDisplayValue: string;
          isNominal?: boolean | null;
          length: {
            __typename?: 'Length';
            id: string;
            displayValue: string;
            actualLengthInches: number;
            nominalLengthInches?: number | null;
          };
          platformProduct: {
            __typename?: 'PlatformProduct';
            id: string;
            name: string;
            code?: string | null;
            standardUnitsCode: UnitCode;
            nominalWidthInches?: number | null;
            actualWidthInches?: number | null;
            nominalThicknessInches?: number | null;
            actualThicknessInches?: number | null;
            actualLengthInches?: number | null;
            piecesPerBundle: {
              __typename?: 'Quantity';
              value: number;
              unit: UnitCode;
            };
          };
        };
      }>;
      quotes: Array<{
        __typename?: 'Quote';
        id: string;
        status: QuoteStatus;
        negotiationAwaitingParty?: QuoteRoundParty | null;
        lockedRecipientIds: Array<string>;
        currency?: Currency | null;
        leadTimeDays?: number | null;
        submittedAt?: string | null;
        primaryContact?:
          | ({ __typename?: 'User'; id: string } & {
              ' $fragmentRefs'?: {
                PrimaryContactFragment: PrimaryContactFragment;
              };
            })
          | null;
        recipients: Array<{
          __typename?: 'User';
          id: string;
          firstName: string;
          lastName: string;
          phoneNumber?: string | null;
          externalId?: string | null;
        }>;
        rounds: Array<
          { __typename?: 'QuoteRound' } & {
            ' $fragmentRefs'?: {
              QuoteTimelineRoundFragment: QuoteTimelineRoundFragment;
              QuoteOfferRoundFragment: QuoteOfferRoundFragment;
            };
          }
        >;
        sellingOrganization: {
          __typename?: 'Organization';
          id: string;
          name: string;
          sellingOrganizationCode?: string | null;
          facilities: Array<{
            __typename?: 'Facility';
            id: string;
            code?: string | null;
            address: {
              __typename?: 'Address';
              addressLine1: string;
              addressLine2?: string | null;
              city: string;
              region?: string | null;
            };
            locations: Array<{
              __typename?: 'Location';
              id: string;
              code: string;
            }>;
          }>;
        };
        sellingOrganizationFacility?: {
          __typename?: 'Facility';
          id: string;
          code?: string | null;
          address: {
            __typename?: 'Address';
            addressLine1: string;
            addressLine2?: string | null;
            city: string;
            region?: string | null;
          };
        } | null;
        offeredPickupPriceForTally?: {
          __typename?: 'Money';
          amount: number;
          currency: Currency;
        } | null;
        offeredDeliveryPriceForTally?: {
          __typename?: 'Money';
          amount: number;
          currency: Currency;
        } | null;
        items: Array<{
          __typename?: 'QuoteItem';
          id: string;
          quantityInPieces: number;
          piecesPerBundle?: number | null;
          status: QuoteItemStatus;
          offeredPickupPrice?: {
            __typename?: 'Money';
            amount: number;
            currency: Currency;
          } | null;
          offeredDeliveryPrice?: {
            __typename?: 'Money';
            amount: number;
            currency: Currency;
          } | null;
          order?: { __typename?: 'Order'; id: string } | null;
          platformProductsLength: {
            __typename?: 'PlatformProductLength';
            id: string;
            lengthDisplayValue: string;
            isNominal?: boolean | null;
            length: {
              __typename?: 'Length';
              id: string;
              displayValue: string;
              actualLengthInches: number;
              nominalLengthInches?: number | null;
            };
            platformProduct: {
              __typename?: 'PlatformProduct';
              id: string;
              name: string;
              code?: string | null;
              standardUnitsCode: UnitCode;
              nominalWidthInches?: number | null;
              actualWidthInches?: number | null;
              nominalThicknessInches?: number | null;
              actualThicknessInches?: number | null;
              actualLengthInches?: number | null;
              piecesPerBundle: {
                __typename?: 'Quantity';
                value: number;
                unit: UnitCode;
              };
            };
          };
        }>;
      }>;
    }>;
  };
};

export type CreateBuyListMutationVariables = Exact<{
  locationId: Scalars['ID']['input'];
  transportVehicleId: Scalars['ID']['input'];
  expectedShipDate: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
}>;

export type CreateBuyListMutation = {
  __typename?: 'Mutation';
  createBuyList: {
    __typename?: 'BuyList';
    id: string;
    expectedShipDate: string;
    note?: string | null;
    status: BuyListStatus;
    location: {
      __typename?: 'Location';
      id: string;
      code: string;
      name: string;
      facility: {
        __typename?: 'Facility';
        id: string;
        code?: string | null;
        address: {
          __typename?: 'Address';
          addressLine1: string;
          addressLine2?: string | null;
          city: string;
          region?: string | null;
          zipCode?: string | null;
        };
      };
    };
    transportVehicle: {
      __typename?: 'TransportVehicle';
      id: string;
      name: string;
    };
    items: Array<{
      __typename?: 'BuyListItem';
      id: string;
      effectivePiecesPerBundle: number;
      piecesPerBundleOverride?: number | null;
      platformProductsLength: {
        __typename?: 'PlatformProductLength';
        id: string;
      };
      quantity: { __typename?: 'Quantity'; value: number; unit: UnitCode };
    }>;
  };
};

export type AddProductToBuyListMutationVariables = Exact<{
  buyListId: Scalars['ID']['input'];
  platformProductsLengthId: Scalars['ID']['input'];
  quantity: QuantityInput;
  piecesPerBundleOverride?: InputMaybe<Scalars['Int']['input']>;
  clearPiecesPerBundleOverride?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type AddProductToBuyListMutation = {
  __typename?: 'Mutation';
  addProductToBuyList: { __typename?: 'BuyList'; id: string };
};

export type RemoveProductFromBuyListMutationVariables = Exact<{
  buyListId: Scalars['ID']['input'];
  platformProductsLengthId: Scalars['ID']['input'];
}>;

export type RemoveProductFromBuyListMutation = {
  __typename?: 'Mutation';
  removeProductFromBuyList: { __typename?: 'BuyList'; id: string };
};

export type SetCannedTallyOnBuyListMutationVariables = Exact<{
  buyListId: Scalars['ID']['input'];
  cannedTallyId: Scalars['ID']['input'];
  tallyCount: Scalars['Int']['input'];
}>;

export type SetCannedTallyOnBuyListMutation = {
  __typename?: 'Mutation';
  setCannedTallyOnBuyList: { __typename?: 'BuyList'; id: string };
};

export type SetRandomTallyOnBuyListMutationVariables = Exact<{
  buyListId: Scalars['ID']['input'];
  platformProductId: Scalars['ID']['input'];
  bundles: Array<RandomTallyBundleInput> | RandomTallyBundleInput;
}>;

export type SetRandomTallyOnBuyListMutation = {
  __typename?: 'Mutation';
  setRandomTallyOnBuyList: { __typename?: 'BuyList'; id: string };
};

export type RemoveTallyFromBuyListMutationVariables = Exact<{
  buyListId: Scalars['ID']['input'];
  buyListTallyId: Scalars['ID']['input'];
}>;

export type RemoveTallyFromBuyListMutation = {
  __typename?: 'Mutation';
  removeTallyFromBuyList: { __typename?: 'BuyList'; id: string };
};

export type UpdateBuyListStatusMutationVariables = Exact<{
  buyListId: Scalars['ID']['input'];
  status: BuyListStatus;
}>;

export type UpdateBuyListStatusMutation = {
  __typename?: 'Mutation';
  updateBuyListStatus: {
    __typename?: 'BuyList';
    id: string;
    status: BuyListStatus;
  };
};

export type AddBuyListToCartMutationVariables = Exact<{
  buyListId: Scalars['ID']['input'];
  sellerOrganizationFacilityId: Scalars['ID']['input'];
  locationId: Scalars['ID']['input'];
  transportVehicleId?: InputMaybe<Scalars['ID']['input']>;
  items: Array<BuyListItemSelectionInput> | BuyListItemSelectionInput;
  tallies?: Array<BuyListTallySelectionInput> | BuyListTallySelectionInput;
}>;

export type AddBuyListToCartMutation = {
  __typename?: 'Mutation';
  addBuyListToCart: {
    __typename?: 'AddBuyListToCartResult';
    cart?: { __typename?: 'Cart'; id: string } | null;
    skippedItems: Array<{
      __typename?: 'SkippedOrderItem';
      productName: string;
      reason: CopyToCartSkipReason;
      tallyKind?: BuyListTallyKind | null;
      tallyName?: string | null;
      tallyCount?: number | null;
    }>;
  };
};

export type UpsertBuyerInventoryConfigurationMutationVariables = Exact<{
  platformProductsLengthId: Scalars['ID']['input'];
  locationId: Scalars['ID']['input'];
  usageRatePerWeek: QuantityInput;
  weeksCoveredBeforeMonitor?: InputMaybe<Scalars['Float']['input']>;
  weeksCoveredBeforeUrgent?: InputMaybe<Scalars['Float']['input']>;
  targetWeeksCovered?: InputMaybe<Scalars['Float']['input']>;
}>;

export type UpsertBuyerInventoryConfigurationMutation = {
  __typename?: 'Mutation';
  upsertBuyerInventoryConfiguration?: {
    __typename?: 'BuyerInventoryConfiguration';
    id: string;
    weeksCoveredBeforeMonitor: number;
    weeksCoveredBeforeUrgent: number;
    targetWeeksCovered: number;
    usageRatePerWeek: {
      __typename?: 'Quantity';
      value: number;
      unit: UnitCode;
    };
    location: { __typename?: 'Location'; id: string; name: string };
    platformProductsLength: {
      __typename?: 'PlatformProductLength';
      id: string;
      platformProduct: { __typename?: 'PlatformProduct'; name: string };
    };
  } | null;
};

export type PlatformProductCannedTalliesQueryVariables = Exact<{
  platformProductId: Scalars['ID']['input'];
  transportVehicleId: Scalars['ID']['input'];
  organizationId?: InputMaybe<Scalars['ID']['input']>;
}>;

export type PlatformProductCannedTalliesQuery = {
  __typename?: 'Query';
  platformProductCannedTallies: Array<{
    __typename?: 'PlatformProductCannedTally';
    id: string;
    name: string;
    bundles: Array<{
      __typename?: 'TallyBundle';
      bundleCount: number;
      platformProductsLength: {
        __typename?: 'PlatformProductLength';
        lengthDisplayValue: string;
        piecesPerLf?: number | null;
        piecesPerBf?: number | null;
        piecesPerMbf?: number | null;
        piecesPerSf?: number | null;
        piecesPerMsf?: number | null;
        piecesPerCbm?: number | null;
        length: { __typename?: 'Length'; actualLengthInches: number };
      };
    }>;
  }>;
};

export type PlatformProductCannedTalliesByOrganizationIdsQueryVariables =
  Exact<{
    platformProductId: Scalars['ID']['input'];
    transportVehicleId: Scalars['ID']['input'];
    organizationIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  }>;

export type PlatformProductCannedTalliesByOrganizationIdsQuery = {
  __typename?: 'Query';
  platformProductCannedTalliesByOrganizationIds: Array<{
    __typename?: 'PlatformProductCannedTalliesForOrganization';
    organizationId: string;
    tallies: Array<{
      __typename?: 'PlatformProductCannedTally';
      id: string;
      name: string;
      bundles: Array<{
        __typename?: 'TallyBundle';
        bundleCount: number;
        platformProductsLength: {
          __typename?: 'PlatformProductLength';
          piecesPerLf?: number | null;
          piecesPerBf?: number | null;
          piecesPerMbf?: number | null;
          piecesPerSf?: number | null;
          piecesPerMsf?: number | null;
          piecesPerCbm?: number | null;
          length: { __typename?: 'Length'; actualLengthInches: number };
        };
      }>;
    }>;
  }>;
};

export type CannedTallyLengthsForCategoryQueryVariables = Exact<{
  platformProductId: Scalars['ID']['input'];
}>;

export type CannedTallyLengthsForCategoryQuery = {
  __typename?: 'Query';
  cannedTallyLengthsForCategory: Array<{
    __typename?: 'ProductLengthOption';
    length: {
      __typename?: 'Length';
      id: string;
      displayValue: string;
      actualLengthInches: number;
    };
    platformProductLength?: {
      __typename?: 'PlatformProductLength';
      id: string;
      isNominal?: boolean | null;
      length: {
        __typename?: 'Length';
        nominalLengthInches?: number | null;
        actualLengthInches: number;
      };
      platformProduct: {
        __typename?: 'PlatformProduct';
        nominalWidthInches?: number | null;
        actualWidthInches?: number | null;
        nominalThicknessInches?: number | null;
        actualThicknessInches?: number | null;
        actualLengthInches?: number | null;
        piecesPerBundle: {
          __typename?: 'Quantity';
          value: number;
          unit: UnitCode;
        };
      };
    } | null;
  }>;
};

export type CannedTallyCandidateLengthsQueryVariables = Exact<{
  platformProductId: Scalars['ID']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  pageInput: PageInput;
}>;

export type CannedTallyCandidateLengthsQuery = {
  __typename?: 'Query';
  lengths: {
    __typename?: 'PagedProductLengthOptions';
    content: Array<{
      __typename?: 'ProductLengthOption';
      length: {
        __typename?: 'Length';
        id: string;
        displayValue: string;
        actualLengthInches: number;
      };
      platformProductLength?: {
        __typename?: 'PlatformProductLength';
        id: string;
        isNominal?: boolean | null;
        length: {
          __typename?: 'Length';
          nominalLengthInches?: number | null;
          actualLengthInches: number;
        };
        platformProduct: {
          __typename?: 'PlatformProduct';
          nominalWidthInches?: number | null;
          actualWidthInches?: number | null;
          nominalThicknessInches?: number | null;
          actualThicknessInches?: number | null;
          actualLengthInches?: number | null;
          piecesPerBundle: {
            __typename?: 'Quantity';
            value: number;
            unit: UnitCode;
          };
        };
      } | null;
    }>;
    paging: {
      __typename?: 'Paging';
      number: number;
      size: number;
      totalElements: number;
      totalPages: number;
    };
  };
};

export type CannedTallySellerGroupsForBuyerQueryVariables = Exact<{
  platformProductId: Scalars['ID']['input'];
  transportVehicleId: Scalars['ID']['input'];
  tallyName?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<CannedTallySellerGroupFilterInput>;
  comparisonFilters?: InputMaybe<SellerComparisonFiltersInput>;
  pageInput: PageInput;
  sort?: InputMaybe<Array<SortInput> | SortInput>;
}>;

export type CannedTallySellerGroupsForBuyerQuery = {
  __typename?: 'Query';
  cannedTallySellerGroupsForBuyer: {
    __typename?: 'PagedCannedTallySellerGroup';
    content: Array<{
      __typename?: 'CannedTallySellerGroup';
      id: string;
      sellerName: string;
      currency: Currency;
      avgPrice: number;
      priceUnit: UnitCode;
      totalBundles: number;
      leadTimeDays?: number | null;
      hasBestPrice: boolean;
      hasAnyPricedLength: boolean;
      facility: {
        __typename?: 'Facility';
        id: string;
        code?: string | null;
        organization: {
          __typename?: 'Organization';
          id: string;
          name: string;
          sellingOrganizationCode?: string | null;
        };
      };
      lengthBreakdown: Array<{
        __typename?: 'CannedTallyLengthBreakdown';
        ft: number;
        actualLengthInches: number;
        platformProductsLengthId?: string | null;
        hasInventory: boolean;
        bundles: number;
        pricePerBundle?: { __typename?: 'Money'; amount: number } | null;
      }>;
    }>;
    paging: {
      __typename?: 'Paging';
      number: number;
      size: number;
      totalElements: number;
      totalPages: number;
    };
  };
};

export type GetChatsByOrderQueryVariables = Exact<{
  orderId: Scalars['ID']['input'];
}>;

export type GetChatsByOrderQuery = {
  __typename?: 'Query';
  chats?: Array<{
    __typename?: 'Chat';
    id: string;
    createdAt: string;
    type: ChatType;
    title?: string | null;
    archived: boolean;
    order: {
      __typename?: 'Order';
      id: string;
      purchaseOrderNumber?: string | null;
      cancellationNote?: string | null;
      shippingLocation?: {
        __typename?: 'Location';
        name: string;
        facility: {
          __typename?: 'Facility';
          address: {
            __typename?: 'Address';
            city: string;
            region?: string | null;
          };
        };
      } | null;
    };
    orderReference?: {
      __typename?: 'OrderReference';
      order: {
        __typename?: 'Order';
        id: string;
        purchaseOrderNumber?: string | null;
        status: OrderStatus;
        cancellationNote?: string | null;
        currency?: Currency | null;
        items: Array<{
          __typename?: 'OrderItem';
          platformProductsLengths: {
            __typename?: 'PlatformProductLength';
            isNominal?: boolean | null;
            lengthDisplayValue: string;
            platformProduct: {
              __typename?: 'PlatformProduct';
              name: string;
              actualWidthInches?: number | null;
              actualThicknessInches?: number | null;
              nominalWidthInches?: number | null;
              nominalThicknessInches?: number | null;
              actualLengthInches?: number | null;
              piecesPerBundle: { __typename?: 'Quantity'; value: number };
            };
            length: {
              __typename?: 'Length';
              actualLengthInches: number;
              nominalLengthInches?: number | null;
            };
          };
          quantity: { __typename?: 'Quantity'; value: number; unit: UnitCode };
          quantityStored: { __typename?: 'Quantity'; value: number };
          effectivePrice?: {
            __typename?: 'Money';
            amount: number;
            currency: Currency;
          } | null;
          price?: {
            __typename?: 'Money';
            amount: number;
            currency: Currency;
          } | null;
          suggestedPrice?: {
            __typename?: 'Money';
            amount: number;
            currency: Currency;
          } | null;
        }>;
      };
    } | null;
    sellingOrganization: {
      __typename?: 'Organization';
      id: string;
      name: string;
      sellingOrganizationCode?: string | null;
    };
    buyingOrganization: {
      __typename?: 'Organization';
      id: string;
      name: string;
    };
    email?: {
      __typename?: 'ChatEmail';
      subject: string;
      htmlBody: string;
      recipientTo?: string | null;
      status: OutboundEmailStatus;
    } | null;
  }> | null;
};

export type GetBuyerOrdersWithChatsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetBuyerOrdersWithChatsQuery = {
  __typename?: 'Query';
  buyerOrdersWithChats?: Array<{
    __typename?: 'Order';
    id: string;
    purchaseOrderNumber?: string | null;
    sellingOrganization: {
      __typename?: 'Organization';
      name: string;
      sellingOrganizationCode?: string | null;
    };
    buyingOrganization: { __typename?: 'Organization'; name: string };
  }> | null;
};

export type GetSellerOrdersWithChatsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetSellerOrdersWithChatsQuery = {
  __typename?: 'Query';
  sellerOrdersWithChats?: Array<{
    __typename?: 'Order';
    id: string;
    sellingOrganization: { __typename?: 'Organization'; name: string };
    buyingOrganization: { __typename?: 'Organization'; name: string };
  }> | null;
};

export type ExtractedDocumentProgressQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type ExtractedDocumentProgressQuery = {
  __typename?: 'Query';
  extractedDocument?: {
    __typename?: 'ExtractedDocument';
    id: string;
    createdAt: string;
    originalFilename?: string | null;
    sourceFormat: SourceFormat;
    documentKind: DocumentKind;
    status: ExtractionStatus;
    failureReason?: ExtractionFailureReason | null;
    vendorName?: string | null;
    documentDate?: string | null;
    currency?: string | null;
    priceBasis?: string | null;
    notes: Array<string>;
    ambiguities: Array<string>;
    expectedPositionCount: number;
    coveredPositionCount: number;
    units: Array<{
      __typename?: 'ExtractionUnitProgress';
      documentId: string;
      sourceFilename?: string | null;
      unitKey: string;
      label: string;
      representation: SourceRepresentation;
      status: UnitStatus;
      expectedPositionCount: number;
      coveredPositionCount: number;
      attemptCount: number;
    }>;
  } | null;
};

export type ExtractedDocumentItemsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type ExtractedDocumentItemsQuery = {
  __typename?: 'Query';
  extractedDocument?: {
    __typename?: 'ExtractedDocument';
    id: string;
    items: Array<{
      __typename?: 'ExtractedDocumentItem';
      id: string;
      documentId: string;
      unitLabel: string;
      positionKey: string;
      provenance?: string | null;
      verdict: ExtractionVerdict;
      verifiedValue?: string | null;
      governingLabels?: string | null;
      claimedValue?: string | null;
      secondOpinion?: SecondOpinion | null;
      secondOpinionReason?: string | null;
      confidence?: string | null;
      ambiguities: Array<string>;
      fields: Array<{
        __typename?: 'ExtractedField';
        name: string;
        value?: string | null;
      }>;
    }>;
  } | null;
};

export type EmailDeliveryTracesQueryVariables = Exact<{
  filter?: InputMaybe<EmailDeliveryTraceFilter>;
  pageInput: PageInput;
}>;

export type EmailDeliveryTracesQuery = {
  __typename?: 'Query';
  emailDeliveryTraces: {
    __typename?: 'PagedEmailDeliveryTraces';
    content: Array<{
      __typename?: 'EmailDeliveryTrace';
      id: string;
      emailType: string;
      recipientTo: string;
      recipientCc: Array<string>;
      status: string;
      lastError?: string | null;
      sesMessageId?: string | null;
      deliveryOutcome: EmailDeliveryOutcome;
      deliveryOutcomeAt?: string | null;
      createdAt: string;
      sentAt?: string | null;
      events: Array<{
        __typename?: 'EmailDeliveryEvent';
        id: string;
        eventType: string;
        recipient?: string | null;
        bounceType?: string | null;
        bounceSubType?: string | null;
        diagnosticCode?: string | null;
        reason?: string | null;
        occurredAt: string;
      }>;
    }>;
    paging: {
      __typename?: 'Paging';
      number: number;
      size: number;
      totalElements: number;
      totalPages: number;
    };
  };
};

export type SendPlatformTestEmailMutationVariables = Exact<{
  input: SendPlatformTestEmailInput;
}>;

export type SendPlatformTestEmailMutation = {
  __typename?: 'Mutation';
  sendPlatformTestEmail: {
    __typename?: 'EmailDeliveryTrace';
    id: string;
    recipientTo: string;
    sesMessageId?: string | null;
    deliveryOutcome: EmailDeliveryOutcome;
    createdAt: string;
  };
};

export type SuggestAddressesQueryVariables = Exact<{
  query: Scalars['String']['input'];
}>;

export type SuggestAddressesQuery = {
  __typename?: 'Query';
  suggestAddresses: Array<{
    __typename?: 'AddressSuggestion';
    text: string;
    placeId: string;
  }>;
};

export type ResolveAddressQueryVariables = Exact<{
  text: Scalars['String']['input'];
}>;

export type ResolveAddressQuery = {
  __typename?: 'Query';
  resolveAddress?: {
    __typename?: 'ResolvedAddress';
    addressLine1?: string | null;
    city?: string | null;
    region?: string | null;
    countryCode?: string | null;
    zipCode?: string | null;
    latitude?: number | null;
    longitude?: number | null;
  } | null;
};

export type ReverseGeocodeQueryVariables = Exact<{
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
}>;

export type ReverseGeocodeQuery = {
  __typename?: 'Query';
  reverseGeocode?: {
    __typename?: 'ResolvedAddress';
    addressLine1?: string | null;
    city?: string | null;
    region?: string | null;
    countryCode?: string | null;
    zipCode?: string | null;
    latitude?: number | null;
    longitude?: number | null;
  } | null;
};

export type GetOrganizationFacilitiesPageQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  size: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  scope?: InputMaybe<FacilityScope>;
}>;

export type GetOrganizationFacilitiesPageQuery = {
  __typename?: 'Query';
  organizationFacilitiesPage: {
    __typename?: 'PagedFacilities';
    content: Array<{
      __typename?: 'Facility';
      id: string;
      code?: string | null;
      phoneNumber?: string | null;
      faxNumber?: string | null;
      address: {
        __typename?: 'Address';
        addressLine1: string;
        addressLine2?: string | null;
        city: string;
        region?: string | null;
        zipCode?: string | null;
        country: string;
      };
      transportVehicles: Array<{
        __typename?: 'TransportVehicle';
        id: string;
        name: string;
        vehicleType: VehicleType;
      }>;
      locations: Array<{
        __typename?: 'Location';
        id: string;
        name: string;
        code: string;
        branchCode?: string | null;
      }>;
      shippingRates: Array<{
        __typename?: 'FacilityShippingRate';
        id: string;
        ratePerMbf?: number | null;
        rateCurrency: Currency;
        shippingRate: {
          __typename?: 'ShippingRate';
          id: string;
          zone: string;
          distanceInMileMin: number;
          distanceInMileMax?: number | null;
          shippingDaysMin: number;
          shippingDaysMax: number;
        };
      }>;
      nearestPort?: {
        __typename?: 'Port';
        id: string;
        code?: string | null;
        name: string;
        city?: string | null;
        country?: string | null;
      } | null;
    }>;
    paging: {
      __typename?: 'Paging';
      totalElements: number;
      totalPages: number;
      number: number;
      size: number;
    };
  };
};

export type GetOrganizationFacilitiesQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetOrganizationFacilitiesQuery = {
  __typename?: 'Query';
  organizationFacilities: Array<{
    __typename?: 'Facility';
    id: string;
    code?: string | null;
    address: { __typename?: 'Address'; city: string };
    locations: Array<{ __typename?: 'Location'; branchCode?: string | null }>;
  }>;
};

export type GetFacilityAddressOptionsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetFacilityAddressOptionsQuery = {
  __typename?: 'Query';
  organizationFacilities: Array<{
    __typename?: 'Facility';
    id: string;
    code?: string | null;
    address: {
      __typename?: 'Address';
      addressLine1: string;
      addressLine2?: string | null;
      city: string;
      region?: string | null;
      zipCode?: string | null;
    };
  }>;
};

export type GetOrganizationLocationsPageQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  size: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  scope?: InputMaybe<LocationScope>;
}>;

export type GetOrganizationLocationsPageQuery = {
  __typename?: 'Query';
  organizationLocationsPage: {
    __typename?: 'PagedLocations';
    content: Array<{
      __typename?: 'Location';
      id: string;
      code: string;
      name: string;
      branchCode?: string | null;
      facility: {
        __typename?: 'Facility';
        id: string;
        code?: string | null;
        address: {
          __typename?: 'Address';
          addressLine1: string;
          addressLine2?: string | null;
          city: string;
          region?: string | null;
          zipCode?: string | null;
          country: string;
        };
      };
    }>;
    paging: {
      __typename?: 'Paging';
      totalElements: number;
      totalPages: number;
      number: number;
      size: number;
    };
  };
};

export type GetTransportVehiclesQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetTransportVehiclesQuery = {
  __typename?: 'Query';
  transportVehicles: Array<{
    __typename?: 'TransportVehicle';
    id: string;
    name: string;
    vehicleType: VehicleType;
  }>;
};

export type GetTransportVehicleByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type GetTransportVehicleByIdQuery = {
  __typename?: 'Query';
  transportVehicle?: {
    __typename?: 'TransportVehicle';
    id: string;
    name: string;
    vehicleType: VehicleType;
  } | null;
};

export type AddTransportVehiclesToFacilityMutationVariables = Exact<{
  facilityId: Scalars['ID']['input'];
  transportVehicleIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;

export type AddTransportVehiclesToFacilityMutation = {
  __typename?: 'Mutation';
  addTransportVehiclesToFacility: {
    __typename?: 'Facility';
    id: string;
    transportVehicles: Array<{
      __typename?: 'TransportVehicle';
      id: string;
      name: string;
      vehicleType: VehicleType;
    }>;
  };
};

export type UpsertFacilityMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
  input: FacilityInput;
}>;

export type UpsertFacilityMutation = {
  __typename?: 'Mutation';
  upsertFacility: {
    __typename?: 'Facility';
    id: string;
    code?: string | null;
    phoneNumber?: string | null;
    faxNumber?: string | null;
    address: {
      __typename?: 'Address';
      addressLine1: string;
      addressLine2?: string | null;
      city: string;
      region?: string | null;
      zipCode?: string | null;
      country: string;
    };
    nearestPort?: {
      __typename?: 'Port';
      id: string;
      code?: string | null;
      name: string;
      city?: string | null;
      country?: string | null;
    } | null;
  };
};

export type DeleteFacilityMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type DeleteFacilityMutation = {
  __typename?: 'Mutation';
  deleteFacility: boolean;
};

export type RemoveTransportVehiclesFromFacilityMutationVariables = Exact<{
  facilityId: Scalars['ID']['input'];
  transportVehicleIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;

export type RemoveTransportVehiclesFromFacilityMutation = {
  __typename?: 'Mutation';
  removeTransportVehiclesFromFacility: {
    __typename?: 'Facility';
    id: string;
    transportVehicles: Array<{
      __typename?: 'TransportVehicle';
      id: string;
      name: string;
      vehicleType: VehicleType;
    }>;
  };
};

export type GetShippingRatesQueryVariables = Exact<{ [key: string]: never }>;

export type GetShippingRatesQuery = {
  __typename?: 'Query';
  shippingRates: Array<{
    __typename?: 'ShippingRate';
    id: string;
    zone: string;
    distanceInMileMin: number;
    distanceInMileMax?: number | null;
    shippingDaysMin: number;
    shippingDaysMax: number;
  }>;
};

export type UpsertFacilityShippingRatesMutationVariables = Exact<{
  facilityId: Scalars['ID']['input'];
  shippingRates: Array<ShippingRateInput> | ShippingRateInput;
}>;

export type UpsertFacilityShippingRatesMutation = {
  __typename?: 'Mutation';
  upsertFacilityShippingRates: Array<{
    __typename?: 'FacilityShippingRate';
    id: string;
  }>;
};

export type GetFeatureFlagsQueryVariables = Exact<{ [key: string]: never }>;

export type GetFeatureFlagsQuery = {
  __typename?: 'Query';
  featureFlags: Array<{
    __typename?: 'FeatureFlag';
    name: string;
    enabled: boolean;
  }>;
};

export type BuyerInventoryQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  size: Scalars['Int']['input'];
  filters?: InputMaybe<BuyerInventoryFiltersInput>;
  includeInventoryLengths?: InputMaybe<Scalars['Boolean']['input']>;
  sort?: InputMaybe<Array<SortInput> | SortInput>;
}>;

export type BuyerInventoryQuery = {
  __typename?: 'Query';
  buyerInventory: {
    __typename?: 'PagedInventory';
    paging: {
      __typename?: 'Paging';
      totalElements: number;
      totalPages: number;
      number: number;
      size: number;
    };
    content: Array<{
      __typename?: 'Inventory';
      id: string;
      quantity: { __typename?: 'Quantity'; value: number; unit: UnitCode };
      onOrderStock: { __typename?: 'Quantity'; unit: UnitCode; value: number };
      availableStock: {
        __typename?: 'Quantity';
        value: number;
        unit: UnitCode;
      };
      onHandStock: { __typename?: 'Quantity'; value: number; unit: UnitCode };
      inboundStock: { __typename?: 'Quantity'; value: number; unit: UnitCode };
      requestedStock: {
        __typename?: 'Quantity';
        value: number;
        unit: UnitCode;
      };
      location: {
        __typename?: 'Location';
        id: string;
        code: string;
        name: string;
        facility: {
          __typename?: 'Facility';
          id: string;
          code?: string | null;
          address: {
            __typename?: 'Address';
            addressLine1: string;
            city: string;
            region?: string | null;
          };
          locations: Array<{
            __typename?: 'Location';
            branchCode?: string | null;
          }>;
        };
      };
      platformProductsLength: {
        __typename?: 'PlatformProductLength';
        id: string;
        isNominal?: boolean | null;
        lengthDisplayValue: string;
        length: {
          __typename?: 'Length';
          id: string;
          displayValue: string;
          nominalLengthInches?: number | null;
          actualLengthInches: number;
        };
        platformProduct: {
          __typename?: 'PlatformProduct';
          id: string;
          code?: string | null;
          name: string;
          category: PlatformProductCategory;
          properties?: Record<string, unknown> | null;
          standardUnitsCode: UnitCode;
          nominalWidthInches?: number | null;
          actualWidthInches?: number | null;
          nominalThicknessInches?: number | null;
          actualThicknessInches?: number | null;
          actualLengthInches?: number | null;
          piecesPerBundle: {
            __typename?: 'Quantity';
            value: number;
            unit: UnitCode;
          };
        };
      };
      buyerInventoryConfiguration?: {
        __typename?: 'BuyerInventoryConfiguration';
        id: string;
        weeksCoveredBeforeUrgent: number;
        weeksCoveredBeforeMonitor: number;
        targetWeeksCovered: number;
        usageRatePerWeek: {
          __typename?: 'Quantity';
          value: number;
          unit: UnitCode;
        };
      } | null;
    } | null>;
  };
};

export type BuyerInventoryRevealCountsQueryVariables = Exact<{
  filters?: InputMaybe<BuyerInventoryFiltersInput>;
}>;

export type BuyerInventoryRevealCountsQuery = {
  __typename?: 'Query';
  buyerInventory: {
    __typename?: 'PagedInventory';
    paging: {
      __typename?: 'Paging';
      totalElements: number;
      totalElementsIncludingHidden?: number | null;
    };
  };
};

export type BuyerInventoryPriorityGroupsQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  size: Scalars['Int']['input'];
  filters?: InputMaybe<BuyerInventoryFiltersInput>;
  includeInventoryLengths?: InputMaybe<Scalars['Boolean']['input']>;
  sort?: InputMaybe<Array<SortInput> | SortInput>;
}>;

export type BuyerInventoryPriorityGroupsQuery = {
  __typename?: 'Query';
  buyerInventoryPriorityGroups: {
    __typename?: 'PagedInventoryPriorityGroups';
    paging: {
      __typename?: 'Paging';
      totalElements: number;
      totalPages: number;
      number: number;
      size: number;
    };
    content: Array<{
      __typename?: 'InventoryPriorityGroup';
      id: string;
      facility: {
        __typename?: 'Facility';
        id: string;
        code?: string | null;
        address: {
          __typename?: 'Address';
          city: string;
          region?: string | null;
        };
        locations: Array<{
          __typename?: 'Location';
          branchCode?: string | null;
        }>;
      };
      platformProductsLength: {
        __typename?: 'PlatformProductLength';
        id: string;
        isNominal?: boolean | null;
        lengthDisplayValue: string;
        length: {
          __typename?: 'Length';
          id: string;
          displayValue: string;
          nominalLengthInches?: number | null;
          actualLengthInches: number;
        };
        platformProduct: {
          __typename?: 'PlatformProduct';
          id: string;
          code?: string | null;
          name: string;
          category: PlatformProductCategory;
          properties?: Record<string, unknown> | null;
          standardUnitsCode: UnitCode;
          nominalWidthInches?: number | null;
          actualWidthInches?: number | null;
          nominalThicknessInches?: number | null;
          actualThicknessInches?: number | null;
          actualLengthInches?: number | null;
          piecesPerBundle: {
            __typename?: 'Quantity';
            value: number;
            unit: UnitCode;
          };
        };
      };
      totalStock: { __typename?: 'Quantity'; value: number; unit: UnitCode };
      totalOnOrderStock: {
        __typename?: 'Quantity';
        value: number;
        unit: UnitCode;
      };
      totalAvailableStock: {
        __typename?: 'Quantity';
        value: number;
        unit: UnitCode;
      };
      totalOnHandStock: {
        __typename?: 'Quantity';
        value: number;
        unit: UnitCode;
      };
      totalInboundStock: {
        __typename?: 'Quantity';
        value: number;
        unit: UnitCode;
      };
      totalRequestedStock: {
        __typename?: 'Quantity';
        value: number;
        unit: UnitCode;
      };
      avgUsageRatePerWeek: {
        __typename?: 'Quantity';
        value: number;
        unit: UnitCode;
      };
      targetInventory: {
        __typename?: 'Inventory';
        id: string;
        location: { __typename?: 'Location'; id: string };
        buyerInventoryConfiguration?: {
          __typename?: 'BuyerInventoryConfiguration';
          id: string;
          weeksCoveredBeforeUrgent: number;
          weeksCoveredBeforeMonitor: number;
        } | null;
      };
    }>;
  };
};

export type BuyerInventoryGroupLocationsQueryVariables = Exact<{
  facilityId: Scalars['ID']['input'];
  platformProductsLengthId: Scalars['ID']['input'];
}>;

export type BuyerInventoryGroupLocationsQuery = {
  __typename?: 'Query';
  buyerInventoryGroupLocations: Array<{
    __typename?: 'InventoryGroupLocation';
    location: {
      __typename?: 'Location';
      id: string;
      name: string;
      code: string;
      facility: {
        __typename?: 'Facility';
        id: string;
        code?: string | null;
        address: {
          __typename?: 'Address';
          addressLine1: string;
          city: string;
          region?: string | null;
        };
      };
    };
    inventory?: {
      __typename?: 'Inventory';
      id: string;
      quantity: { __typename?: 'Quantity'; value: number; unit: UnitCode };
      onOrderStock: { __typename?: 'Quantity'; value: number; unit: UnitCode };
      availableStock: {
        __typename?: 'Quantity';
        value: number;
        unit: UnitCode;
      };
      onHandStock: { __typename?: 'Quantity'; value: number; unit: UnitCode };
      inboundStock: { __typename?: 'Quantity'; value: number; unit: UnitCode };
      requestedStock: {
        __typename?: 'Quantity';
        value: number;
        unit: UnitCode;
      };
      buyerInventoryConfiguration?: {
        __typename?: 'BuyerInventoryConfiguration';
        id: string;
        weeksCoveredBeforeUrgent: number;
        weeksCoveredBeforeMonitor: number;
        targetWeeksCovered: number;
        usageRatePerWeek: {
          __typename?: 'Quantity';
          value: number;
          unit: UnitCode;
        };
      } | null;
    } | null;
  }>;
};

export type UpsertInventoryMutationVariables = Exact<{
  platformProductsLengthId: Scalars['ID']['input'];
  locationId: Scalars['ID']['input'];
  quantity: QuantityInput;
}>;

export type UpsertInventoryMutation = {
  __typename?: 'Mutation';
  upsertInventory?: {
    __typename?: 'Inventory';
    id: string;
    location: { __typename?: 'Location'; id: string; name: string };
    platformProductsLength: {
      __typename?: 'PlatformProductLength';
      id: string;
      platformProduct: { __typename?: 'PlatformProduct'; name: string };
    };
    buyerInventoryConfiguration?: {
      __typename?: 'BuyerInventoryConfiguration';
      weeksCoveredBeforeMonitor: number;
      weeksCoveredBeforeUrgent: number;
      targetWeeksCovered: number;
      location: { __typename?: 'Location'; id: string };
      platformProductsLength: {
        __typename?: 'PlatformProductLength';
        id: string;
      };
      usageRatePerWeek: {
        __typename?: 'Quantity';
        value: number;
        unit: UnitCode;
      };
    } | null;
    quantity: { __typename?: 'Quantity'; value: number; unit: UnitCode };
    availableStock: { __typename?: 'Quantity'; value: number; unit: UnitCode };
    onHandStock: { __typename?: 'Quantity'; value: number; unit: UnitCode };
  } | null;
};

export type PlatformProductsLengthsForProductQueryVariables = Exact<{
  platformProductId: Scalars['ID']['input'];
}>;

export type PlatformProductsLengthsForProductQuery = {
  __typename?: 'Query';
  platformProductsLengthsForProduct?: Array<{
    __typename?: 'PlatformProductLength';
    id: string;
    isNominal?: boolean | null;
    inventoryOnly?: boolean | null;
    lengthDisplayValue: string;
    platformProduct: {
      __typename?: 'PlatformProduct';
      id: string;
      name: string;
      standardUnitsCode: UnitCode;
      nominalWidthInches?: number | null;
      actualWidthInches?: number | null;
      nominalThicknessInches?: number | null;
      actualThicknessInches?: number | null;
      actualLengthInches?: number | null;
      piecesPerBundle: {
        __typename?: 'Quantity';
        value: number;
        unit: UnitCode;
      };
    };
    length: {
      __typename?: 'Length';
      id: string;
      actualLengthInches: number;
      nominalLengthInches?: number | null;
    };
    latestPriceMax?: {
      __typename?: 'Money';
      amount: number;
      currency: Currency;
    } | null;
    latestPriceMin?: {
      __typename?: 'Money';
      amount: number;
      currency: Currency;
    } | null;
    latestPriceMid?: {
      __typename?: 'Money';
      amount: number;
      currency: Currency;
    } | null;
  }> | null;
};

export type SellerProductInventoriesForBuyerQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  size: Scalars['Int']['input'];
  platformProductLengthIds?: InputMaybe<
    Array<Scalars['ID']['input']> | Scalars['ID']['input']
  >;
  platformProductId?: InputMaybe<Scalars['ID']['input']>;
  sellerOrganizationId?: InputMaybe<Scalars['ID']['input']>;
  destinationLocationId?: InputMaybe<Scalars['ID']['input']>;
  deliveryMode?: InputMaybe<DeliveryMode>;
  includeInventoryLengths?: InputMaybe<Scalars['Boolean']['input']>;
  comparisonFilters?: InputMaybe<SellerComparisonFiltersInput>;
  sort?: InputMaybe<Array<SortInput> | SortInput>;
}>;

export type SellerProductInventoriesForBuyerQuery = {
  __typename?: 'Query';
  sellerProductInventoriesForBuyer: {
    __typename?: 'PagedSellerProductInventoryForBuyer';
    recommendedPriceCount: number;
    sellersCount: number;
    paging: {
      __typename?: 'Paging';
      totalElements: number;
      totalPages: number;
      number: number;
      size: number;
    };
    recommendedPrice?: {
      __typename?: 'Money';
      amount: number;
      currency: Currency;
    } | null;
    content: Array<{
      __typename?: 'SellerProductInventoryForBuyer';
      id: string;
      quantity?: {
        __typename?: 'Quantity';
        value: number;
        unit: UnitCode;
      } | null;
      unitPrice?: {
        __typename?: 'UnitPrice';
        unit: UnitCode;
        price?: {
          __typename?: 'Money';
          amount: number;
          currency: Currency;
        } | null;
      } | null;
      deliveredShippingRate?: {
        __typename?: 'Money';
        amount: number;
        currency: Currency;
      } | null;
      pickupShippingRate?: {
        __typename?: 'Money';
        amount: number;
        currency: Currency;
      } | null;
      facility: {
        __typename?: 'Facility';
        id: string;
        code?: string | null;
        address: {
          __typename?: 'Address';
          addressLine1: string;
          addressLine2?: string | null;
          city: string;
          region?: string | null;
          country: string;
        };
        organization: {
          __typename?: 'Organization';
          id: string;
          name: string;
          sellingOrganizationCode?: string | null;
        };
      };
      platformProductsLength: {
        __typename?: 'PlatformProductLength';
        id: string;
        isNominal?: boolean | null;
        inventoryOnly?: boolean | null;
        lengthDisplayValue: string;
        length: {
          __typename?: 'Length';
          nominalLengthInches?: number | null;
          actualLengthInches: number;
        };
        platformProduct: {
          __typename?: 'PlatformProduct';
          id: string;
          name: string;
          code?: string | null;
          nominalWidthInches?: number | null;
          actualWidthInches?: number | null;
          nominalThicknessInches?: number | null;
          actualThicknessInches?: number | null;
          actualLengthInches?: number | null;
          standardUnitsCode: UnitCode;
          piecesPerBundle: {
            __typename?: 'Quantity';
            value: number;
            unit: UnitCode;
          };
        };
      };
      sellerProductConfiguration?: {
        __typename?: 'SellerProductConfiguration';
        id: string;
        readyToShipDays: number;
        unit: UnitCode;
        minimumOrderQuantity: {
          __typename?: 'Quantity';
          value: number;
          unit: UnitCode;
        };
        facility?: {
          __typename?: 'Facility';
          id: string;
          code?: string | null;
          address: {
            __typename?: 'Address';
            addressLine1: string;
            addressLine2?: string | null;
            city: string;
            region?: string | null;
            country: string;
          };
        } | null;
        organization: {
          __typename?: 'Organization';
          id: string;
          name: string;
          sellingOrganizationCode?: string | null;
        };
      } | null;
    } | null>;
  };
};

export type SellerVendorInventoryGroupsForBuyerQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  size: Scalars['Int']['input'];
  platformProductLengthIds?: InputMaybe<
    Array<Scalars['ID']['input']> | Scalars['ID']['input']
  >;
  platformProductId?: InputMaybe<Scalars['ID']['input']>;
  sellerOrganizationId?: InputMaybe<Scalars['ID']['input']>;
  destinationLocationId?: InputMaybe<Scalars['ID']['input']>;
  deliveryMode?: InputMaybe<DeliveryMode>;
  includeInventoryLengths?: InputMaybe<Scalars['Boolean']['input']>;
  comparisonFilters?: InputMaybe<SellerComparisonFiltersInput>;
  sort?: InputMaybe<Array<SortInput> | SortInput>;
}>;

export type SellerVendorInventoryGroupsForBuyerQuery = {
  __typename?: 'Query';
  sellerVendorInventoryGroupsForBuyer: {
    __typename?: 'PagedSellerVendorInventoryGroup';
    recommendedPriceCount: number;
    sellersCount: number;
    content: Array<{
      __typename?: 'SellerVendorInventoryGroup';
      id: string;
      minReadyToShipDays?: number | null;
      facilityCount: number;
      hasPricedFacility: boolean;
      organization: {
        __typename?: 'Organization';
        id: string;
        name: string;
        sellingOrganizationCode?: string | null;
        defaultCurrency: Currency;
        facilities: Array<{
          __typename?: 'Facility';
          id: string;
          code?: string | null;
          locations: Array<{
            __typename?: 'Location';
            id: string;
            code: string;
          }>;
        }>;
      };
      platformProductsLength: {
        __typename?: 'PlatformProductLength';
        id: string;
        lengthDisplayValue: string;
        isNominal?: boolean | null;
        inventoryOnly?: boolean | null;
      };
      priceRange?: {
        __typename?: 'MoneyRange';
        min: { __typename?: 'Money'; amount: number; currency: Currency };
        max: { __typename?: 'Money'; amount: number; currency: Currency };
      } | null;
      totalStock?: {
        __typename?: 'Quantity';
        value: number;
        unit: UnitCode;
      } | null;
    }>;
    paging: {
      __typename?: 'Paging';
      number: number;
      size: number;
      totalElements: number;
      totalPages: number;
    };
    recommendedPrice?: {
      __typename?: 'Money';
      amount: number;
      currency: Currency;
    } | null;
  };
};

export type BuyerProductInventoryQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type BuyerProductInventoryQuery = {
  __typename?: 'Query';
  buyerProductInventory: {
    __typename?: 'Inventory';
    id: string;
    quantity: { __typename?: 'Quantity'; value: number; unit: UnitCode };
    availableStock: { __typename?: 'Quantity'; value: number; unit: UnitCode };
    onHandStock: { __typename?: 'Quantity'; value: number; unit: UnitCode };
    location: {
      __typename?: 'Location';
      id: string;
      name: string;
      facility: {
        __typename?: 'Facility';
        address: {
          __typename?: 'Address';
          city: string;
          region?: string | null;
        };
      };
    };
    platformProductsLength: {
      __typename?: 'PlatformProductLength';
      id: string;
      lengthDisplayValue: string;
      platformProduct: {
        __typename?: 'PlatformProduct';
        id: string;
        name: string;
        code?: string | null;
        actualThicknessInches?: number | null;
        actualWidthInches?: number | null;
        finishCode?: string | null;
        constructionCode?: string | null;
        properties?: Record<string, unknown> | null;
      };
    };
    buyerInventoryConfiguration?: {
      __typename?: 'BuyerInventoryConfiguration';
      id: string;
      weeksCoveredBeforeUrgent: number;
      weeksCoveredBeforeMonitor: number;
      targetWeeksCovered: number;
      usageRatePerWeek: {
        __typename?: 'Quantity';
        value: number;
        unit: UnitCode;
      };
    } | null;
  };
};

export type BuyerInventoryByProductAndLocationQueryVariables = Exact<{
  lengthId: Scalars['ID']['input'];
  platformProductId: Scalars['ID']['input'];
  locationId: Scalars['ID']['input'];
}>;

export type BuyerInventoryByProductAndLocationQuery = {
  __typename?: 'Query';
  buyerInventoryByProductAndLocation?: {
    __typename?: 'Inventory';
    id: string;
    quantity: { __typename?: 'Quantity'; value: number; unit: UnitCode };
    availableStock: { __typename?: 'Quantity'; value: number; unit: UnitCode };
    onHandStock: { __typename?: 'Quantity'; value: number; unit: UnitCode };
    onOrderStock: { __typename?: 'Quantity'; value: number; unit: UnitCode };
    inboundStock: { __typename?: 'Quantity'; value: number; unit: UnitCode };
    location: {
      __typename?: 'Location';
      id: string;
      name: string;
      facility: {
        __typename?: 'Facility';
        address: {
          __typename?: 'Address';
          city: string;
          region?: string | null;
        };
      };
    };
    platformProductsLength: {
      __typename?: 'PlatformProductLength';
      id: string;
      isNominal?: boolean | null;
      lengthDisplayValue: string;
      length: {
        __typename?: 'Length';
        id: string;
        nominalLengthInches?: number | null;
        actualLengthInches: number;
      };
      platformProduct: {
        __typename?: 'PlatformProduct';
        id: string;
        name: string;
        code?: string | null;
        nominalThicknessInches?: number | null;
        actualThicknessInches?: number | null;
        nominalWidthInches?: number | null;
        actualWidthInches?: number | null;
        actualLengthInches?: number | null;
        finishCode?: string | null;
        constructionCode?: string | null;
        properties?: Record<string, unknown> | null;
      };
    };
    buyerInventoryConfiguration?: {
      __typename?: 'BuyerInventoryConfiguration';
      id: string;
      weeksCoveredBeforeUrgent: number;
      weeksCoveredBeforeMonitor: number;
      targetWeeksCovered: number;
      usageRatePerWeek: {
        __typename?: 'Quantity';
        value: number;
        unit: UnitCode;
      };
    } | null;
  } | null;
};

export type AdditionalProductsFromSellerQueryVariables = Exact<{
  orderId: Scalars['ID']['input'];
  pageInput: PageInput;
}>;

export type AdditionalProductsFromSellerQuery = {
  __typename?: 'Query';
  additionalProductsFromSeller: {
    __typename?: 'PagedAdditionalItems';
    content: Array<{
      __typename?: 'AdditionalItem';
      id: string;
      weeksCovered?: number | null;
      stockHealth?: InventoryStockHealth | null;
      quantity: { __typename?: 'Quantity'; value: number; unit: UnitCode };
      unitPrice: {
        __typename?: 'UnitPrice';
        unit: UnitCode;
        price?: {
          __typename?: 'Money';
          amount: number;
          currency: Currency;
        } | null;
      };
      platformProductsLength: {
        __typename?: 'PlatformProductLength';
        id: string;
        isNominal?: boolean | null;
        lengthDisplayValue: string;
        length: {
          __typename?: 'Length';
          nominalLengthInches?: number | null;
          actualLengthInches: number;
        };
        platformProduct: {
          __typename?: 'PlatformProduct';
          id: string;
          name: string;
          nominalWidthInches?: number | null;
          actualWidthInches?: number | null;
          nominalThicknessInches?: number | null;
          actualThicknessInches?: number | null;
          actualLengthInches?: number | null;
          standardUnitsCode: UnitCode;
          properties?: Record<string, unknown> | null;
          piecesPerBundle: { __typename?: 'Quantity'; value: number };
        };
        platformProductVehicleCapacities?: Array<{
          __typename?: 'PlatformProductVehicleCapacity';
          transportVehicle: { __typename?: 'TransportVehicle'; id: string };
          capacity: { __typename?: 'Quantity'; value: number; unit: UnitCode };
        } | null> | null;
      };
    }>;
    paging: {
      __typename?: 'Paging';
      totalElements: number;
      totalPages: number;
      number: number;
      size: number;
    };
  };
};

export type GetSellerLowStockProductsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetSellerLowStockProductsQuery = {
  __typename?: 'Query';
  sellerLowStockProducts: Array<{
    __typename?: 'SellerProductConfiguration';
    id: string;
    health?: InventoryStockHealth | null;
    platformProductLength: {
      __typename?: 'PlatformProductLength';
      lengthDisplayValue: string;
      platformProduct: {
        __typename?: 'PlatformProduct';
        id: string;
        name: string;
      };
    };
    lowStockLevel: { __typename?: 'Quantity'; value: number; unit: UnitCode };
  }>;
};

export type BuyerInventoriesByProductAndLocationForTallyQueryVariables = Exact<{
  lengthIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  platformProductId: Scalars['ID']['input'];
  locationId: Scalars['ID']['input'];
}>;

export type BuyerInventoriesByProductAndLocationForTallyQuery = {
  __typename?: 'Query';
  buyerInventoriesByProductAndLocation: Array<{
    __typename?: 'Inventory';
    quantity: { __typename?: 'Quantity'; value: number; unit: UnitCode };
    buyerInventoryConfiguration?: {
      __typename?: 'BuyerInventoryConfiguration';
      weeksCoveredBeforeUrgent: number;
      weeksCoveredBeforeMonitor: number;
      targetWeeksCovered: number;
      usageRatePerWeek: {
        __typename?: 'Quantity';
        value: number;
        unit: UnitCode;
      };
    } | null;
  } | null>;
};

export type SellerPriceForBuyerQueryVariables = Exact<{
  platformProductLengthId: Scalars['ID']['input'];
  sellerOrganizationId?: InputMaybe<Scalars['ID']['input']>;
  facilityId?: InputMaybe<Scalars['ID']['input']>;
  deliveryMode?: InputMaybe<DeliveryMode>;
  destinationLocationId?: InputMaybe<Scalars['ID']['input']>;
}>;

export type SellerPriceForBuyerQuery = {
  __typename?: 'Query';
  sellerProductInventoriesForBuyer: {
    __typename?: 'PagedSellerProductInventoryForBuyer';
    content: Array<{
      __typename?: 'SellerProductInventoryForBuyer';
      unitPrice?: {
        __typename?: 'UnitPrice';
        unit: UnitCode;
        price?: {
          __typename?: 'Money';
          amount: number;
          currency: Currency;
        } | null;
      } | null;
    } | null>;
  };
};

export type FailedJobOutboxEntriesQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  size: Scalars['Int']['input'];
}>;

export type FailedJobOutboxEntriesQuery = {
  __typename?: 'Query';
  failedJobOutboxEntries: {
    __typename?: 'PagedAdminJobOutboxEntries';
    content: Array<{
      __typename?: 'AdminJobOutboxEntry';
      id: string;
      payloadType: string;
      payload: string;
      lastError?: string | null;
      attempts: number;
      failedAt?: string | null;
    }>;
    paging: {
      __typename?: 'Paging';
      number: number;
      size: number;
      totalElements: number;
      totalPages: number;
    };
  };
};

export type RetryFailedJobOutboxEntryMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type RetryFailedJobOutboxEntryMutation = {
  __typename?: 'Mutation';
  retryFailedJobOutboxEntry: { __typename?: 'AdminJobOutboxEntry'; id: string };
};

export type LocationsQueryVariables = Exact<{ [key: string]: never }>;

export type LocationsQuery = {
  __typename?: 'Query';
  locations?: Array<{
    __typename?: 'Location';
    id: string;
    name: string;
    code: string;
    branchCode?: string | null;
  }> | null;
};

export type BuyListLocationsQueryVariables = Exact<{ [key: string]: never }>;

export type BuyListLocationsQuery = {
  __typename?: 'Query';
  buyListLocations: Array<{
    __typename?: 'Location';
    id: string;
    code: string;
    name: string;
    branchCode?: string | null;
    facility: {
      __typename?: 'Facility';
      id: string;
      code?: string | null;
      address: {
        __typename?: 'Address';
        addressLine1: string;
        addressLine2?: string | null;
        city: string;
        region?: string | null;
        zipCode?: string | null;
      };
    };
  }>;
};

export type UpsertLocationMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
  facilityId?: InputMaybe<Scalars['ID']['input']>;
  input: LocationInput;
}>;

export type UpsertLocationMutation = {
  __typename?: 'Mutation';
  upsertLocation: {
    __typename?: 'Location';
    id: string;
    name: string;
    code: string;
    branchCode?: string | null;
  };
};

export type DeleteLocationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type DeleteLocationMutation = {
  __typename?: 'Mutation';
  deleteLocation: boolean;
};

export type AssignCurrentUserToLocationMutationVariables = Exact<{
  locationId: Scalars['ID']['input'];
}>;

export type AssignCurrentUserToLocationMutation = {
  __typename?: 'Mutation';
  assignCurrentUserToLocation: {
    __typename?: 'Location';
    id: string;
    name: string;
    code: string;
    branchCode?: string | null;
  };
};

export type UnassignUserFromLocationMutationVariables = Exact<{
  locationId: Scalars['ID']['input'];
}>;

export type UnassignUserFromLocationMutation = {
  __typename?: 'Mutation';
  unassignUserFromLocation: {
    __typename?: 'Location';
    id: string;
    name: string;
    code: string;
    branchCode?: string | null;
  };
};

export type GetShippingRoutesQueryVariables = Exact<{
  pageInput: PageInput;
  sort?: InputMaybe<Array<SortInput> | SortInput>;
  filter?: InputMaybe<ShippingRouteFilterInput>;
}>;

export type GetShippingRoutesQuery = {
  __typename?: 'Query';
  shippingRoutes: {
    __typename?: 'PagedShippingRoutes';
    content: Array<{
      __typename?: 'ShippingRoute';
      id: string;
      organizationId?: string | null;
      status: ShippingRouteStatus;
      category?: string | null;
      forwarder?: string | null;
      forwarderEmail?: string | null;
      hasForwarderContact: boolean;
      transitDays?: number | null;
      freeDays?: number | null;
      notes?: string | null;
      expirationDate?: string | null;
      incotermLoading?: LogisticsIncoterm | null;
      incotermDischarge?: LogisticsIncoterm | null;
      portOfLoading: {
        __typename?: 'Port';
        id: string;
        code?: string | null;
        name: string;
        city?: string | null;
        country?: string | null;
        type: PortType;
      };
      originDelivery?: {
        __typename?: 'Port';
        id: string;
        code?: string | null;
        name: string;
        city?: string | null;
        country?: string | null;
        type: PortType;
      } | null;
      portOfDischarge: {
        __typename?: 'Port';
        id: string;
        code?: string | null;
        name: string;
        city?: string | null;
        country?: string | null;
        type: PortType;
      };
      destinationDelivery?: {
        __typename?: 'Port';
        id: string;
        code?: string | null;
        name: string;
        city?: string | null;
        country?: string | null;
        type: PortType;
      } | null;
      freightCost?: {
        __typename?: 'Money';
        amount: number;
        currency: Currency;
      } | null;
      terminalHandlingCharge?: {
        __typename?: 'Money';
        amount: number;
        currency: Currency;
      } | null;
      gassingCost?: {
        __typename?: 'Money';
        amount: number;
        currency: Currency;
      } | null;
      additionalCostsPerContainer?: {
        __typename?: 'Money';
        amount: number;
        currency: Currency;
      } | null;
      additionalCostsPerShipment?: {
        __typename?: 'Money';
        amount: number;
        currency: Currency;
      } | null;
    }>;
    paging: {
      __typename?: 'Paging';
      totalPages: number;
      totalElements: number;
      number: number;
      size: number;
    };
  };
};

export type GetPortsQueryVariables = Exact<{ [key: string]: never }>;

export type GetPortsQuery = {
  __typename?: 'Query';
  ports: Array<{
    __typename?: 'Port';
    id: string;
    code?: string | null;
    name: string;
    city?: string | null;
    country?: string | null;
    type: PortType;
    active: boolean;
  }>;
};

export type GetAllPortsQueryVariables = Exact<{ [key: string]: never }>;

export type GetAllPortsQuery = {
  __typename?: 'Query';
  ports: Array<{
    __typename?: 'Port';
    id: string;
    code?: string | null;
    name: string;
    city?: string | null;
    country?: string | null;
    type: PortType;
    active: boolean;
  }>;
};

export type GetDutyCostsQueryVariables = Exact<{ [key: string]: never }>;

export type GetDutyCostsQuery = {
  __typename?: 'Query';
  dutyCosts: Array<{
    __typename?: 'DutyCost';
    id: string;
    htsNumber: string;
    description?: string | null;
    dutyAdValoremRate?: number | null;
    dutySpecificRate?: number | null;
    dutySpecificUnit?: string | null;
    section301Rate?: number | null;
    adCvdRate?: number | null;
    adCvdType?: string | null;
    adCvdDescription?: string | null;
    softwoodLumberFeeMbf?: number | null;
    softwoodLumberFeeCbm?: number | null;
    currencyCode?: string | null;
    originCountryCode?: string | null;
    gspEligible: boolean;
    conditional: boolean;
    active: boolean;
  }>;
};

export type GetShippingRouteCategoriesQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetShippingRouteCategoriesQuery = {
  __typename?: 'Query';
  shippingRouteCategories: Array<string>;
};

export type GetShippingAddOnCategoriesQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetShippingAddOnCategoriesQuery = {
  __typename?: 'Query';
  shippingAddOnCategories: Array<string>;
};

export type GetLogisticsIncotermsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetLogisticsIncotermsQuery = {
  __typename?: 'Query';
  logisticsIncoterms: Array<LogisticsIncoterm>;
};

export type CreateShippingRouteMutationVariables = Exact<{
  input: CreateShippingRouteInput;
}>;

export type CreateShippingRouteMutation = {
  __typename?: 'Mutation';
  createShippingRoute: {
    __typename?: 'ShippingRoute';
    id: string;
    organizationId?: string | null;
    status: ShippingRouteStatus;
    category?: string | null;
    incotermLoading?: LogisticsIncoterm | null;
    incotermDischarge?: LogisticsIncoterm | null;
    portOfLoading: {
      __typename?: 'Port';
      id: string;
      code?: string | null;
      name: string;
    };
    portOfDischarge: {
      __typename?: 'Port';
      id: string;
      code?: string | null;
      name: string;
    };
  };
};

export type UpdateShippingRouteMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateShippingRouteInput;
}>;

export type UpdateShippingRouteMutation = {
  __typename?: 'Mutation';
  updateShippingRoute: {
    __typename?: 'ShippingRoute';
    id: string;
    organizationId?: string | null;
    status: ShippingRouteStatus;
    category?: string | null;
    incotermLoading?: LogisticsIncoterm | null;
    incotermDischarge?: LogisticsIncoterm | null;
    portOfLoading: {
      __typename?: 'Port';
      id: string;
      code?: string | null;
      name: string;
    };
    portOfDischarge: {
      __typename?: 'Port';
      id: string;
      code?: string | null;
      name: string;
    };
  };
};

export type RequestShippingRouteMutationVariables = Exact<{
  input: CreateShippingRouteInput;
}>;

export type RequestShippingRouteMutation = {
  __typename?: 'Mutation';
  requestShippingRoute: {
    __typename?: 'ShippingRoute';
    id: string;
    organizationId?: string | null;
    status: ShippingRouteStatus;
    category?: string | null;
    hasForwarderContact: boolean;
    incotermLoading?: LogisticsIncoterm | null;
    incotermDischarge?: LogisticsIncoterm | null;
    portOfLoading: {
      __typename?: 'Port';
      id: string;
      code?: string | null;
      name: string;
    };
    portOfDischarge: {
      __typename?: 'Port';
      id: string;
      code?: string | null;
      name: string;
    };
  };
};

export type GetShippingAddOnsQueryVariables = Exact<{
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type GetShippingAddOnsQuery = {
  __typename?: 'Query';
  shippingAddOns: Array<{
    __typename?: 'ShippingAddOn';
    id: string;
    organizationId?: string | null;
    name: string;
    description?: string | null;
    category: string;
    billingUnit: AddOnBillingUnit;
    cost: number;
    currency: Currency;
    active: boolean;
    hidden: boolean;
    isPlatformCustomization: boolean;
  }>;
};

export type CreateShippingAddOnMutationVariables = Exact<{
  input: CreateShippingAddOnInput;
}>;

export type CreateShippingAddOnMutation = {
  __typename?: 'Mutation';
  createShippingAddOn: {
    __typename?: 'ShippingAddOn';
    id: string;
    organizationId?: string | null;
    name: string;
    description?: string | null;
    category: string;
    billingUnit: AddOnBillingUnit;
    cost: number;
    currency: Currency;
    active: boolean;
  };
};

export type UpdateShippingAddOnMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateShippingAddOnInput;
}>;

export type UpdateShippingAddOnMutation = {
  __typename?: 'Mutation';
  updateShippingAddOn: {
    __typename?: 'ShippingAddOn';
    id: string;
    organizationId?: string | null;
    name: string;
    description?: string | null;
    category: string;
    billingUnit: AddOnBillingUnit;
    cost: number;
    currency: Currency;
    active: boolean;
  };
};

export type DeleteShippingAddOnMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type DeleteShippingAddOnMutation = {
  __typename?: 'Mutation';
  deleteShippingAddOn: boolean;
};

export type CustomizePlatformShippingAddOnMutationVariables = Exact<{
  platformAddOnId: Scalars['ID']['input'];
  input: UpdateShippingAddOnInput;
}>;

export type CustomizePlatformShippingAddOnMutation = {
  __typename?: 'Mutation';
  customizePlatformShippingAddOn: {
    __typename?: 'ShippingAddOn';
    id: string;
    organizationId?: string | null;
    name: string;
    description?: string | null;
    category: string;
    billingUnit: AddOnBillingUnit;
    cost: number;
    currency: Currency;
    active: boolean;
    hidden: boolean;
  };
};

export type HidePlatformShippingAddOnMutationVariables = Exact<{
  platformAddOnId: Scalars['ID']['input'];
}>;

export type HidePlatformShippingAddOnMutation = {
  __typename?: 'Mutation';
  hidePlatformShippingAddOn: {
    __typename?: 'ShippingAddOn';
    id: string;
    organizationId?: string | null;
    name: string;
    category: string;
    hidden: boolean;
  };
};

export type HideShippingAddOnMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type HideShippingAddOnMutation = {
  __typename?: 'Mutation';
  hideShippingAddOn: {
    __typename?: 'ShippingAddOn';
    id: string;
    organizationId?: string | null;
    name: string;
    category: string;
    hidden: boolean;
  };
};

export type HideShippingAddOnCategoryMutationVariables = Exact<{
  category: Scalars['String']['input'];
}>;

export type HideShippingAddOnCategoryMutation = {
  __typename?: 'Mutation';
  hideShippingAddOnCategory: number;
};

export type UnhideShippingAddOnMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type UnhideShippingAddOnMutation = {
  __typename?: 'Mutation';
  unhideShippingAddOn: {
    __typename?: 'ShippingAddOn';
    id: string;
    hidden: boolean;
  };
};

export type GetOrderMsrPurchaseOrderQueryVariables = Exact<{
  orderId: Scalars['ID']['input'];
}>;

export type GetOrderMsrPurchaseOrderQuery = {
  __typename?: 'Query';
  order?: {
    __typename?: 'Order';
    id: string;
    msrPurchaseOrder?: {
      __typename?: 'MsrPurchaseOrder';
      fields: Array<{
        __typename?: 'MsrPurchaseOrderField';
        key: string;
        value?: string | null;
        editability: MsrFieldEditability;
      }>;
      items: Array<{
        __typename?: 'MsrPurchaseOrderItem';
        fields: Array<{
          __typename?: 'MsrPurchaseOrderField';
          key: string;
          value?: string | null;
          editability: MsrFieldEditability;
        }>;
      }>;
    } | null;
  } | null;
};

export type MsrUnitTypesQueryVariables = Exact<{
  transportVehicleId: Scalars['ID']['input'];
}>;

export type MsrUnitTypesQuery = {
  __typename?: 'Query';
  msrUnitTypes: Array<{
    __typename?: 'MsrUnitType';
    code: string;
    description: string;
    isDefault: boolean;
  }>;
};

export type MsrIncoTermsQueryVariables = Exact<{
  incoTerm: LogisticsIncoterm;
  incotermDischarge?: InputMaybe<LogisticsIncoterm>;
}>;

export type MsrIncoTermsQuery = {
  __typename?: 'Query';
  msrIncoTerms: Array<{
    __typename?: 'MsrIncoTermOption';
    code: MsrIncoTerm;
    isDefault: boolean;
    defaultLocation: MsrIncoTermLocation;
  }>;
};

export type SellerProductInventoriesQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  size: Scalars['Int']['input'];
  filters?: InputMaybe<SellerProductFiltersInput>;
}>;

export type SellerProductInventoriesQuery = {
  __typename?: 'Query';
  sellerProductInventories: {
    __typename?: 'PaginatedSellerProductInventory';
    paging: {
      __typename?: 'Paging';
      totalPages: number;
      totalElements: number;
      size: number;
      number: number;
    };
    content: Array<{
      __typename?: 'SellerProductInventory';
      id: string;
      quantity: { __typename?: 'Quantity'; value: number; unit: UnitCode };
      location: {
        __typename?: 'Location';
        id: string;
        name: string;
        code: string;
        facility: {
          __typename?: 'Facility';
          id: string;
          address: {
            __typename?: 'Address';
            addressLine1: string;
            city: string;
            region?: string | null;
          };
        };
      };
      sellerProductConfiguration?: {
        __typename?: 'SellerProductConfiguration';
        id: string;
        scope: SellerProductConfigurationScope;
        internalNotes?: string | null;
        readyToShipDays: number;
        status?: SellerProductStatus | null;
        unit: UnitCode;
        facility?: {
          __typename?: 'Facility';
          id: string;
          code?: string | null;
        } | null;
        criticalStockLevel: {
          __typename?: 'Quantity';
          value: number;
          unit: UnitCode;
        };
        lowStockLevel: {
          __typename?: 'Quantity';
          value: number;
          unit: UnitCode;
        };
        replenishmentRatePerWeek: {
          __typename?: 'Quantity';
          value: number;
          unit: UnitCode;
        };
        replenishmentRateStored: {
          __typename?: 'Quantity';
          value: number;
          unit: UnitCode;
        };
        minimumOrderQuantity: {
          __typename?: 'Quantity';
          value: number;
          unit: UnitCode;
        };
      } | null;
      unitPrice?: {
        __typename?: 'UnitPrice';
        unit: UnitCode;
        price?: {
          __typename?: 'Money';
          amount: number;
          currency: Currency;
        } | null;
      } | null;
      platformProductsLength: {
        __typename?: 'PlatformProductLength';
        id: string;
        isNominal?: boolean | null;
        lengthDisplayValue: string;
        length: {
          __typename?: 'Length';
          id: string;
          actualLengthInches: number;
          nominalLengthInches?: number | null;
        };
        platformProduct: {
          __typename?: 'PlatformProduct';
          id: string;
          name: string;
          code?: string | null;
          category: PlatformProductCategory;
          actualWidthInches?: number | null;
          actualThicknessInches?: number | null;
          nominalWidthInches?: number | null;
          nominalThicknessInches?: number | null;
          actualLengthInches?: number | null;
        };
      };
    } | null>;
  };
};

export type GetProductLengthsByProductIdQueryVariables = Exact<{
  inventoryId: Scalars['ID']['input'];
}>;

export type GetProductLengthsByProductIdQuery = {
  __typename?: 'Query';
  sellerProductInventory?: {
    __typename?: 'SellerProductInventory';
    id: string;
    quantity: { __typename?: 'Quantity'; value: number; unit: UnitCode };
    location: {
      __typename?: 'Location';
      id: string;
      facility: {
        __typename?: 'Facility';
        id: string;
        organization: {
          __typename?: 'Organization';
          id: string;
          defaultCurrency: Currency;
        };
      };
    };
    platformProductsLength: {
      __typename?: 'PlatformProductLength';
      id: string;
      isNominal?: boolean | null;
      lengthDisplayValue: string;
      length: {
        __typename?: 'Length';
        id: string;
        actualLengthInches: number;
        nominalLengthInches?: number | null;
      };
      latestPriceMid?: {
        __typename?: 'Money';
        amount: number;
        currency: Currency;
      } | null;
      platformProduct: {
        __typename?: 'PlatformProduct';
        id: string;
        name: string;
        category: PlatformProductCategory;
        materialCode?: string | null;
        constructionCode?: string | null;
        code?: string | null;
        properties?: Record<string, unknown> | null;
        actualWidthInches?: number | null;
        actualThicknessInches?: number | null;
        nominalWidthInches?: number | null;
        nominalThicknessInches?: number | null;
        actualLengthInches?: number | null;
      };
    };
    sellerProductConfiguration?: {
      __typename?: 'SellerProductConfiguration';
      id: string;
      scope: SellerProductConfigurationScope;
      internalNotes?: string | null;
      readyToShipDays: number;
      status?: SellerProductStatus | null;
      unit: UnitCode;
      facility?: {
        __typename?: 'Facility';
        id: string;
        code?: string | null;
      } | null;
      replenishmentRatePerWeek: {
        __typename?: 'Quantity';
        value: number;
        unit: UnitCode;
      };
      criticalStockLevel: {
        __typename?: 'Quantity';
        value: number;
        unit: UnitCode;
      };
      criticalStockLevelInPieces: {
        __typename?: 'Quantity';
        value: number;
        unit: UnitCode;
      };
      lowStockLevel: { __typename?: 'Quantity'; value: number; unit: UnitCode };
      lowStockLevelInPieces: {
        __typename?: 'Quantity';
        value: number;
        unit: UnitCode;
      };
      minimumOrderQuantity: {
        __typename?: 'Quantity';
        value: number;
        unit: UnitCode;
      };
    } | null;
  } | null;
};

export type UpsertSellerInventoryMutationVariables = Exact<{
  platformProductsLengthId: Scalars['ID']['input'];
  locationId: Scalars['ID']['input'];
  quantity: QuantityInput;
}>;

export type UpsertSellerInventoryMutation = {
  __typename?: 'Mutation';
  upsertSellerInventory?: {
    __typename?: 'Inventory';
    id: string;
    quantity: { __typename?: 'Quantity'; value: number; unit: UnitCode };
  } | null;
};

export type UpsertSellerProductConfigurationMutationVariables = Exact<{
  platformProductLengthId: Scalars['ID']['input'];
  scope?: InputMaybe<SellerProductConfigurationScope>;
  facilityId?: InputMaybe<Scalars['ID']['input']>;
  sellerProductConfigurationInput: SellerProductConfigurationInput;
}>;

export type UpsertSellerProductConfigurationMutation = {
  __typename?: 'Mutation';
  upsertSellerProductConfiguration?: {
    __typename?: 'SellerProductConfiguration';
    id: string;
    scope: SellerProductConfigurationScope;
    internalNotes?: string | null;
    readyToShipDays: number;
    status?: SellerProductStatus | null;
    facility?: {
      __typename?: 'Facility';
      id: string;
      code?: string | null;
    } | null;
    criticalStockLevel: {
      __typename?: 'Quantity';
      value: number;
      unit: UnitCode;
    };
    lowStockLevel: { __typename?: 'Quantity'; value: number; unit: UnitCode };
    minimumOrderQuantity: {
      __typename?: 'Quantity';
      value: number;
      unit: UnitCode;
    };
    replenishmentRatePerWeek: {
      __typename?: 'Quantity';
      value: number;
      unit: UnitCode;
    };
  } | null;
};

export type UpsertSellerInventoryAndProductConfigurationMutationVariables =
  Exact<{
    platformProductsLengthId: Scalars['ID']['input'];
    locationId: Scalars['ID']['input'];
    scope?: InputMaybe<SellerProductConfigurationScope>;
    facilityId?: InputMaybe<Scalars['ID']['input']>;
    quantity: QuantityInput;
    sellerProductConfigurationInput: SellerProductConfigurationInput;
  }>;

export type UpsertSellerInventoryAndProductConfigurationMutation = {
  __typename?: 'Mutation';
  upsertSellerInventory?: {
    __typename?: 'Inventory';
    id: string;
    quantity: { __typename?: 'Quantity'; value: number; unit: UnitCode };
  } | null;
  upsertSellerProductConfiguration?: {
    __typename?: 'SellerProductConfiguration';
    id: string;
    scope: SellerProductConfigurationScope;
    internalNotes?: string | null;
    readyToShipDays: number;
    status?: SellerProductStatus | null;
    facility?: {
      __typename?: 'Facility';
      id: string;
      code?: string | null;
    } | null;
    criticalStockLevel: {
      __typename?: 'Quantity';
      value: number;
      unit: UnitCode;
    };
    criticalStockLevelInPieces: {
      __typename?: 'Quantity';
      value: number;
      unit: UnitCode;
    };
    lowStockLevel: { __typename?: 'Quantity'; value: number; unit: UnitCode };
    lowStockLevelInPieces: {
      __typename?: 'Quantity';
      value: number;
      unit: UnitCode;
    };
    minimumOrderQuantity: {
      __typename?: 'Quantity';
      value: number;
      unit: UnitCode;
    };
    replenishmentRatePerWeek: {
      __typename?: 'Quantity';
      value: number;
      unit: UnitCode;
    };
  } | null;
};

export type SetSellerProductPriceMutationVariables = Exact<{
  input: SellerProductPriceInput;
}>;

export type SetSellerProductPriceMutation = {
  __typename?: 'Mutation';
  setSellerProductPrice?: {
    __typename?: 'SellerProductPrice';
    id: string;
    margin?: number | null;
    currencyCode: Currency;
    unit: UnitCode;
    platformProductLength: { __typename?: 'PlatformProductLength'; id: string };
    materialCost?: {
      __typename?: 'Money';
      amount: number;
      currency: Currency;
    } | null;
    pricePerUnit?: {
      __typename?: 'Money';
      amount: number;
      currency: Currency;
    } | null;
  } | null;
};

export type SellerCatalogPricesQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  size: Scalars['Int']['input'];
  filters?: InputMaybe<SellerCatalogPriceFiltersInput>;
}>;

export type SellerCatalogPricesQuery = {
  __typename?: 'Query';
  sellerCatalogPrices: {
    __typename?: 'PagedPlatformProductLength';
    paging: {
      __typename?: 'Paging';
      totalPages: number;
      totalElements: number;
      size: number;
      number: number;
    };
    content: Array<{
      __typename?: 'PlatformProductLength';
      id: string;
      lengthDisplayValue: string;
      platformProduct: {
        __typename?: 'PlatformProduct';
        id: string;
        name: string;
        code?: string | null;
        category: PlatformProductCategory;
      };
      myPrice?: {
        __typename?: 'SellerProductPrice';
        id: string;
        margin?: number | null;
        currencyCode: Currency;
        unit: UnitCode;
        materialCost?: {
          __typename?: 'Money';
          amount: number;
          currency: Currency;
        } | null;
        pricePerUnit?: {
          __typename?: 'Money';
          amount: number;
          currency: Currency;
        } | null;
      } | null;
    } | null>;
  };
};

export type UniqueLocationsWithInventoryQueryVariables = Exact<{
  [key: string]: never;
}>;

export type UniqueLocationsWithInventoryQuery = {
  __typename?: 'Query';
  uniqueLocationsWithInventory: Array<{
    __typename?: 'Location';
    id: string;
    name: string;
    code: string;
    branchCode?: string | null;
    facility: {
      __typename?: 'Facility';
      address: {
        __typename?: 'Address';
        addressLine1: string;
        city: string;
        region?: string | null;
      };
    };
  }>;
};

export type MyProductFilterOptionsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type MyProductFilterOptionsQuery = {
  __typename?: 'Query';
  platformProductDimensions: Array<{
    __typename?: 'ProductDimension';
    nominalThicknessInches?: number | null;
    nominalWidthInches?: number | null;
  }>;
};

export type ReceiveOrderMutationVariables = Exact<{
  orderId: Scalars['ID']['input'];
}>;

export type ReceiveOrderMutation = {
  __typename?: 'Mutation';
  receiveOrder?: { __typename?: 'Order'; id: string } | null;
};

export type ConfirmShipmentReceiptMutationVariables = Exact<{
  subOrderId: Scalars['ID']['input'];
}>;

export type ConfirmShipmentReceiptMutation = {
  __typename?: 'Mutation';
  confirmShipmentReceipt: { __typename?: 'Order'; id: string };
};

export type GetBuyerOrderCountsQueryVariables = Exact<{ [key: string]: never }>;

export type GetBuyerOrderCountsQuery = {
  __typename?: 'Query';
  buyerOrdersCount: {
    __typename?: 'OrderStatusCount';
    confirmed: number;
    delivered: number;
    draft: number;
    pendingSellerConfirmation: number;
    pendingSellerConfirmationWithReminders: number;
    shipped: number;
    cancelled: number;
    blocked: number;
  };
};

export type GetSellerOrderCountsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetSellerOrderCountsQuery = {
  __typename?: 'Query';
  sellerOrdersCount: {
    __typename?: 'OrderStatusCount';
    confirmed: number;
    delivered: number;
    draft: number;
    pendingSellerConfirmation: number;
    pendingSellerConfirmationWithReminders: number;
    shipped: number;
    cancelled: number;
    blocked: number;
  };
};

export type ShipOrderMutationVariables = Exact<{
  orderId: Scalars['ID']['input'];
  shippedDate: Scalars['Instant']['input'];
  deliveryStartDate: Scalars['Instant']['input'];
  deliveryEndDate?: InputMaybe<Scalars['Instant']['input']>;
}>;

export type ShipOrderMutation = {
  __typename?: 'Mutation';
  shipOrder?: { __typename?: 'Order'; id: string } | null;
};

export type GetOrderByIdQueryVariables = Exact<{
  orderId: Scalars['ID']['input'];
}>;

export type GetOrderByIdQuery = {
  __typename?: 'Query';
  order?: {
    __typename?: 'Order';
    id: string;
    viewerPerspective: TradePerspective;
    createdAt: string;
    updatedAt?: string | null;
    status: OrderStatus;
    isBrokered: boolean;
    cancellationNote?: string | null;
    purchaseOrderNumber?: string | null;
    shippedDate?: string | null;
    deliveryStartDate?: string | null;
    deliveryEndDate?: string | null;
    receivedDate?: string | null;
    canManuallySyncWithMsr: boolean;
    canViewMsrPurchaseOrder: boolean;
    canReturnToDraft: boolean;
    msrSyncedAt?: string | null;
    canChoosePrimaryContact: boolean;
    awaitingPurchaseOrderNumber: boolean;
    incoTerm?: LogisticsIncoterm | null;
    isInternational: boolean;
    tarp: boolean;
    currency?: Currency | null;
    deliveryMethod?: DeliveryMethod | null;
    incotermLoading?: LogisticsIncoterm | null;
    incotermDischarge?: LogisticsIncoterm | null;
    incotermAddressDestination?: string | null;
    parentOrder?: { __typename?: 'Order'; id: string } | null;
    confirmedBy?: {
      __typename?: 'User';
      id: string;
      firstName: string;
      lastName: string;
      externalId?: string | null;
    } | null;
    shippedBy?: {
      __typename?: 'User';
      id: string;
      firstName: string;
      lastName: string;
      externalId?: string | null;
    } | null;
    blockMessages: Array<{
      __typename?: 'OrderBlockMessage';
      id: string;
      message: string;
      createdAt: string;
      processedAt?: string | null;
    }>;
    buyer: { __typename?: 'User'; firstName: string; lastName: string };
    buyerContact?: {
      __typename?: 'User';
      id: string;
      firstName: string;
      lastName: string;
      phoneNumber?: string | null;
      externalId?: string | null;
    } | null;
    sellerContacts: Array<{
      __typename?: 'User';
      id: string;
      firstName: string;
      lastName: string;
      phoneNumber?: string | null;
      externalId?: string | null;
    }>;
    primaryContact?: { __typename?: 'User'; id: string } | null;
    shippingLocation?: {
      __typename?: 'Location';
      id: string;
      name: string;
      facility: {
        __typename?: 'Facility';
        address: {
          __typename?: 'Address';
          addressLine1: string;
          addressLine2?: string | null;
          city: string;
          region?: string | null;
          zipCode?: string | null;
          latitude?: number | null;
          longitude?: number | null;
        };
      };
      organization: { __typename?: 'Organization'; name: string };
    } | null;
    deliveryAddress?: {
      __typename?: 'DeliveryAddress';
      addressLine1?: string | null;
      addressLine2?: string | null;
      city?: string | null;
      region?: string | null;
      zipCode?: string | null;
      country?: string | null;
      latitude?: number | null;
      longitude?: number | null;
    } | null;
    buyingOrganization: {
      __typename?: 'Organization';
      name: string;
      msrSyncEnabled: boolean;
    };
    msrPurchaseOrderEmails: Array<{
      __typename?: 'MsrPurchaseOrderEmail';
      id: string;
      recipientTo: string;
      createdAt: string;
      status: OutboundEmailStatus;
      requestedBy?: {
        __typename?: 'User';
        id: string;
        firstName: string;
        lastName: string;
      } | null;
    }>;
    msrPurchaseOrderInputs?: {
      __typename?: 'MsrPurchaseOrderInputsView';
      orderedByCode?: string | null;
      buyerCode?: string | null;
      cashContract: boolean;
      numDaysIntransit?: number | null;
      unitType?: string | null;
      isImport: boolean;
      readyAtMill?: string | null;
      incoTerms?: MsrIncoTerm | null;
      incoTermsLoc?: string | null;
    } | null;
    sellingOrganization: {
      __typename?: 'Organization';
      id: string;
      name: string;
      sellingOrganizationCode?: string | null;
    };
    sellingOrganizationFacility: {
      __typename?: 'Facility';
      address: {
        __typename?: 'Address';
        addressLine1: string;
        addressLine2?: string | null;
        city: string;
        region?: string | null;
        country: string;
      };
    };
    portOfLoading?: {
      __typename?: 'Port';
      id: string;
      code?: string | null;
      name: string;
      city?: string | null;
      country?: string | null;
      type: PortType;
    } | null;
    portOfDischarge?: {
      __typename?: 'Port';
      id: string;
      code?: string | null;
      name: string;
      city?: string | null;
      country?: string | null;
      type: PortType;
    } | null;
    shippingRoute?: {
      __typename?: 'ShippingRoute';
      id: string;
      forwarder?: string | null;
      transitDays?: number | null;
    } | null;
    shippingRouteSnapshot?: {
      __typename?: 'OrderShippingRouteSnapshot';
      id: string;
      forwarder?: string | null;
      transitDays?: number | null;
      createdAt: string;
      freightCost?: {
        __typename?: 'Money';
        amount: number;
        currency: Currency;
      } | null;
      terminalHandlingCharge?: {
        __typename?: 'Money';
        amount: number;
        currency: Currency;
      } | null;
      gassingCost?: {
        __typename?: 'Money';
        amount: number;
        currency: Currency;
      } | null;
      additionalCostsPerContainer?: {
        __typename?: 'Money';
        amount: number;
        currency: Currency;
      } | null;
      additionalCostsPerShipment?: {
        __typename?: 'Money';
        amount: number;
        currency: Currency;
      } | null;
    } | null;
    shippingFee?: {
      __typename?: 'Money';
      amount: number;
      currency: Currency;
    } | null;
    transportVehicle?: {
      __typename?: 'TransportVehicle';
      id: string;
      name: string;
      vehicleType: VehicleType;
    } | null;
    documents: Array<{
      __typename?: 'OrderDocument';
      id: string;
      documentType: DocumentType;
      uploadType: UploadType;
      originalFilename: string;
      fileSizeBytes: number;
      mimeType: string;
      createdAt: string;
    }>;
    items: Array<{
      __typename?: 'OrderItem';
      effectivePiecesPerBundle: number;
      piecesPerBundleOverride?: number | null;
      buyCode?: string | null;
      quantity: { __typename?: 'Quantity'; value: number; unit: UnitCode };
      piecesQuantity: { __typename?: 'Quantity'; value: number };
      quantityStored: { __typename?: 'Quantity'; value: number };
      price?: {
        __typename?: 'Money';
        amount: number;
        currency: Currency;
      } | null;
      suggestedPrice?: {
        __typename?: 'Money';
        amount: number;
        currency: Currency;
      } | null;
      effectivePrice?: {
        __typename?: 'Money';
        amount: number;
        currency: Currency;
      } | null;
      pickupPrice?: {
        __typename?: 'Money';
        amount: number;
        currency: Currency;
      } | null;
      deliveryPrice?: {
        __typename?: 'Money';
        amount: number;
        currency: Currency;
      } | null;
      pricePerPiece?: {
        __typename?: 'Money';
        amount: number;
        currency: Currency;
      } | null;
      suggestedPricePerPiece?: {
        __typename?: 'Money';
        amount: number;
        currency: Currency;
      } | null;
      pickupPricePerPiece?: {
        __typename?: 'Money';
        amount: number;
        currency: Currency;
      } | null;
      deliveryPricePerPiece?: {
        __typename?: 'Money';
        amount: number;
        currency: Currency;
      } | null;
      platformProductsLengths: {
        __typename?: 'PlatformProductLength';
        id: string;
        isNominal?: boolean | null;
        lengthDisplayValue: string;
        platformProduct: {
          __typename?: 'PlatformProduct';
          id: string;
          name: string;
          category: PlatformProductCategory;
          actualWidthInches?: number | null;
          actualThicknessInches?: number | null;
          nominalWidthInches?: number | null;
          nominalThicknessInches?: number | null;
          actualLengthInches?: number | null;
          standardUnitsCode: UnitCode;
          properties?: Record<string, unknown> | null;
          piecesPerBundle: {
            __typename?: 'Quantity';
            value: number;
            unit: UnitCode;
          };
        };
        platformProductVehicleCapacities?: Array<{
          __typename?: 'PlatformProductVehicleCapacity';
          transportVehicle: { __typename?: 'TransportVehicle'; id: string };
          capacity: { __typename?: 'Quantity'; value: number; unit: UnitCode };
        } | null> | null;
        length: {
          __typename?: 'Length';
          id: string;
          actualLengthInches: number;
          nominalLengthInches?: number | null;
        };
      };
      tallyPlatformProduct?: {
        __typename?: 'PlatformProduct';
        id: string;
      } | null;
      cannedTally?: {
        __typename?: 'PlatformProductCannedTally';
        id: string;
      } | null;
    }>;
    subOrders: Array<{
      __typename?: 'Order';
      id: string;
      status: OrderStatus;
      sellingOrganization: {
        __typename?: 'Organization';
        name: string;
        sellingOrganizationCode?: string | null;
      };
      items: Array<{
        __typename?: 'OrderItem';
        quantity: { __typename?: 'Quantity'; value: number; unit: UnitCode };
        platformProductsLengths: {
          __typename?: 'PlatformProductLength';
          id: string;
          lengthDisplayValue: string;
          platformProduct: { __typename?: 'PlatformProduct'; name: string };
        };
      }>;
    }>;
    shipments: Array<{
      __typename?: 'OrderShipment';
      id: string;
      status: OrderStatus;
      shippedDate?: string | null;
      deliveryStartDate?: string | null;
      deliveryEndDate?: string | null;
      receivedDate?: string | null;
      items: Array<{
        __typename?: 'OrderItem';
        quantity: { __typename?: 'Quantity'; value: number; unit: UnitCode };
        platformProductsLengths: {
          __typename?: 'PlatformProductLength';
          id: string;
          lengthDisplayValue: string;
          platformProduct: { __typename?: 'PlatformProduct'; name: string };
        };
      }>;
      packingListItems: Array<{
        __typename?: 'PackingListItem';
        id: string;
        price: { __typename?: 'Money'; amount: number; currency: Currency };
        quantity: { __typename?: 'Quantity'; value: number; unit: UnitCode };
        platformProductsLengths: {
          __typename?: 'PlatformProductLength';
          id: string;
          lengthDisplayValue: string;
          platformProduct: { __typename?: 'PlatformProduct'; name: string };
        };
      }>;
    }>;
  } | null;
};

export type GetOrderMsrSyncStatusQueryVariables = Exact<{
  orderId: Scalars['ID']['input'];
}>;

export type GetOrderMsrSyncStatusQuery = {
  __typename?: 'Query';
  order?: {
    __typename?: 'Order';
    id: string;
    updatedAt?: string | null;
    purchaseOrderNumber?: string | null;
  } | null;
};

export type GetOrdersQueryVariables = Exact<{
  status?: InputMaybe<OrderStatus>;
  perspective: TradePerspective;
  filters?: InputMaybe<OrderFiltersInput>;
  page: Scalars['Int']['input'];
  size: Scalars['Int']['input'];
}>;

export type GetOrdersQuery = {
  __typename?: 'Query';
  orders: {
    __typename?: 'PagedOrders';
    paging: {
      __typename?: 'Paging';
      totalElements: number;
      totalPages: number;
      number: number;
      size: number;
    };
    content: Array<{
      __typename?: 'Order';
      createdAt: string;
      id: string;
      purchaseOrderNumber?: string | null;
      deliveryStartDate?: string | null;
      deliveryEndDate?: string | null;
      shippedDate?: string | null;
      isBrokered: boolean;
      currency?: Currency | null;
      status: OrderStatus;
      parentOrder?: { __typename?: 'Order'; id: string } | null;
      buyer: {
        __typename?: 'User';
        firstName: string;
        lastName: string;
        externalId?: string | null;
      };
      buyingOrganization: {
        __typename?: 'Organization';
        name: string;
        buyingOrganizationCode?: string | null;
      };
      sellingOrganization: {
        __typename?: 'Organization';
        name: string;
        sellingOrganizationCode?: string | null;
      };
      shippingLocation?: {
        __typename?: 'Location';
        name: string;
        code: string;
      } | null;
      deliveryAddress?: {
        __typename?: 'DeliveryAddress';
        addressLine1?: string | null;
        city?: string | null;
        region?: string | null;
      } | null;
      items: Array<{
        __typename?: 'OrderItem';
        quantity: { __typename?: 'Quantity'; value: number; unit: UnitCode };
        price?: {
          __typename?: 'Money';
          amount: number;
          currency: Currency;
        } | null;
        suggestedPrice?: {
          __typename?: 'Money';
          amount: number;
          currency: Currency;
        } | null;
        effectivePrice?: {
          __typename?: 'Money';
          amount: number;
          currency: Currency;
        } | null;
        quantityStored: { __typename?: 'Quantity'; value: number };
        pricePerPiece?: {
          __typename?: 'Money';
          amount: number;
          currency: Currency;
        } | null;
        suggestedPricePerPiece?: {
          __typename?: 'Money';
          amount: number;
          currency: Currency;
        } | null;
        platformProductsLengths: {
          __typename?: 'PlatformProductLength';
          isNominal?: boolean | null;
          platformProduct: {
            __typename?: 'PlatformProduct';
            name: string;
            code?: string | null;
            category: PlatformProductCategory;
            standardUnitsCode: UnitCode;
            actualWidthInches?: number | null;
            actualThicknessInches?: number | null;
            nominalWidthInches?: number | null;
            nominalThicknessInches?: number | null;
            actualLengthInches?: number | null;
            piecesPerBundle: { __typename?: 'Quantity'; value: number };
          };
          length: {
            __typename?: 'Length';
            actualLengthInches: number;
            nominalLengthInches?: number | null;
          };
        };
      }>;
    }>;
  };
};

export type ConfirmOrderMutationVariables = Exact<{
  orderId: Scalars['ID']['input'];
  shippedDate?: InputMaybe<Scalars['Instant']['input']>;
  deliveryStartDate?: InputMaybe<Scalars['Instant']['input']>;
  deliveryEndDate?: InputMaybe<Scalars['Instant']['input']>;
}>;

export type ConfirmOrderMutation = {
  __typename?: 'Mutation';
  confirmOrder?: { __typename?: 'Order'; id: string } | null;
};

export type CalculateShipDatesQueryVariables = Exact<{
  orderId: Scalars['ID']['input'];
}>;

export type CalculateShipDatesQuery = {
  __typename?: 'Query';
  calculateShipDates: {
    __typename?: 'ShipDateCalculation';
    shippedDate?: string | null;
    deliveryStartDate?: string | null;
    deliveryEndDate?: string | null;
  };
};

export type PlaceOrderMutationVariables = Exact<{
  orderId: Scalars['ID']['input'];
  locationId: Scalars['ID']['input'];
  incoTerm: LogisticsIncoterm;
  transportVehicleId: Scalars['ID']['input'];
  tarp?: InputMaybe<Scalars['Boolean']['input']>;
  recipientUserIds?: InputMaybe<
    Array<Scalars['ID']['input']> | Scalars['ID']['input']
  >;
  primaryContactUserId?: InputMaybe<Scalars['ID']['input']>;
  promiseDate?: InputMaybe<Scalars['Date']['input']>;
  shipWeekDate?: InputMaybe<Scalars['Date']['input']>;
  dueByDate?: InputMaybe<Scalars['Date']['input']>;
  msrPurchaseOrderInput?: InputMaybe<MsrPurchaseOrderInput>;
}>;

export type PlaceOrderMutation = {
  __typename?: 'Mutation';
  placeOrder?: { __typename?: 'Order'; id: string } | null;
};

export type CancelOrderMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  note: Scalars['String']['input'];
}>;

export type CancelOrderMutation = {
  __typename?: 'Mutation';
  cancelOrder?: {
    __typename?: 'Order';
    id: string;
    status: OrderStatus;
  } | null;
};

export type CopyOrderToCartMutationVariables = Exact<{
  orderId: Scalars['ID']['input'];
}>;

export type CopyOrderToCartMutation = {
  __typename?: 'Mutation';
  copyOrderToCart: {
    __typename?: 'CopyOrderToCartResult';
    cart?: { __typename?: 'Cart'; id: string } | null;
    skippedItems: Array<{
      __typename?: 'SkippedOrderItem';
      productName: string;
      reason: CopyToCartSkipReason;
    }>;
  };
};

export type AddRequestForQuoteToCartMutationVariables = Exact<{
  requestForQuoteId: Scalars['ID']['input'];
  facilityId: Scalars['ID']['input'];
  recipientUserIds?: InputMaybe<
    Array<Scalars['ID']['input']> | Scalars['ID']['input']
  >;
}>;

export type AddRequestForQuoteToCartMutation = {
  __typename?: 'Mutation';
  addRequestForQuoteToCart: { __typename?: 'Cart'; id: string };
};

export type RevertBlockedOrderToDraftMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type RevertBlockedOrderToDraftMutation = {
  __typename?: 'Mutation';
  revertBlockedOrderToDraft?: {
    __typename?: 'Order';
    id: string;
    status: OrderStatus;
  } | null;
};

export type ResubmitBlockedOrderMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type ResubmitBlockedOrderMutation = {
  __typename?: 'Mutation';
  resubmitBlockedOrder?: {
    __typename?: 'Order';
    id: string;
    status: OrderStatus;
  } | null;
};

export type SyncOrderWithExternalVendorMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type SyncOrderWithExternalVendorMutation = {
  __typename?: 'Mutation';
  syncOrderWithExternalVendor: { __typename?: 'Order'; id: string };
};

export type ResendOrderPlacedEmailMutationVariables = Exact<{
  orderId: Scalars['ID']['input'];
}>;

export type ResendOrderPlacedEmailMutation = {
  __typename?: 'Mutation';
  resendOrderPlacedEmail: boolean;
};

export type EmailMsrPurchaseOrderMutationVariables = Exact<{
  orderId: Scalars['ID']['input'];
  contactIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  printOptions?: InputMaybe<MsrPurchaseOrderPrintOptionsInput>;
}>;

export type EmailMsrPurchaseOrderMutation = {
  __typename?: 'Mutation';
  emailMsrPurchaseOrder: boolean;
};

export type DeclinePriceNegotiationMutationVariables = Exact<{
  orderId: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
}>;

export type DeclinePriceNegotiationMutation = {
  __typename?: 'Mutation';
  declinePriceNegotiation?: { __typename?: 'Order'; id: string } | null;
};

export type ShippingSoonQueryVariables = Exact<{ [key: string]: never }>;

export type ShippingSoonQuery = {
  __typename?: 'Query';
  shippingSoon: Array<{
    __typename?: 'Order';
    id: string;
    purchaseOrderNumber?: string | null;
    status: OrderStatus;
    deliveryStartDate?: string | null;
    currency?: Currency | null;
    sellingOrganization: {
      __typename?: 'Organization';
      name: string;
      sellingOrganizationCode?: string | null;
    };
    items: Array<{
      __typename?: 'OrderItem';
      quantity: { __typename?: 'Quantity'; value: number; unit: UnitCode };
      price?: {
        __typename?: 'Money';
        amount: number;
        currency: Currency;
      } | null;
      suggestedPrice?: {
        __typename?: 'Money';
        amount: number;
        currency: Currency;
      } | null;
      effectivePrice?: {
        __typename?: 'Money';
        amount: number;
        currency: Currency;
      } | null;
      quantityStored: { __typename?: 'Quantity'; value: number };
      pricePerPiece?: {
        __typename?: 'Money';
        amount: number;
        currency: Currency;
      } | null;
      suggestedPricePerPiece?: {
        __typename?: 'Money';
        amount: number;
        currency: Currency;
      } | null;
      platformProductsLengths: {
        __typename?: 'PlatformProductLength';
        isNominal?: boolean | null;
        platformProduct: {
          __typename?: 'PlatformProduct';
          name: string;
          actualWidthInches?: number | null;
          actualThicknessInches?: number | null;
          nominalWidthInches?: number | null;
          nominalThicknessInches?: number | null;
          actualLengthInches?: number | null;
          piecesPerBundle: { __typename?: 'Quantity'; value: number };
        };
        length: {
          __typename?: 'Length';
          actualLengthInches: number;
          nominalLengthInches?: number | null;
        };
      };
    }>;
  }>;
};

export type DeleteOrderDocumentMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type DeleteOrderDocumentMutation = {
  __typename?: 'Mutation';
  deleteOrderDocument: boolean;
};

export type OrderDocumentPresignedUrlQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type OrderDocumentPresignedUrlQuery = {
  __typename?: 'Query';
  orderDocumentPresignedUrl: string;
};

export type OrganizationsByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;

export type OrganizationsByIdsQuery = {
  __typename?: 'Query';
  organizationsByIds: Array<{
    __typename?: 'Organization';
    id: string;
    sellerContacts: Array<{
      __typename?: 'User';
      id: string;
      firstName: string;
      lastName: string;
      phoneNumber?: string | null;
      externalId?: string | null;
    }>;
    notificationPreference: Array<{ __typename?: 'User'; id: string }>;
  }>;
};

export type GetOrganizationsQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  size: Scalars['Int']['input'];
  name?: InputMaybe<StringOperatorInput>;
}>;

export type GetOrganizationsQuery = {
  __typename?: 'Query';
  organizations: {
    __typename?: 'PagedOrganizations';
    content: Array<{
      __typename?: 'Organization';
      id: string;
      name: string;
      sellingOrganizationCode?: string | null;
    }>;
    paging: {
      __typename?: 'Paging';
      totalElements: number;
      totalPages: number;
      number: number;
      size: number;
    };
  };
};

export type GetTradingPartnerOrganizationsForBuyerQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  size: Scalars['Int']['input'];
  name?: InputMaybe<StringOperatorInput>;
  excludeOrganizationIds?: InputMaybe<
    Array<Scalars['ID']['input']> | Scalars['ID']['input']
  >;
  onlyOrganizationIds?: InputMaybe<
    Array<Scalars['ID']['input']> | Scalars['ID']['input']
  >;
}>;

export type GetTradingPartnerOrganizationsForBuyerQuery = {
  __typename?: 'Query';
  tradingPartnerOrganizationsForBuyer: {
    __typename?: 'PagedOrganizations';
    content: Array<{
      __typename?: 'Organization';
      id: string;
      name: string;
      sellingOrganizationCode?: string | null;
      defaultCurrency: Currency;
      sellerContacts: Array<{
        __typename?: 'User';
        id: string;
        firstName: string;
        lastName: string;
      }>;
      facilities: Array<{
        __typename?: 'Facility';
        id: string;
        code?: string | null;
        address: {
          __typename?: 'Address';
          addressLine1: string;
          addressLine2?: string | null;
          city: string;
          region?: string | null;
        };
        locations: Array<{ __typename?: 'Location'; id: string; code: string }>;
      }>;
    }>;
    paging: {
      __typename?: 'Paging';
      totalElements: number;
      totalPages: number;
      number: number;
      size: number;
    };
  };
};

export type AddTradingPartnersToProductComparisonMutationVariables = Exact<{
  input: AddTradingPartnersToProductInput;
}>;

export type AddTradingPartnersToProductComparisonMutation = {
  __typename?: 'Mutation';
  addTradingPartnersToProductComparison: {
    __typename?: 'AddTradingPartnersToProductComparisonResult';
    addedOrganizationIds: Array<string>;
    configurations: Array<{
      __typename?: 'SellerProductConfiguration';
      id: string;
    }>;
  };
};

export type RemoveTradingPartnersFromProductComparisonMutationVariables =
  Exact<{
    input: RemoveTradingPartnersFromProductComparisonInput;
  }>;

export type RemoveTradingPartnersFromProductComparisonMutation = {
  __typename?: 'Mutation';
  removeTradingPartnersFromProductComparison: Array<string>;
};

export type CreateOrganizationMutationVariables = Exact<{
  input: CreateOrganizationInput;
}>;

export type CreateOrganizationMutation = {
  __typename?: 'Mutation';
  createOrganization: { __typename?: 'Organization'; id: string; name: string };
};

export type GetMySellersQueryVariables = Exact<{ [key: string]: never }>;

export type GetMySellersQuery = {
  __typename?: 'Query';
  mySellers: Array<{
    __typename?: 'TradingPartner';
    organizationId: string;
    organizationName: string;
    buyingOrganizationCode?: string | null;
    sellingOrganizationCode?: string | null;
  }>;
};

export type GetMyBuyersQueryVariables = Exact<{ [key: string]: never }>;

export type GetMyBuyersQuery = {
  __typename?: 'Query';
  myBuyers: Array<{
    __typename?: 'TradingPartner';
    organizationId: string;
    organizationName: string;
    buyingOrganizationCode?: string | null;
    sellingOrganizationCode?: string | null;
  }>;
};

export type UpdateMySellerCodeMutationVariables = Exact<{
  sellerOrganizationId: Scalars['ID']['input'];
  code?: InputMaybe<Scalars['String']['input']>;
}>;

export type UpdateMySellerCodeMutation = {
  __typename?: 'Mutation';
  updateMySellerCode: {
    __typename?: 'TradingPartner';
    organizationId: string;
    organizationName: string;
    buyingOrganizationCode?: string | null;
    sellingOrganizationCode?: string | null;
  };
};

export type UpdateMyBuyerCodeMutationVariables = Exact<{
  buyerOrganizationId: Scalars['ID']['input'];
  code?: InputMaybe<Scalars['String']['input']>;
}>;

export type UpdateMyBuyerCodeMutation = {
  __typename?: 'Mutation';
  updateMyBuyerCode: {
    __typename?: 'TradingPartner';
    organizationId: string;
    organizationName: string;
    buyingOrganizationCode?: string | null;
    sellingOrganizationCode?: string | null;
  };
};

export type GetBuyerMarginsQueryVariables = Exact<{
  platformProductLengthId: Scalars['ID']['input'];
}>;

export type GetBuyerMarginsQuery = {
  __typename?: 'Query';
  buyerMargins: Array<{
    __typename?: 'SellerProductBuyerMargin';
    id: string;
    marginRate: number;
    pricePerUnit?: {
      __typename?: 'Money';
      amount: number;
      currency: Currency;
    } | null;
    buyingOrganization: {
      __typename?: 'Organization';
      id: string;
      name: string;
    };
  }>;
};

export type GetBuyerNegotiatedPricesQueryVariables = Exact<{
  platformProductLengthId: Scalars['ID']['input'];
}>;

export type GetBuyerNegotiatedPricesQuery = {
  __typename?: 'Query';
  buyerNegotiatedPrices: Array<{
    __typename?: 'BuyerNegotiatedPrice';
    buyingOrganization: {
      __typename?: 'Organization';
      id: string;
      name: string;
    };
    price: { __typename?: 'Money'; amount: number; currency: Currency };
  }>;
};

export type SetBuyerMarginMutationVariables = Exact<{
  platformProductLengthId: Scalars['ID']['input'];
  buyingOrganizationId: Scalars['ID']['input'];
  marginRate: Scalars['Float']['input'];
}>;

export type SetBuyerMarginMutation = {
  __typename?: 'Mutation';
  setBuyerMargin: {
    __typename?: 'SellerProductBuyerMargin';
    id: string;
    marginRate: number;
    pricePerUnit?: {
      __typename?: 'Money';
      amount: number;
      currency: Currency;
    } | null;
    buyingOrganization: {
      __typename?: 'Organization';
      id: string;
      name: string;
    };
  };
};

export type RemoveBuyerMarginMutationVariables = Exact<{
  platformProductLengthId: Scalars['ID']['input'];
  buyingOrganizationId: Scalars['ID']['input'];
}>;

export type RemoveBuyerMarginMutation = {
  __typename?: 'Mutation';
  removeBuyerMargin: boolean;
};

export type GetOrganizationQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type GetOrganizationQuery = {
  __typename?: 'Query';
  organization?: {
    __typename?: 'Organization';
    id: string;
    name: string;
    phoneNumber?: string | null;
    faxNumber?: string | null;
    tenantAdmins: Array<{
      __typename?: 'User';
      id: string;
      firstName: string;
      lastName: string;
      externalId?: string | null;
      phoneNumber?: string | null;
      status: UserStatus;
      lastEditedAt?: string | null;
      lastEditedBy?: {
        __typename?: 'User';
        id: string;
        firstName: string;
        lastName: string;
      } | null;
    }>;
  } | null;
};

export type GetLinkedOrganizationQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type GetLinkedOrganizationQuery = {
  __typename?: 'Query';
  organization?: {
    __typename?: 'Organization';
    id: string;
    name: string;
    sellingOrganizationCode?: string | null;
    users: Array<{
      __typename?: 'User';
      id: string;
      firstName: string;
      lastName: string;
      externalId?: string | null;
      employeeId?: string | null;
      phoneNumber?: string | null;
      role: UserRole;
      status: UserStatus;
      lastEditedAt?: string | null;
      lastEditedBy?: {
        __typename?: 'User';
        id: string;
        firstName: string;
        lastName: string;
      } | null;
    }>;
  } | null;
};

export type GetLinkedOrganizationUsersQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetLinkedOrganizationUsersQuery = {
  __typename?: 'Query';
  linkedOrganizationUsers: Array<{
    __typename?: 'User';
    id: string;
    firstName: string;
    lastName: string;
    externalId?: string | null;
    phoneNumber?: string | null;
    role: UserRole;
    status: UserStatus;
    lastEditedAt?: string | null;
    lastEditedBy?: {
      __typename?: 'User';
      id: string;
      firstName: string;
      lastName: string;
    } | null;
    organization?: {
      __typename?: 'Organization';
      id: string;
      name: string;
    } | null;
  }>;
};

export type CreateContactMutationVariables = Exact<{
  input: ContactInput;
}>;

export type CreateContactMutation = {
  __typename?: 'Mutation';
  createContact: {
    __typename?: 'User';
    id: string;
    firstName: string;
    lastName: string;
    phoneNumber?: string | null;
    externalId?: string | null;
  };
};

export type UpdateContactMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateContactInput;
}>;

export type UpdateContactMutation = {
  __typename?: 'Mutation';
  updateContact: {
    __typename?: 'User';
    id: string;
    firstName: string;
    lastName: string;
  };
};

export type CreateTenantAdminMutationVariables = Exact<{
  input: CreateTenantAdminInput;
}>;

export type CreateTenantAdminMutation = {
  __typename?: 'Mutation';
  createTenantAdmin: {
    __typename?: 'User';
    id: string;
    firstName: string;
    lastName: string;
    externalId?: string | null;
    status: UserStatus;
  };
};

export type UpdateOrderNotificationEmailsMutationVariables = Exact<{
  input: OrderNotificationEmailsInput;
}>;

export type UpdateOrderNotificationEmailsMutation = {
  __typename?: 'Mutation';
  updateOrderNotificationEmails: {
    __typename?: 'Organization';
    id: string;
    orderNotificationEmails?: {
      __typename?: 'OrderNotificationEmails';
      domestic?: string | null;
      international?: string | null;
    } | null;
  };
};

export type UpdateOrganizationContactMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  input: OrganizationContactInput;
}>;

export type UpdateOrganizationContactMutation = {
  __typename?: 'Mutation';
  updateOrganizationContact: {
    __typename?: 'Organization';
    id: string;
    phoneNumber?: string | null;
    faxNumber?: string | null;
  };
};

export type DeactivateTenantAdminForOrgMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;

export type DeactivateTenantAdminForOrgMutation = {
  __typename?: 'Mutation';
  deactivateTenantUser: { __typename?: 'User'; id: string; status: UserStatus };
};

export type ReactivateTenantAdminForOrgMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;

export type ReactivateTenantAdminForOrgMutation = {
  __typename?: 'Mutation';
  reactivateTenantUser: { __typename?: 'User'; id: string; status: UserStatus };
};

export type GetPackingListQueryVariables = Exact<{
  orderId: Scalars['ID']['input'];
}>;

export type GetPackingListQuery = {
  __typename?: 'Query';
  packingList?: {
    __typename?: 'PackingList';
    id: string;
    notes?: string | null;
    createdAt: string;
    updatedAt?: string | null;
    items: Array<{
      __typename?: 'PackingListItem';
      id: string;
      piecesPerBundleOverride?: number | null;
      price: { __typename?: 'Money'; amount: number; currency: Currency };
      platformProductsLengths: {
        __typename?: 'PlatformProductLength';
        id: string;
        isNominal?: boolean | null;
        lengthDisplayValue: string;
        length: {
          __typename?: 'Length';
          nominalLengthInches?: number | null;
          actualLengthInches: number;
        };
        platformProduct: {
          __typename?: 'PlatformProduct';
          name: string;
          standardUnitsCode: UnitCode;
          nominalWidthInches?: number | null;
          actualWidthInches?: number | null;
          nominalThicknessInches?: number | null;
          actualThicknessInches?: number | null;
          actualLengthInches?: number | null;
          piecesPerBundle: {
            __typename?: 'Quantity';
            value: number;
            unit: UnitCode;
          };
        };
      };
      quantity: { __typename?: 'Quantity'; value: number; unit: UnitCode };
      piecesQuantity: { __typename?: 'Quantity'; value: number };
    }>;
  } | null;
};

export type GetSellerProductsQueryVariables = Exact<{
  pageInput: PageInput;
}>;

export type GetSellerProductsQuery = {
  __typename?: 'Query';
  sellerProductInventories: {
    __typename?: 'PaginatedSellerProductInventory';
    content: Array<{
      __typename?: 'SellerProductInventory';
      id: string;
      sellerProductConfiguration?: {
        __typename?: 'SellerProductConfiguration';
        price?: {
          __typename?: 'SellerProductPrice';
          pricePerUnit?: {
            __typename?: 'Money';
            amount: number;
            currency: Currency;
          } | null;
        } | null;
        platformProductLength: {
          __typename?: 'PlatformProductLength';
          id: string;
          isNominal?: boolean | null;
          lengthDisplayValue: string;
          length: {
            __typename?: 'Length';
            nominalLengthInches?: number | null;
            actualLengthInches: number;
          };
          platformProduct: {
            __typename?: 'PlatformProduct';
            name: string;
            standardUnitsCode: UnitCode;
            nominalWidthInches?: number | null;
            actualWidthInches?: number | null;
            nominalThicknessInches?: number | null;
            actualThicknessInches?: number | null;
            actualLengthInches?: number | null;
            piecesPerBundle: {
              __typename?: 'Quantity';
              value: number;
              unit: UnitCode;
            };
          };
        };
      } | null;
    } | null>;
  };
};

export type PackItemMutationVariables = Exact<{
  orderId: Scalars['ID']['input'];
  platformProductLengthId: Scalars['ID']['input'];
  quantity: QuantityInput;
}>;

export type PackItemMutation = {
  __typename?: 'Mutation';
  packItem: {
    __typename?: 'PackingListItem';
    id: string;
    price: { __typename?: 'Money'; amount: number; currency: Currency };
    platformProductsLengths: {
      __typename?: 'PlatformProductLength';
      id: string;
    };
    quantity: { __typename?: 'Quantity'; value: number; unit: UnitCode };
  };
};

export type RemovePackedItemMutationVariables = Exact<{
  orderId: Scalars['ID']['input'];
  platformProductLengthId: Scalars['ID']['input'];
}>;

export type RemovePackedItemMutation = {
  __typename?: 'Mutation';
  removePackedItem: boolean;
};

export type PublishPackingListMutationVariables = Exact<{
  orderId: Scalars['ID']['input'];
}>;

export type PublishPackingListMutation = {
  __typename?: 'Mutation';
  publishPackingList: boolean;
};

export type SavePackingListMutationVariables = Exact<{
  orderId: Scalars['ID']['input'];
  items: Array<PackItemInput> | PackItemInput;
  notes?: InputMaybe<Scalars['String']['input']>;
}>;

export type SavePackingListMutation = {
  __typename?: 'Mutation';
  savePackingList: Array<{
    __typename?: 'PackingListItem';
    id: string;
    piecesPerBundleOverride?: number | null;
    price: { __typename?: 'Money'; amount: number; currency: Currency };
    platformProductsLengths: {
      __typename?: 'PlatformProductLength';
      id: string;
      isNominal?: boolean | null;
      lengthDisplayValue: string;
      length: {
        __typename?: 'Length';
        nominalLengthInches?: number | null;
        actualLengthInches: number;
      };
      platformProduct: {
        __typename?: 'PlatformProduct';
        name: string;
        standardUnitsCode: UnitCode;
        nominalWidthInches?: number | null;
        actualWidthInches?: number | null;
        nominalThicknessInches?: number | null;
        actualThicknessInches?: number | null;
        actualLengthInches?: number | null;
        piecesPerBundle: {
          __typename?: 'Quantity';
          value: number;
          unit: UnitCode;
        };
      };
    };
    quantity: { __typename?: 'Quantity'; value: number; unit: UnitCode };
    piecesQuantity: { __typename?: 'Quantity'; value: number };
  }>;
};

export type AdminSearchPlatformProductsQueryVariables = Exact<{
  search: Scalars['String']['input'];
  page: Scalars['Int']['input'];
  size: Scalars['Int']['input'];
}>;

export type AdminSearchPlatformProductsQuery = {
  __typename?: 'Query';
  adminSearchPlatformProducts: {
    __typename?: 'PagedAdminPlatformProducts';
    content: Array<{
      __typename?: 'AdminPlatformProduct';
      id: string;
      code?: string | null;
      name: string;
      piecesPerBundle?: number | null;
      standardUnitsCode: UnitCode;
      vehicleCapacities: Array<{
        __typename?: 'AdminVehicleCapacity';
        capacity: { __typename?: 'Quantity'; value: number; unit: UnitCode };
        transportVehicle: {
          __typename?: 'TransportVehicle';
          id: string;
          name: string;
        };
      }>;
      lengths: Array<{
        __typename?: 'AdminPlatformProductLength';
        id: string;
        lengthDisplayValue: string;
        isNominal: boolean;
        inventoryOnly: boolean;
      }>;
    }>;
    paging: {
      __typename?: 'Paging';
      number: number;
      size: number;
      totalElements: number;
      totalPages: number;
    };
  };
};

export type SetPlatformProductLengthInventoryOnlyMutationVariables = Exact<{
  platformProductLengthId: Scalars['ID']['input'];
  inventoryOnly: Scalars['Boolean']['input'];
}>;

export type SetPlatformProductLengthInventoryOnlyMutation = {
  __typename?: 'Mutation';
  setPlatformProductLengthInventoryOnly: {
    __typename?: 'AdminPlatformProductLength';
    id: string;
    inventoryOnly: boolean;
  };
};

export type SetPlatformProductPiecesPerBundleMutationVariables = Exact<{
  platformProductId: Scalars['ID']['input'];
  piecesPerBundle: Scalars['Int']['input'];
}>;

export type SetPlatformProductPiecesPerBundleMutation = {
  __typename?: 'Mutation';
  setPlatformProductPiecesPerBundle: {
    __typename?: 'AdminPlatformProduct';
    id: string;
    piecesPerBundle?: number | null;
  };
};

export type SetPlatformProductVehicleCapacityMutationVariables = Exact<{
  platformProductId: Scalars['ID']['input'];
  transportVehicleId: Scalars['ID']['input'];
  capacity: QuantityInput;
}>;

export type SetPlatformProductVehicleCapacityMutation = {
  __typename?: 'Mutation';
  setPlatformProductVehicleCapacity: {
    __typename?: 'AdminVehicleCapacity';
    capacity: { __typename?: 'Quantity'; value: number; unit: UnitCode };
    transportVehicle: {
      __typename?: 'TransportVehicle';
      id: string;
      name: string;
    };
  };
};

export type ImportPlatformProductsMutationVariables = Exact<{
  input: PlatformProductImportInput;
  dryRun: Scalars['Boolean']['input'];
}>;

export type ImportPlatformProductsMutation = {
  __typename?: 'Mutation';
  importPlatformProducts: {
    __typename?: 'PlatformProductImportResult';
    fileErrors: Array<string>;
    rowErrors: Array<{
      __typename?: 'PlatformProductImportRowError';
      rowNumber: number;
      code: string;
      messages: Array<string>;
    }>;
    products: Array<{
      __typename?: 'PlatformProductImportChange';
      code: string;
      action: PlatformProductImportAction;
      addedLengths: Array<string>;
      addedCapacities: Array<string>;
      createdFields: Array<{
        __typename?: 'PlatformProductImportFieldValue';
        field: string;
        value: string;
      }>;
      conflicts: Array<{
        __typename?: 'PlatformProductImportConflict';
        field: string;
        currentValue: string;
        importedValue: string;
      }>;
    }>;
  };
};

export type PlatformProductsQueryVariables = Exact<{
  filter?: InputMaybe<ProductFilterInput>;
}>;

export type PlatformProductsQuery = {
  __typename?: 'Query';
  platformProducts?: Array<{
    __typename?: 'PlatformProduct';
    id: string;
    code?: string | null;
    name: string;
    category: PlatformProductCategory;
    standardUnitsCode: UnitCode;
    piecesPerBundle: { __typename?: 'Quantity'; value: number; unit: UnitCode };
  }> | null;
};

export type BuyListProductsQueryVariables = Exact<{ [key: string]: never }>;

export type BuyListProductsQuery = {
  __typename?: 'Query';
  buyListProducts: Array<{
    __typename?: 'PlatformProduct';
    id: string;
    code?: string | null;
    name: string;
  }>;
};

export type MyBuyListProductsQueryVariables = Exact<{ [key: string]: never }>;

export type MyBuyListProductsQuery = {
  __typename?: 'Query';
  myBuyListProducts: Array<{
    __typename?: 'PlatformProduct';
    id: string;
    code?: string | null;
    name: string;
  }>;
};

export type PlatformProductByIdQueryVariables = Exact<{
  platformProductId: Scalars['ID']['input'];
}>;

export type PlatformProductByIdQuery = {
  __typename?: 'Query';
  platformProduct?: {
    __typename?: 'PlatformProduct';
    actualLengthInches?: number | null;
    actualThicknessInches?: number | null;
    actualWidthInches?: number | null;
    category: PlatformProductCategory;
    code?: string | null;
    constructionCode?: string | null;
    finishCode?: string | null;
    harmonizedCode?: string | null;
    id: string;
    materialCode?: string | null;
    name: string;
    nominalThicknessInches?: number | null;
    nominalWidthInches?: number | null;
    properties?: Record<string, unknown> | null;
    standardUnitsCode: UnitCode;
    lengths?: Array<{
      __typename?: 'Length';
      actualLengthInches: number;
      nominalLengthInches?: number | null;
      displayValue: string;
      id: string;
    } | null> | null;
    piecesPerBundle: { __typename?: 'Quantity'; value: number; unit: UnitCode };
    platformProductVehicleCapacities?: Array<{
      __typename?: 'PlatformProductVehicleCapacity';
      id: string;
      transportVehicle: {
        __typename?: 'TransportVehicle';
        id: string;
        name: string;
        vehicleType: VehicleType;
      };
      capacity: { __typename?: 'Quantity'; value: number; unit: UnitCode };
    } | null> | null;
  } | null;
};

export type EnsurePlatformProductLengthMutationVariables = Exact<{
  platformProductId: Scalars['ID']['input'];
  lengthId: Scalars['ID']['input'];
}>;

export type EnsurePlatformProductLengthMutation = {
  __typename?: 'Mutation';
  ensurePlatformProductLength: {
    __typename?: 'PlatformProductLength';
    id: string;
    isNominal?: boolean | null;
    length: {
      __typename?: 'Length';
      id: string;
      nominalLengthInches?: number | null;
      actualLengthInches: number;
    };
    platformProduct: {
      __typename?: 'PlatformProduct';
      nominalWidthInches?: number | null;
      actualWidthInches?: number | null;
      nominalThicknessInches?: number | null;
      actualThicknessInches?: number | null;
      actualLengthInches?: number | null;
      piecesPerBundle: {
        __typename?: 'Quantity';
        value: number;
        unit: UnitCode;
      };
    };
  };
};

export type PendingPriceNegotiationsQueryVariables = Exact<{
  platformProductId: Scalars['ID']['input'];
}>;

export type PendingPriceNegotiationsQuery = {
  __typename?: 'Query';
  pendingPriceNegotiations: Array<{
    __typename?: 'PriceNegotiation';
    id: string;
    platformProductLength?: {
      __typename?: 'PlatformProductLength';
      id: string;
    } | null;
    platformProductCannedTally?: {
      __typename?: 'PlatformProductCannedTally';
      id: string;
    } | null;
    sellingOrganization: { __typename?: 'Organization'; id: string };
  }>;
};

export type AcceptedPriceNegotiationsQueryVariables = Exact<{
  platformProductId: Scalars['ID']['input'];
}>;

export type AcceptedPriceNegotiationsQuery = {
  __typename?: 'Query';
  acceptedPriceNegotiations: Array<{
    __typename?: 'PriceNegotiation';
    id: string;
    unit: UnitCode;
    platformProductCannedTally?: {
      __typename?: 'PlatformProductCannedTally';
      id: string;
    } | null;
    sellingOrganization: { __typename?: 'Organization'; id: string };
    offeredPrice?: {
      __typename?: 'Money';
      amount: number;
      currency: Currency;
    } | null;
  }>;
};

export type SellerPriceNegotiationsQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  size: Scalars['Int']['input'];
  assignedToMe?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Array<PriceNegotiationStatus> | PriceNegotiationStatus>;
}>;

export type SellerPriceNegotiationsQuery = {
  __typename?: 'Query';
  sellerPriceNegotiations: {
    __typename?: 'PagedPriceNegotiations';
    paging: {
      __typename?: 'Paging';
      totalElements: number;
      totalPages: number;
      number: number;
      size: number;
    };
    content: Array<{
      __typename?: 'PriceNegotiation';
      id: string;
      status: PriceNegotiationStatus;
      unit: UnitCode;
      buyerNote?: string | null;
      sellerNote?: string | null;
      createdAt: string;
      updatedAt?: string | null;
      targetPrice?: {
        __typename?: 'Money';
        amount: number;
        currency: Currency;
      } | null;
      offeredPrice?: {
        __typename?: 'Money';
        amount: number;
        currency: Currency;
      } | null;
      buyingOrganization: {
        __typename?: 'Organization';
        id: string;
        name: string;
      };
      sellingOrganization: {
        __typename?: 'Organization';
        id: string;
        name: string;
        sellingOrganizationCode?: string | null;
      };
      createdBy: {
        __typename?: 'User';
        id: string;
        firstName: string;
        lastName: string;
      };
      platformProductLength?: {
        __typename?: 'PlatformProductLength';
        id: string;
        lengthDisplayValue: string;
        isNominal?: boolean | null;
        platformProduct: {
          __typename?: 'PlatformProduct';
          id: string;
          name: string;
          code?: string | null;
        };
      } | null;
      platformProductCannedTally?: {
        __typename?: 'PlatformProductCannedTally';
        id: string;
        name: string;
        platformProduct: {
          __typename?: 'PlatformProduct';
          id: string;
          code?: string | null;
        };
      } | null;
      recipients: Array<{
        __typename?: 'User';
        id: string;
        firstName: string;
        lastName: string;
      }>;
    }>;
  };
};

export type SellerPriceNegotiationDetailQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type SellerPriceNegotiationDetailQuery = {
  __typename?: 'Query';
  sellerPriceNegotiation: {
    __typename?: 'PriceNegotiation';
    id: string;
    offerCurrency: Currency;
    tallyRecipe?: Array<{
      __typename?: 'PriceNegotiationTallyRecipeLine';
      lengthLabel: string;
      bundleCount: number;
      piecesPerBundle: number;
    }> | null;
    currentSellerListPrice?: {
      __typename?: 'Money';
      amount: number;
      currency: Currency;
    } | null;
  };
};

export type SellerPriceNegotiationCountsQueryVariables = Exact<{
  assignedToMe?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type SellerPriceNegotiationCountsQuery = {
  __typename?: 'Query';
  sellerPriceNegotiationCounts: {
    __typename?: 'PriceNegotiationStatusCount';
    waiting: number;
    responded: number;
  };
};

export type BuyerPriceNegotiationsQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  size: Scalars['Int']['input'];
  status?: InputMaybe<Array<PriceNegotiationStatus> | PriceNegotiationStatus>;
}>;

export type BuyerPriceNegotiationsQuery = {
  __typename?: 'Query';
  buyerPriceNegotiations: {
    __typename?: 'PagedPriceNegotiations';
    paging: {
      __typename?: 'Paging';
      totalElements: number;
      totalPages: number;
      number: number;
      size: number;
    };
    content: Array<{
      __typename?: 'PriceNegotiation';
      id: string;
      status: PriceNegotiationStatus;
      unit: UnitCode;
      buyerNote?: string | null;
      sellerNote?: string | null;
      createdAt: string;
      updatedAt?: string | null;
      targetPrice?: {
        __typename?: 'Money';
        amount: number;
        currency: Currency;
      } | null;
      offeredPrice?: {
        __typename?: 'Money';
        amount: number;
        currency: Currency;
      } | null;
      buyingOrganization: {
        __typename?: 'Organization';
        id: string;
        name: string;
      };
      sellingOrganization: {
        __typename?: 'Organization';
        id: string;
        name: string;
        sellingOrganizationCode?: string | null;
      };
      createdBy: {
        __typename?: 'User';
        id: string;
        firstName: string;
        lastName: string;
      };
      recipients: Array<{
        __typename?: 'User';
        id: string;
        firstName: string;
        lastName: string;
      }>;
      platformProductLength?: {
        __typename?: 'PlatformProductLength';
        id: string;
        lengthDisplayValue: string;
        isNominal?: boolean | null;
        platformProduct: {
          __typename?: 'PlatformProduct';
          id: string;
          name: string;
          code?: string | null;
        };
      } | null;
      platformProductCannedTally?: {
        __typename?: 'PlatformProductCannedTally';
        id: string;
        name: string;
        platformProduct: {
          __typename?: 'PlatformProduct';
          id: string;
          code?: string | null;
        };
      } | null;
    }>;
  };
};

export type BuyerPriceNegotiationCountsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type BuyerPriceNegotiationCountsQuery = {
  __typename?: 'Query';
  buyerPriceNegotiationCounts: {
    __typename?: 'PriceNegotiationStatusCount';
    waiting: number;
    responded: number;
  };
};

export type RequestPriceNegotiationMutationVariables = Exact<{
  platformProductLengthIds:
    Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  sellingOrganizationIds:
    Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  targetPrice?: InputMaybe<MoneyInput>;
  buyerNote?: InputMaybe<Scalars['String']['input']>;
  recipientUserIds?: InputMaybe<
    Array<Scalars['ID']['input']> | Scalars['ID']['input']
  >;
}>;

export type RequestPriceNegotiationMutation = {
  __typename?: 'Mutation';
  requestPriceNegotiation?: boolean | null;
};

export type RespondToPriceNegotiationInAppMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: RespondToPriceNegotiationInput;
}>;

export type RespondToPriceNegotiationInAppMutation = {
  __typename?: 'Mutation';
  respondToPriceNegotiationInApp: {
    __typename?: 'PriceNegotiation';
    id: string;
    status: PriceNegotiationStatus;
  };
};

export type DeclinePriceNegotiationRequestMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
}>;

export type DeclinePriceNegotiationRequestMutation = {
  __typename?: 'Mutation';
  declinePriceNegotiationRequest: {
    __typename?: 'PriceNegotiation';
    id: string;
    status: PriceNegotiationStatus;
  };
};

export type RequestTallyPriceNegotiationMutationVariables = Exact<{
  platformProductCannedTallyIds:
    Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  sellingOrganizationIds:
    Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  unit: UnitCode;
  targetPrice?: InputMaybe<MoneyInput>;
  buyerNote?: InputMaybe<Scalars['String']['input']>;
  recipientUserIds?: InputMaybe<
    Array<Scalars['ID']['input']> | Scalars['ID']['input']
  >;
}>;

export type RequestTallyPriceNegotiationMutation = {
  __typename?: 'Mutation';
  requestTallyPriceNegotiation?: boolean | null;
};

export type ChooseOrderPrimaryContactMutationVariables = Exact<{
  orderId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
}>;

export type ChooseOrderPrimaryContactMutation = {
  __typename?: 'Mutation';
  chooseOrderPrimaryContact: {
    __typename?: 'Order';
    id: string;
    canChoosePrimaryContact: boolean;
  };
};

export type ProductPropertyKeysWithValuesQueryVariables = Exact<{
  category: PlatformProductCategory;
}>;

export type ProductPropertyKeysWithValuesQuery = {
  __typename?: 'Query';
  productPropertyKeysWithValues: Array<{
    __typename?: 'ProductPropertyKeyWithValues';
    key: string;
    displayName: string;
    isArray: boolean;
    values: Array<{
      __typename?: 'ProductPropertyValue';
      value: string;
      displayValue: string;
    }>;
  }>;
};

export type PropertyValuesQueryVariables = Exact<{
  category: PlatformProductCategory;
  key: Scalars['String']['input'];
}>;

export type PropertyValuesQuery = {
  __typename?: 'Query';
  productPropertyValues: Array<{
    __typename?: 'ProductPropertyValue';
    value: string;
    displayValue: string;
  }>;
};

export type AllUniqueProductsQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  size: Scalars['Int']['input'];
  filters?: InputMaybe<UniqueProductFiltersInput>;
}>;

export type AllUniqueProductsQuery = {
  __typename?: 'Query';
  findAvailableUniqueProductsWithSellers: {
    __typename?: 'PagedUniqueProductWithSellers';
    paging: {
      __typename?: 'Paging';
      totalElements: number;
      totalPages: number;
      number: number;
      size: number;
    };
    content: Array<{
      __typename?: 'UniqueProductWithSellers';
      id: string;
      lengths?: Array<{
        __typename?: 'Length';
        actualLengthInches: number;
        nominalLengthInches?: number | null;
        displayValue: string;
        id: string;
      } | null> | null;
      marketAvailability?: {
        __typename?: 'MarketAvailability';
        listingsCount: number;
        leadTimeMin: number;
        leadTimeMax: number;
        sellersCount: number;
        priceMin?: {
          __typename?: 'Money';
          amount: number;
          currency: Currency;
        } | null;
        priceMax?: {
          __typename?: 'Money';
          amount: number;
          currency: Currency;
        } | null;
        totalStock: { __typename?: 'Quantity'; value: number; unit: UnitCode };
      } | null;
      landedPriceRange?: {
        __typename?: 'MoneyRange';
        min: { __typename?: 'Money'; amount: number; currency: Currency };
        max: { __typename?: 'Money'; amount: number; currency: Currency };
      } | null;
      platformProduct: {
        __typename?: 'PlatformProduct';
        id: string;
        name: string;
        category: PlatformProductCategory;
        finishCode?: string | null;
        standardUnitsCode: UnitCode;
        nominalWidthInches?: number | null;
        actualWidthInches?: number | null;
        nominalThicknessInches?: number | null;
        actualThicknessInches?: number | null;
        actualLengthInches?: number | null;
        properties?: Record<string, unknown> | null;
        piecesPerBundle: {
          __typename?: 'Quantity';
          value: number;
          unit: UnitCode;
        };
        platformProductVehicleCapacities?: Array<{
          __typename?: 'PlatformProductVehicleCapacity';
          id: string;
          isOrganizationOverride: boolean;
          transportVehicle: {
            __typename?: 'TransportVehicle';
            id: string;
            name: string;
            vehicleType: VehicleType;
          };
          capacity: { __typename?: 'Quantity'; value: number; unit: UnitCode };
        } | null> | null;
      };
    } | null>;
  };
};

export type UpdateCartMutationVariables = Exact<{
  quantity?: InputMaybe<QuantityInput>;
  locationId: Scalars['ID']['input'];
  sellerOrganizationFacilityId: Scalars['ID']['input'];
  piecesPerBundle?: InputMaybe<Scalars['Int']['input']>;
  suggestedPrice?: InputMaybe<Scalars['Float']['input']>;
  platformProductInputFilter: PlatformProductInputFilter;
  parentOrderId?: InputMaybe<Scalars['ID']['input']>;
}>;

export type UpdateCartMutation = {
  __typename?: 'Mutation';
  updateCart?: {
    __typename?: 'Cart';
    id: string;
    items?: Array<{
      __typename?: 'OrderItem';
      effectivePiecesPerBundle: number;
      quantity: { __typename?: 'Quantity'; value: number; unit: UnitCode };
      suggestedPrice?: {
        __typename?: 'Money';
        amount: number;
        currency: Currency;
      } | null;
    }> | null;
  } | null;
};

export type SetRandomTallyInCartMutationVariables = Exact<{
  sellerOrganizationFacilityId: Scalars['ID']['input'];
  locationId: Scalars['ID']['input'];
  platformProductId: Scalars['ID']['input'];
  bundles: Array<RandomTallyBundleInput> | RandomTallyBundleInput;
  parentOrderId?: InputMaybe<Scalars['ID']['input']>;
}>;

export type SetRandomTallyInCartMutation = {
  __typename?: 'Mutation';
  setRandomTallyInCart?: { __typename?: 'Cart'; id: string } | null;
};

export type SetCartItemBuyCodeMutationVariables = Exact<{
  cartId: Scalars['ID']['input'];
  platformProductLengthId: Scalars['ID']['input'];
  buyCode?: InputMaybe<Scalars['String']['input']>;
}>;

export type SetCartItemBuyCodeMutation = {
  __typename?: 'Mutation';
  setCartItemBuyCode?: {
    __typename?: 'Cart';
    id: string;
    items?: Array<{ __typename?: 'OrderItem'; buyCode?: string | null }> | null;
  } | null;
};

export type RemoveCannedTallyItemsMutationVariables = Exact<{
  cartId: Scalars['ID']['input'];
  tallyPlatformProductId: Scalars['ID']['input'];
}>;

export type RemoveCannedTallyItemsMutation = {
  __typename?: 'Mutation';
  removeCannedTallyItems?: { __typename?: 'Cart'; id: string } | null;
};

export type RemoveCartItemMutationVariables = Exact<{
  cartId: Scalars['ID']['input'];
  platformProductLengthId: Scalars['ID']['input'];
}>;

export type RemoveCartItemMutation = {
  __typename?: 'Mutation';
  removeCartItem?: { __typename?: 'Cart'; id: string } | null;
};

export type RemoveRandomTallyMutationVariables = Exact<{
  cartId: Scalars['ID']['input'];
  tallyPlatformProductId: Scalars['ID']['input'];
}>;

export type RemoveRandomTallyMutation = {
  __typename?: 'Mutation';
  removeRandomTally?: { __typename?: 'Cart'; id: string } | null;
};

export type UpdateCartTransportMutationVariables = Exact<{
  cartId: Scalars['ID']['input'];
  incoTerm: LogisticsIncoterm;
  transportVehicleId?: InputMaybe<Scalars['ID']['input']>;
  internationalShipping?: InputMaybe<InternationalShippingInput>;
}>;

export type UpdateCartTransportMutation = {
  __typename?: 'Mutation';
  updateCartTransport?: {
    __typename?: 'Cart';
    id: string;
    deliveryMethod?: DeliveryMethod | null;
    incotermLoading?: LogisticsIncoterm | null;
    incotermDischarge?: LogisticsIncoterm | null;
    incotermAddressDestination?: string | null;
    transportVehicle?: {
      __typename?: 'TransportVehicle';
      id: string;
      name: string;
    } | null;
    portOfLoading?: {
      __typename?: 'Port';
      id: string;
      code?: string | null;
      name: string;
    } | null;
    portOfDischarge?: {
      __typename?: 'Port';
      id: string;
      code?: string | null;
      name: string;
    } | null;
    shippingRoute?: {
      __typename?: 'ShippingRoute';
      id: string;
      status: ShippingRouteStatus;
      forwarder?: string | null;
      transitDays?: number | null;
    } | null;
  } | null;
};

export type UpdateCartTarpMutationVariables = Exact<{
  cartId: Scalars['ID']['input'];
  tarp: Scalars['Boolean']['input'];
}>;

export type UpdateCartTarpMutation = {
  __typename?: 'Mutation';
  updateCartTarp?: { __typename?: 'Cart'; id: string; tarp: boolean } | null;
};

export type UpdateCartDeliveryAddressMutationVariables = Exact<{
  cartId: Scalars['ID']['input'];
  deliveryAddress?: InputMaybe<DeliveryAddressInput>;
}>;

export type UpdateCartDeliveryAddressMutation = {
  __typename?: 'Mutation';
  updateCartDeliveryAddress?: {
    __typename?: 'Cart';
    id: string;
    incotermAddressDestination?: string | null;
    deliveryAddress?: {
      __typename?: 'DeliveryAddress';
      addressLine1?: string | null;
      addressLine2?: string | null;
      city?: string | null;
      region?: string | null;
      zipCode?: string | null;
      country?: string | null;
      latitude?: number | null;
      longitude?: number | null;
    } | null;
  } | null;
};

export type GetCartsWithFilterQueryVariables = Exact<{
  locationId?: InputMaybe<Scalars['ID']['input']>;
  withContacts: Scalars['Boolean']['input'];
}>;

export type GetCartsWithFilterQuery = {
  __typename?: 'Query';
  carts?: Array<{
    __typename?: 'Cart';
    id: string;
    isFromQuote: boolean;
    incoTerm?: LogisticsIncoterm | null;
    deliveryMethod?: DeliveryMethod | null;
    isInternational: boolean;
    tarp: boolean;
    currency?: Currency | null;
    incotermLoading?: LogisticsIncoterm | null;
    incotermDischarge?: LogisticsIncoterm | null;
    incotermAddressDestination?: string | null;
    sellerContacts?: Array<{
      __typename?: 'User';
      id: string;
      firstName: string;
      lastName: string;
      phoneNumber?: string | null;
      externalId?: string | null;
    }>;
    parentOrder?: { __typename?: 'Order'; id: string } | null;
    deliveryAddress?: {
      __typename?: 'DeliveryAddress';
      addressLine1?: string | null;
      addressLine2?: string | null;
      city?: string | null;
      region?: string | null;
      zipCode?: string | null;
      country?: string | null;
      latitude?: number | null;
      longitude?: number | null;
    } | null;
    sellingOrganization: {
      __typename?: 'Organization';
      id: string;
      name: string;
      sellingOrganizationCode?: string | null;
    };
    items?: Array<{
      __typename?: 'OrderItem';
      effectivePiecesPerBundle: number;
      buyCode?: string | null;
      platformProductsLengths: {
        __typename?: 'PlatformProductLength';
        id: string;
        isNominal?: boolean | null;
        lengthDisplayValue: string;
        latestPriceMid?: {
          __typename?: 'Money';
          amount: number;
          currency: Currency;
        } | null;
        platformProduct: {
          __typename?: 'PlatformProduct';
          id: string;
          name: string;
          code?: string | null;
          category: PlatformProductCategory;
          nominalThicknessInches?: number | null;
          nominalWidthInches?: number | null;
          actualThicknessInches?: number | null;
          actualWidthInches?: number | null;
          actualLengthInches?: number | null;
          standardUnitsCode: UnitCode;
          properties?: Record<string, unknown> | null;
          piecesPerBundle: {
            __typename?: 'Quantity';
            value: number;
            unit: UnitCode;
          };
        };
        platformProductVehicleCapacities?: Array<{
          __typename?: 'PlatformProductVehicleCapacity';
          isOrganizationOverride: boolean;
          transportVehicle: {
            __typename?: 'TransportVehicle';
            id: string;
            vehicleType: VehicleType;
          };
          capacity: { __typename?: 'Quantity'; value: number; unit: UnitCode };
        } | null> | null;
        length: {
          __typename?: 'Length';
          id: string;
          actualLengthInches: number;
          nominalLengthInches?: number | null;
        };
      };
      price?: {
        __typename?: 'Money';
        amount: number;
        currency: Currency;
      } | null;
      suggestedPrice?: {
        __typename?: 'Money';
        amount: number;
        currency: Currency;
      } | null;
      effectivePrice?: {
        __typename?: 'Money';
        amount: number;
        currency: Currency;
      } | null;
      quantityStored: { __typename?: 'Quantity'; value: number };
      pricePerPiece?: {
        __typename?: 'Money';
        amount: number;
        currency: Currency;
      } | null;
      suggestedPricePerPiece?: {
        __typename?: 'Money';
        amount: number;
        currency: Currency;
      } | null;
      pickupPricePerPiece?: {
        __typename?: 'Money';
        amount: number;
        currency: Currency;
      } | null;
      deliveryPricePerPiece?: {
        __typename?: 'Money';
        amount: number;
        currency: Currency;
      } | null;
      quantity: { __typename?: 'Quantity'; value: number; unit: UnitCode };
      tallyPlatformProduct?: {
        __typename?: 'PlatformProduct';
        id: string;
      } | null;
      cannedTally?: {
        __typename?: 'PlatformProductCannedTally';
        id: string;
        name: string;
      } | null;
    }> | null;
    portOfLoading?: {
      __typename?: 'Port';
      id: string;
      code?: string | null;
      name: string;
      city?: string | null;
      country?: string | null;
      type: PortType;
    } | null;
    portOfDischarge?: {
      __typename?: 'Port';
      id: string;
      code?: string | null;
      name: string;
      city?: string | null;
      country?: string | null;
      type: PortType;
    } | null;
    shippingRoute?: {
      __typename?: 'ShippingRoute';
      id: string;
      status: ShippingRouteStatus;
      forwarder?: string | null;
      hasForwarderContact: boolean;
      transitDays?: number | null;
      freeDays?: number | null;
      incotermLoading?: LogisticsIncoterm | null;
      incotermDischarge?: LogisticsIncoterm | null;
      freightCost?: {
        __typename?: 'Money';
        amount: number;
        currency: Currency;
      } | null;
    } | null;
    transportVehicle?: {
      __typename?: 'TransportVehicle';
      id: string;
      name: string;
      vehicleType: VehicleType;
    } | null;
    sellerOrganizationFacility: {
      __typename?: 'Facility';
      id: string;
      code?: string | null;
      transportVehicles: Array<{
        __typename?: 'TransportVehicle';
        id: string;
        name: string;
        vehicleType: VehicleType;
      }>;
      nearestPort?: {
        __typename?: 'Port';
        id: string;
        code?: string | null;
        name: string;
        city?: string | null;
        country?: string | null;
        type: PortType;
      } | null;
      address: {
        __typename?: 'Address';
        addressLine1: string;
        addressLine2?: string | null;
        city: string;
        country: string;
        region?: string | null;
      };
    };
    shippingLocation: {
      __typename?: 'Location';
      id: string;
      name: string;
      facility: {
        __typename?: 'Facility';
        transportVehicles: Array<{
          __typename?: 'TransportVehicle';
          id: string;
          name: string;
          vehicleType: VehicleType;
        }>;
        nearestPort?: {
          __typename?: 'Port';
          id: string;
          code?: string | null;
          name: string;
          city?: string | null;
          country?: string | null;
          type: PortType;
        } | null;
        address: {
          __typename?: 'Address';
          addressLine1: string;
          addressLine2?: string | null;
          city: string;
          region?: string | null;
          zipCode?: string | null;
          country: string;
          latitude?: number | null;
          longitude?: number | null;
        };
      };
    };
  }> | null;
};

export type GetCartQueryVariables = Exact<{
  cartId: Scalars['ID']['input'];
}>;

export type GetCartQuery = {
  __typename?: 'Query';
  cart?: {
    __typename?: 'Cart';
    id: string;
    lockedRecipientIds: Array<string>;
    purchaseOrderDatesRequired: boolean;
    incoTerm?: LogisticsIncoterm | null;
    deliveryMethod?: DeliveryMethod | null;
    isInternational: boolean;
    tarp: boolean;
    currency?: Currency | null;
    incotermLoading?: LogisticsIncoterm | null;
    incotermDischarge?: LogisticsIncoterm | null;
    incotermAddressDestination?: string | null;
    recipients: Array<{ __typename?: 'User'; id: string }>;
    primaryContact?:
      | ({ __typename?: 'User' } & {
          ' $fragmentRefs'?: { PrimaryContactFragment: PrimaryContactFragment };
        })
      | null;
    deliveryAddress?: {
      __typename?: 'DeliveryAddress';
      addressLine1?: string | null;
      addressLine2?: string | null;
      city?: string | null;
      region?: string | null;
      zipCode?: string | null;
      country?: string | null;
      latitude?: number | null;
      longitude?: number | null;
    } | null;
    sellingOrganization: {
      __typename?: 'Organization';
      id: string;
      name: string;
      sellingOrganizationCode?: string | null;
    };
    items?: Array<{
      __typename?: 'OrderItem';
      effectivePiecesPerBundle: number;
      buyCode?: string | null;
      price?: {
        __typename?: 'Money';
        amount: number;
        currency: Currency;
      } | null;
      suggestedPrice?: {
        __typename?: 'Money';
        amount: number;
        currency: Currency;
      } | null;
      effectivePrice?: {
        __typename?: 'Money';
        amount: number;
        currency: Currency;
      } | null;
      pickupPrice?: {
        __typename?: 'Money';
        amount: number;
        currency: Currency;
      } | null;
      deliveryPrice?: {
        __typename?: 'Money';
        amount: number;
        currency: Currency;
      } | null;
      quantityStored: { __typename?: 'Quantity'; value: number };
      pricePerPiece?: {
        __typename?: 'Money';
        amount: number;
        currency: Currency;
      } | null;
      suggestedPricePerPiece?: {
        __typename?: 'Money';
        amount: number;
        currency: Currency;
      } | null;
      pickupPricePerPiece?: {
        __typename?: 'Money';
        amount: number;
        currency: Currency;
      } | null;
      deliveryPricePerPiece?: {
        __typename?: 'Money';
        amount: number;
        currency: Currency;
      } | null;
      quantity: { __typename?: 'Quantity'; value: number; unit: UnitCode };
      platformProductsLengths: {
        __typename?: 'PlatformProductLength';
        id: string;
        isNominal?: boolean | null;
        lengthDisplayValue: string;
        platformProduct: {
          __typename?: 'PlatformProduct';
          id: string;
          name: string;
          category: PlatformProductCategory;
          nominalThicknessInches?: number | null;
          nominalWidthInches?: number | null;
          actualThicknessInches?: number | null;
          actualWidthInches?: number | null;
          actualLengthInches?: number | null;
          standardUnitsCode: UnitCode;
          properties?: Record<string, unknown> | null;
          piecesPerBundle: {
            __typename?: 'Quantity';
            value: number;
            unit: UnitCode;
          };
        };
        platformProductVehicleCapacities?: Array<{
          __typename?: 'PlatformProductVehicleCapacity';
          transportVehicle: {
            __typename?: 'TransportVehicle';
            id: string;
            vehicleType: VehicleType;
          };
          capacity: { __typename?: 'Quantity'; value: number; unit: UnitCode };
        } | null> | null;
        length: {
          __typename?: 'Length';
          id: string;
          actualLengthInches: number;
          nominalLengthInches?: number | null;
        };
      };
      tallyPlatformProduct?: {
        __typename?: 'PlatformProduct';
        id: string;
      } | null;
      cannedTally?: {
        __typename?: 'PlatformProductCannedTally';
        id: string;
        name: string;
      } | null;
    }> | null;
    portOfLoading?: {
      __typename?: 'Port';
      id: string;
      code?: string | null;
      name: string;
      city?: string | null;
      country?: string | null;
      type: PortType;
    } | null;
    portOfDischarge?: {
      __typename?: 'Port';
      id: string;
      code?: string | null;
      name: string;
      city?: string | null;
      country?: string | null;
      type: PortType;
    } | null;
    shippingRoute?: {
      __typename?: 'ShippingRoute';
      id: string;
      status: ShippingRouteStatus;
      forwarder?: string | null;
      hasForwarderContact: boolean;
      transitDays?: number | null;
      freeDays?: number | null;
      incotermLoading?: LogisticsIncoterm | null;
      incotermDischarge?: LogisticsIncoterm | null;
      freightCost?: {
        __typename?: 'Money';
        amount: number;
        currency: Currency;
      } | null;
    } | null;
    transportVehicle?: {
      __typename?: 'TransportVehicle';
      id: string;
      vehicleType: VehicleType;
    } | null;
    shippingLocation: {
      __typename?: 'Location';
      id: string;
      name: string;
      facility: {
        __typename?: 'Facility';
        address: {
          __typename?: 'Address';
          addressLine1: string;
          city: string;
          region?: string | null;
          zipCode?: string | null;
          latitude?: number | null;
          longitude?: number | null;
        };
      };
    };
  } | null;
};

export type ProductCategoriesQueryVariables = Exact<{ [key: string]: never }>;

export type ProductCategoriesQuery = {
  __typename?: 'Query';
  platformProductCategories: Array<{
    __typename?: 'PlatformProductCategoryOption';
    value: PlatformProductCategory;
    label: string;
  }>;
};

export type ProductFilterOptionsQueryVariables = Exact<{
  category: PlatformProductCategory;
}>;

export type ProductFilterOptionsQuery = {
  __typename?: 'Query';
  platformProductDimensions: Array<{
    __typename?: 'ProductDimension';
    nominalThicknessInches?: number | null;
    nominalWidthInches?: number | null;
  }>;
  productPropertyKeys: Array<{
    __typename?: 'ProductPropertyKey';
    key: string;
    displayName: string;
    isArray: boolean;
  }>;
};

export type BuyerInventoryLocationsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type BuyerInventoryLocationsQuery = {
  __typename?: 'Query';
  allUniqueProductInventoryLocationsForBuyer: Array<{
    __typename?: 'Location';
    id: string;
    name: string;
    facility: {
      __typename?: 'Facility';
      address: {
        __typename?: 'Address';
        addressLine1: string;
        addressLine2?: string | null;
        city: string;
        region?: string | null;
        zipCode?: string | null;
        country: string;
      };
    };
  }>;
};

export type CatalogLengthsQueryVariables = Exact<{
  platformProductId: Scalars['ID']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  pageInput: PageInput;
}>;

export type CatalogLengthsQuery = {
  __typename?: 'Query';
  lengths: {
    __typename?: 'PagedCatalogLengthOptions';
    content: Array<{
      __typename?: 'CatalogLengthOption';
      length: {
        __typename?: 'Length';
        id: string;
        displayValue: string;
        actualLengthInches: number;
      };
      platformProductLength: {
        __typename?: 'PlatformProductLength';
        id: string;
        isNominal?: boolean | null;
        length: {
          __typename?: 'Length';
          nominalLengthInches?: number | null;
          actualLengthInches: number;
        };
        platformProduct: {
          __typename?: 'PlatformProduct';
          nominalWidthInches?: number | null;
          actualWidthInches?: number | null;
          nominalThicknessInches?: number | null;
          actualThicknessInches?: number | null;
          actualLengthInches?: number | null;
          piecesPerBundle: {
            __typename?: 'Quantity';
            value: number;
            unit: UnitCode;
          };
        };
      };
    }>;
    paging: {
      __typename?: 'Paging';
      number: number;
      size: number;
      totalElements: number;
      totalPages: number;
    };
  };
};

export type QuoteTimelineRoundFragment = {
  __typename?: 'QuoteRound';
  roundNumber: number;
  party: QuoteRoundParty;
  authorName: string;
  declined: boolean;
  declineReason?: string | null;
  createdAt: string;
  pickupPriceForTally?: {
    __typename?: 'Money';
    amount: number;
    currency: Currency;
  } | null;
  deliveryPriceForTally?: {
    __typename?: 'Money';
    amount: number;
    currency: Currency;
  } | null;
  items: Array<{
    __typename?: 'QuoteRoundItem';
    pickupPrice?: {
      __typename?: 'Money';
      amount: number;
      currency: Currency;
    } | null;
    deliveryPrice?: {
      __typename?: 'Money';
      amount: number;
      currency: Currency;
    } | null;
    platformProductsLength: {
      __typename?: 'PlatformProductLength';
      lengthDisplayValue: string;
    };
  }>;
} & { ' $fragmentName'?: 'QuoteTimelineRoundFragment' };

export type QuoteOfferRoundFragment = {
  __typename?: 'QuoteRound';
  roundNumber: number;
  party: QuoteRoundParty;
  pickupPriceForTally?: {
    __typename?: 'Money';
    amount: number;
    currency: Currency;
  } | null;
  deliveryPriceForTally?: {
    __typename?: 'Money';
    amount: number;
    currency: Currency;
  } | null;
  items: Array<{
    __typename?: 'QuoteRoundItem';
    quantityInPieces: number;
    piecesPerBundle?: number | null;
    pickupPrice?: {
      __typename?: 'Money';
      amount: number;
      currency: Currency;
    } | null;
    deliveryPrice?: {
      __typename?: 'Money';
      amount: number;
      currency: Currency;
    } | null;
    platformProductsLength: {
      __typename?: 'PlatformProductLength';
      id: string;
    };
  }>;
} & { ' $fragmentName'?: 'QuoteOfferRoundFragment' };

export type RequestForQuotesQueryVariables = Exact<{ [key: string]: never }>;

export type RequestForQuotesQuery = {
  __typename?: 'Query';
  requestForQuotes: Array<{
    __typename?: 'RequestForQuote';
    id: string;
    status: RequestForQuoteStatus;
    createdAt: string;
    tallyPlatformProduct?: {
      __typename?: 'PlatformProduct';
      id: string;
      name: string;
    } | null;
    items: Array<{
      __typename?: 'RequestForQuoteItem';
      id: string;
      platformProductsLength: {
        __typename?: 'PlatformProductLength';
        platformProduct: {
          __typename?: 'PlatformProduct';
          id: string;
          name: string;
        };
      };
    }>;
  }>;
};

export type DraftRequestForQuoteQueryVariables = Exact<{
  tallyPlatformProductId: Scalars['ID']['input'];
  shippingLocationId: Scalars['ID']['input'];
}>;

export type DraftRequestForQuoteQuery = {
  __typename?: 'Query';
  draftRequestForQuote?: {
    __typename?: 'RequestForQuote';
    id: string;
    leadTimeDays?: number | null;
    useTallyPrice: boolean;
    pickupPriceForTally?: {
      __typename?: 'Money';
      amount: number;
      currency: Currency;
    } | null;
    deliveryPriceForTally?: {
      __typename?: 'Money';
      amount: number;
      currency: Currency;
    } | null;
    items: Array<{
      __typename?: 'RequestForQuoteItem';
      id: string;
      quantityInPieces: number;
      pickupPrice?: {
        __typename?: 'Money';
        amount: number;
        currency: Currency;
      } | null;
      deliveryPrice?: {
        __typename?: 'Money';
        amount: number;
        currency: Currency;
      } | null;
      platformProductsLength: {
        __typename?: 'PlatformProductLength';
        id: string;
        length: { __typename?: 'Length'; id: string };
      };
    }>;
  } | null;
};

export type GetRequestForQuoteWithQuotesQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type GetRequestForQuoteWithQuotesQuery = {
  __typename?: 'Query';
  requestForQuote?: {
    __typename?: 'RequestForQuote';
    id: string;
    status: RequestForQuoteStatus;
    createdAt: string;
    createdByUserName?: string | null;
    leadTimeDays?: number | null;
    useTallyPrice: boolean;
    cannedTallyCount?: number | null;
    currency?: Currency | null;
    buyList?: { __typename?: 'BuyList'; id: string } | null;
    cannedTally?: {
      __typename?: 'PlatformProductCannedTally';
      id: string;
      name: string;
    } | null;
    tallyPlatformProduct?: {
      __typename?: 'PlatformProduct';
      id: string;
      name: string;
      standardUnitsCode: UnitCode;
      piecesPerBundle: {
        __typename?: 'Quantity';
        value: number;
        unit: UnitCode;
      };
    } | null;
    shippingLocation?: {
      __typename?: 'Location';
      id: string;
      name: string;
      code: string;
      facility: {
        __typename?: 'Facility';
        id: string;
        address: {
          __typename?: 'Address';
          addressLine1: string;
          addressLine2?: string | null;
          city: string;
          region?: string | null;
          zipCode?: string | null;
          country: string;
        };
      };
    } | null;
    pickupPriceForTally?: {
      __typename?: 'Money';
      amount: number;
      currency: Currency;
    } | null;
    deliveryPriceForTally?: {
      __typename?: 'Money';
      amount: number;
      currency: Currency;
    } | null;
    items: Array<{
      __typename?: 'RequestForQuoteItem';
      id: string;
      quantityInPieces: number;
      piecesPerBundle?: number | null;
      pickupPrice?: {
        __typename?: 'Money';
        amount: number;
        currency: Currency;
      } | null;
      deliveryPrice?: {
        __typename?: 'Money';
        amount: number;
        currency: Currency;
      } | null;
      platformProductsLength: {
        __typename?: 'PlatformProductLength';
        id: string;
        lengthDisplayValue: string;
        isNominal?: boolean | null;
        length: {
          __typename?: 'Length';
          id: string;
          displayValue: string;
          actualLengthInches: number;
          nominalLengthInches?: number | null;
        };
        platformProduct: {
          __typename?: 'PlatformProduct';
          id: string;
          name: string;
          code?: string | null;
          standardUnitsCode: UnitCode;
          nominalWidthInches?: number | null;
          actualWidthInches?: number | null;
          nominalThicknessInches?: number | null;
          actualThicknessInches?: number | null;
          actualLengthInches?: number | null;
          piecesPerBundle: {
            __typename?: 'Quantity';
            value: number;
            unit: UnitCode;
          };
        };
      };
    }>;
  } | null;
  quotesForRequestForQuote: Array<{
    __typename?: 'Quote';
    id: string;
    status: QuoteStatus;
    negotiationAwaitingParty?: QuoteRoundParty | null;
    lockedRecipientIds: Array<string>;
    currency?: Currency | null;
    leadTimeDays?: number | null;
    submittedAt?: string | null;
    primaryContact?:
      | ({ __typename?: 'User'; id: string } & {
          ' $fragmentRefs'?: { PrimaryContactFragment: PrimaryContactFragment };
        })
      | null;
    recipients: Array<{
      __typename?: 'User';
      id: string;
      firstName: string;
      lastName: string;
      phoneNumber?: string | null;
      externalId?: string | null;
    }>;
    rounds: Array<
      { __typename?: 'QuoteRound' } & {
        ' $fragmentRefs'?: {
          QuoteTimelineRoundFragment: QuoteTimelineRoundFragment;
          QuoteOfferRoundFragment: QuoteOfferRoundFragment;
        };
      }
    >;
    requestForQuote: {
      __typename?: 'RequestForQuote';
      id: string;
      status: RequestForQuoteStatus;
    };
    sellingOrganization: {
      __typename?: 'Organization';
      id: string;
      name: string;
      sellingOrganizationCode?: string | null;
      facilities: Array<{
        __typename?: 'Facility';
        id: string;
        code?: string | null;
        address: {
          __typename?: 'Address';
          addressLine1: string;
          addressLine2?: string | null;
          city: string;
          region?: string | null;
        };
        locations: Array<{ __typename?: 'Location'; id: string; code: string }>;
      }>;
    };
    sellingOrganizationFacility?: {
      __typename?: 'Facility';
      id: string;
      code?: string | null;
      address: {
        __typename?: 'Address';
        addressLine1: string;
        addressLine2?: string | null;
        city: string;
        region?: string | null;
      };
    } | null;
    offeredPickupPriceForTally?: {
      __typename?: 'Money';
      amount: number;
      currency: Currency;
    } | null;
    offeredDeliveryPriceForTally?: {
      __typename?: 'Money';
      amount: number;
      currency: Currency;
    } | null;
    items: Array<{
      __typename?: 'QuoteItem';
      id: string;
      quantityInPieces: number;
      piecesPerBundle?: number | null;
      status: QuoteItemStatus;
      offeredPickupPrice?: {
        __typename?: 'Money';
        amount: number;
        currency: Currency;
      } | null;
      offeredDeliveryPrice?: {
        __typename?: 'Money';
        amount: number;
        currency: Currency;
      } | null;
      order?: { __typename?: 'Order'; id: string } | null;
      platformProductsLength: {
        __typename?: 'PlatformProductLength';
        id: string;
        lengthDisplayValue: string;
        isNominal?: boolean | null;
        length: {
          __typename?: 'Length';
          id: string;
          displayValue: string;
          actualLengthInches: number;
          nominalLengthInches?: number | null;
        };
        platformProduct: {
          __typename?: 'PlatformProduct';
          id: string;
          name: string;
          code?: string | null;
          standardUnitsCode: UnitCode;
          nominalWidthInches?: number | null;
          actualWidthInches?: number | null;
          nominalThicknessInches?: number | null;
          actualThicknessInches?: number | null;
          actualLengthInches?: number | null;
          piecesPerBundle: {
            __typename?: 'Quantity';
            value: number;
            unit: UnitCode;
          };
        };
      };
    }>;
  }>;
};

export type GetRequestForQuoteFullyPricedQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type GetRequestForQuoteFullyPricedQuery = {
  __typename?: 'Query';
  requestForQuote?: {
    __typename?: 'RequestForQuote';
    id: string;
    fullyPriced: boolean;
  } | null;
};

export type GetQuoteByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type GetQuoteByIdQuery = {
  __typename?: 'Query';
  quote?: {
    __typename?: 'Quote';
    id: string;
    status: QuoteStatus;
    negotiationAwaitingParty?: QuoteRoundParty | null;
    currency?: Currency | null;
    leadTimeDays?: number | null;
    rounds: Array<
      { __typename?: 'QuoteRound' } & {
        ' $fragmentRefs'?: {
          QuoteTimelineRoundFragment: QuoteTimelineRoundFragment;
        };
      }
    >;
    sellingOrganization: {
      __typename?: 'Organization';
      id: string;
      name: string;
      facilities: Array<{
        __typename?: 'Facility';
        id: string;
        code?: string | null;
        address: {
          __typename?: 'Address';
          addressLine1: string;
          addressLine2?: string | null;
          city: string;
          region?: string | null;
        };
        locations: Array<{ __typename?: 'Location'; id: string; code: string }>;
      }>;
    };
    sellingOrganizationFacility?: {
      __typename?: 'Facility';
      id: string;
      code?: string | null;
      address: {
        __typename?: 'Address';
        addressLine1: string;
        addressLine2?: string | null;
        city: string;
        region?: string | null;
      };
    } | null;
    offeredPickupPriceForTally?: {
      __typename?: 'Money';
      amount: number;
      currency: Currency;
    } | null;
    offeredDeliveryPriceForTally?: {
      __typename?: 'Money';
      amount: number;
      currency: Currency;
    } | null;
    items: Array<{
      __typename?: 'QuoteItem';
      id: string;
      quantityInPieces: number;
      piecesPerBundle?: number | null;
      status: QuoteItemStatus;
      order?: { __typename?: 'Order'; id: string } | null;
      offeredPickupPrice?: {
        __typename?: 'Money';
        amount: number;
        currency: Currency;
      } | null;
      offeredDeliveryPrice?: {
        __typename?: 'Money';
        amount: number;
        currency: Currency;
      } | null;
      platformProductsLength: {
        __typename?: 'PlatformProductLength';
        id: string;
        lengthDisplayValue: string;
        isNominal?: boolean | null;
        length: {
          __typename?: 'Length';
          id: string;
          displayValue: string;
          actualLengthInches: number;
          nominalLengthInches?: number | null;
        };
        platformProduct: {
          __typename?: 'PlatformProduct';
          id: string;
          name: string;
          standardUnitsCode: UnitCode;
          nominalWidthInches?: number | null;
          actualWidthInches?: number | null;
          nominalThicknessInches?: number | null;
          actualThicknessInches?: number | null;
          actualLengthInches?: number | null;
          piecesPerBundle: {
            __typename?: 'Quantity';
            value: number;
            unit: UnitCode;
          };
        };
      };
    }>;
    requestForQuote: {
      __typename?: 'RequestForQuote';
      id: string;
      status: RequestForQuoteStatus;
      createdAt: string;
      leadTimeDays?: number | null;
      useTallyPrice: boolean;
      cannedTallyCount?: number | null;
      currency?: Currency | null;
      createdByUserName?: string | null;
      cannedTally?: {
        __typename?: 'PlatformProductCannedTally';
        id: string;
        name: string;
      } | null;
      buyingOrganization: {
        __typename?: 'Organization';
        id: string;
        name: string;
      };
      createdByUser?: {
        __typename?: 'User';
        id: string;
        firstName: string;
        lastName: string;
        phoneNumber?: string | null;
        externalId?: string | null;
      } | null;
      transportVehicle?: {
        __typename?: 'TransportVehicle';
        id: string;
        name: string;
      } | null;
      tallyPlatformProduct?: {
        __typename?: 'PlatformProduct';
        id: string;
        name: string;
        standardUnitsCode: UnitCode;
        piecesPerBundle: {
          __typename?: 'Quantity';
          value: number;
          unit: UnitCode;
        };
      } | null;
      shippingLocation?: {
        __typename?: 'Location';
        id: string;
        name: string;
        code: string;
        facility: {
          __typename?: 'Facility';
          id: string;
          address: {
            __typename?: 'Address';
            addressLine1: string;
            addressLine2?: string | null;
            city: string;
            region?: string | null;
            zipCode?: string | null;
            country: string;
          };
        };
      } | null;
      pickupPriceForTally?: {
        __typename?: 'Money';
        amount: number;
        currency: Currency;
      } | null;
      deliveryPriceForTally?: {
        __typename?: 'Money';
        amount: number;
        currency: Currency;
      } | null;
      items: Array<{
        __typename?: 'RequestForQuoteItem';
        id: string;
        quantityInPieces: number;
        piecesPerBundle?: number | null;
        pickupPrice?: {
          __typename?: 'Money';
          amount: number;
          currency: Currency;
        } | null;
        deliveryPrice?: {
          __typename?: 'Money';
          amount: number;
          currency: Currency;
        } | null;
        platformProductsLength: {
          __typename?: 'PlatformProductLength';
          id: string;
          lengthDisplayValue: string;
          isNominal?: boolean | null;
          length: {
            __typename?: 'Length';
            id: string;
            displayValue: string;
            actualLengthInches: number;
            nominalLengthInches?: number | null;
          };
          platformProduct: {
            __typename?: 'PlatformProduct';
            id: string;
            name: string;
            standardUnitsCode: UnitCode;
            nominalWidthInches?: number | null;
            actualWidthInches?: number | null;
            nominalThicknessInches?: number | null;
            actualThicknessInches?: number | null;
            actualLengthInches?: number | null;
            piecesPerBundle: {
              __typename?: 'Quantity';
              value: number;
              unit: UnitCode;
            };
          };
        };
      }>;
    };
  } | null;
};

export type MyQuotesQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  size: Scalars['Int']['input'];
  needsResponse?: InputMaybe<Scalars['Boolean']['input']>;
  sort?: InputMaybe<Array<SortInput> | SortInput>;
}>;

export type MyQuotesQuery = {
  __typename?: 'Query';
  myQuotes: {
    __typename?: 'PagedQuote';
    paging: {
      __typename?: 'Paging';
      totalElements: number;
      totalPages: number;
      number: number;
      size: number;
    };
    content: Array<{
      __typename?: 'Quote';
      id: string;
      status: QuoteStatus;
      needsSellerResponse: boolean;
      createdAt: string;
      leadTimeDays?: number | null;
      offeredPickupPriceForTally?: {
        __typename?: 'Money';
        amount: number;
        currency: Currency;
      } | null;
      offeredDeliveryPriceForTally?: {
        __typename?: 'Money';
        amount: number;
        currency: Currency;
      } | null;
      requestForQuote: {
        __typename?: 'RequestForQuote';
        id: string;
        status: RequestForQuoteStatus;
        tallyPlatformProduct?: {
          __typename?: 'PlatformProduct';
          id: string;
          name: string;
        } | null;
        items: Array<{
          __typename?: 'RequestForQuoteItem';
          id: string;
          platformProductsLength: {
            __typename?: 'PlatformProductLength';
            platformProduct: {
              __typename?: 'PlatformProduct';
              id: string;
              name: string;
            };
          };
        }>;
        buyingOrganization: {
          __typename?: 'Organization';
          id: string;
          name: string;
        };
      };
      items: Array<{ __typename?: 'QuoteItem'; id: string }>;
    }>;
  };
};

export type MyRequestForQuotesQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  size: Scalars['Int']['input'];
  needsResponse?: InputMaybe<Scalars['Boolean']['input']>;
  archived?: InputMaybe<RequestForQuoteArchivedFilter>;
  filters?: InputMaybe<RequestForQuoteFiltersInput>;
}>;

export type MyRequestForQuotesQuery = {
  __typename?: 'Query';
  myRequestForQuotes: {
    __typename?: 'PagedRequestForQuotes';
    paging: {
      __typename?: 'Paging';
      totalElements: number;
      totalPages: number;
      number: number;
      size: number;
    };
    content: Array<{
      __typename?: 'RequestForQuote';
      id: string;
      status: RequestForQuoteStatus;
      createdAt: string;
      createdByUserName?: string | null;
      tallyPlatformProduct?: {
        __typename?: 'PlatformProduct';
        id: string;
        name: string;
      } | null;
      items: Array<{
        __typename?: 'RequestForQuoteItem';
        id: string;
        platformProductsLength: {
          __typename?: 'PlatformProductLength';
          platformProduct: {
            __typename?: 'PlatformProduct';
            id: string;
            name: string;
          };
        };
      }>;
      quotes: Array<{
        __typename?: 'Quote';
        id: string;
        sellingOrganization: {
          __typename?: 'Organization';
          id: string;
          name: string;
          sellingOrganizationCode?: string | null;
        };
      }>;
    }>;
  };
};

export type MyRequestForQuoteFilterOptionsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type MyRequestForQuoteFilterOptionsQuery = {
  __typename?: 'Query';
  myRequestForQuoteFilterOptions: {
    __typename?: 'RequestForQuoteFilterOptions';
    hasArchivedRequests: boolean;
    hasSentRequests: boolean;
    products: Array<{
      __typename?: 'PlatformProduct';
      id: string;
      name: string;
      code?: string | null;
    }>;
    sellers: Array<{
      __typename?: 'Organization';
      id: string;
      name: string;
      sellingOrganizationCode?: string | null;
    }>;
    creators: Array<{
      __typename?: 'RequestForQuoteCreatorOption';
      id: string;
      name: string;
    }>;
  };
};

export type UpsertRequestForQuoteMutationVariables = Exact<{
  tallyPlatformProductId?: InputMaybe<Scalars['ID']['input']>;
  leadTimeDays?: InputMaybe<Scalars['Int']['input']>;
  shippingLocationId?: InputMaybe<Scalars['ID']['input']>;
  pickupPriceForTally?: InputMaybe<MoneyInput>;
  deliveryPriceForTally?: InputMaybe<MoneyInput>;
  useTallyPrice?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type UpsertRequestForQuoteMutation = {
  __typename?: 'Mutation';
  upsertRequestForQuote: {
    __typename?: 'RequestForQuote';
    id: string;
    leadTimeDays?: number | null;
    useTallyPrice: boolean;
    shippingLocation?: { __typename?: 'Location'; id: string } | null;
  };
};

export type AddRequestForQuoteItemsMutationVariables = Exact<{
  requestForQuoteId: Scalars['ID']['input'];
  items: Array<RequestForQuoteItemInput> | RequestForQuoteItemInput;
  replace?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type AddRequestForQuoteItemsMutation = {
  __typename?: 'Mutation';
  addRequestForQuoteItems: Array<{
    __typename?: 'RequestForQuoteItem';
    id: string;
  }>;
};

export type SubmitRequestForQuoteMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  sellerInvitations: Array<SellerInvitationInput> | SellerInvitationInput;
}>;

export type SubmitRequestForQuoteMutation = {
  __typename?: 'Mutation';
  submitRequestForQuote: {
    __typename?: 'RequestForQuote';
    id: string;
    status: RequestForQuoteStatus;
  };
};

export type CreateRequestForQuoteFromBuyListMutationVariables = Exact<{
  buyListId: Scalars['ID']['input'];
  items: Array<BuyListItemSelectionInput> | BuyListItemSelectionInput;
  tallies?: Array<BuyListTallySelectionInput> | BuyListTallySelectionInput;
  sellerInvitations: Array<SellerInvitationInput> | SellerInvitationInput;
}>;

export type CreateRequestForQuoteFromBuyListMutation = {
  __typename?: 'Mutation';
  createRequestForQuoteFromBuyList: Array<{
    __typename?: 'RequestForQuote';
    id: string;
    status: RequestForQuoteStatus;
  }>;
};

export type CreateRequestForQuoteMutationVariables = Exact<{
  shippingLocationId: Scalars['ID']['input'];
  currency: Currency;
  leadTimeDays?: InputMaybe<Scalars['Int']['input']>;
  items: Array<CreateRequestForQuoteItemInput> | CreateRequestForQuoteItemInput;
  sellerInvitations: Array<SellerInvitationInput> | SellerInvitationInput;
}>;

export type CreateRequestForQuoteMutation = {
  __typename?: 'Mutation';
  createRequestForQuote: { __typename?: 'RequestForQuote'; id: string };
};

export type AcceptQuoteMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type AcceptQuoteMutation = {
  __typename?: 'Mutation';
  acceptQuote: {
    __typename?: 'Quote';
    id: string;
    status: QuoteStatus;
    order?: { __typename?: 'Order'; id: string } | null;
  };
};

export type AcceptQuoteItemsMutationVariables = Exact<{
  quoteItemIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;

export type AcceptQuoteItemsMutation = {
  __typename?: 'Mutation';
  acceptQuoteItems: Array<{ __typename?: 'Order'; id: string }>;
};

export type SubmitQuoteItemEditsMutationVariables = Exact<{
  quoteId: Scalars['ID']['input'];
  input: SubmitQuoteItemEditsInput;
}>;

export type SubmitQuoteItemEditsMutation = {
  __typename?: 'Mutation';
  submitQuoteItemEdits: {
    __typename?: 'Quote';
    id: string;
    status: QuoteStatus;
    items: Array<{
      __typename?: 'QuoteItem';
      id: string;
      status: QuoteItemStatus;
      quantityInPieces: number;
      piecesPerBundle?: number | null;
      offeredPickupPrice?: {
        __typename?: 'Money';
        amount: number;
        currency: Currency;
      } | null;
      offeredDeliveryPrice?: {
        __typename?: 'Money';
        amount: number;
        currency: Currency;
      } | null;
      platformProductsLength: {
        __typename?: 'PlatformProductLength';
        id: string;
        lengthDisplayValue: string;
        length: {
          __typename?: 'Length';
          id: string;
          displayValue: string;
          actualLengthInches: number;
        };
      };
    }>;
  };
};

export type CounterQuoteMutationVariables = Exact<{
  quoteId: Scalars['ID']['input'];
  input: SubmitQuoteItemEditsInput;
}>;

export type CounterQuoteMutation = {
  __typename?: 'Mutation';
  counterQuote: { __typename?: 'Quote'; id: string; status: QuoteStatus };
};

export type AcceptCounterQuoteMutationVariables = Exact<{
  quoteId: Scalars['ID']['input'];
}>;

export type AcceptCounterQuoteMutation = {
  __typename?: 'Mutation';
  acceptCounterQuote: { __typename?: 'Quote'; id: string; status: QuoteStatus };
};

export type DeclineQuoteMutationVariables = Exact<{
  quoteId: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
}>;

export type DeclineQuoteMutation = {
  __typename?: 'Mutation';
  declineQuote: { __typename?: 'Quote'; id: string; status: QuoteStatus };
};

export type ArchiveQuoteMutationVariables = Exact<{
  quoteId: Scalars['ID']['input'];
}>;

export type ArchiveQuoteMutation = {
  __typename?: 'Mutation';
  archiveQuote: { __typename?: 'Quote'; id: string; status: QuoteStatus };
};

export type ArchiveRequestForQuoteMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type ArchiveRequestForQuoteMutation = {
  __typename?: 'Mutation';
  archiveRequestForQuote: {
    __typename?: 'RequestForQuote';
    id: string;
    status: RequestForQuoteStatus;
  };
};

export type FulfillRequestForQuoteMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type FulfillRequestForQuoteMutation = {
  __typename?: 'Mutation';
  fulfillRequestForQuote: {
    __typename?: 'RequestForQuote';
    id: string;
    status: RequestForQuoteStatus;
  };
};

export type QuoteCommentsQueryVariables = Exact<{
  quoteId: Scalars['ID']['input'];
}>;

export type QuoteCommentsQuery = {
  __typename?: 'Query';
  quoteComments: Array<{
    __typename?: 'QuoteComment';
    id: string;
    body: string;
    authorName: string;
    createdAt: string;
    authorOrganization: {
      __typename?: 'Organization';
      id: string;
      name: string;
      sellingOrganizationCode?: string | null;
    };
  }>;
};

export type PostQuoteCommentMutationVariables = Exact<{
  quoteId: Scalars['ID']['input'];
  body: Scalars['String']['input'];
}>;

export type PostQuoteCommentMutation = {
  __typename?: 'Mutation';
  postQuoteComment: { __typename?: 'QuoteComment'; id: string };
};

export type PrimaryContactFragment = {
  __typename?: 'User';
  id: string;
  firstName: string;
  lastName: string;
} & { ' $fragmentName'?: 'PrimaryContactFragment' };

export type ChooseQuoteContactsMutationVariables = Exact<{
  quoteId: Scalars['ID']['input'];
  primaryContactUserId: Scalars['ID']['input'];
  recipientUserIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;

export type ChooseQuoteContactsMutation = {
  __typename?: 'Mutation';
  chooseQuoteContacts: { __typename?: 'Quote'; id: string };
};

export type MySellerListsQueryVariables = Exact<{ [key: string]: never }>;

export type MySellerListsQuery = {
  __typename?: 'Query';
  mySellerLists: Array<{
    __typename?: 'SellerList';
    id: string;
    name: string;
    members: Array<{
      __typename?: 'SellerListMember';
      seller: {
        __typename?: 'Organization';
        id: string;
        name: string;
        sellingOrganizationCode?: string | null;
      };
      contacts: Array<{
        __typename?: 'User';
        id: string;
        firstName: string;
        lastName: string;
      }>;
    }>;
  }>;
};

export type SaveSellerListMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  members: Array<SellerListMemberInput> | SellerListMemberInput;
}>;

export type SaveSellerListMutation = {
  __typename?: 'Mutation';
  saveSellerList: { __typename?: 'SellerList'; id: string };
};

export type DeleteSellerListMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type DeleteSellerListMutation = {
  __typename?: 'Mutation';
  deleteSellerList: boolean;
};

export type StartUfpInventoryRunMutationVariables = Exact<{
  input: StartUfpInventoryRunInput;
}>;

export type StartUfpInventoryRunMutation = {
  __typename?: 'Mutation';
  startUfpInventoryRun: { __typename?: 'UfpInventoryRun'; id: string };
};

export type UfpInventoryRunQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type UfpInventoryRunQuery = {
  __typename?: 'Query';
  ufpInventoryRun?: {
    __typename?: 'UfpInventoryRun';
    id: string;
    status: UfpInventoryRunStatus;
    branchCodes: Array<string>;
    weeksToLookBack: number;
    apiVersion: number;
    queuedAt: string;
    startedAt?: string | null;
    finishedAt?: string | null;
    ufpHttpStatus?: number | null;
    failureDetail?: string | null;
  } | null;
};

export type UfpInventoryRunResultQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type UfpInventoryRunResultQuery = {
  __typename?: 'Query';
  ufpInventoryRunResult: {
    __typename?: 'UfpInventoryRunResult';
    locations?: Array<{
      __typename?: 'UfpInventoryRunLocation';
      branchCode?: string | null;
      locationCode?: string | null;
      asOfTimestampUtc?: string | null;
      matchedLocations: Array<{
        __typename?: 'UfpInventoryRunMatchedLocation';
        id: string;
        name: string;
        organizationName: string;
      }>;
      items: Array<{
        __typename?: 'UfpInventoryRunItem';
        productCode?: string | null;
        description?: string | null;
        length?: string | null;
        outcome: UfpInventoryItemOutcome;
        productName?: string | null;
        lengthName?: string | null;
        availablePcs?: number | null;
        inboundPcs?: number | null;
        onOrderPcs?: number | null;
        requestedPcs?: number | null;
        avgWeeklyUsagePcs?: number | null;
      }>;
    }> | null;
  };
};

export type UfpInventoryRunRawResponseUrlQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type UfpInventoryRunRawResponseUrlQuery = {
  __typename?: 'Query';
  ufpInventoryRunRawResponseUrl: string;
};

export type GetAllUnitsQueryVariables = Exact<{ [key: string]: never }>;

export type GetAllUnitsQuery = {
  __typename?: 'Query';
  units: Array<{
    __typename?: 'Unit';
    code: string;
    category: string;
    name: string;
  }>;
};

export type TenantUsersQueryVariables = Exact<{ [key: string]: never }>;

export type TenantUsersQuery = {
  __typename?: 'Query';
  users?: Array<{
    __typename?: 'User';
    id: string;
    externalId?: string | null;
    firstName: string;
    lastName: string;
    employeeId?: string | null;
    phoneNumber?: string | null;
    role: UserRole;
    status: UserStatus;
    lastEditedAt?: string | null;
    lastEditedBy?: {
      __typename?: 'User';
      id: string;
      firstName: string;
      lastName: string;
    } | null;
  }> | null;
};

export type OrganizationBuyersQueryVariables = Exact<{ [key: string]: never }>;

export type OrganizationBuyersQuery = {
  __typename?: 'Query';
  users: Array<{
    __typename?: 'BuyListTeamCandidate';
    id: string;
    firstName: string;
    lastName: string;
    status: UserStatus;
  }>;
};

export type CreateTenantUserMutationVariables = Exact<{
  input: CreateTenantUserInput;
}>;

export type CreateTenantUserMutation = {
  __typename?: 'Mutation';
  createTenantUser: { __typename?: 'User'; id: string };
};

export type UpdateTenantUserMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  input: UpdateTenantUserInput;
}>;

export type UpdateTenantUserMutation = {
  __typename?: 'Mutation';
  updateTenantUser: { __typename?: 'User'; id: string };
};

export type SetTenantUserRoleMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  role: UserRole;
}>;

export type SetTenantUserRoleMutation = {
  __typename?: 'Mutation';
  setTenantUserRole: { __typename?: 'User'; id: string };
};

export type ChangeTenantUserTradeRoleMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  role: UserRole;
}>;

export type ChangeTenantUserTradeRoleMutation = {
  __typename?: 'Mutation';
  changeTenantUserTradeRole: {
    __typename?: 'User';
    id: string;
    role: UserRole;
  };
};

export type DeactivateTenantUserMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;

export type DeactivateTenantUserMutation = {
  __typename?: 'Mutation';
  deactivateTenantUser: { __typename?: 'User'; id: string };
};

export type ReactivateTenantUserMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;

export type ReactivateTenantUserMutation = {
  __typename?: 'Mutation';
  reactivateTenantUser: { __typename?: 'User'; id: string };
};

export type ResendTenantUserInviteMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;

export type ResendTenantUserInviteMutation = {
  __typename?: 'Mutation';
  resendTenantUserInvite: { __typename?: 'User'; id: string };
};

export type MsrBuyerCodeCandidatesQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;

export type MsrBuyerCodeCandidatesQuery = {
  __typename?: 'Query';
  organization?: {
    __typename?: 'Organization';
    id: string;
    users: Array<{
      __typename?: 'User';
      id: string;
      firstName: string;
      lastName: string;
      employeeId?: string | null;
      status: UserStatus;
    }>;
  } | null;
};

export type UpsertProductVehicleCapacityMutationVariables = Exact<{
  platformProductLengthId: Scalars['ID']['input'];
  transportVehicleId: Scalars['ID']['input'];
  capacity: QuantityInput;
}>;

export type UpsertProductVehicleCapacityMutation = {
  __typename?: 'Mutation';
  upsertProductVehicleCapacity: {
    __typename?: 'PlatformProductVehicleCapacity';
    id: string;
  };
};

export type SellerImportColumnMappingsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type SellerImportColumnMappingsQuery = {
  __typename?: 'Query';
  sellerImportColumnMappings: Array<{
    __typename?: 'SellerImportColumnMapping';
    headerSignature: string;
    mapping: Record<string, unknown>;
  }>;
};

export type RememberSellerImportColumnMappingMutationVariables = Exact<{
  headerSignature: Scalars['String']['input'];
  mapping: Scalars['JSON']['input'];
}>;

export type RememberSellerImportColumnMappingMutation = {
  __typename?: 'Mutation';
  rememberSellerImportColumnMapping: {
    __typename?: 'SellerImportColumnMapping';
    headerSignature: string;
  };
};

export type ProposeSellerImportMappingMutationVariables = Exact<{
  columns: Array<ImportMappingColumnInput> | ImportMappingColumnInput;
  fields: Array<ImportMappingFieldInput> | ImportMappingFieldInput;
}>;

export type ProposeSellerImportMappingMutation = {
  __typename?: 'Mutation';
  proposeSellerImportMapping: Record<string, unknown>;
};

export type ImportSellerInventoryMutationVariables = Exact<{
  rows: Array<SellerImportRowInput> | SellerImportRowInput;
}>;

export type ImportSellerInventoryMutation = {
  __typename?: 'Mutation';
  importSellerInventory: {
    __typename?: 'SellerImportResult';
    total: number;
    imported: number;
    failed: Array<{
      __typename?: 'SellerImportRowError';
      rowId: number;
      messages: Array<string>;
    }>;
  };
};

export type InventoryImportLocationsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type InventoryImportLocationsQuery = {
  __typename?: 'Query';
  locations?: Array<{
    __typename?: 'Location';
    id: string;
    code: string;
    name: string;
    facility: {
      __typename?: 'Facility';
      address: {
        __typename?: 'Address';
        addressLine1: string;
        city: string;
        region?: string | null;
      };
    };
  }> | null;
};

export type InventoryImportPlatformCatalogQueryVariables = Exact<{
  [key: string]: never;
}>;

export type InventoryImportPlatformCatalogQuery = {
  __typename?: 'Query';
  platformProducts?: Array<{
    __typename?: 'PlatformProduct';
    id: string;
    name: string;
    category: PlatformProductCategory;
    standardUnitsCode: UnitCode;
    finishCode?: string | null;
    nominalThicknessInches?: number | null;
    nominalWidthInches?: number | null;
    actualThicknessInches?: number | null;
    actualWidthInches?: number | null;
    properties?: Record<string, unknown> | null;
    unitsPerTruckload?: number | null;
    lengths?: Array<{
      __typename?: 'Length';
      id: string;
      actualLengthInches: number;
      nominalLengthInches?: number | null;
      displayValue: string;
    } | null> | null;
  }> | null;
};

export class TypedDocumentString<TResult, TVariables>
  extends String
  implements DocumentTypeDecoration<TResult, TVariables>
{
  __apiType?: NonNullable<
    DocumentTypeDecoration<TResult, TVariables>['__apiType']
  >;
  private value: string;
  public __meta__?: Record<string, any> | undefined;

  constructor(value: string, __meta__?: Record<string, any> | undefined) {
    super(value);
    this.value = value;
    this.__meta__ = __meta__;
  }

  override toString(): string & DocumentTypeDecoration<TResult, TVariables> {
    return this.value;
  }
}
export const BuyListItemSummaryFragmentDoc = new TypedDocumentString(
  `
    fragment BuyListItemSummary on BuyListItem {
  id
  quantity {
    value
    unit
  }
  effectivePiecesPerBundle
  platformProductsLength {
    id
    lengthDisplayValue
    isNominal
    length {
      nominalLengthInches
      actualLengthInches
    }
    platformProduct {
      code
      name
      nominalWidthInches
      actualWidthInches
      nominalThicknessInches
      actualThicknessInches
      actualLengthInches
      piecesPerBundle {
        value
        unit
      }
    }
  }
}
    `,
  { fragmentName: 'BuyListItemSummary' }
) as unknown as TypedDocumentString<BuyListItemSummaryFragment, unknown>;
export const QuoteTimelineRoundFragmentDoc = new TypedDocumentString(
  `
    fragment QuoteTimelineRound on QuoteRound {
  roundNumber
  party
  authorName
  declined
  declineReason
  createdAt
  pickupPriceForTally {
    amount
    currency
  }
  deliveryPriceForTally {
    amount
    currency
  }
  items {
    pickupPrice {
      amount
      currency
    }
    deliveryPrice {
      amount
      currency
    }
    platformProductsLength {
      lengthDisplayValue
    }
  }
}
    `,
  { fragmentName: 'QuoteTimelineRound' }
) as unknown as TypedDocumentString<QuoteTimelineRoundFragment, unknown>;
export const QuoteOfferRoundFragmentDoc = new TypedDocumentString(
  `
    fragment QuoteOfferRound on QuoteRound {
  roundNumber
  party
  pickupPriceForTally {
    amount
    currency
  }
  deliveryPriceForTally {
    amount
    currency
  }
  items {
    quantityInPieces
    pickupPrice {
      amount
      currency
    }
    deliveryPrice {
      amount
      currency
    }
    platformProductsLength {
      id
    }
    piecesPerBundle
  }
}
    `,
  { fragmentName: 'QuoteOfferRound' }
) as unknown as TypedDocumentString<QuoteOfferRoundFragment, unknown>;
export const PrimaryContactFragmentDoc = new TypedDocumentString(
  `
    fragment PrimaryContact on User {
  id
  firstName
  lastName
}
    `,
  { fragmentName: 'PrimaryContact' }
) as unknown as TypedDocumentString<PrimaryContactFragment, unknown>;
export const CurrentUserDocument = new TypedDocumentString(`
    query currentUser {
  currentUser {
    externalId
    firstName
    id
    lastName
    role
    locations {
      id
      code
      name
      branchCode
      facility {
        id
        code
        address {
          addressLine1
          addressLine2
          city
          region
          zipCode
          country
        }
        transportVehicles {
          id
          name
          vehicleType
        }
      }
    }
    organization {
      id
      name
      defaultCurrency
      orderNotificationEmails {
        domestic
        international
      }
    }
  }
}
    `) as unknown as TypedDocumentString<
  CurrentUserQuery,
  CurrentUserQueryVariables
>;
export const GetUserPreferencesDocument = new TypedDocumentString(`
    query getUserPreferences {
  userPreferences {
    category
    buyerInventorySelectedLocationId
    buyerInventorySelectedBranchCode
    sellerProductSelectedLocationId
    buyerInventoryColumnOrder
    buyerInventoryGroupedColumnOrder
    sellerInventoryColumnOrder
    sellerPricingColumnOrder
    pricesAndAvailabilityColumnOrder
    pricesAndAvailabilityGroupedColumnOrder
    sellerProductFilters {
      field
      operator
      value
      connector
    }
    buyerInventoryFilters {
      field
      operator
      value
      connector
    }
    buyerActiveFilterId
    sellerActiveFilterId
    buyerAnonymousFilter
    sellerAnonymousFilter
    buyerOrdersActiveFilterId
    sellerOrdersActiveFilterId
    buyerOrdersAnonymousFilter
    sellerOrdersAnonymousFilter
    buyerComparisonActiveFilterId
    buyerComparisonAnonymousFilter
    sellerPricingActiveFilterId
    sellerPricingAnonymousFilter
    productPreferredUnitFilters {
      category
      unit
    }
    buyListTeamMemberIds
    buyerBuyListsActiveFilterId
    buyListFilter
    myBuyListsActiveFilterId
    myBuyListFilter
    buyerRequestForQuotesActiveFilterId
    buyerRequestForQuotesAnonymousFilter
    randomTallyUseTallyPrice
  }
}
    `) as unknown as TypedDocumentString<
  GetUserPreferencesQuery,
  GetUserPreferencesQueryVariables
>;
export const UpdateUserPreferencesDocument = new TypedDocumentString(`
    mutation updateUserPreferences($preferences: UserPreferenceInput!) {
  updateUserPreferences(preferences: $preferences) {
    category
    buyerInventorySelectedLocationId
    buyerInventorySelectedBranchCode
    sellerProductSelectedLocationId
    buyerInventoryColumnOrder
    buyerInventoryGroupedColumnOrder
    sellerInventoryColumnOrder
    sellerPricingColumnOrder
    pricesAndAvailabilityColumnOrder
    pricesAndAvailabilityGroupedColumnOrder
    sellerProductFilters {
      field
      operator
      value
      connector
    }
    buyerInventoryFilters {
      field
      operator
      value
      connector
    }
    buyerActiveFilterId
    sellerActiveFilterId
    buyerAnonymousFilter
    sellerAnonymousFilter
    buyerOrdersActiveFilterId
    sellerOrdersActiveFilterId
    buyerOrdersAnonymousFilter
    sellerOrdersAnonymousFilter
    buyerComparisonActiveFilterId
    buyerComparisonAnonymousFilter
    sellerPricingActiveFilterId
    sellerPricingAnonymousFilter
    productPreferredUnitFilters {
      category
      unit
    }
    buyListTeamMemberIds
    buyerBuyListsActiveFilterId
    buyListFilter
    myBuyListsActiveFilterId
    myBuyListFilter
    buyerRequestForQuotesActiveFilterId
    buyerRequestForQuotesAnonymousFilter
    randomTallyUseTallyPrice
  }
}
    `) as unknown as TypedDocumentString<
  UpdateUserPreferencesMutation,
  UpdateUserPreferencesMutationVariables
>;
export const UpdateProductPreferredUnitFiltersDocument =
  new TypedDocumentString(`
    mutation updateProductPreferredUnitFilters($filters: [ProductPreferredUnitFilterInput!]!) {
  updateProductPreferredUnitFilters(filters: $filters) {
    productPreferredUnitFilters {
      category
      unit
    }
  }
}
    `) as unknown as TypedDocumentString<
    UpdateProductPreferredUnitFiltersMutation,
    UpdateProductPreferredUnitFiltersMutationVariables
  >;
export const GetUserFiltersDocument = new TypedDocumentString(`
    query getUserFilters($perspective: TradePerspective!) {
  userFilters(perspective: $perspective) {
    id
    name
    filterData
    createdAt
  }
}
    `) as unknown as TypedDocumentString<
  GetUserFiltersQuery,
  GetUserFiltersQueryVariables
>;
export const SaveFilterDocument = new TypedDocumentString(`
    mutation saveFilter($name: String!, $filterData: JSON!, $perspective: TradePerspective!) {
  saveFilter(name: $name, filterData: $filterData, perspective: $perspective) {
    id
    name
    filterData
    createdAt
  }
}
    `) as unknown as TypedDocumentString<
  SaveFilterMutation,
  SaveFilterMutationVariables
>;
export const SetActiveFilterDocument = new TypedDocumentString(`
    mutation setActiveFilter($filterId: ID!, $perspective: TradePerspective!, $view: FilterView) {
  setActiveFilter(filterId: $filterId, perspective: $perspective, view: $view) {
    buyerActiveFilterId
    sellerActiveFilterId
    buyerOrdersActiveFilterId
    sellerOrdersActiveFilterId
    buyerComparisonActiveFilterId
    sellerPricingActiveFilterId
    buyerBuyListsActiveFilterId
    myBuyListsActiveFilterId
    buyerRequestForQuotesActiveFilterId
  }
}
    `) as unknown as TypedDocumentString<
  SetActiveFilterMutation,
  SetActiveFilterMutationVariables
>;
export const ClearActiveFilterDocument = new TypedDocumentString(`
    mutation clearActiveFilter($perspective: TradePerspective!, $view: FilterView) {
  clearActiveFilter(perspective: $perspective, view: $view) {
    buyerActiveFilterId
    sellerActiveFilterId
    buyerOrdersActiveFilterId
    sellerOrdersActiveFilterId
    buyerComparisonActiveFilterId
    sellerPricingActiveFilterId
    buyerBuyListsActiveFilterId
    myBuyListsActiveFilterId
    buyerRequestForQuotesActiveFilterId
  }
}
    `) as unknown as TypedDocumentString<
  ClearActiveFilterMutation,
  ClearActiveFilterMutationVariables
>;
export const ClearAnonymousFilterDocument = new TypedDocumentString(`
    mutation clearAnonymousFilter($perspective: TradePerspective!, $view: FilterView) {
  clearAnonymousFilter(perspective: $perspective, view: $view) {
    buyerAnonymousFilter
    sellerAnonymousFilter
    buyerActiveFilterId
    sellerActiveFilterId
    buyerOrdersAnonymousFilter
    sellerOrdersAnonymousFilter
    buyerOrdersActiveFilterId
    sellerOrdersActiveFilterId
    buyerComparisonAnonymousFilter
    buyerComparisonActiveFilterId
    sellerPricingActiveFilterId
    sellerPricingAnonymousFilter
    buyListFilter
    buyerBuyListsActiveFilterId
    myBuyListFilter
    myBuyListsActiveFilterId
    buyerRequestForQuotesAnonymousFilter
    buyerRequestForQuotesActiveFilterId
  }
}
    `) as unknown as TypedDocumentString<
  ClearAnonymousFilterMutation,
  ClearAnonymousFilterMutationVariables
>;
export const RenameFilterDocument = new TypedDocumentString(`
    mutation renameFilter($id: ID!, $name: String!) {
  renameFilter(id: $id, name: $name) {
    id
    name
    filterData
    createdAt
  }
}
    `) as unknown as TypedDocumentString<
  RenameFilterMutation,
  RenameFilterMutationVariables
>;
export const UpdateFilterDocument = new TypedDocumentString(`
    mutation updateFilter($id: ID!, $filterData: JSON!) {
  updateFilter(id: $id, filterData: $filterData) {
    id
    name
    filterData
    createdAt
  }
}
    `) as unknown as TypedDocumentString<
  UpdateFilterMutation,
  UpdateFilterMutationVariables
>;
export const DeleteFilterDocument = new TypedDocumentString(`
    mutation deleteFilter($id: ID!, $perspective: TradePerspective!, $view: FilterView) {
  deleteFilter(id: $id, perspective: $perspective, view: $view)
}
    `) as unknown as TypedDocumentString<
  DeleteFilterMutation,
  DeleteFilterMutationVariables
>;
export const MyBuyListsDocument = new TypedDocumentString(`
    query MyBuyLists($page: Int!, $size: Int!, $match: BuyListMatchInput, $sort: [SortInput!]) {
  myBuyLists(pageInput: {page: $page, size: $size}, match: $match, sort: $sort) {
    paging {
      totalElements
      totalPages
      number
      size
    }
    content {
      id
      expectedShipDate
      note
      status
      location {
        id
        code
        name
        facility {
          id
          code
          address {
            addressLine1
            addressLine2
            city
            region
            zipCode
          }
        }
      }
      transportVehicle {
        id
        name
      }
      itemCount
      tallyCount
      items {
        ...BuyListItemSummary
      }
    }
  }
}
    fragment BuyListItemSummary on BuyListItem {
  id
  quantity {
    value
    unit
  }
  effectivePiecesPerBundle
  platformProductsLength {
    id
    lengthDisplayValue
    isNominal
    length {
      nominalLengthInches
      actualLengthInches
    }
    platformProduct {
      code
      name
      nominalWidthInches
      actualWidthInches
      nominalThicknessInches
      actualThicknessInches
      actualLengthInches
      piecesPerBundle {
        value
        unit
      }
    }
  }
}`) as unknown as TypedDocumentString<
  MyBuyListsQuery,
  MyBuyListsQueryVariables
>;
export const MyBuyListTargetsDocument = new TypedDocumentString(`
    query MyBuyListTargets($page: Int!, $size: Int!) {
  myBuyLists(pageInput: {page: $page, size: $size}) {
    paging {
      totalElements
      totalPages
      number
      size
    }
    content {
      id
      expectedShipDate
      note
      status
      location {
        id
        code
        name
        facility {
          id
          code
          address {
            addressLine1
            addressLine2
            city
            region
            zipCode
          }
        }
      }
      transportVehicle {
        id
        name
      }
      items {
        id
        platformProductsLength {
          id
        }
        quantity {
          value
          unit
        }
        effectivePiecesPerBundle
      }
    }
  }
}
    `) as unknown as TypedDocumentString<
  MyBuyListTargetsQuery,
  MyBuyListTargetsQueryVariables
>;
export const TeamBuyListsDocument = new TypedDocumentString(`
    query TeamBuyLists($page: Int!, $size: Int!, $filter: BuyListFilterInput, $sort: [SortInput!]) {
  teamBuyLists(
    pageInput: {page: $page, size: $size}
    filter: $filter
    sort: $sort
  ) {
    paging {
      totalElements
      totalPages
      number
      size
    }
    content {
      id
      expectedShipDate
      note
      status
      initiatingUser {
        id
        firstName
        lastName
      }
      location {
        id
        code
        name
        facility {
          id
          code
          address {
            addressLine1
            addressLine2
            city
            region
            zipCode
          }
        }
      }
      transportVehicle {
        id
        name
      }
      itemCount
      tallyCount
      items {
        ...BuyListItemSummary
      }
    }
  }
}
    fragment BuyListItemSummary on BuyListItem {
  id
  quantity {
    value
    unit
  }
  effectivePiecesPerBundle
  platformProductsLength {
    id
    lengthDisplayValue
    isNominal
    length {
      nominalLengthInches
      actualLengthInches
    }
    platformProduct {
      code
      name
      nominalWidthInches
      actualWidthInches
      nominalThicknessInches
      actualThicknessInches
      actualLengthInches
      piecesPerBundle {
        value
        unit
      }
    }
  }
}`) as unknown as TypedDocumentString<
  TeamBuyListsQuery,
  TeamBuyListsQueryVariables
>;
export const BuyListDocument = new TypedDocumentString(`
    query BuyList($id: ID!) {
  buyList(id: $id) {
    id
    expectedShipDate
    note
    status
    initiatingUser {
      id
      firstName
      lastName
    }
    location {
      id
      code
      name
      facility {
        id
        code
        address {
          addressLine1
          addressLine2
          city
          region
          zipCode
        }
      }
    }
    transportVehicle {
      id
      name
    }
    items {
      id
      platformProductsLength {
        id
        lengthDisplayValue
        isNominal
        latestPriceMid {
          amount
          currency
        }
        length {
          nominalLengthInches
          actualLengthInches
        }
        platformProduct {
          code
          name
          category
          standardUnitsCode
          nominalWidthInches
          actualWidthInches
          nominalThicknessInches
          actualThicknessInches
          actualLengthInches
          piecesPerBundle {
            value
            unit
          }
        }
      }
      quantity {
        value
        unit
      }
      effectivePiecesPerBundle
      piecesPerBundleOverride
      carts {
        buyer {
          id
          firstName
          lastName
        }
        quantity {
          value
          unit
        }
      }
    }
    tallies {
      __typename
      id
      ... on CannedBuyListTally {
        cannedTally {
          id
          name
        }
        tallyCount
      }
      platformProduct {
        id
        code
        name
        standardUnitsCode
        piecesPerBundle {
          value
          unit
        }
      }
      quantity {
        value
        unit
      }
      bundles {
        bundleCount
        quantity {
          value
          unit
        }
        platformProductsLength {
          id
          lengthDisplayValue
          isNominal
          length {
            id
            nominalLengthInches
            actualLengthInches
          }
          platformProduct {
            id
            nominalWidthInches
            actualWidthInches
            nominalThicknessInches
            actualThicknessInches
            actualLengthInches
            piecesPerBundle {
              value
              unit
            }
          }
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<BuyListQuery, BuyListQueryVariables>;
export const BuyListQuoteComparisonDocument = new TypedDocumentString(`
    query BuyListQuoteComparison($buyListId: ID!, $page: Int!, $size: Int!) {
  buyListRequestForQuotes(
    buyListId: $buyListId
    pageInput: {page: $page, size: $size}
  ) {
    paging {
      totalElements
    }
    content {
      id
      status
      createdAt
      createdByUserName
      leadTimeDays
      useTallyPrice
      currency
      cannedTally {
        id
        name
      }
      cannedTallyCount
      tallyPlatformProduct {
        id
        name
        standardUnitsCode
        piecesPerBundle {
          value
          unit
        }
      }
      shippingLocation {
        id
        name
        code
        facility {
          id
          address {
            addressLine1
            addressLine2
            city
            region
            zipCode
            country
          }
        }
      }
      pickupPriceForTally {
        amount
        currency
      }
      deliveryPriceForTally {
        amount
        currency
      }
      items {
        id
        quantityInPieces
        piecesPerBundle
        pickupPrice {
          amount
          currency
        }
        deliveryPrice {
          amount
          currency
        }
        platformProductsLength {
          id
          lengthDisplayValue
          isNominal
          length {
            id
            displayValue
            actualLengthInches
            nominalLengthInches
          }
          platformProduct {
            id
            name
            code
            standardUnitsCode
            nominalWidthInches
            actualWidthInches
            nominalThicknessInches
            actualThicknessInches
            actualLengthInches
            piecesPerBundle {
              value
              unit
            }
          }
        }
      }
      quotes {
        id
        status
        negotiationAwaitingParty
        primaryContact {
          id
          ...PrimaryContact
        }
        recipients {
          id
          firstName
          lastName
          phoneNumber
          externalId
        }
        lockedRecipientIds
        rounds {
          ...QuoteTimelineRound
          ...QuoteOfferRound
        }
        currency
        leadTimeDays
        submittedAt
        sellingOrganization {
          id
          name
          sellingOrganizationCode
          facilities {
            id
            code
            address {
              addressLine1
              addressLine2
              city
              region
            }
            locations {
              id
              code
            }
          }
        }
        sellingOrganizationFacility {
          id
          code
          address {
            addressLine1
            addressLine2
            city
            region
          }
        }
        offeredPickupPriceForTally {
          amount
          currency
        }
        offeredDeliveryPriceForTally {
          amount
          currency
        }
        items {
          id
          quantityInPieces
          piecesPerBundle
          status
          offeredPickupPrice {
            amount
            currency
          }
          offeredDeliveryPrice {
            amount
            currency
          }
          order {
            id
          }
          platformProductsLength {
            id
            lengthDisplayValue
            isNominal
            length {
              id
              displayValue
              actualLengthInches
              nominalLengthInches
            }
            platformProduct {
              id
              name
              code
              standardUnitsCode
              nominalWidthInches
              actualWidthInches
              nominalThicknessInches
              actualThicknessInches
              actualLengthInches
              piecesPerBundle {
                value
                unit
              }
            }
          }
        }
      }
    }
  }
}
    fragment QuoteTimelineRound on QuoteRound {
  roundNumber
  party
  authorName
  declined
  declineReason
  createdAt
  pickupPriceForTally {
    amount
    currency
  }
  deliveryPriceForTally {
    amount
    currency
  }
  items {
    pickupPrice {
      amount
      currency
    }
    deliveryPrice {
      amount
      currency
    }
    platformProductsLength {
      lengthDisplayValue
    }
  }
}
fragment QuoteOfferRound on QuoteRound {
  roundNumber
  party
  pickupPriceForTally {
    amount
    currency
  }
  deliveryPriceForTally {
    amount
    currency
  }
  items {
    quantityInPieces
    pickupPrice {
      amount
      currency
    }
    deliveryPrice {
      amount
      currency
    }
    platformProductsLength {
      id
    }
    piecesPerBundle
  }
}
fragment PrimaryContact on User {
  id
  firstName
  lastName
}`) as unknown as TypedDocumentString<
  BuyListQuoteComparisonQuery,
  BuyListQuoteComparisonQueryVariables
>;
export const CreateBuyListDocument = new TypedDocumentString(`
    mutation CreateBuyList($locationId: ID!, $transportVehicleId: ID!, $expectedShipDate: String!, $note: String) {
  createBuyList(
    locationId: $locationId
    transportVehicleId: $transportVehicleId
    expectedShipDate: $expectedShipDate
    note: $note
  ) {
    id
    expectedShipDate
    note
    status
    location {
      id
      code
      name
      facility {
        id
        code
        address {
          addressLine1
          addressLine2
          city
          region
          zipCode
        }
      }
    }
    transportVehicle {
      id
      name
    }
    items {
      id
      platformProductsLength {
        id
      }
      quantity {
        value
        unit
      }
      effectivePiecesPerBundle
      piecesPerBundleOverride
    }
  }
}
    `) as unknown as TypedDocumentString<
  CreateBuyListMutation,
  CreateBuyListMutationVariables
>;
export const AddProductToBuyListDocument = new TypedDocumentString(`
    mutation AddProductToBuyList($buyListId: ID!, $platformProductsLengthId: ID!, $quantity: QuantityInput!, $piecesPerBundleOverride: Int, $clearPiecesPerBundleOverride: Boolean) {
  addProductToBuyList(
    buyListId: $buyListId
    platformProductsLengthId: $platformProductsLengthId
    quantity: $quantity
    piecesPerBundleOverride: $piecesPerBundleOverride
    clearPiecesPerBundleOverride: $clearPiecesPerBundleOverride
  ) {
    id
  }
}
    `) as unknown as TypedDocumentString<
  AddProductToBuyListMutation,
  AddProductToBuyListMutationVariables
>;
export const RemoveProductFromBuyListDocument = new TypedDocumentString(`
    mutation RemoveProductFromBuyList($buyListId: ID!, $platformProductsLengthId: ID!) {
  removeProductFromBuyList(
    buyListId: $buyListId
    platformProductsLengthId: $platformProductsLengthId
  ) {
    id
  }
}
    `) as unknown as TypedDocumentString<
  RemoveProductFromBuyListMutation,
  RemoveProductFromBuyListMutationVariables
>;
export const SetCannedTallyOnBuyListDocument = new TypedDocumentString(`
    mutation SetCannedTallyOnBuyList($buyListId: ID!, $cannedTallyId: ID!, $tallyCount: Int!) {
  setCannedTallyOnBuyList(
    buyListId: $buyListId
    cannedTallyId: $cannedTallyId
    tallyCount: $tallyCount
  ) {
    id
  }
}
    `) as unknown as TypedDocumentString<
  SetCannedTallyOnBuyListMutation,
  SetCannedTallyOnBuyListMutationVariables
>;
export const SetRandomTallyOnBuyListDocument = new TypedDocumentString(`
    mutation SetRandomTallyOnBuyList($buyListId: ID!, $platformProductId: ID!, $bundles: [RandomTallyBundleInput!]!) {
  setRandomTallyOnBuyList(
    buyListId: $buyListId
    platformProductId: $platformProductId
    bundles: $bundles
  ) {
    id
  }
}
    `) as unknown as TypedDocumentString<
  SetRandomTallyOnBuyListMutation,
  SetRandomTallyOnBuyListMutationVariables
>;
export const RemoveTallyFromBuyListDocument = new TypedDocumentString(`
    mutation RemoveTallyFromBuyList($buyListId: ID!, $buyListTallyId: ID!) {
  removeTallyFromBuyList(buyListId: $buyListId, buyListTallyId: $buyListTallyId) {
    id
  }
}
    `) as unknown as TypedDocumentString<
  RemoveTallyFromBuyListMutation,
  RemoveTallyFromBuyListMutationVariables
>;
export const UpdateBuyListStatusDocument = new TypedDocumentString(`
    mutation UpdateBuyListStatus($buyListId: ID!, $status: BuyListStatus!) {
  updateBuyListStatus(buyListId: $buyListId, status: $status) {
    id
    status
  }
}
    `) as unknown as TypedDocumentString<
  UpdateBuyListStatusMutation,
  UpdateBuyListStatusMutationVariables
>;
export const AddBuyListToCartDocument = new TypedDocumentString(`
    mutation AddBuyListToCart($buyListId: ID!, $sellerOrganizationFacilityId: ID!, $locationId: ID!, $transportVehicleId: ID, $items: [BuyListItemSelectionInput!]!, $tallies: [BuyListTallySelectionInput!]! = []) {
  addBuyListToCart(
    buyListId: $buyListId
    sellerOrganizationFacilityId: $sellerOrganizationFacilityId
    locationId: $locationId
    transportVehicleId: $transportVehicleId
    items: $items
    tallies: $tallies
  ) {
    cart {
      id
    }
    skippedItems {
      productName
      reason
      tallyKind
      tallyName
      tallyCount
    }
  }
}
    `) as unknown as TypedDocumentString<
  AddBuyListToCartMutation,
  AddBuyListToCartMutationVariables
>;
export const UpsertBuyerInventoryConfigurationDocument =
  new TypedDocumentString(`
    mutation upsertBuyerInventoryConfiguration($platformProductsLengthId: ID!, $locationId: ID!, $usageRatePerWeek: QuantityInput!, $weeksCoveredBeforeMonitor: Float, $weeksCoveredBeforeUrgent: Float, $targetWeeksCovered: Float) {
  upsertBuyerInventoryConfiguration(
    platformProductsLengthId: $platformProductsLengthId
    locationId: $locationId
    usageRatePerWeek: $usageRatePerWeek
    weeksCoveredBeforeMonitor: $weeksCoveredBeforeMonitor
    weeksCoveredBeforeUrgent: $weeksCoveredBeforeUrgent
    targetWeeksCovered: $targetWeeksCovered
  ) {
    id
    usageRatePerWeek {
      value
      unit
    }
    weeksCoveredBeforeMonitor
    weeksCoveredBeforeUrgent
    targetWeeksCovered
    location {
      id
      name
    }
    platformProductsLength {
      id
      platformProduct {
        name
      }
    }
  }
}
    `) as unknown as TypedDocumentString<
    UpsertBuyerInventoryConfigurationMutation,
    UpsertBuyerInventoryConfigurationMutationVariables
  >;
export const PlatformProductCannedTalliesDocument = new TypedDocumentString(`
    query PlatformProductCannedTallies($platformProductId: ID!, $transportVehicleId: ID!, $organizationId: ID) {
  platformProductCannedTallies(
    platformProductId: $platformProductId
    transportVehicleId: $transportVehicleId
    organizationId: $organizationId
  ) {
    id
    name
    bundles {
      platformProductsLength {
        lengthDisplayValue
        piecesPerLf
        piecesPerBf
        piecesPerMbf
        piecesPerSf
        piecesPerMsf
        piecesPerCbm
        length {
          actualLengthInches
        }
      }
      bundleCount
    }
  }
}
    `) as unknown as TypedDocumentString<
  PlatformProductCannedTalliesQuery,
  PlatformProductCannedTalliesQueryVariables
>;
export const PlatformProductCannedTalliesByOrganizationIdsDocument =
  new TypedDocumentString(`
    query PlatformProductCannedTalliesByOrganizationIds($platformProductId: ID!, $transportVehicleId: ID!, $organizationIds: [ID!]!) {
  platformProductCannedTalliesByOrganizationIds(
    platformProductId: $platformProductId
    transportVehicleId: $transportVehicleId
    organizationIds: $organizationIds
  ) {
    organizationId
    tallies {
      id
      name
      bundles {
        platformProductsLength {
          piecesPerLf
          piecesPerBf
          piecesPerMbf
          piecesPerSf
          piecesPerMsf
          piecesPerCbm
          length {
            actualLengthInches
          }
        }
        bundleCount
      }
    }
  }
}
    `) as unknown as TypedDocumentString<
    PlatformProductCannedTalliesByOrganizationIdsQuery,
    PlatformProductCannedTalliesByOrganizationIdsQueryVariables
  >;
export const CannedTallyLengthsForCategoryDocument = new TypedDocumentString(`
    query CannedTallyLengthsForCategory($platformProductId: ID!) {
  cannedTallyLengthsForCategory(platformProductId: $platformProductId) {
    length {
      id
      displayValue
      actualLengthInches
    }
    platformProductLength {
      id
      isNominal
      length {
        nominalLengthInches
        actualLengthInches
      }
      platformProduct {
        nominalWidthInches
        actualWidthInches
        nominalThicknessInches
        actualThicknessInches
        actualLengthInches
        piecesPerBundle {
          value
          unit
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<
  CannedTallyLengthsForCategoryQuery,
  CannedTallyLengthsForCategoryQueryVariables
>;
export const CannedTallyCandidateLengthsDocument = new TypedDocumentString(`
    query CannedTallyCandidateLengths($platformProductId: ID!, $search: String, $pageInput: PageInput!) {
  lengths: cannedTallyCandidateLengths(
    platformProductId: $platformProductId
    search: $search
    pageInput: $pageInput
  ) {
    content {
      length {
        id
        displayValue
        actualLengthInches
      }
      platformProductLength {
        id
        isNominal
        length {
          nominalLengthInches
          actualLengthInches
        }
        platformProduct {
          nominalWidthInches
          actualWidthInches
          nominalThicknessInches
          actualThicknessInches
          actualLengthInches
          piecesPerBundle {
            value
            unit
          }
        }
      }
    }
    paging {
      number
      size
      totalElements
      totalPages
    }
  }
}
    `) as unknown as TypedDocumentString<
  CannedTallyCandidateLengthsQuery,
  CannedTallyCandidateLengthsQueryVariables
>;
export const CannedTallySellerGroupsForBuyerDocument = new TypedDocumentString(`
    query CannedTallySellerGroupsForBuyer($platformProductId: ID!, $transportVehicleId: ID!, $tallyName: String, $filter: CannedTallySellerGroupFilterInput, $comparisonFilters: SellerComparisonFiltersInput, $pageInput: PageInput!, $sort: [SortInput!]) {
  cannedTallySellerGroupsForBuyer(
    platformProductId: $platformProductId
    transportVehicleId: $transportVehicleId
    tallyName: $tallyName
    filter: $filter
    comparisonFilters: $comparisonFilters
    pageInput: $pageInput
    sort: $sort
  ) {
    content {
      id
      sellerName
      facility {
        id
        code
        organization {
          id
          name
          sellingOrganizationCode
        }
      }
      currency
      avgPrice
      priceUnit
      totalBundles
      leadTimeDays
      hasBestPrice
      hasAnyPricedLength
      lengthBreakdown {
        ft
        actualLengthInches
        platformProductsLengthId
        hasInventory
        bundles
        pricePerBundle {
          amount
        }
      }
    }
    paging {
      number
      size
      totalElements
      totalPages
    }
  }
}
    `) as unknown as TypedDocumentString<
  CannedTallySellerGroupsForBuyerQuery,
  CannedTallySellerGroupsForBuyerQueryVariables
>;
export const GetChatsByOrderDocument = new TypedDocumentString(`
    query GetChatsByOrder($orderId: ID!) {
  chats(orderId: $orderId) {
    id
    createdAt
    type
    title
    archived
    order {
      id
      purchaseOrderNumber
      cancellationNote
      shippingLocation {
        name
        facility {
          address {
            city
            region
          }
        }
      }
    }
    orderReference {
      order {
        id
        purchaseOrderNumber
        status
        cancellationNote
        currency
        items {
          platformProductsLengths {
            isNominal
            platformProduct {
              name
              actualWidthInches
              actualThicknessInches
              nominalWidthInches
              nominalThicknessInches
              actualLengthInches
              piecesPerBundle {
                value
              }
            }
            lengthDisplayValue
            length {
              actualLengthInches
              nominalLengthInches
            }
          }
          quantity(mode: {mode: USER_PREFERRED}) {
            value
            unit
          }
          quantityStored: quantity(mode: {mode: STORED}) {
            value
          }
          effectivePrice {
            amount
            currency
          }
          price {
            amount
            currency
          }
          suggestedPrice {
            amount
            currency
          }
        }
      }
    }
    sellingOrganization {
      id
      name
      sellingOrganizationCode
    }
    buyingOrganization {
      id
      name
    }
    email {
      subject
      htmlBody
      recipientTo
      status
    }
  }
}
    `) as unknown as TypedDocumentString<
  GetChatsByOrderQuery,
  GetChatsByOrderQueryVariables
>;
export const GetBuyerOrdersWithChatsDocument = new TypedDocumentString(`
    query GetBuyerOrdersWithChats {
  buyerOrdersWithChats {
    id
    purchaseOrderNumber
    sellingOrganization {
      name
      sellingOrganizationCode
    }
    buyingOrganization {
      name
    }
  }
}
    `) as unknown as TypedDocumentString<
  GetBuyerOrdersWithChatsQuery,
  GetBuyerOrdersWithChatsQueryVariables
>;
export const GetSellerOrdersWithChatsDocument = new TypedDocumentString(`
    query GetSellerOrdersWithChats {
  sellerOrdersWithChats {
    id
    sellingOrganization {
      name
    }
    buyingOrganization {
      name
    }
  }
}
    `) as unknown as TypedDocumentString<
  GetSellerOrdersWithChatsQuery,
  GetSellerOrdersWithChatsQueryVariables
>;
export const ExtractedDocumentProgressDocument = new TypedDocumentString(`
    query ExtractedDocumentProgress($id: ID!) {
  extractedDocument(id: $id) {
    id
    createdAt
    originalFilename
    sourceFormat
    documentKind
    status
    failureReason
    vendorName
    documentDate
    currency
    priceBasis
    notes
    ambiguities
    expectedPositionCount
    coveredPositionCount
    units {
      documentId
      sourceFilename
      unitKey
      label
      representation
      status
      expectedPositionCount
      coveredPositionCount
      attemptCount
    }
  }
}
    `) as unknown as TypedDocumentString<
  ExtractedDocumentProgressQuery,
  ExtractedDocumentProgressQueryVariables
>;
export const ExtractedDocumentItemsDocument = new TypedDocumentString(`
    query ExtractedDocumentItems($id: ID!) {
  extractedDocument(id: $id) {
    id
    items {
      id
      documentId
      unitLabel
      positionKey
      provenance
      verdict
      verifiedValue
      governingLabels
      claimedValue
      secondOpinion
      secondOpinionReason
      confidence
      ambiguities
      fields {
        name
        value
      }
    }
  }
}
    `) as unknown as TypedDocumentString<
  ExtractedDocumentItemsQuery,
  ExtractedDocumentItemsQueryVariables
>;
export const EmailDeliveryTracesDocument = new TypedDocumentString(`
    query EmailDeliveryTraces($filter: EmailDeliveryTraceFilter, $pageInput: PageInput!) {
  emailDeliveryTraces(filter: $filter, pageInput: $pageInput) {
    content {
      id
      emailType
      recipientTo
      recipientCc
      status
      lastError
      sesMessageId
      deliveryOutcome
      deliveryOutcomeAt
      createdAt
      sentAt
      events {
        id
        eventType
        recipient
        bounceType
        bounceSubType
        diagnosticCode
        reason
        occurredAt
      }
    }
    paging {
      number
      size
      totalElements
      totalPages
    }
  }
}
    `) as unknown as TypedDocumentString<
  EmailDeliveryTracesQuery,
  EmailDeliveryTracesQueryVariables
>;
export const SendPlatformTestEmailDocument = new TypedDocumentString(`
    mutation SendPlatformTestEmail($input: SendPlatformTestEmailInput!) {
  sendPlatformTestEmail(input: $input) {
    id
    recipientTo
    sesMessageId
    deliveryOutcome
    createdAt
  }
}
    `) as unknown as TypedDocumentString<
  SendPlatformTestEmailMutation,
  SendPlatformTestEmailMutationVariables
>;
export const SuggestAddressesDocument = new TypedDocumentString(`
    query SuggestAddresses($query: String!) {
  suggestAddresses(query: $query) {
    text
    placeId
  }
}
    `) as unknown as TypedDocumentString<
  SuggestAddressesQuery,
  SuggestAddressesQueryVariables
>;
export const ResolveAddressDocument = new TypedDocumentString(`
    query ResolveAddress($text: String!) {
  resolveAddress(text: $text) {
    addressLine1
    city
    region
    countryCode
    zipCode
    latitude
    longitude
  }
}
    `) as unknown as TypedDocumentString<
  ResolveAddressQuery,
  ResolveAddressQueryVariables
>;
export const ReverseGeocodeDocument = new TypedDocumentString(`
    query ReverseGeocode($latitude: Float!, $longitude: Float!) {
  reverseGeocode(latitude: $latitude, longitude: $longitude) {
    addressLine1
    city
    region
    countryCode
    zipCode
    latitude
    longitude
  }
}
    `) as unknown as TypedDocumentString<
  ReverseGeocodeQuery,
  ReverseGeocodeQueryVariables
>;
export const GetOrganizationFacilitiesPageDocument = new TypedDocumentString(`
    query GetOrganizationFacilitiesPage($page: Int!, $size: Int!, $search: String, $scope: FacilityScope) {
  organizationFacilitiesPage(
    pageInput: {page: $page, size: $size}
    filters: {search: $search, scope: $scope}
  ) {
    content {
      id
      code
      phoneNumber
      faxNumber
      address {
        addressLine1
        addressLine2
        city
        region
        zipCode
        country
      }
      transportVehicles {
        id
        name
        vehicleType
      }
      locations {
        id
        name
        code
        branchCode
      }
      shippingRates {
        id
        shippingRate {
          id
          zone
          distanceInMileMin
          distanceInMileMax
          shippingDaysMin
          shippingDaysMax
        }
        ratePerMbf
        rateCurrency
      }
      nearestPort {
        id
        code
        name
        city
        country
      }
    }
    paging {
      totalElements
      totalPages
      number
      size
    }
  }
}
    `) as unknown as TypedDocumentString<
  GetOrganizationFacilitiesPageQuery,
  GetOrganizationFacilitiesPageQueryVariables
>;
export const GetOrganizationFacilitiesDocument = new TypedDocumentString(`
    query GetOrganizationFacilities {
  organizationFacilities {
    id
    code
    address {
      city
    }
    locations {
      branchCode
    }
  }
}
    `) as unknown as TypedDocumentString<
  GetOrganizationFacilitiesQuery,
  GetOrganizationFacilitiesQueryVariables
>;
export const GetFacilityAddressOptionsDocument = new TypedDocumentString(`
    query GetFacilityAddressOptions {
  organizationFacilities {
    id
    code
    address {
      addressLine1
      addressLine2
      city
      region
      zipCode
    }
  }
}
    `) as unknown as TypedDocumentString<
  GetFacilityAddressOptionsQuery,
  GetFacilityAddressOptionsQueryVariables
>;
export const GetOrganizationLocationsPageDocument = new TypedDocumentString(`
    query GetOrganizationLocationsPage($page: Int!, $size: Int!, $search: String, $scope: LocationScope) {
  organizationLocationsPage(
    pageInput: {page: $page, size: $size}
    filters: {search: $search, scope: $scope}
  ) {
    content {
      id
      code
      name
      branchCode
      facility {
        id
        code
        address {
          addressLine1
          addressLine2
          city
          region
          zipCode
          country
        }
      }
    }
    paging {
      totalElements
      totalPages
      number
      size
    }
  }
}
    `) as unknown as TypedDocumentString<
  GetOrganizationLocationsPageQuery,
  GetOrganizationLocationsPageQueryVariables
>;
export const GetTransportVehiclesDocument = new TypedDocumentString(`
    query GetTransportVehicles {
  transportVehicles {
    id
    name
    vehicleType
  }
}
    `) as unknown as TypedDocumentString<
  GetTransportVehiclesQuery,
  GetTransportVehiclesQueryVariables
>;
export const GetTransportVehicleByIdDocument = new TypedDocumentString(`
    query GetTransportVehicleById($id: ID!) {
  transportVehicle(id: $id) {
    id
    name
    vehicleType
  }
}
    `) as unknown as TypedDocumentString<
  GetTransportVehicleByIdQuery,
  GetTransportVehicleByIdQueryVariables
>;
export const AddTransportVehiclesToFacilityDocument = new TypedDocumentString(`
    mutation AddTransportVehiclesToFacility($facilityId: ID!, $transportVehicleIds: [ID!]!) {
  addTransportVehiclesToFacility(
    facilityId: $facilityId
    transportVehicleIds: $transportVehicleIds
  ) {
    id
    transportVehicles {
      id
      name
      vehicleType
    }
  }
}
    `) as unknown as TypedDocumentString<
  AddTransportVehiclesToFacilityMutation,
  AddTransportVehiclesToFacilityMutationVariables
>;
export const UpsertFacilityDocument = new TypedDocumentString(`
    mutation UpsertFacility($id: ID, $input: FacilityInput!) {
  upsertFacility(id: $id, input: $input) {
    id
    code
    phoneNumber
    faxNumber
    address {
      addressLine1
      addressLine2
      city
      region
      zipCode
      country
    }
    nearestPort {
      id
      code
      name
      city
      country
    }
  }
}
    `) as unknown as TypedDocumentString<
  UpsertFacilityMutation,
  UpsertFacilityMutationVariables
>;
export const DeleteFacilityDocument = new TypedDocumentString(`
    mutation DeleteFacility($id: ID!) {
  deleteFacility(id: $id)
}
    `) as unknown as TypedDocumentString<
  DeleteFacilityMutation,
  DeleteFacilityMutationVariables
>;
export const RemoveTransportVehiclesFromFacilityDocument =
  new TypedDocumentString(`
    mutation RemoveTransportVehiclesFromFacility($facilityId: ID!, $transportVehicleIds: [ID!]!) {
  removeTransportVehiclesFromFacility(
    facilityId: $facilityId
    transportVehicleIds: $transportVehicleIds
  ) {
    id
    transportVehicles {
      id
      name
      vehicleType
    }
  }
}
    `) as unknown as TypedDocumentString<
    RemoveTransportVehiclesFromFacilityMutation,
    RemoveTransportVehiclesFromFacilityMutationVariables
  >;
export const GetShippingRatesDocument = new TypedDocumentString(`
    query GetShippingRates {
  shippingRates {
    id
    zone
    distanceInMileMin
    distanceInMileMax
    shippingDaysMin
    shippingDaysMax
  }
}
    `) as unknown as TypedDocumentString<
  GetShippingRatesQuery,
  GetShippingRatesQueryVariables
>;
export const UpsertFacilityShippingRatesDocument = new TypedDocumentString(`
    mutation UpsertFacilityShippingRates($facilityId: ID!, $shippingRates: [ShippingRateInput!]!) {
  upsertFacilityShippingRates(
    facilityId: $facilityId
    shippingRates: $shippingRates
  ) {
    id
  }
}
    `) as unknown as TypedDocumentString<
  UpsertFacilityShippingRatesMutation,
  UpsertFacilityShippingRatesMutationVariables
>;
export const GetFeatureFlagsDocument = new TypedDocumentString(`
    query getFeatureFlags {
  featureFlags {
    name
    enabled
  }
}
    `) as unknown as TypedDocumentString<
  GetFeatureFlagsQuery,
  GetFeatureFlagsQueryVariables
>;
export const BuyerInventoryDocument = new TypedDocumentString(`
    query buyerInventory($page: Int!, $size: Int!, $filters: BuyerInventoryFiltersInput, $includeInventoryLengths: Boolean, $sort: [SortInput!]) {
  buyerInventory(
    pageInput: {page: $page, size: $size}
    filters: $filters
    includeInventoryLengths: $includeInventoryLengths
    sort: $sort
  ) {
    paging {
      totalElements
      totalPages
      number
      size
    }
    content {
      id
      quantity {
        value
        unit
      }
      onOrderStock {
        unit
        value
      }
      availableStock {
        value
        unit
      }
      onHandStock {
        value
        unit
      }
      inboundStock {
        value
        unit
      }
      requestedStock {
        value
        unit
      }
      location {
        id
        code
        name
        facility {
          id
          code
          address {
            addressLine1
            city
            region
          }
          locations {
            branchCode
          }
        }
      }
      platformProductsLength {
        id
        isNominal
        lengthDisplayValue
        length {
          id
          displayValue
          nominalLengthInches
          actualLengthInches
        }
        platformProduct {
          id
          code
          name
          category
          properties
          standardUnitsCode
          nominalWidthInches
          actualWidthInches
          nominalThicknessInches
          actualThicknessInches
          actualLengthInches
          piecesPerBundle {
            value
            unit
          }
        }
      }
      buyerInventoryConfiguration {
        id
        usageRatePerWeek {
          value
          unit
        }
        weeksCoveredBeforeUrgent
        weeksCoveredBeforeMonitor
        targetWeeksCovered
      }
    }
  }
}
    `) as unknown as TypedDocumentString<
  BuyerInventoryQuery,
  BuyerInventoryQueryVariables
>;
export const BuyerInventoryRevealCountsDocument = new TypedDocumentString(`
    query buyerInventoryRevealCounts($filters: BuyerInventoryFiltersInput) {
  buyerInventory(pageInput: {page: 0, size: 1}, filters: $filters) {
    paging {
      totalElements
      totalElementsIncludingHidden
    }
  }
}
    `) as unknown as TypedDocumentString<
  BuyerInventoryRevealCountsQuery,
  BuyerInventoryRevealCountsQueryVariables
>;
export const BuyerInventoryPriorityGroupsDocument = new TypedDocumentString(`
    query buyerInventoryPriorityGroups($page: Int!, $size: Int!, $filters: BuyerInventoryFiltersInput, $includeInventoryLengths: Boolean, $sort: [SortInput!]) {
  buyerInventoryPriorityGroups(
    pageInput: {page: $page, size: $size}
    filters: $filters
    includeInventoryLengths: $includeInventoryLengths
    sort: $sort
  ) {
    paging {
      totalElements
      totalPages
      number
      size
    }
    content {
      id
      facility {
        id
        code
        address {
          city
          region
        }
        locations {
          branchCode
        }
      }
      platformProductsLength {
        id
        isNominal
        lengthDisplayValue
        length {
          id
          displayValue
          nominalLengthInches
          actualLengthInches
        }
        platformProduct {
          id
          code
          name
          category
          properties
          standardUnitsCode
          nominalWidthInches
          actualWidthInches
          nominalThicknessInches
          actualThicknessInches
          actualLengthInches
          piecesPerBundle {
            value
            unit
          }
        }
      }
      totalStock {
        value
        unit
      }
      totalOnOrderStock {
        value
        unit
      }
      totalAvailableStock {
        value
        unit
      }
      totalOnHandStock {
        value
        unit
      }
      totalInboundStock {
        value
        unit
      }
      totalRequestedStock {
        value
        unit
      }
      avgUsageRatePerWeek {
        value
        unit
      }
      targetInventory {
        id
        location {
          id
        }
        buyerInventoryConfiguration {
          id
          weeksCoveredBeforeUrgent
          weeksCoveredBeforeMonitor
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<
  BuyerInventoryPriorityGroupsQuery,
  BuyerInventoryPriorityGroupsQueryVariables
>;
export const BuyerInventoryGroupLocationsDocument = new TypedDocumentString(`
    query buyerInventoryGroupLocations($facilityId: ID!, $platformProductsLengthId: ID!) {
  buyerInventoryGroupLocations(
    facilityId: $facilityId
    platformProductsLengthId: $platformProductsLengthId
  ) {
    location {
      id
      name
      code
      facility {
        id
        code
        address {
          addressLine1
          city
          region
        }
      }
    }
    inventory {
      id
      quantity {
        value
        unit
      }
      onOrderStock {
        value
        unit
      }
      availableStock {
        value
        unit
      }
      onHandStock {
        value
        unit
      }
      inboundStock {
        value
        unit
      }
      requestedStock {
        value
        unit
      }
      buyerInventoryConfiguration {
        id
        usageRatePerWeek {
          value
          unit
        }
        weeksCoveredBeforeUrgent
        weeksCoveredBeforeMonitor
        targetWeeksCovered
      }
    }
  }
}
    `) as unknown as TypedDocumentString<
  BuyerInventoryGroupLocationsQuery,
  BuyerInventoryGroupLocationsQueryVariables
>;
export const UpsertInventoryDocument = new TypedDocumentString(`
    mutation upsertInventory($platformProductsLengthId: ID!, $locationId: ID!, $quantity: QuantityInput!) {
  upsertInventory(
    platformProductsLengthId: $platformProductsLengthId
    locationId: $locationId
    quantity: $quantity
  ) {
    id
    location {
      id
      name
    }
    platformProductsLength {
      id
      platformProduct {
        name
      }
    }
    buyerInventoryConfiguration {
      weeksCoveredBeforeMonitor
      weeksCoveredBeforeUrgent
      targetWeeksCovered
      location {
        id
      }
      platformProductsLength {
        id
      }
      usageRatePerWeek {
        value
        unit
      }
    }
    quantity {
      value
      unit
    }
    availableStock {
      value
      unit
    }
    onHandStock {
      value
      unit
    }
  }
}
    `) as unknown as TypedDocumentString<
  UpsertInventoryMutation,
  UpsertInventoryMutationVariables
>;
export const PlatformProductsLengthsForProductDocument =
  new TypedDocumentString(`
    query platformProductsLengthsForProduct($platformProductId: ID!) {
  platformProductsLengthsForProduct(platformProductId: $platformProductId) {
    id
    isNominal
    inventoryOnly
    lengthDisplayValue
    platformProduct {
      id
      name
      standardUnitsCode
      nominalWidthInches
      actualWidthInches
      nominalThicknessInches
      actualThicknessInches
      actualLengthInches
      piecesPerBundle {
        value
        unit
      }
    }
    length {
      id
      actualLengthInches
      nominalLengthInches
    }
    latestPriceMax {
      amount
      currency
    }
    latestPriceMin {
      amount
      currency
    }
    latestPriceMid {
      amount
      currency
    }
  }
}
    `) as unknown as TypedDocumentString<
    PlatformProductsLengthsForProductQuery,
    PlatformProductsLengthsForProductQueryVariables
  >;
export const SellerProductInventoriesForBuyerDocument =
  new TypedDocumentString(`
    query sellerProductInventoriesForBuyer($page: Int!, $size: Int!, $platformProductLengthIds: [ID!], $platformProductId: ID, $sellerOrganizationId: ID, $destinationLocationId: ID, $deliveryMode: DeliveryMode, $includeInventoryLengths: Boolean, $comparisonFilters: SellerComparisonFiltersInput, $sort: [SortInput!]) {
  sellerProductInventoriesForBuyer(
    pageInput: {page: $page, size: $size}
    filter: {platformProductLengthIds: $platformProductLengthIds, platformProductId: $platformProductId, sellerOrganizationId: $sellerOrganizationId, destinationLocationId: $destinationLocationId, deliveryMode: $deliveryMode, includeInventoryLengths: $includeInventoryLengths}
    comparisonFilters: $comparisonFilters
    sort: $sort
  ) {
    paging {
      totalElements
      totalPages
      number
      size
    }
    recommendedPrice {
      amount
      currency
    }
    recommendedPriceCount
    sellersCount
    content {
      id
      quantity {
        value
        unit
      }
      unitPrice {
        price {
          amount
          currency
        }
        unit
      }
      deliveredShippingRate(destinationLocationId: $destinationLocationId) {
        amount
        currency
      }
      pickupShippingRate(destinationLocationId: $destinationLocationId) {
        amount
        currency
      }
      facility {
        id
        code
        address {
          addressLine1
          addressLine2
          city
          region
          country
        }
        organization {
          id
          name
          sellingOrganizationCode
        }
      }
      platformProductsLength {
        id
        isNominal
        inventoryOnly
        lengthDisplayValue
        length {
          nominalLengthInches
          actualLengthInches
        }
        platformProduct {
          id
          name
          code
          nominalWidthInches
          actualWidthInches
          nominalThicknessInches
          actualThicknessInches
          actualLengthInches
          standardUnitsCode
          piecesPerBundle {
            value
            unit
          }
        }
      }
      sellerProductConfiguration {
        id
        minimumOrderQuantity {
          value
          unit
        }
        readyToShipDays
        facility {
          id
          code
          address {
            addressLine1
            addressLine2
            city
            region
            country
          }
        }
        organization {
          id
          name
          sellingOrganizationCode
        }
        unit
      }
    }
  }
}
    `) as unknown as TypedDocumentString<
    SellerProductInventoriesForBuyerQuery,
    SellerProductInventoriesForBuyerQueryVariables
  >;
export const SellerVendorInventoryGroupsForBuyerDocument =
  new TypedDocumentString(`
    query SellerVendorInventoryGroupsForBuyer($page: Int!, $size: Int!, $platformProductLengthIds: [ID!], $platformProductId: ID, $sellerOrganizationId: ID, $destinationLocationId: ID, $deliveryMode: DeliveryMode, $includeInventoryLengths: Boolean, $comparisonFilters: SellerComparisonFiltersInput, $sort: [SortInput!]) {
  sellerVendorInventoryGroupsForBuyer(
    pageInput: {page: $page, size: $size}
    filter: {platformProductLengthIds: $platformProductLengthIds, platformProductId: $platformProductId, sellerOrganizationId: $sellerOrganizationId, destinationLocationId: $destinationLocationId, deliveryMode: $deliveryMode, includeInventoryLengths: $includeInventoryLengths}
    comparisonFilters: $comparisonFilters
    sort: $sort
  ) {
    content {
      id
      organization {
        id
        name
        sellingOrganizationCode
        defaultCurrency
        facilities {
          id
          code
          locations {
            id
            code
          }
        }
      }
      platformProductsLength {
        id
        lengthDisplayValue
        isNominal
        inventoryOnly
      }
      priceRange {
        min {
          amount
          currency
        }
        max {
          amount
          currency
        }
      }
      totalStock {
        value
        unit
      }
      minReadyToShipDays
      facilityCount
      hasPricedFacility
    }
    paging {
      number
      size
      totalElements
      totalPages
    }
    recommendedPrice {
      amount
      currency
    }
    recommendedPriceCount
    sellersCount
  }
}
    `) as unknown as TypedDocumentString<
    SellerVendorInventoryGroupsForBuyerQuery,
    SellerVendorInventoryGroupsForBuyerQueryVariables
  >;
export const BuyerProductInventoryDocument = new TypedDocumentString(`
    query buyerProductInventory($id: ID!) {
  buyerProductInventory(id: $id) {
    id
    quantity {
      value
      unit
    }
    availableStock {
      value
      unit
    }
    onHandStock {
      value
      unit
    }
    location {
      id
      name
      facility {
        address {
          city
          region
        }
      }
    }
    platformProductsLength {
      id
      lengthDisplayValue
      platformProduct {
        id
        name
        code
        actualThicknessInches
        actualWidthInches
        finishCode
        constructionCode
        properties
      }
    }
    buyerInventoryConfiguration {
      id
      usageRatePerWeek {
        value
        unit
      }
      weeksCoveredBeforeUrgent
      weeksCoveredBeforeMonitor
      targetWeeksCovered
    }
  }
}
    `) as unknown as TypedDocumentString<
  BuyerProductInventoryQuery,
  BuyerProductInventoryQueryVariables
>;
export const BuyerInventoryByProductAndLocationDocument =
  new TypedDocumentString(`
    query buyerInventoryByProductAndLocation($lengthId: ID!, $platformProductId: ID!, $locationId: ID!) {
  buyerInventoryByProductAndLocation(
    lengthId: $lengthId
    platformProductId: $platformProductId
    locationId: $locationId
  ) {
    id
    quantity {
      value
      unit
    }
    availableStock {
      value
      unit
    }
    onHandStock {
      value
      unit
    }
    onOrderStock {
      value
      unit
    }
    inboundStock {
      value
      unit
    }
    location {
      id
      name
      facility {
        address {
          city
          region
        }
      }
    }
    platformProductsLength {
      id
      isNominal
      lengthDisplayValue
      length {
        id
        nominalLengthInches
        actualLengthInches
      }
      platformProduct {
        id
        name
        code
        nominalThicknessInches
        actualThicknessInches
        nominalWidthInches
        actualWidthInches
        actualLengthInches
        finishCode
        constructionCode
        properties
      }
    }
    buyerInventoryConfiguration {
      id
      usageRatePerWeek {
        value
        unit
      }
      weeksCoveredBeforeUrgent
      weeksCoveredBeforeMonitor
      targetWeeksCovered
    }
  }
}
    `) as unknown as TypedDocumentString<
    BuyerInventoryByProductAndLocationQuery,
    BuyerInventoryByProductAndLocationQueryVariables
  >;
export const AdditionalProductsFromSellerDocument = new TypedDocumentString(`
    query additionalProductsFromSeller($orderId: ID!, $pageInput: PageInput!) {
  additionalProductsFromSeller(orderId: $orderId, pageInput: $pageInput) {
    content {
      id
      quantity(mode: {mode: USER_PREFERRED}) {
        value
        unit
      }
      unitPrice {
        price {
          amount
          currency
        }
        unit
      }
      platformProductsLength {
        id
        isNominal
        lengthDisplayValue
        length {
          nominalLengthInches
          actualLengthInches
        }
        platformProduct {
          id
          name
          nominalWidthInches
          actualWidthInches
          nominalThicknessInches
          actualThicknessInches
          actualLengthInches
          standardUnitsCode
          properties
          piecesPerBundle {
            value
          }
        }
        platformProductVehicleCapacities {
          transportVehicle {
            id
          }
          capacity {
            value
            unit
          }
        }
      }
      weeksCovered
      stockHealth
    }
    paging {
      totalElements
      totalPages
      number
      size
    }
  }
}
    `) as unknown as TypedDocumentString<
  AdditionalProductsFromSellerQuery,
  AdditionalProductsFromSellerQueryVariables
>;
export const GetSellerLowStockProductsDocument = new TypedDocumentString(`
    query GetSellerLowStockProducts {
  sellerLowStockProducts {
    id
    health
    platformProductLength {
      lengthDisplayValue
      platformProduct {
        id
        name
      }
    }
    lowStockLevel {
      value
      unit
    }
  }
}
    `) as unknown as TypedDocumentString<
  GetSellerLowStockProductsQuery,
  GetSellerLowStockProductsQueryVariables
>;
export const BuyerInventoriesByProductAndLocationForTallyDocument =
  new TypedDocumentString(`
    query buyerInventoriesByProductAndLocationForTally($lengthIds: [ID!]!, $platformProductId: ID!, $locationId: ID!) {
  buyerInventoriesByProductAndLocation(
    lengthIds: $lengthIds
    platformProductId: $platformProductId
    locationId: $locationId
  ) {
    quantity {
      value
      unit
    }
    buyerInventoryConfiguration {
      usageRatePerWeek {
        value
        unit
      }
      weeksCoveredBeforeUrgent
      weeksCoveredBeforeMonitor
      targetWeeksCovered
    }
  }
}
    `) as unknown as TypedDocumentString<
    BuyerInventoriesByProductAndLocationForTallyQuery,
    BuyerInventoriesByProductAndLocationForTallyQueryVariables
  >;
export const SellerPriceForBuyerDocument = new TypedDocumentString(`
    query sellerPriceForBuyer($platformProductLengthId: ID!, $sellerOrganizationId: ID, $facilityId: ID, $deliveryMode: DeliveryMode, $destinationLocationId: ID) {
  sellerProductInventoriesForBuyer(
    pageInput: {page: 0, size: 1}
    filter: {platformProductLengthIds: [$platformProductLengthId], sellerOrganizationId: $sellerOrganizationId, facilityId: $facilityId, deliveryMode: $deliveryMode, destinationLocationId: $destinationLocationId}
  ) {
    content {
      unitPrice {
        price {
          amount
          currency
        }
        unit
      }
    }
  }
}
    `) as unknown as TypedDocumentString<
  SellerPriceForBuyerQuery,
  SellerPriceForBuyerQueryVariables
>;
export const FailedJobOutboxEntriesDocument = new TypedDocumentString(`
    query FailedJobOutboxEntries($page: Int!, $size: Int!) {
  failedJobOutboxEntries(pageInput: {page: $page, size: $size}) {
    content {
      id
      payloadType
      payload
      lastError
      attempts
      failedAt
    }
    paging {
      number
      size
      totalElements
      totalPages
    }
  }
}
    `) as unknown as TypedDocumentString<
  FailedJobOutboxEntriesQuery,
  FailedJobOutboxEntriesQueryVariables
>;
export const RetryFailedJobOutboxEntryDocument = new TypedDocumentString(`
    mutation RetryFailedJobOutboxEntry($id: ID!) {
  retryFailedJobOutboxEntry(id: $id) {
    id
  }
}
    `) as unknown as TypedDocumentString<
  RetryFailedJobOutboxEntryMutation,
  RetryFailedJobOutboxEntryMutationVariables
>;
export const LocationsDocument = new TypedDocumentString(`
    query locations {
  locations {
    id
    name
    code
    branchCode
  }
}
    `) as unknown as TypedDocumentString<
  LocationsQuery,
  LocationsQueryVariables
>;
export const BuyListLocationsDocument = new TypedDocumentString(`
    query BuyListLocations {
  buyListLocations {
    id
    code
    name
    branchCode
    facility {
      id
      code
      address {
        addressLine1
        addressLine2
        city
        region
        zipCode
      }
    }
  }
}
    `) as unknown as TypedDocumentString<
  BuyListLocationsQuery,
  BuyListLocationsQueryVariables
>;
export const UpsertLocationDocument = new TypedDocumentString(`
    mutation UpsertLocation($id: ID, $facilityId: ID, $input: LocationInput!) {
  upsertLocation(id: $id, facilityId: $facilityId, input: $input) {
    id
    name
    code
    branchCode
  }
}
    `) as unknown as TypedDocumentString<
  UpsertLocationMutation,
  UpsertLocationMutationVariables
>;
export const DeleteLocationDocument = new TypedDocumentString(`
    mutation DeleteLocation($id: ID!) {
  deleteLocation(id: $id)
}
    `) as unknown as TypedDocumentString<
  DeleteLocationMutation,
  DeleteLocationMutationVariables
>;
export const AssignCurrentUserToLocationDocument = new TypedDocumentString(`
    mutation AssignCurrentUserToLocation($locationId: ID!) {
  assignCurrentUserToLocation(locationId: $locationId) {
    id
    name
    code
    branchCode
  }
}
    `) as unknown as TypedDocumentString<
  AssignCurrentUserToLocationMutation,
  AssignCurrentUserToLocationMutationVariables
>;
export const UnassignUserFromLocationDocument = new TypedDocumentString(`
    mutation UnassignUserFromLocation($locationId: ID!) {
  unassignUserFromLocation(locationId: $locationId) {
    id
    name
    code
    branchCode
  }
}
    `) as unknown as TypedDocumentString<
  UnassignUserFromLocationMutation,
  UnassignUserFromLocationMutationVariables
>;
export const GetShippingRoutesDocument = new TypedDocumentString(`
    query GetShippingRoutes($pageInput: PageInput!, $sort: [SortInput!], $filter: ShippingRouteFilterInput) {
  shippingRoutes(pageInput: $pageInput, sort: $sort, filter: $filter) {
    content {
      id
      organizationId
      status
      category
      forwarder
      forwarderEmail
      hasForwarderContact
      transitDays
      freeDays
      notes
      expirationDate
      incotermLoading
      incotermDischarge
      portOfLoading {
        id
        code
        name
        city
        country
        type
      }
      originDelivery {
        id
        code
        name
        city
        country
        type
      }
      portOfDischarge {
        id
        code
        name
        city
        country
        type
      }
      destinationDelivery {
        id
        code
        name
        city
        country
        type
      }
      freightCost {
        amount
        currency
      }
      terminalHandlingCharge {
        amount
        currency
      }
      gassingCost {
        amount
        currency
      }
      additionalCostsPerContainer {
        amount
        currency
      }
      additionalCostsPerShipment {
        amount
        currency
      }
    }
    paging {
      totalPages
      totalElements
      number
      size
    }
  }
}
    `) as unknown as TypedDocumentString<
  GetShippingRoutesQuery,
  GetShippingRoutesQueryVariables
>;
export const GetPortsDocument = new TypedDocumentString(`
    query GetPorts {
  ports(active: true) {
    id
    code
    name
    city
    country
    type
    active
  }
}
    `) as unknown as TypedDocumentString<GetPortsQuery, GetPortsQueryVariables>;
export const GetAllPortsDocument = new TypedDocumentString(`
    query GetAllPorts {
  ports {
    id
    code
    name
    city
    country
    type
    active
  }
}
    `) as unknown as TypedDocumentString<
  GetAllPortsQuery,
  GetAllPortsQueryVariables
>;
export const GetDutyCostsDocument = new TypedDocumentString(`
    query GetDutyCosts {
  dutyCosts {
    id
    htsNumber
    description
    dutyAdValoremRate
    dutySpecificRate
    dutySpecificUnit
    section301Rate
    adCvdRate
    adCvdType
    adCvdDescription
    softwoodLumberFeeMbf
    softwoodLumberFeeCbm
    currencyCode
    originCountryCode
    gspEligible
    conditional
    active
  }
}
    `) as unknown as TypedDocumentString<
  GetDutyCostsQuery,
  GetDutyCostsQueryVariables
>;
export const GetShippingRouteCategoriesDocument = new TypedDocumentString(`
    query GetShippingRouteCategories {
  shippingRouteCategories
}
    `) as unknown as TypedDocumentString<
  GetShippingRouteCategoriesQuery,
  GetShippingRouteCategoriesQueryVariables
>;
export const GetShippingAddOnCategoriesDocument = new TypedDocumentString(`
    query GetShippingAddOnCategories {
  shippingAddOnCategories
}
    `) as unknown as TypedDocumentString<
  GetShippingAddOnCategoriesQuery,
  GetShippingAddOnCategoriesQueryVariables
>;
export const GetLogisticsIncotermsDocument = new TypedDocumentString(`
    query GetLogisticsIncoterms {
  logisticsIncoterms
}
    `) as unknown as TypedDocumentString<
  GetLogisticsIncotermsQuery,
  GetLogisticsIncotermsQueryVariables
>;
export const CreateShippingRouteDocument = new TypedDocumentString(`
    mutation CreateShippingRoute($input: CreateShippingRouteInput!) {
  createShippingRoute(input: $input) {
    id
    organizationId
    status
    category
    incotermLoading
    incotermDischarge
    portOfLoading {
      id
      code
      name
    }
    portOfDischarge {
      id
      code
      name
    }
  }
}
    `) as unknown as TypedDocumentString<
  CreateShippingRouteMutation,
  CreateShippingRouteMutationVariables
>;
export const UpdateShippingRouteDocument = new TypedDocumentString(`
    mutation UpdateShippingRoute($id: ID!, $input: UpdateShippingRouteInput!) {
  updateShippingRoute(id: $id, input: $input) {
    id
    organizationId
    status
    category
    incotermLoading
    incotermDischarge
    portOfLoading {
      id
      code
      name
    }
    portOfDischarge {
      id
      code
      name
    }
  }
}
    `) as unknown as TypedDocumentString<
  UpdateShippingRouteMutation,
  UpdateShippingRouteMutationVariables
>;
export const RequestShippingRouteDocument = new TypedDocumentString(`
    mutation RequestShippingRoute($input: CreateShippingRouteInput!) {
  requestShippingRoute(input: $input) {
    id
    organizationId
    status
    category
    hasForwarderContact
    incotermLoading
    incotermDischarge
    portOfLoading {
      id
      code
      name
    }
    portOfDischarge {
      id
      code
      name
    }
  }
}
    `) as unknown as TypedDocumentString<
  RequestShippingRouteMutation,
  RequestShippingRouteMutationVariables
>;
export const GetShippingAddOnsDocument = new TypedDocumentString(`
    query GetShippingAddOns($hidden: Boolean) {
  shippingAddOns(hidden: $hidden) {
    id
    organizationId
    name
    description
    category
    billingUnit
    cost
    currency
    active
    hidden
    isPlatformCustomization
  }
}
    `) as unknown as TypedDocumentString<
  GetShippingAddOnsQuery,
  GetShippingAddOnsQueryVariables
>;
export const CreateShippingAddOnDocument = new TypedDocumentString(`
    mutation CreateShippingAddOn($input: CreateShippingAddOnInput!) {
  createShippingAddOn(input: $input) {
    id
    organizationId
    name
    description
    category
    billingUnit
    cost
    currency
    active
  }
}
    `) as unknown as TypedDocumentString<
  CreateShippingAddOnMutation,
  CreateShippingAddOnMutationVariables
>;
export const UpdateShippingAddOnDocument = new TypedDocumentString(`
    mutation UpdateShippingAddOn($id: ID!, $input: UpdateShippingAddOnInput!) {
  updateShippingAddOn(id: $id, input: $input) {
    id
    organizationId
    name
    description
    category
    billingUnit
    cost
    currency
    active
  }
}
    `) as unknown as TypedDocumentString<
  UpdateShippingAddOnMutation,
  UpdateShippingAddOnMutationVariables
>;
export const DeleteShippingAddOnDocument = new TypedDocumentString(`
    mutation DeleteShippingAddOn($id: ID!) {
  deleteShippingAddOn(id: $id)
}
    `) as unknown as TypedDocumentString<
  DeleteShippingAddOnMutation,
  DeleteShippingAddOnMutationVariables
>;
export const CustomizePlatformShippingAddOnDocument = new TypedDocumentString(`
    mutation CustomizePlatformShippingAddOn($platformAddOnId: ID!, $input: UpdateShippingAddOnInput!) {
  customizePlatformShippingAddOn(platformAddOnId: $platformAddOnId, input: $input) {
    id
    organizationId
    name
    description
    category
    billingUnit
    cost
    currency
    active
    hidden
  }
}
    `) as unknown as TypedDocumentString<
  CustomizePlatformShippingAddOnMutation,
  CustomizePlatformShippingAddOnMutationVariables
>;
export const HidePlatformShippingAddOnDocument = new TypedDocumentString(`
    mutation HidePlatformShippingAddOn($platformAddOnId: ID!) {
  hidePlatformShippingAddOn(platformAddOnId: $platformAddOnId) {
    id
    organizationId
    name
    category
    hidden
  }
}
    `) as unknown as TypedDocumentString<
  HidePlatformShippingAddOnMutation,
  HidePlatformShippingAddOnMutationVariables
>;
export const HideShippingAddOnDocument = new TypedDocumentString(`
    mutation HideShippingAddOn($id: ID!) {
  hideShippingAddOn(id: $id) {
    id
    organizationId
    name
    category
    hidden
  }
}
    `) as unknown as TypedDocumentString<
  HideShippingAddOnMutation,
  HideShippingAddOnMutationVariables
>;
export const HideShippingAddOnCategoryDocument = new TypedDocumentString(`
    mutation HideShippingAddOnCategory($category: String!) {
  hideShippingAddOnCategory(category: $category)
}
    `) as unknown as TypedDocumentString<
  HideShippingAddOnCategoryMutation,
  HideShippingAddOnCategoryMutationVariables
>;
export const UnhideShippingAddOnDocument = new TypedDocumentString(`
    mutation UnhideShippingAddOn($id: ID!) {
  unhideShippingAddOn(id: $id) {
    id
    hidden
  }
}
    `) as unknown as TypedDocumentString<
  UnhideShippingAddOnMutation,
  UnhideShippingAddOnMutationVariables
>;
export const GetOrderMsrPurchaseOrderDocument = new TypedDocumentString(`
    query GetOrderMsrPurchaseOrder($orderId: ID!) {
  order(id: $orderId) {
    id
    msrPurchaseOrder {
      fields {
        key
        value
        editability
      }
      items {
        fields {
          key
          value
          editability
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<
  GetOrderMsrPurchaseOrderQuery,
  GetOrderMsrPurchaseOrderQueryVariables
>;
export const MsrUnitTypesDocument = new TypedDocumentString(`
    query MsrUnitTypes($transportVehicleId: ID!) {
  msrUnitTypes(transportVehicleId: $transportVehicleId) {
    code
    description
    isDefault
  }
}
    `) as unknown as TypedDocumentString<
  MsrUnitTypesQuery,
  MsrUnitTypesQueryVariables
>;
export const MsrIncoTermsDocument = new TypedDocumentString(`
    query MsrIncoTerms($incoTerm: LogisticsIncoterm!, $incotermDischarge: LogisticsIncoterm) {
  msrIncoTerms(incoTerm: $incoTerm, incotermDischarge: $incotermDischarge) {
    code
    isDefault
    defaultLocation
  }
}
    `) as unknown as TypedDocumentString<
  MsrIncoTermsQuery,
  MsrIncoTermsQueryVariables
>;
export const SellerProductInventoriesDocument = new TypedDocumentString(`
    query sellerProductInventories($page: Int!, $size: Int!, $filters: SellerProductFiltersInput) {
  sellerProductInventories(
    pageInput: {page: $page, size: $size}
    filters: $filters
  ) {
    paging {
      totalPages
      totalElements
      size
      number
    }
    content {
      id
      quantity(mode: {mode: USER_PREFERRED}) {
        value
        unit
      }
      location {
        id
        name
        code
        facility {
          id
          address {
            addressLine1
            city
            region
          }
        }
      }
      sellerProductConfiguration {
        id
        scope
        facility {
          id
          code
        }
        criticalStockLevel(mode: {mode: USER_PREFERRED}) {
          value
          unit
        }
        internalNotes
        lowStockLevel(mode: {mode: USER_PREFERRED}) {
          value
          unit
        }
        readyToShipDays
        replenishmentRatePerWeek(mode: {mode: USER_PREFERRED}) {
          value
          unit
        }
        replenishmentRateStored: replenishmentRatePerWeek(mode: {mode: STORED}) {
          value
          unit
        }
        minimumOrderQuantity(mode: {mode: USER_PREFERRED}) {
          value
          unit
        }
        status
        unit
      }
      unitPrice {
        price {
          amount
          currency
        }
        unit
      }
      platformProductsLength {
        id
        isNominal
        lengthDisplayValue
        length {
          id
          actualLengthInches
          nominalLengthInches
        }
        platformProduct {
          id
          name
          code
          category
          actualWidthInches
          actualThicknessInches
          nominalWidthInches
          nominalThicknessInches
          actualLengthInches
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<
  SellerProductInventoriesQuery,
  SellerProductInventoriesQueryVariables
>;
export const GetProductLengthsByProductIdDocument = new TypedDocumentString(`
    query GetProductLengthsByProductId($inventoryId: ID!) {
  sellerProductInventory(id: $inventoryId) {
    id
    quantity {
      value
      unit
    }
    location {
      id
      facility {
        id
        organization {
          id
          defaultCurrency
        }
      }
    }
    platformProductsLength {
      id
      isNominal
      lengthDisplayValue
      length {
        id
        actualLengthInches
        nominalLengthInches
      }
      latestPriceMid {
        amount
        currency
      }
      platformProduct {
        id
        name
        category
        materialCode
        constructionCode
        code
        properties
        actualWidthInches
        actualThicknessInches
        nominalWidthInches
        nominalThicknessInches
        actualLengthInches
      }
    }
    sellerProductConfiguration {
      id
      scope
      facility {
        id
        code
      }
      internalNotes
      replenishmentRatePerWeek {
        value
        unit
      }
      readyToShipDays
      criticalStockLevel {
        value
        unit
      }
      criticalStockLevelInPieces: criticalStockLevel(
        mode: {mode: SPECIFIC, unit: PCS}
      ) {
        value
        unit
      }
      lowStockLevel {
        value
        unit
      }
      lowStockLevelInPieces: lowStockLevel(mode: {mode: SPECIFIC, unit: PCS}) {
        value
        unit
      }
      minimumOrderQuantity {
        value
        unit
      }
      status
      unit
    }
  }
}
    `) as unknown as TypedDocumentString<
  GetProductLengthsByProductIdQuery,
  GetProductLengthsByProductIdQueryVariables
>;
export const UpsertSellerInventoryDocument = new TypedDocumentString(`
    mutation UpsertSellerInventory($platformProductsLengthId: ID!, $locationId: ID!, $quantity: QuantityInput!) {
  upsertSellerInventory(
    platformProductsLengthId: $platformProductsLengthId
    locationId: $locationId
    quantity: $quantity
  ) {
    id
    quantity {
      value
      unit
    }
  }
}
    `) as unknown as TypedDocumentString<
  UpsertSellerInventoryMutation,
  UpsertSellerInventoryMutationVariables
>;
export const UpsertSellerProductConfigurationDocument =
  new TypedDocumentString(`
    mutation UpsertSellerProductConfiguration($platformProductLengthId: ID!, $scope: SellerProductConfigurationScope, $facilityId: ID, $sellerProductConfigurationInput: SellerProductConfigurationInput!) {
  upsertSellerProductConfiguration(
    platformProductLengthId: $platformProductLengthId
    scope: $scope
    facilityId: $facilityId
    sellerProductConfigurationInput: $sellerProductConfigurationInput
  ) {
    id
    scope
    facility {
      id
      code
    }
    criticalStockLevel {
      value
      unit
    }
    internalNotes
    lowStockLevel {
      value
      unit
    }
    minimumOrderQuantity {
      value
      unit
    }
    readyToShipDays
    replenishmentRatePerWeek {
      value
      unit
    }
    status
  }
}
    `) as unknown as TypedDocumentString<
    UpsertSellerProductConfigurationMutation,
    UpsertSellerProductConfigurationMutationVariables
  >;
export const UpsertSellerInventoryAndProductConfigurationDocument =
  new TypedDocumentString(`
    mutation UpsertSellerInventoryAndProductConfiguration($platformProductsLengthId: ID!, $locationId: ID!, $scope: SellerProductConfigurationScope, $facilityId: ID, $quantity: QuantityInput!, $sellerProductConfigurationInput: SellerProductConfigurationInput!) {
  upsertSellerInventory(
    platformProductsLengthId: $platformProductsLengthId
    locationId: $locationId
    quantity: $quantity
  ) {
    id
    quantity {
      value
      unit
    }
  }
  upsertSellerProductConfiguration(
    platformProductLengthId: $platformProductsLengthId
    scope: $scope
    facilityId: $facilityId
    sellerProductConfigurationInput: $sellerProductConfigurationInput
  ) {
    id
    scope
    facility {
      id
      code
    }
    criticalStockLevel {
      value
      unit
    }
    criticalStockLevelInPieces: criticalStockLevel(
      mode: {mode: SPECIFIC, unit: PCS}
    ) {
      value
      unit
    }
    internalNotes
    lowStockLevel {
      value
      unit
    }
    lowStockLevelInPieces: lowStockLevel(mode: {mode: SPECIFIC, unit: PCS}) {
      value
      unit
    }
    minimumOrderQuantity {
      value
      unit
    }
    readyToShipDays
    replenishmentRatePerWeek {
      value
      unit
    }
    status
  }
}
    `) as unknown as TypedDocumentString<
    UpsertSellerInventoryAndProductConfigurationMutation,
    UpsertSellerInventoryAndProductConfigurationMutationVariables
  >;
export const SetSellerProductPriceDocument = new TypedDocumentString(`
    mutation SetSellerProductPrice($input: SellerProductPriceInput!) {
  setSellerProductPrice(input: $input) {
    id
    platformProductLength {
      id
    }
    materialCost {
      amount
      currency
    }
    margin
    pricePerUnit {
      amount
      currency
    }
    currencyCode
    unit
  }
}
    `) as unknown as TypedDocumentString<
  SetSellerProductPriceMutation,
  SetSellerProductPriceMutationVariables
>;
export const SellerCatalogPricesDocument = new TypedDocumentString(`
    query sellerCatalogPrices($page: Int!, $size: Int!, $filters: SellerCatalogPriceFiltersInput) {
  sellerCatalogPrices(pageInput: {page: $page, size: $size}, filters: $filters) {
    paging {
      totalPages
      totalElements
      size
      number
    }
    content {
      id
      lengthDisplayValue
      platformProduct {
        id
        name
        code
        category
      }
      myPrice {
        id
        materialCost {
          amount
          currency
        }
        margin
        pricePerUnit {
          amount
          currency
        }
        currencyCode
        unit
      }
    }
  }
}
    `) as unknown as TypedDocumentString<
  SellerCatalogPricesQuery,
  SellerCatalogPricesQueryVariables
>;
export const UniqueLocationsWithInventoryDocument = new TypedDocumentString(`
    query UniqueLocationsWithInventory {
  uniqueLocationsWithInventory {
    id
    name
    code
    branchCode
    facility {
      address {
        addressLine1
        city
        region
      }
    }
  }
}
    `) as unknown as TypedDocumentString<
  UniqueLocationsWithInventoryQuery,
  UniqueLocationsWithInventoryQueryVariables
>;
export const MyProductFilterOptionsDocument = new TypedDocumentString(`
    query MyProductFilterOptions {
  platformProductDimensions {
    nominalThicknessInches
    nominalWidthInches
  }
}
    `) as unknown as TypedDocumentString<
  MyProductFilterOptionsQuery,
  MyProductFilterOptionsQueryVariables
>;
export const ReceiveOrderDocument = new TypedDocumentString(`
    mutation receiveOrder($orderId: ID!) {
  receiveOrder(id: $orderId) {
    id
  }
}
    `) as unknown as TypedDocumentString<
  ReceiveOrderMutation,
  ReceiveOrderMutationVariables
>;
export const ConfirmShipmentReceiptDocument = new TypedDocumentString(`
    mutation confirmShipmentReceipt($subOrderId: ID!) {
  confirmShipmentReceipt(subOrderId: $subOrderId) {
    id
  }
}
    `) as unknown as TypedDocumentString<
  ConfirmShipmentReceiptMutation,
  ConfirmShipmentReceiptMutationVariables
>;
export const GetBuyerOrderCountsDocument = new TypedDocumentString(`
    query getBuyerOrderCounts {
  buyerOrdersCount {
    confirmed
    delivered
    draft
    pendingSellerConfirmation
    pendingSellerConfirmationWithReminders
    shipped
    cancelled
    blocked
  }
}
    `) as unknown as TypedDocumentString<
  GetBuyerOrderCountsQuery,
  GetBuyerOrderCountsQueryVariables
>;
export const GetSellerOrderCountsDocument = new TypedDocumentString(`
    query getSellerOrderCounts {
  sellerOrdersCount {
    confirmed
    delivered
    draft
    pendingSellerConfirmation
    pendingSellerConfirmationWithReminders
    shipped
    cancelled
    blocked
  }
}
    `) as unknown as TypedDocumentString<
  GetSellerOrderCountsQuery,
  GetSellerOrderCountsQueryVariables
>;
export const ShipOrderDocument = new TypedDocumentString(`
    mutation ShipOrder($orderId: ID!, $shippedDate: Instant!, $deliveryStartDate: Instant!, $deliveryEndDate: Instant) {
  shipOrder(
    id: $orderId
    shippedDate: $shippedDate
    deliveryStartDate: $deliveryStartDate
    deliveryEndDate: $deliveryEndDate
  ) {
    id
  }
}
    `) as unknown as TypedDocumentString<
  ShipOrderMutation,
  ShipOrderMutationVariables
>;
export const GetOrderByIdDocument = new TypedDocumentString(`
    query GetOrderById($orderId: ID!) {
  order(id: $orderId) {
    id
    viewerPerspective
    createdAt
    updatedAt
    status
    isBrokered
    parentOrder {
      id
    }
    cancellationNote
    confirmedBy {
      id
      firstName
      lastName
      externalId
    }
    shippedBy {
      id
      firstName
      lastName
      externalId
    }
    blockMessages {
      id
      message
      createdAt
      processedAt
    }
    purchaseOrderNumber
    shippedDate
    deliveryStartDate
    deliveryEndDate
    receivedDate
    buyer {
      firstName
      lastName
    }
    buyerContact {
      id
      firstName
      lastName
      phoneNumber
      externalId
    }
    sellerContacts {
      id
      firstName
      lastName
      phoneNumber
      externalId
    }
    primaryContact {
      id
    }
    shippingLocation {
      id
      name
      facility {
        address {
          addressLine1
          addressLine2
          city
          region
          zipCode
          latitude
          longitude
        }
      }
      organization {
        name
      }
    }
    deliveryAddress {
      addressLine1
      addressLine2
      city
      region
      zipCode
      country
      latitude
      longitude
    }
    buyingOrganization {
      name
      msrSyncEnabled
    }
    canManuallySyncWithMsr
    canViewMsrPurchaseOrder
    msrPurchaseOrderEmails {
      id
      recipientTo
      requestedBy {
        id
        firstName
        lastName
      }
      createdAt
      status
    }
    canReturnToDraft
    msrSyncedAt
    msrPurchaseOrderInputs {
      orderedByCode
      buyerCode
      cashContract
      numDaysIntransit
      unitType
      isImport
      readyAtMill
      incoTerms
      incoTermsLoc
    }
    canChoosePrimaryContact
    awaitingPurchaseOrderNumber
    sellingOrganization {
      id
      name
      sellingOrganizationCode
    }
    sellingOrganizationFacility {
      address {
        addressLine1
        addressLine2
        city
        region
        country
      }
    }
    incoTerm
    isInternational
    tarp
    currency
    deliveryMethod
    incotermLoading
    incotermDischarge
    incotermAddressDestination
    portOfLoading {
      id
      code
      name
      city
      country
      type
    }
    portOfDischarge {
      id
      code
      name
      city
      country
      type
    }
    shippingRoute {
      id
      forwarder
      transitDays
    }
    shippingRouteSnapshot {
      id
      forwarder
      transitDays
      freightCost {
        amount
        currency
      }
      terminalHandlingCharge {
        amount
        currency
      }
      gassingCost {
        amount
        currency
      }
      additionalCostsPerContainer {
        amount
        currency
      }
      additionalCostsPerShipment {
        amount
        currency
      }
      createdAt
    }
    shippingFee {
      amount
      currency
    }
    transportVehicle {
      id
      name
      vehicleType
    }
    documents {
      id
      documentType
      uploadType
      originalFilename
      fileSizeBytes
      mimeType
      createdAt
    }
    items {
      effectivePiecesPerBundle
      piecesPerBundleOverride
      quantity(mode: {mode: USER_PREFERRED}) {
        value
        unit
      }
      piecesQuantity: quantity(mode: {mode: STORED}) {
        value
      }
      quantityStored: quantity(mode: {mode: STORED}) {
        value
      }
      price {
        amount
        currency
      }
      suggestedPrice {
        amount
        currency
      }
      effectivePrice {
        amount
        currency
      }
      pickupPrice {
        amount
        currency
      }
      deliveryPrice {
        amount
        currency
      }
      pricePerPiece {
        amount
        currency
      }
      suggestedPricePerPiece {
        amount
        currency
      }
      pickupPricePerPiece {
        amount
        currency
      }
      deliveryPricePerPiece {
        amount
        currency
      }
      platformProductsLengths {
        id
        isNominal
        lengthDisplayValue
        platformProduct {
          id
          name
          category
          actualWidthInches
          actualThicknessInches
          nominalWidthInches
          nominalThicknessInches
          actualLengthInches
          standardUnitsCode
          properties
          piecesPerBundle {
            value
            unit
          }
        }
        platformProductVehicleCapacities {
          transportVehicle {
            id
          }
          capacity {
            value
            unit
          }
        }
        length {
          id
          actualLengthInches
          nominalLengthInches
        }
      }
      tallyPlatformProduct {
        id
      }
      cannedTally {
        id
      }
      buyCode
    }
    subOrders {
      id
      status
      sellingOrganization {
        name
        sellingOrganizationCode
      }
      items {
        quantity(mode: {mode: USER_PREFERRED}) {
          value
          unit
        }
        platformProductsLengths {
          id
          lengthDisplayValue
          platformProduct {
            name
          }
        }
      }
    }
    shipments {
      id
      status
      items {
        quantity(mode: {mode: USER_PREFERRED}) {
          value
          unit
        }
        platformProductsLengths {
          id
          lengthDisplayValue
          platformProduct {
            name
          }
        }
      }
      packingListItems {
        id
        price {
          amount
          currency
        }
        quantity(mode: {mode: STANDARD}) {
          value
          unit
        }
        platformProductsLengths {
          id
          lengthDisplayValue
          platformProduct {
            name
          }
        }
      }
      shippedDate
      deliveryStartDate
      deliveryEndDate
      receivedDate
    }
  }
}
    `) as unknown as TypedDocumentString<
  GetOrderByIdQuery,
  GetOrderByIdQueryVariables
>;
export const GetOrderMsrSyncStatusDocument = new TypedDocumentString(`
    query GetOrderMsrSyncStatus($orderId: ID!) {
  order(id: $orderId) {
    id
    updatedAt
    purchaseOrderNumber
  }
}
    `) as unknown as TypedDocumentString<
  GetOrderMsrSyncStatusQuery,
  GetOrderMsrSyncStatusQueryVariables
>;
export const GetOrdersDocument = new TypedDocumentString(`
    query getOrders($status: OrderStatus, $perspective: TradePerspective!, $filters: OrderFiltersInput, $page: Int!, $size: Int!) {
  orders(
    status: $status
    perspective: $perspective
    filters: $filters
    pageInput: {page: $page, size: $size}
  ) {
    paging {
      totalElements
      totalPages
      number
      size
    }
    content {
      createdAt
      id
      purchaseOrderNumber
      deliveryStartDate
      deliveryEndDate
      shippedDate
      parentOrder {
        id
      }
      isBrokered
      buyer {
        firstName
        lastName
        externalId
      }
      buyingOrganization {
        name
        buyingOrganizationCode
      }
      sellingOrganization {
        name
        sellingOrganizationCode
      }
      currency
      shippingLocation {
        name
        code
      }
      deliveryAddress {
        addressLine1
        city
        region
      }
      items {
        quantity(mode: {mode: USER_PREFERRED}) {
          value
          unit
        }
        price {
          amount
          currency
        }
        suggestedPrice {
          amount
          currency
        }
        effectivePrice {
          amount
          currency
        }
        quantityStored: quantity(mode: {mode: STORED}) {
          value
        }
        pricePerPiece {
          amount
          currency
        }
        suggestedPricePerPiece {
          amount
          currency
        }
        platformProductsLengths {
          isNominal
          platformProduct {
            name
            code
            category
            standardUnitsCode
            actualWidthInches
            actualThicknessInches
            nominalWidthInches
            nominalThicknessInches
            actualLengthInches
            piecesPerBundle {
              value
            }
          }
          length {
            actualLengthInches
            nominalLengthInches
          }
        }
      }
      status
    }
  }
}
    `) as unknown as TypedDocumentString<
  GetOrdersQuery,
  GetOrdersQueryVariables
>;
export const ConfirmOrderDocument = new TypedDocumentString(`
    mutation confirmOrder($orderId: ID!, $shippedDate: Instant, $deliveryStartDate: Instant, $deliveryEndDate: Instant) {
  confirmOrder(
    id: $orderId
    shippedDate: $shippedDate
    deliveryStartDate: $deliveryStartDate
    deliveryEndDate: $deliveryEndDate
  ) {
    id
  }
}
    `) as unknown as TypedDocumentString<
  ConfirmOrderMutation,
  ConfirmOrderMutationVariables
>;
export const CalculateShipDatesDocument = new TypedDocumentString(`
    query CalculateShipDates($orderId: ID!) {
  calculateShipDates(orderId: $orderId) {
    shippedDate
    deliveryStartDate
    deliveryEndDate
  }
}
    `) as unknown as TypedDocumentString<
  CalculateShipDatesQuery,
  CalculateShipDatesQueryVariables
>;
export const PlaceOrderDocument = new TypedDocumentString(`
    mutation placeOrder($orderId: ID!, $locationId: ID!, $incoTerm: LogisticsIncoterm!, $transportVehicleId: ID!, $tarp: Boolean, $recipientUserIds: [ID!], $primaryContactUserId: ID, $promiseDate: Date, $shipWeekDate: Date, $dueByDate: Date, $msrPurchaseOrderInput: MsrPurchaseOrderInput) {
  placeOrder(
    orderId: $orderId
    locationId: $locationId
    incoTerm: $incoTerm
    transportVehicleId: $transportVehicleId
    tarp: $tarp
    recipientUserIds: $recipientUserIds
    primaryContactUserId: $primaryContactUserId
    promiseDate: $promiseDate
    shipWeekDate: $shipWeekDate
    dueByDate: $dueByDate
    msrPurchaseOrderInput: $msrPurchaseOrderInput
  ) {
    id
  }
}
    `) as unknown as TypedDocumentString<
  PlaceOrderMutation,
  PlaceOrderMutationVariables
>;
export const CancelOrderDocument = new TypedDocumentString(`
    mutation CancelOrder($id: ID!, $note: String!) {
  cancelOrder(id: $id, note: $note) {
    id
    status
  }
}
    `) as unknown as TypedDocumentString<
  CancelOrderMutation,
  CancelOrderMutationVariables
>;
export const CopyOrderToCartDocument = new TypedDocumentString(`
    mutation copyOrderToCart($orderId: ID!) {
  copyOrderToCart(orderId: $orderId) {
    cart {
      id
    }
    skippedItems {
      productName
      reason
    }
  }
}
    `) as unknown as TypedDocumentString<
  CopyOrderToCartMutation,
  CopyOrderToCartMutationVariables
>;
export const AddRequestForQuoteToCartDocument = new TypedDocumentString(`
    mutation addRequestForQuoteToCart($requestForQuoteId: ID!, $facilityId: ID!, $recipientUserIds: [ID!]) {
  addRequestForQuoteToCart(
    requestForQuoteId: $requestForQuoteId
    facilityId: $facilityId
    recipientUserIds: $recipientUserIds
  ) {
    id
  }
}
    `) as unknown as TypedDocumentString<
  AddRequestForQuoteToCartMutation,
  AddRequestForQuoteToCartMutationVariables
>;
export const RevertBlockedOrderToDraftDocument = new TypedDocumentString(`
    mutation RevertBlockedOrderToDraft($id: ID!) {
  revertBlockedOrderToDraft(id: $id) {
    id
    status
  }
}
    `) as unknown as TypedDocumentString<
  RevertBlockedOrderToDraftMutation,
  RevertBlockedOrderToDraftMutationVariables
>;
export const ResubmitBlockedOrderDocument = new TypedDocumentString(`
    mutation ResubmitBlockedOrder($id: ID!) {
  resubmitBlockedOrder(id: $id) {
    id
    status
  }
}
    `) as unknown as TypedDocumentString<
  ResubmitBlockedOrderMutation,
  ResubmitBlockedOrderMutationVariables
>;
export const SyncOrderWithExternalVendorDocument = new TypedDocumentString(`
    mutation SyncOrderWithExternalVendor($id: ID!) {
  syncOrderWithExternalVendor(id: $id) {
    id
  }
}
    `) as unknown as TypedDocumentString<
  SyncOrderWithExternalVendorMutation,
  SyncOrderWithExternalVendorMutationVariables
>;
export const ResendOrderPlacedEmailDocument = new TypedDocumentString(`
    mutation ResendOrderPlacedEmail($orderId: ID!) {
  resendOrderPlacedEmail(orderId: $orderId)
}
    `) as unknown as TypedDocumentString<
  ResendOrderPlacedEmailMutation,
  ResendOrderPlacedEmailMutationVariables
>;
export const EmailMsrPurchaseOrderDocument = new TypedDocumentString(`
    mutation EmailMsrPurchaseOrder($orderId: ID!, $contactIds: [ID!]!, $printOptions: MsrPurchaseOrderPrintOptionsInput) {
  emailMsrPurchaseOrder(
    orderId: $orderId
    contactIds: $contactIds
    printOptions: $printOptions
  )
}
    `) as unknown as TypedDocumentString<
  EmailMsrPurchaseOrderMutation,
  EmailMsrPurchaseOrderMutationVariables
>;
export const DeclinePriceNegotiationDocument = new TypedDocumentString(`
    mutation DeclinePriceNegotiation($orderId: ID!, $reason: String) {
  declinePriceNegotiation(orderId: $orderId, reason: $reason) {
    id
  }
}
    `) as unknown as TypedDocumentString<
  DeclinePriceNegotiationMutation,
  DeclinePriceNegotiationMutationVariables
>;
export const ShippingSoonDocument = new TypedDocumentString(`
    query ShippingSoon {
  shippingSoon {
    id
    purchaseOrderNumber
    status
    deliveryStartDate
    sellingOrganization {
      name
      sellingOrganizationCode
    }
    currency
    items {
      quantity(mode: {mode: USER_PREFERRED}) {
        value
        unit
      }
      price {
        amount
        currency
      }
      suggestedPrice {
        amount
        currency
      }
      effectivePrice {
        amount
        currency
      }
      quantityStored: quantity(mode: {mode: STORED}) {
        value
      }
      pricePerPiece {
        amount
        currency
      }
      suggestedPricePerPiece {
        amount
        currency
      }
      platformProductsLengths {
        isNominal
        platformProduct {
          name
          actualWidthInches
          actualThicknessInches
          nominalWidthInches
          nominalThicknessInches
          actualLengthInches
          piecesPerBundle {
            value
          }
        }
        length {
          actualLengthInches
          nominalLengthInches
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<
  ShippingSoonQuery,
  ShippingSoonQueryVariables
>;
export const DeleteOrderDocumentDocument = new TypedDocumentString(`
    mutation DeleteOrderDocument($id: ID!) {
  deleteOrderDocument(id: $id)
}
    `) as unknown as TypedDocumentString<
  DeleteOrderDocumentMutation,
  DeleteOrderDocumentMutationVariables
>;
export const OrderDocumentPresignedUrlDocument = new TypedDocumentString(`
    query OrderDocumentPresignedUrl($id: ID!) {
  orderDocumentPresignedUrl(id: $id)
}
    `) as unknown as TypedDocumentString<
  OrderDocumentPresignedUrlQuery,
  OrderDocumentPresignedUrlQueryVariables
>;
export const OrganizationsByIdsDocument = new TypedDocumentString(`
    query OrganizationsByIds($ids: [ID!]!) {
  organizationsByIds(ids: $ids) {
    id
    sellerContacts {
      id
      firstName
      lastName
      phoneNumber
      externalId
    }
    notificationPreference {
      id
    }
  }
}
    `) as unknown as TypedDocumentString<
  OrganizationsByIdsQuery,
  OrganizationsByIdsQueryVariables
>;
export const GetOrganizationsDocument = new TypedDocumentString(`
    query GetOrganizations($page: Int!, $size: Int!, $name: StringOperatorInput) {
  organizations(pageInput: {page: $page, size: $size}, filter: {name: $name}) {
    content {
      id
      name
      sellingOrganizationCode
    }
    paging {
      totalElements
      totalPages
      number
      size
    }
  }
}
    `) as unknown as TypedDocumentString<
  GetOrganizationsQuery,
  GetOrganizationsQueryVariables
>;
export const GetTradingPartnerOrganizationsForBuyerDocument =
  new TypedDocumentString(`
    query GetTradingPartnerOrganizationsForBuyer($page: Int!, $size: Int!, $name: StringOperatorInput, $excludeOrganizationIds: [ID!], $onlyOrganizationIds: [ID!]) {
  tradingPartnerOrganizationsForBuyer(
    pageInput: {page: $page, size: $size}
    filter: {name: $name}
    excludeOrganizationIds: $excludeOrganizationIds
    onlyOrganizationIds: $onlyOrganizationIds
  ) {
    content {
      id
      name
      sellingOrganizationCode
      defaultCurrency
      sellerContacts {
        id
        firstName
        lastName
      }
      facilities {
        id
        code
        address {
          addressLine1
          addressLine2
          city
          region
        }
        locations {
          id
          code
        }
      }
    }
    paging {
      totalElements
      totalPages
      number
      size
    }
  }
}
    `) as unknown as TypedDocumentString<
    GetTradingPartnerOrganizationsForBuyerQuery,
    GetTradingPartnerOrganizationsForBuyerQueryVariables
  >;
export const AddTradingPartnersToProductComparisonDocument =
  new TypedDocumentString(`
    mutation AddTradingPartnersToProductComparison($input: AddTradingPartnersToProductInput!) {
  addTradingPartnersToProductComparison(input: $input) {
    configurations {
      id
    }
    addedOrganizationIds
  }
}
    `) as unknown as TypedDocumentString<
    AddTradingPartnersToProductComparisonMutation,
    AddTradingPartnersToProductComparisonMutationVariables
  >;
export const RemoveTradingPartnersFromProductComparisonDocument =
  new TypedDocumentString(`
    mutation RemoveTradingPartnersFromProductComparison($input: RemoveTradingPartnersFromProductComparisonInput!) {
  removeTradingPartnersFromProductComparison(input: $input)
}
    `) as unknown as TypedDocumentString<
    RemoveTradingPartnersFromProductComparisonMutation,
    RemoveTradingPartnersFromProductComparisonMutationVariables
  >;
export const CreateOrganizationDocument = new TypedDocumentString(`
    mutation CreateOrganization($input: CreateOrganizationInput!) {
  createOrganization(input: $input) {
    id
    name
  }
}
    `) as unknown as TypedDocumentString<
  CreateOrganizationMutation,
  CreateOrganizationMutationVariables
>;
export const GetMySellersDocument = new TypedDocumentString(`
    query GetMySellers {
  mySellers {
    organizationId
    organizationName
    buyingOrganizationCode
    sellingOrganizationCode
  }
}
    `) as unknown as TypedDocumentString<
  GetMySellersQuery,
  GetMySellersQueryVariables
>;
export const GetMyBuyersDocument = new TypedDocumentString(`
    query GetMyBuyers {
  myBuyers {
    organizationId
    organizationName
    buyingOrganizationCode
    sellingOrganizationCode
  }
}
    `) as unknown as TypedDocumentString<
  GetMyBuyersQuery,
  GetMyBuyersQueryVariables
>;
export const UpdateMySellerCodeDocument = new TypedDocumentString(`
    mutation UpdateMySellerCode($sellerOrganizationId: ID!, $code: String) {
  updateMySellerCode(sellerOrganizationId: $sellerOrganizationId, code: $code) {
    organizationId
    organizationName
    buyingOrganizationCode
    sellingOrganizationCode
  }
}
    `) as unknown as TypedDocumentString<
  UpdateMySellerCodeMutation,
  UpdateMySellerCodeMutationVariables
>;
export const UpdateMyBuyerCodeDocument = new TypedDocumentString(`
    mutation UpdateMyBuyerCode($buyerOrganizationId: ID!, $code: String) {
  updateMyBuyerCode(buyerOrganizationId: $buyerOrganizationId, code: $code) {
    organizationId
    organizationName
    buyingOrganizationCode
    sellingOrganizationCode
  }
}
    `) as unknown as TypedDocumentString<
  UpdateMyBuyerCodeMutation,
  UpdateMyBuyerCodeMutationVariables
>;
export const GetBuyerMarginsDocument = new TypedDocumentString(`
    query GetBuyerMargins($platformProductLengthId: ID!) {
  buyerMargins(platformProductLengthId: $platformProductLengthId) {
    id
    marginRate
    pricePerUnit {
      amount
      currency
    }
    buyingOrganization {
      id
      name
    }
  }
}
    `) as unknown as TypedDocumentString<
  GetBuyerMarginsQuery,
  GetBuyerMarginsQueryVariables
>;
export const GetBuyerNegotiatedPricesDocument = new TypedDocumentString(`
    query GetBuyerNegotiatedPrices($platformProductLengthId: ID!) {
  buyerNegotiatedPrices(platformProductLengthId: $platformProductLengthId) {
    buyingOrganization {
      id
      name
    }
    price {
      amount
      currency
    }
  }
}
    `) as unknown as TypedDocumentString<
  GetBuyerNegotiatedPricesQuery,
  GetBuyerNegotiatedPricesQueryVariables
>;
export const SetBuyerMarginDocument = new TypedDocumentString(`
    mutation SetBuyerMargin($platformProductLengthId: ID!, $buyingOrganizationId: ID!, $marginRate: Float!) {
  setBuyerMargin(
    platformProductLengthId: $platformProductLengthId
    buyingOrganizationId: $buyingOrganizationId
    marginRate: $marginRate
  ) {
    id
    marginRate
    pricePerUnit {
      amount
      currency
    }
    buyingOrganization {
      id
      name
    }
  }
}
    `) as unknown as TypedDocumentString<
  SetBuyerMarginMutation,
  SetBuyerMarginMutationVariables
>;
export const RemoveBuyerMarginDocument = new TypedDocumentString(`
    mutation RemoveBuyerMargin($platformProductLengthId: ID!, $buyingOrganizationId: ID!) {
  removeBuyerMargin(
    platformProductLengthId: $platformProductLengthId
    buyingOrganizationId: $buyingOrganizationId
  )
}
    `) as unknown as TypedDocumentString<
  RemoveBuyerMarginMutation,
  RemoveBuyerMarginMutationVariables
>;
export const GetOrganizationDocument = new TypedDocumentString(`
    query GetOrganization($id: ID!) {
  organization(id: $id) {
    id
    name
    phoneNumber
    faxNumber
    tenantAdmins {
      id
      firstName
      lastName
      externalId
      phoneNumber
      status
      lastEditedAt
      lastEditedBy {
        id
        firstName
        lastName
      }
    }
  }
}
    `) as unknown as TypedDocumentString<
  GetOrganizationQuery,
  GetOrganizationQueryVariables
>;
export const GetLinkedOrganizationDocument = new TypedDocumentString(`
    query GetLinkedOrganization($id: ID!) {
  organization(id: $id) {
    id
    name
    sellingOrganizationCode
    users {
      id
      firstName
      lastName
      externalId
      employeeId
      phoneNumber
      role
      status
      lastEditedAt
      lastEditedBy {
        id
        firstName
        lastName
      }
    }
  }
}
    `) as unknown as TypedDocumentString<
  GetLinkedOrganizationQuery,
  GetLinkedOrganizationQueryVariables
>;
export const GetLinkedOrganizationUsersDocument = new TypedDocumentString(`
    query GetLinkedOrganizationUsers {
  linkedOrganizationUsers {
    id
    firstName
    lastName
    externalId
    phoneNumber
    role
    status
    lastEditedAt
    lastEditedBy {
      id
      firstName
      lastName
    }
    organization {
      id
      name
    }
  }
}
    `) as unknown as TypedDocumentString<
  GetLinkedOrganizationUsersQuery,
  GetLinkedOrganizationUsersQueryVariables
>;
export const CreateContactDocument = new TypedDocumentString(`
    mutation CreateContact($input: ContactInput!) {
  createContact(input: $input) {
    id
    firstName
    lastName
    phoneNumber
    externalId
  }
}
    `) as unknown as TypedDocumentString<
  CreateContactMutation,
  CreateContactMutationVariables
>;
export const UpdateContactDocument = new TypedDocumentString(`
    mutation UpdateContact($id: ID!, $input: UpdateContactInput!) {
  updateContact(id: $id, input: $input) {
    id
    firstName
    lastName
  }
}
    `) as unknown as TypedDocumentString<
  UpdateContactMutation,
  UpdateContactMutationVariables
>;
export const CreateTenantAdminDocument = new TypedDocumentString(`
    mutation CreateTenantAdmin($input: CreateTenantAdminInput!) {
  createTenantAdmin(input: $input) {
    id
    firstName
    lastName
    externalId
    status
  }
}
    `) as unknown as TypedDocumentString<
  CreateTenantAdminMutation,
  CreateTenantAdminMutationVariables
>;
export const UpdateOrderNotificationEmailsDocument = new TypedDocumentString(`
    mutation UpdateOrderNotificationEmails($input: OrderNotificationEmailsInput!) {
  updateOrderNotificationEmails(input: $input) {
    id
    orderNotificationEmails {
      domestic
      international
    }
  }
}
    `) as unknown as TypedDocumentString<
  UpdateOrderNotificationEmailsMutation,
  UpdateOrderNotificationEmailsMutationVariables
>;
export const UpdateOrganizationContactDocument = new TypedDocumentString(`
    mutation UpdateOrganizationContact($organizationId: ID!, $input: OrganizationContactInput!) {
  updateOrganizationContact(organizationId: $organizationId, input: $input) {
    id
    phoneNumber
    faxNumber
  }
}
    `) as unknown as TypedDocumentString<
  UpdateOrganizationContactMutation,
  UpdateOrganizationContactMutationVariables
>;
export const DeactivateTenantAdminForOrgDocument = new TypedDocumentString(`
    mutation DeactivateTenantAdminForOrg($userId: ID!) {
  deactivateTenantUser(userId: $userId) {
    id
    status
  }
}
    `) as unknown as TypedDocumentString<
  DeactivateTenantAdminForOrgMutation,
  DeactivateTenantAdminForOrgMutationVariables
>;
export const ReactivateTenantAdminForOrgDocument = new TypedDocumentString(`
    mutation ReactivateTenantAdminForOrg($userId: ID!) {
  reactivateTenantUser(userId: $userId) {
    id
    status
  }
}
    `) as unknown as TypedDocumentString<
  ReactivateTenantAdminForOrgMutation,
  ReactivateTenantAdminForOrgMutationVariables
>;
export const GetPackingListDocument = new TypedDocumentString(`
    query GetPackingList($orderId: ID!) {
  packingList(orderId: $orderId) {
    id
    notes
    createdAt
    updatedAt
    items {
      id
      piecesPerBundleOverride
      price {
        amount
        currency
      }
      platformProductsLengths {
        id
        isNominal
        lengthDisplayValue
        length {
          nominalLengthInches
          actualLengthInches
        }
        platformProduct {
          name
          standardUnitsCode
          nominalWidthInches
          actualWidthInches
          nominalThicknessInches
          actualThicknessInches
          actualLengthInches
          piecesPerBundle {
            value
            unit
          }
        }
      }
      quantity(mode: {mode: STANDARD}) {
        value
        unit
      }
      piecesQuantity: quantity(mode: {mode: STORED}) {
        value
      }
    }
  }
}
    `) as unknown as TypedDocumentString<
  GetPackingListQuery,
  GetPackingListQueryVariables
>;
export const GetSellerProductsDocument = new TypedDocumentString(`
    query GetSellerProducts($pageInput: PageInput!) {
  sellerProductInventories(pageInput: $pageInput) {
    content {
      id
      sellerProductConfiguration {
        price {
          pricePerUnit {
            amount
            currency
          }
        }
        platformProductLength {
          id
          isNominal
          lengthDisplayValue
          length {
            nominalLengthInches
            actualLengthInches
          }
          platformProduct {
            name
            standardUnitsCode
            nominalWidthInches
            actualWidthInches
            nominalThicknessInches
            actualThicknessInches
            actualLengthInches
            piecesPerBundle {
              value
              unit
            }
          }
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<
  GetSellerProductsQuery,
  GetSellerProductsQueryVariables
>;
export const PackItemDocument = new TypedDocumentString(`
    mutation PackItem($orderId: ID!, $platformProductLengthId: ID!, $quantity: QuantityInput!) {
  packItem(
    orderId: $orderId
    platformProductLengthId: $platformProductLengthId
    quantity: $quantity
  ) {
    id
    price {
      amount
      currency
    }
    platformProductsLengths {
      id
    }
    quantity(mode: {mode: STANDARD}) {
      value
      unit
    }
  }
}
    `) as unknown as TypedDocumentString<
  PackItemMutation,
  PackItemMutationVariables
>;
export const RemovePackedItemDocument = new TypedDocumentString(`
    mutation RemovePackedItem($orderId: ID!, $platformProductLengthId: ID!) {
  removePackedItem(
    orderId: $orderId
    platformProductLengthId: $platformProductLengthId
  )
}
    `) as unknown as TypedDocumentString<
  RemovePackedItemMutation,
  RemovePackedItemMutationVariables
>;
export const PublishPackingListDocument = new TypedDocumentString(`
    mutation PublishPackingList($orderId: ID!) {
  publishPackingList(orderId: $orderId)
}
    `) as unknown as TypedDocumentString<
  PublishPackingListMutation,
  PublishPackingListMutationVariables
>;
export const SavePackingListDocument = new TypedDocumentString(`
    mutation SavePackingList($orderId: ID!, $items: [PackItemInput!]!, $notes: String) {
  savePackingList(orderId: $orderId, items: $items, notes: $notes) {
    id
    piecesPerBundleOverride
    price {
      amount
      currency
    }
    platformProductsLengths {
      id
      isNominal
      lengthDisplayValue
      length {
        nominalLengthInches
        actualLengthInches
      }
      platformProduct {
        name
        standardUnitsCode
        nominalWidthInches
        actualWidthInches
        nominalThicknessInches
        actualThicknessInches
        actualLengthInches
        piecesPerBundle {
          value
          unit
        }
      }
    }
    quantity(mode: {mode: STANDARD}) {
      value
      unit
    }
    piecesQuantity: quantity(mode: {mode: STORED}) {
      value
    }
  }
}
    `) as unknown as TypedDocumentString<
  SavePackingListMutation,
  SavePackingListMutationVariables
>;
export const AdminSearchPlatformProductsDocument = new TypedDocumentString(`
    query AdminSearchPlatformProducts($search: String!, $page: Int!, $size: Int!) {
  adminSearchPlatformProducts(
    search: $search
    pageInput: {page: $page, size: $size}
  ) {
    content {
      id
      code
      name
      piecesPerBundle
      standardUnitsCode
      vehicleCapacities {
        capacity {
          value
          unit
        }
        transportVehicle {
          id
          name
        }
      }
      lengths {
        id
        lengthDisplayValue
        isNominal
        inventoryOnly
      }
    }
    paging {
      number
      size
      totalElements
      totalPages
    }
  }
}
    `) as unknown as TypedDocumentString<
  AdminSearchPlatformProductsQuery,
  AdminSearchPlatformProductsQueryVariables
>;
export const SetPlatformProductLengthInventoryOnlyDocument =
  new TypedDocumentString(`
    mutation SetPlatformProductLengthInventoryOnly($platformProductLengthId: ID!, $inventoryOnly: Boolean!) {
  setPlatformProductLengthInventoryOnly(
    platformProductLengthId: $platformProductLengthId
    inventoryOnly: $inventoryOnly
  ) {
    id
    inventoryOnly
  }
}
    `) as unknown as TypedDocumentString<
    SetPlatformProductLengthInventoryOnlyMutation,
    SetPlatformProductLengthInventoryOnlyMutationVariables
  >;
export const SetPlatformProductPiecesPerBundleDocument =
  new TypedDocumentString(`
    mutation SetPlatformProductPiecesPerBundle($platformProductId: ID!, $piecesPerBundle: Int!) {
  setPlatformProductPiecesPerBundle(
    platformProductId: $platformProductId
    piecesPerBundle: $piecesPerBundle
  ) {
    id
    piecesPerBundle
  }
}
    `) as unknown as TypedDocumentString<
    SetPlatformProductPiecesPerBundleMutation,
    SetPlatformProductPiecesPerBundleMutationVariables
  >;
export const SetPlatformProductVehicleCapacityDocument =
  new TypedDocumentString(`
    mutation SetPlatformProductVehicleCapacity($platformProductId: ID!, $transportVehicleId: ID!, $capacity: QuantityInput!) {
  setPlatformProductVehicleCapacity(
    platformProductId: $platformProductId
    transportVehicleId: $transportVehicleId
    capacity: $capacity
  ) {
    capacity {
      value
      unit
    }
    transportVehicle {
      id
      name
    }
  }
}
    `) as unknown as TypedDocumentString<
    SetPlatformProductVehicleCapacityMutation,
    SetPlatformProductVehicleCapacityMutationVariables
  >;
export const ImportPlatformProductsDocument = new TypedDocumentString(`
    mutation ImportPlatformProducts($input: PlatformProductImportInput!, $dryRun: Boolean!) {
  importPlatformProducts(input: $input, dryRun: $dryRun) {
    fileErrors
    rowErrors {
      rowNumber
      code
      messages
    }
    products {
      code
      action
      createdFields {
        field
        value
      }
      addedLengths
      addedCapacities
      conflicts {
        field
        currentValue
        importedValue
      }
    }
  }
}
    `) as unknown as TypedDocumentString<
  ImportPlatformProductsMutation,
  ImportPlatformProductsMutationVariables
>;
export const PlatformProductsDocument = new TypedDocumentString(`
    query platformProducts($filter: ProductFilterInput) {
  platformProducts(filter: $filter) {
    id
    code
    name
    category
    standardUnitsCode
    piecesPerBundle {
      value
      unit
    }
  }
}
    `) as unknown as TypedDocumentString<
  PlatformProductsQuery,
  PlatformProductsQueryVariables
>;
export const BuyListProductsDocument = new TypedDocumentString(`
    query buyListProducts {
  buyListProducts {
    id
    code
    name
  }
}
    `) as unknown as TypedDocumentString<
  BuyListProductsQuery,
  BuyListProductsQueryVariables
>;
export const MyBuyListProductsDocument = new TypedDocumentString(`
    query myBuyListProducts {
  myBuyListProducts {
    id
    code
    name
  }
}
    `) as unknown as TypedDocumentString<
  MyBuyListProductsQuery,
  MyBuyListProductsQueryVariables
>;
export const PlatformProductByIdDocument = new TypedDocumentString(`
    query platformProductById($platformProductId: ID!) {
  platformProduct(id: $platformProductId) {
    actualLengthInches
    actualThicknessInches
    actualWidthInches
    category
    code
    constructionCode
    finishCode
    harmonizedCode
    id
    lengths {
      actualLengthInches
      nominalLengthInches
      displayValue
      id
    }
    materialCode
    name
    nominalThicknessInches
    nominalWidthInches
    properties
    piecesPerBundle {
      value
      unit
    }
    platformProductVehicleCapacities {
      id
      transportVehicle {
        id
        name
        vehicleType
      }
      capacity {
        value
        unit
      }
    }
    standardUnitsCode
  }
}
    `) as unknown as TypedDocumentString<
  PlatformProductByIdQuery,
  PlatformProductByIdQueryVariables
>;
export const EnsurePlatformProductLengthDocument = new TypedDocumentString(`
    mutation ensurePlatformProductLength($platformProductId: ID!, $lengthId: ID!) {
  ensurePlatformProductLength(
    platformProductId: $platformProductId
    lengthId: $lengthId
  ) {
    id
    isNominal
    length {
      id
      nominalLengthInches
      actualLengthInches
    }
    platformProduct {
      nominalWidthInches
      actualWidthInches
      nominalThicknessInches
      actualThicknessInches
      actualLengthInches
      piecesPerBundle {
        value
        unit
      }
    }
  }
}
    `) as unknown as TypedDocumentString<
  EnsurePlatformProductLengthMutation,
  EnsurePlatformProductLengthMutationVariables
>;
export const PendingPriceNegotiationsDocument = new TypedDocumentString(`
    query PendingPriceNegotiations($platformProductId: ID!) {
  pendingPriceNegotiations(platformProductId: $platformProductId) {
    id
    platformProductLength {
      id
    }
    platformProductCannedTally {
      id
    }
    sellingOrganization {
      id
    }
  }
}
    `) as unknown as TypedDocumentString<
  PendingPriceNegotiationsQuery,
  PendingPriceNegotiationsQueryVariables
>;
export const AcceptedPriceNegotiationsDocument = new TypedDocumentString(`
    query AcceptedPriceNegotiations($platformProductId: ID!) {
  acceptedPriceNegotiations(platformProductId: $platformProductId) {
    id
    platformProductCannedTally {
      id
    }
    sellingOrganization {
      id
    }
    unit
    offeredPrice {
      amount
      currency
    }
  }
}
    `) as unknown as TypedDocumentString<
  AcceptedPriceNegotiationsQuery,
  AcceptedPriceNegotiationsQueryVariables
>;
export const SellerPriceNegotiationsDocument = new TypedDocumentString(`
    query SellerPriceNegotiations($page: Int!, $size: Int!, $assignedToMe: Boolean, $status: [PriceNegotiationStatus!]) {
  sellerPriceNegotiations(
    pageInput: {page: $page, size: $size}
    assignedToMe: $assignedToMe
    status: $status
  ) {
    paging {
      totalElements
      totalPages
      number
      size
    }
    content {
      id
      status
      unit
      targetPrice {
        amount
        currency
      }
      offeredPrice {
        amount
        currency
      }
      buyerNote
      sellerNote
      createdAt
      updatedAt
      buyingOrganization {
        id
        name
      }
      sellingOrganization {
        id
        name
        sellingOrganizationCode
      }
      createdBy {
        id
        firstName
        lastName
      }
      platformProductLength {
        id
        lengthDisplayValue
        isNominal
        platformProduct {
          id
          name
          code
        }
      }
      platformProductCannedTally {
        id
        name
        platformProduct {
          id
          code
        }
      }
      recipients {
        id
        firstName
        lastName
      }
    }
  }
}
    `) as unknown as TypedDocumentString<
  SellerPriceNegotiationsQuery,
  SellerPriceNegotiationsQueryVariables
>;
export const SellerPriceNegotiationDetailDocument = new TypedDocumentString(`
    query SellerPriceNegotiationDetail($id: ID!) {
  sellerPriceNegotiation(id: $id) {
    id
    tallyRecipe {
      lengthLabel
      bundleCount
      piecesPerBundle
    }
    currentSellerListPrice {
      amount
      currency
    }
    offerCurrency
  }
}
    `) as unknown as TypedDocumentString<
  SellerPriceNegotiationDetailQuery,
  SellerPriceNegotiationDetailQueryVariables
>;
export const SellerPriceNegotiationCountsDocument = new TypedDocumentString(`
    query SellerPriceNegotiationCounts($assignedToMe: Boolean) {
  sellerPriceNegotiationCounts(assignedToMe: $assignedToMe) {
    waiting
    responded
  }
}
    `) as unknown as TypedDocumentString<
  SellerPriceNegotiationCountsQuery,
  SellerPriceNegotiationCountsQueryVariables
>;
export const BuyerPriceNegotiationsDocument = new TypedDocumentString(`
    query BuyerPriceNegotiations($page: Int!, $size: Int!, $status: [PriceNegotiationStatus!]) {
  buyerPriceNegotiations(pageInput: {page: $page, size: $size}, status: $status) {
    paging {
      totalElements
      totalPages
      number
      size
    }
    content {
      id
      status
      unit
      targetPrice {
        amount
        currency
      }
      offeredPrice {
        amount
        currency
      }
      buyerNote
      sellerNote
      createdAt
      updatedAt
      buyingOrganization {
        id
        name
      }
      sellingOrganization {
        id
        name
        sellingOrganizationCode
      }
      createdBy {
        id
        firstName
        lastName
      }
      recipients {
        id
        firstName
        lastName
      }
      platformProductLength {
        id
        lengthDisplayValue
        isNominal
        platformProduct {
          id
          name
          code
        }
      }
      platformProductCannedTally {
        id
        name
        platformProduct {
          id
          code
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<
  BuyerPriceNegotiationsQuery,
  BuyerPriceNegotiationsQueryVariables
>;
export const BuyerPriceNegotiationCountsDocument = new TypedDocumentString(`
    query BuyerPriceNegotiationCounts {
  buyerPriceNegotiationCounts {
    waiting
    responded
  }
}
    `) as unknown as TypedDocumentString<
  BuyerPriceNegotiationCountsQuery,
  BuyerPriceNegotiationCountsQueryVariables
>;
export const RequestPriceNegotiationDocument = new TypedDocumentString(`
    mutation RequestPriceNegotiation($platformProductLengthIds: [ID!]!, $sellingOrganizationIds: [ID!]!, $targetPrice: MoneyInput, $buyerNote: String, $recipientUserIds: [ID!]) {
  requestPriceNegotiation(
    platformProductLengthIds: $platformProductLengthIds
    sellingOrganizationIds: $sellingOrganizationIds
    targetPrice: $targetPrice
    buyerNote: $buyerNote
    recipientUserIds: $recipientUserIds
  )
}
    `) as unknown as TypedDocumentString<
  RequestPriceNegotiationMutation,
  RequestPriceNegotiationMutationVariables
>;
export const RespondToPriceNegotiationInAppDocument = new TypedDocumentString(`
    mutation RespondToPriceNegotiationInApp($id: ID!, $input: RespondToPriceNegotiationInput!) {
  respondToPriceNegotiationInApp(id: $id, input: $input) {
    id
    status
  }
}
    `) as unknown as TypedDocumentString<
  RespondToPriceNegotiationInAppMutation,
  RespondToPriceNegotiationInAppMutationVariables
>;
export const DeclinePriceNegotiationRequestDocument = new TypedDocumentString(`
    mutation DeclinePriceNegotiationRequest($id: ID!, $reason: String) {
  declinePriceNegotiationRequest(id: $id, reason: $reason) {
    id
    status
  }
}
    `) as unknown as TypedDocumentString<
  DeclinePriceNegotiationRequestMutation,
  DeclinePriceNegotiationRequestMutationVariables
>;
export const RequestTallyPriceNegotiationDocument = new TypedDocumentString(`
    mutation RequestTallyPriceNegotiation($platformProductCannedTallyIds: [ID!]!, $sellingOrganizationIds: [ID!]!, $unit: UnitCode!, $targetPrice: MoneyInput, $buyerNote: String, $recipientUserIds: [ID!]) {
  requestTallyPriceNegotiation(
    platformProductCannedTallyIds: $platformProductCannedTallyIds
    sellingOrganizationIds: $sellingOrganizationIds
    unit: $unit
    targetPrice: $targetPrice
    buyerNote: $buyerNote
    recipientUserIds: $recipientUserIds
  )
}
    `) as unknown as TypedDocumentString<
  RequestTallyPriceNegotiationMutation,
  RequestTallyPriceNegotiationMutationVariables
>;
export const ChooseOrderPrimaryContactDocument = new TypedDocumentString(`
    mutation ChooseOrderPrimaryContact($orderId: ID!, $userId: ID!) {
  chooseOrderPrimaryContact(orderId: $orderId, userId: $userId) {
    id
    canChoosePrimaryContact
  }
}
    `) as unknown as TypedDocumentString<
  ChooseOrderPrimaryContactMutation,
  ChooseOrderPrimaryContactMutationVariables
>;
export const ProductPropertyKeysWithValuesDocument = new TypedDocumentString(`
    query ProductPropertyKeysWithValues($category: PlatformProductCategory!) {
  productPropertyKeysWithValues(category: $category) {
    key
    displayName
    isArray
    values {
      value
      displayValue
    }
  }
}
    `) as unknown as TypedDocumentString<
  ProductPropertyKeysWithValuesQuery,
  ProductPropertyKeysWithValuesQueryVariables
>;
export const PropertyValuesDocument = new TypedDocumentString(`
    query PropertyValues($category: PlatformProductCategory!, $key: String!) {
  productPropertyValues(category: $category, key: $key) {
    value
    displayValue
  }
}
    `) as unknown as TypedDocumentString<
  PropertyValuesQuery,
  PropertyValuesQueryVariables
>;
export const AllUniqueProductsDocument = new TypedDocumentString(`
    query AllUniqueProducts($page: Int!, $size: Int!, $filters: UniqueProductFiltersInput) {
  findAvailableUniqueProductsWithSellers(
    pageInput: {page: $page, size: $size}
    filters: $filters
  ) {
    paging {
      totalElements
      totalPages
      number
      size
    }
    content {
      id
      lengths {
        actualLengthInches
        nominalLengthInches
        displayValue
        id
      }
      marketAvailability {
        listingsCount
        leadTimeMin
        leadTimeMax
        priceMin {
          amount
          currency
        }
        priceMax {
          amount
          currency
        }
        sellersCount
        totalStock {
          value
          unit
        }
      }
      landedPriceRange {
        min {
          amount
          currency
        }
        max {
          amount
          currency
        }
      }
      platformProduct {
        id
        name
        category
        finishCode
        standardUnitsCode
        nominalWidthInches
        actualWidthInches
        nominalThicknessInches
        actualThicknessInches
        actualLengthInches
        piecesPerBundle {
          value
          unit
        }
        platformProductVehicleCapacities {
          id
          transportVehicle {
            id
            name
            vehicleType
          }
          capacity {
            value
            unit
          }
          isOrganizationOverride
        }
        properties
      }
    }
  }
}
    `) as unknown as TypedDocumentString<
  AllUniqueProductsQuery,
  AllUniqueProductsQueryVariables
>;
export const UpdateCartDocument = new TypedDocumentString(`
    mutation updateCart($quantity: QuantityInput, $locationId: ID!, $sellerOrganizationFacilityId: ID!, $piecesPerBundle: Int, $suggestedPrice: Float, $platformProductInputFilter: PlatformProductInputFilter!, $parentOrderId: ID) {
  updateCart(
    quantity: $quantity
    locationId: $locationId
    sellerOrganizationFacilityId: $sellerOrganizationFacilityId
    piecesPerBundle: $piecesPerBundle
    suggestedPrice: $suggestedPrice
    platformProductInputFilter: $platformProductInputFilter
    parentOrderId: $parentOrderId
  ) {
    id
    items {
      quantity(mode: {mode: USER_PREFERRED}) {
        value
        unit
      }
      effectivePiecesPerBundle
      suggestedPrice {
        amount
        currency
      }
    }
  }
}
    `) as unknown as TypedDocumentString<
  UpdateCartMutation,
  UpdateCartMutationVariables
>;
export const SetRandomTallyInCartDocument = new TypedDocumentString(`
    mutation SetRandomTallyInCart($sellerOrganizationFacilityId: ID!, $locationId: ID!, $platformProductId: ID!, $bundles: [RandomTallyBundleInput!]!, $parentOrderId: ID) {
  setRandomTallyInCart(
    sellerOrganizationFacilityId: $sellerOrganizationFacilityId
    locationId: $locationId
    platformProductId: $platformProductId
    bundles: $bundles
    parentOrderId: $parentOrderId
  ) {
    id
  }
}
    `) as unknown as TypedDocumentString<
  SetRandomTallyInCartMutation,
  SetRandomTallyInCartMutationVariables
>;
export const SetCartItemBuyCodeDocument = new TypedDocumentString(`
    mutation setCartItemBuyCode($cartId: ID!, $platformProductLengthId: ID!, $buyCode: String) {
  setCartItemBuyCode(
    cartId: $cartId
    platformProductLengthId: $platformProductLengthId
    buyCode: $buyCode
  ) {
    id
    items {
      buyCode
    }
  }
}
    `) as unknown as TypedDocumentString<
  SetCartItemBuyCodeMutation,
  SetCartItemBuyCodeMutationVariables
>;
export const RemoveCannedTallyItemsDocument = new TypedDocumentString(`
    mutation RemoveCannedTallyItems($cartId: ID!, $tallyPlatformProductId: ID!) {
  removeCannedTallyItems(
    cartId: $cartId
    tallyPlatformProductId: $tallyPlatformProductId
  ) {
    id
  }
}
    `) as unknown as TypedDocumentString<
  RemoveCannedTallyItemsMutation,
  RemoveCannedTallyItemsMutationVariables
>;
export const RemoveCartItemDocument = new TypedDocumentString(`
    mutation RemoveCartItem($cartId: ID!, $platformProductLengthId: ID!) {
  removeCartItem(
    cartId: $cartId
    platformProductLengthId: $platformProductLengthId
  ) {
    id
  }
}
    `) as unknown as TypedDocumentString<
  RemoveCartItemMutation,
  RemoveCartItemMutationVariables
>;
export const RemoveRandomTallyDocument = new TypedDocumentString(`
    mutation RemoveRandomTally($cartId: ID!, $tallyPlatformProductId: ID!) {
  removeRandomTally(
    cartId: $cartId
    tallyPlatformProductId: $tallyPlatformProductId
  ) {
    id
  }
}
    `) as unknown as TypedDocumentString<
  RemoveRandomTallyMutation,
  RemoveRandomTallyMutationVariables
>;
export const UpdateCartTransportDocument = new TypedDocumentString(`
    mutation UpdateCartTransport($cartId: ID!, $incoTerm: LogisticsIncoterm!, $transportVehicleId: ID, $internationalShipping: InternationalShippingInput) {
  updateCartTransport(
    cartId: $cartId
    incoTerm: $incoTerm
    transportVehicleId: $transportVehicleId
    internationalShipping: $internationalShipping
  ) {
    id
    transportVehicle {
      id
      name
    }
    deliveryMethod
    incotermLoading
    incotermDischarge
    incotermAddressDestination
    portOfLoading {
      id
      code
      name
    }
    portOfDischarge {
      id
      code
      name
    }
    shippingRoute {
      id
      status
      forwarder
      transitDays
    }
  }
}
    `) as unknown as TypedDocumentString<
  UpdateCartTransportMutation,
  UpdateCartTransportMutationVariables
>;
export const UpdateCartTarpDocument = new TypedDocumentString(`
    mutation UpdateCartTarp($cartId: ID!, $tarp: Boolean!) {
  updateCartTarp(cartId: $cartId, tarp: $tarp) {
    id
    tarp
  }
}
    `) as unknown as TypedDocumentString<
  UpdateCartTarpMutation,
  UpdateCartTarpMutationVariables
>;
export const UpdateCartDeliveryAddressDocument = new TypedDocumentString(`
    mutation UpdateCartDeliveryAddress($cartId: ID!, $deliveryAddress: DeliveryAddressInput) {
  updateCartDeliveryAddress(cartId: $cartId, deliveryAddress: $deliveryAddress) {
    id
    deliveryAddress {
      addressLine1
      addressLine2
      city
      region
      zipCode
      country
      latitude
      longitude
    }
    incotermAddressDestination
  }
}
    `) as unknown as TypedDocumentString<
  UpdateCartDeliveryAddressMutation,
  UpdateCartDeliveryAddressMutationVariables
>;
export const GetCartsWithFilterDocument = new TypedDocumentString(`
    query GetCartsWithFilter($locationId: ID, $withContacts: Boolean!) {
  carts(filter: {locationId: $locationId}) {
    id
    sellerContacts @include(if: $withContacts) {
      id
      firstName
      lastName
      phoneNumber
      externalId
    }
    isFromQuote
    parentOrder {
      id
    }
    deliveryAddress {
      addressLine1
      addressLine2
      city
      region
      zipCode
      country
      latitude
      longitude
    }
    sellingOrganization {
      id
      name
      sellingOrganizationCode
    }
    items {
      platformProductsLengths {
        id
        isNominal
        latestPriceMid {
          amount
          currency
        }
        platformProduct {
          id
          name
          code
          category
          nominalThicknessInches
          nominalWidthInches
          actualThicknessInches
          actualWidthInches
          actualLengthInches
          standardUnitsCode
          piecesPerBundle {
            value
            unit
          }
          properties
        }
        platformProductVehicleCapacities {
          transportVehicle {
            id
            vehicleType
          }
          capacity {
            value
            unit
          }
          isOrganizationOverride
        }
        lengthDisplayValue
        length {
          id
          actualLengthInches
          nominalLengthInches
        }
      }
      price {
        amount
        currency
      }
      suggestedPrice {
        amount
        currency
      }
      effectivePrice {
        amount
        currency
      }
      quantityStored: quantity(mode: {mode: STORED}) {
        value
      }
      pricePerPiece {
        amount
        currency
      }
      suggestedPricePerPiece {
        amount
        currency
      }
      pickupPricePerPiece {
        amount
        currency
      }
      deliveryPricePerPiece {
        amount
        currency
      }
      quantity {
        value
        unit
      }
      effectivePiecesPerBundle
      tallyPlatformProduct {
        id
      }
      cannedTally {
        id
        name
      }
      buyCode
    }
    incoTerm
    deliveryMethod
    isInternational
    tarp
    currency
    incotermLoading
    incotermDischarge
    incotermAddressDestination
    portOfLoading {
      id
      code
      name
      city
      country
      type
    }
    portOfDischarge {
      id
      code
      name
      city
      country
      type
    }
    shippingRoute {
      id
      status
      forwarder
      hasForwarderContact
      transitDays
      freeDays
      freightCost {
        amount
        currency
      }
      incotermLoading
      incotermDischarge
    }
    transportVehicle {
      id
      name
      vehicleType
    }
    sellerOrganizationFacility {
      id
      transportVehicles {
        id
        name
        vehicleType
      }
      code
      nearestPort {
        id
        code
        name
        city
        country
        type
      }
      address {
        addressLine1
        addressLine2
        city
        country
        region
      }
    }
    shippingLocation {
      id
      name
      facility {
        transportVehicles {
          id
          name
          vehicleType
        }
        nearestPort {
          id
          code
          name
          city
          country
          type
        }
        address {
          addressLine1
          addressLine2
          city
          region
          zipCode
          country
          latitude
          longitude
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<
  GetCartsWithFilterQuery,
  GetCartsWithFilterQueryVariables
>;
export const GetCartDocument = new TypedDocumentString(`
    query GetCart($cartId: ID!) {
  cart(id: $cartId) {
    id
    recipients {
      id
    }
    lockedRecipientIds
    primaryContact {
      ...PrimaryContact
    }
    purchaseOrderDatesRequired
    deliveryAddress {
      addressLine1
      addressLine2
      city
      region
      zipCode
      country
      latitude
      longitude
    }
    sellingOrganization {
      id
      name
      sellingOrganizationCode
    }
    items {
      effectivePiecesPerBundle
      price {
        amount
        currency
      }
      suggestedPrice {
        amount
        currency
      }
      effectivePrice {
        amount
        currency
      }
      pickupPrice {
        amount
        currency
      }
      deliveryPrice {
        amount
        currency
      }
      quantityStored: quantity(mode: {mode: STORED}) {
        value
      }
      pricePerPiece {
        amount
        currency
      }
      suggestedPricePerPiece {
        amount
        currency
      }
      pickupPricePerPiece {
        amount
        currency
      }
      deliveryPricePerPiece {
        amount
        currency
      }
      quantity {
        value
        unit
      }
      platformProductsLengths {
        id
        isNominal
        platformProduct {
          id
          name
          category
          nominalThicknessInches
          nominalWidthInches
          actualThicknessInches
          actualWidthInches
          actualLengthInches
          standardUnitsCode
          properties
          piecesPerBundle {
            value
            unit
          }
        }
        platformProductVehicleCapacities {
          transportVehicle {
            id
            vehicleType
          }
          capacity {
            value
            unit
          }
        }
        lengthDisplayValue
        length {
          id
          actualLengthInches
          nominalLengthInches
        }
      }
      tallyPlatformProduct {
        id
      }
      cannedTally {
        id
        name
      }
      buyCode
    }
    incoTerm
    deliveryMethod
    isInternational
    tarp
    currency
    incotermLoading
    incotermDischarge
    incotermAddressDestination
    portOfLoading {
      id
      code
      name
      city
      country
      type
    }
    portOfDischarge {
      id
      code
      name
      city
      country
      type
    }
    shippingRoute {
      id
      status
      forwarder
      hasForwarderContact
      transitDays
      freeDays
      freightCost {
        amount
        currency
      }
      incotermLoading
      incotermDischarge
    }
    transportVehicle {
      id
      vehicleType
    }
    shippingLocation {
      id
      name
      facility {
        address {
          addressLine1
          city
          region
          zipCode
          latitude
          longitude
        }
      }
    }
  }
}
    fragment PrimaryContact on User {
  id
  firstName
  lastName
}`) as unknown as TypedDocumentString<GetCartQuery, GetCartQueryVariables>;
export const ProductCategoriesDocument = new TypedDocumentString(`
    query ProductCategories {
  platformProductCategories {
    value
    label
  }
}
    `) as unknown as TypedDocumentString<
  ProductCategoriesQuery,
  ProductCategoriesQueryVariables
>;
export const ProductFilterOptionsDocument = new TypedDocumentString(`
    query ProductFilterOptions($category: PlatformProductCategory!) {
  platformProductDimensions {
    nominalThicknessInches
    nominalWidthInches
  }
  productPropertyKeys(category: $category) {
    key
    displayName
    isArray
  }
}
    `) as unknown as TypedDocumentString<
  ProductFilterOptionsQuery,
  ProductFilterOptionsQueryVariables
>;
export const BuyerInventoryLocationsDocument = new TypedDocumentString(`
    query BuyerInventoryLocations {
  allUniqueProductInventoryLocationsForBuyer {
    id
    name
    facility {
      address {
        addressLine1
        addressLine2
        city
        region
        zipCode
        country
      }
    }
  }
}
    `) as unknown as TypedDocumentString<
  BuyerInventoryLocationsQuery,
  BuyerInventoryLocationsQueryVariables
>;
export const CatalogLengthsDocument = new TypedDocumentString(`
    query CatalogLengths($platformProductId: ID!, $search: String, $pageInput: PageInput!) {
  lengths: catalogLengths(
    platformProductId: $platformProductId
    search: $search
    pageInput: $pageInput
  ) {
    content {
      length {
        id
        displayValue
        actualLengthInches
      }
      platformProductLength {
        id
        isNominal
        length {
          nominalLengthInches
          actualLengthInches
        }
        platformProduct {
          nominalWidthInches
          actualWidthInches
          nominalThicknessInches
          actualThicknessInches
          actualLengthInches
          piecesPerBundle {
            value
            unit
          }
        }
      }
    }
    paging {
      number
      size
      totalElements
      totalPages
    }
  }
}
    `) as unknown as TypedDocumentString<
  CatalogLengthsQuery,
  CatalogLengthsQueryVariables
>;
export const RequestForQuotesDocument = new TypedDocumentString(`
    query RequestForQuotes {
  requestForQuotes {
    id
    status
    createdAt
    tallyPlatformProduct {
      id
      name
    }
    items {
      id
      platformProductsLength {
        platformProduct {
          id
          name
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<
  RequestForQuotesQuery,
  RequestForQuotesQueryVariables
>;
export const DraftRequestForQuoteDocument = new TypedDocumentString(`
    query DraftRequestForQuote($tallyPlatformProductId: ID!, $shippingLocationId: ID!) {
  draftRequestForQuote(
    tallyPlatformProductId: $tallyPlatformProductId
    shippingLocationId: $shippingLocationId
  ) {
    id
    leadTimeDays
    useTallyPrice
    pickupPriceForTally {
      amount
      currency
    }
    deliveryPriceForTally {
      amount
      currency
    }
    items {
      id
      quantityInPieces
      pickupPrice {
        amount
        currency
      }
      deliveryPrice {
        amount
        currency
      }
      platformProductsLength {
        id
        length {
          id
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<
  DraftRequestForQuoteQuery,
  DraftRequestForQuoteQueryVariables
>;
export const GetRequestForQuoteWithQuotesDocument = new TypedDocumentString(`
    query GetRequestForQuoteWithQuotes($id: ID!) {
  requestForQuote(id: $id) {
    id
    status
    createdAt
    createdByUserName
    buyList {
      id
    }
    leadTimeDays
    useTallyPrice
    cannedTally {
      id
      name
    }
    cannedTallyCount
    currency
    tallyPlatformProduct {
      id
      name
      standardUnitsCode
      piecesPerBundle {
        value
        unit
      }
    }
    shippingLocation {
      id
      name
      code
      facility {
        id
        address {
          addressLine1
          addressLine2
          city
          region
          zipCode
          country
        }
      }
    }
    pickupPriceForTally {
      amount
      currency
    }
    deliveryPriceForTally {
      amount
      currency
    }
    items {
      id
      quantityInPieces
      piecesPerBundle
      pickupPrice {
        amount
        currency
      }
      deliveryPrice {
        amount
        currency
      }
      platformProductsLength {
        id
        lengthDisplayValue
        isNominal
        length {
          id
          displayValue
          actualLengthInches
          nominalLengthInches
        }
        platformProduct {
          id
          name
          code
          standardUnitsCode
          nominalWidthInches
          actualWidthInches
          nominalThicknessInches
          actualThicknessInches
          actualLengthInches
          piecesPerBundle {
            value
            unit
          }
        }
      }
    }
  }
  quotesForRequestForQuote(requestForQuoteId: $id) {
    id
    status
    negotiationAwaitingParty
    primaryContact {
      id
      ...PrimaryContact
    }
    recipients {
      id
      firstName
      lastName
      phoneNumber
      externalId
    }
    lockedRecipientIds
    rounds {
      ...QuoteTimelineRound
      ...QuoteOfferRound
    }
    currency
    leadTimeDays
    submittedAt
    requestForQuote {
      id
      status
    }
    sellingOrganization {
      id
      name
      sellingOrganizationCode
      facilities {
        id
        code
        address {
          addressLine1
          addressLine2
          city
          region
        }
        locations {
          id
          code
        }
      }
    }
    sellingOrganizationFacility {
      id
      code
      address {
        addressLine1
        addressLine2
        city
        region
      }
    }
    offeredPickupPriceForTally {
      amount
      currency
    }
    offeredDeliveryPriceForTally {
      amount
      currency
    }
    items {
      id
      quantityInPieces
      piecesPerBundle
      status
      offeredPickupPrice {
        amount
        currency
      }
      offeredDeliveryPrice {
        amount
        currency
      }
      order {
        id
      }
      platformProductsLength {
        id
        lengthDisplayValue
        isNominal
        length {
          id
          displayValue
          actualLengthInches
          nominalLengthInches
        }
        platformProduct {
          id
          name
          code
          standardUnitsCode
          nominalWidthInches
          actualWidthInches
          nominalThicknessInches
          actualThicknessInches
          actualLengthInches
          piecesPerBundle {
            value
            unit
          }
        }
      }
    }
  }
}
    fragment QuoteTimelineRound on QuoteRound {
  roundNumber
  party
  authorName
  declined
  declineReason
  createdAt
  pickupPriceForTally {
    amount
    currency
  }
  deliveryPriceForTally {
    amount
    currency
  }
  items {
    pickupPrice {
      amount
      currency
    }
    deliveryPrice {
      amount
      currency
    }
    platformProductsLength {
      lengthDisplayValue
    }
  }
}
fragment QuoteOfferRound on QuoteRound {
  roundNumber
  party
  pickupPriceForTally {
    amount
    currency
  }
  deliveryPriceForTally {
    amount
    currency
  }
  items {
    quantityInPieces
    pickupPrice {
      amount
      currency
    }
    deliveryPrice {
      amount
      currency
    }
    platformProductsLength {
      id
    }
    piecesPerBundle
  }
}
fragment PrimaryContact on User {
  id
  firstName
  lastName
}`) as unknown as TypedDocumentString<
  GetRequestForQuoteWithQuotesQuery,
  GetRequestForQuoteWithQuotesQueryVariables
>;
export const GetRequestForQuoteFullyPricedDocument = new TypedDocumentString(`
    query GetRequestForQuoteFullyPriced($id: ID!) {
  requestForQuote(id: $id) {
    id
    fullyPriced
  }
}
    `) as unknown as TypedDocumentString<
  GetRequestForQuoteFullyPricedQuery,
  GetRequestForQuoteFullyPricedQueryVariables
>;
export const GetQuoteByIdDocument = new TypedDocumentString(`
    query GetQuoteById($id: ID!) {
  quote(id: $id) {
    id
    status
    negotiationAwaitingParty
    rounds {
      ...QuoteTimelineRound
    }
    currency
    leadTimeDays
    sellingOrganization {
      id
      name
      facilities {
        id
        code
        address {
          addressLine1
          addressLine2
          city
          region
        }
        locations {
          id
          code
        }
      }
    }
    sellingOrganizationFacility {
      id
      code
      address {
        addressLine1
        addressLine2
        city
        region
      }
    }
    offeredPickupPriceForTally {
      amount
      currency
    }
    offeredDeliveryPriceForTally {
      amount
      currency
    }
    items {
      id
      quantityInPieces
      piecesPerBundle
      status
      order {
        id
      }
      offeredPickupPrice {
        amount
        currency
      }
      offeredDeliveryPrice {
        amount
        currency
      }
      platformProductsLength {
        id
        lengthDisplayValue
        isNominal
        length {
          id
          displayValue
          actualLengthInches
          nominalLengthInches
        }
        platformProduct {
          id
          name
          standardUnitsCode
          nominalWidthInches
          actualWidthInches
          nominalThicknessInches
          actualThicknessInches
          actualLengthInches
          piecesPerBundle {
            value
            unit
          }
        }
      }
    }
    requestForQuote {
      id
      status
      createdAt
      leadTimeDays
      useTallyPrice
      cannedTally {
        id
        name
      }
      cannedTallyCount
      currency
      buyingOrganization {
        id
        name
      }
      createdByUserName
      createdByUser {
        id
        firstName
        lastName
        phoneNumber
        externalId
      }
      transportVehicle {
        id
        name
      }
      tallyPlatformProduct {
        id
        name
        standardUnitsCode
        piecesPerBundle {
          value
          unit
        }
      }
      shippingLocation {
        id
        name
        code
        facility {
          id
          address {
            addressLine1
            addressLine2
            city
            region
            zipCode
            country
          }
        }
      }
      pickupPriceForTally {
        amount
        currency
      }
      deliveryPriceForTally {
        amount
        currency
      }
      items {
        id
        quantityInPieces
        piecesPerBundle
        pickupPrice {
          amount
          currency
        }
        deliveryPrice {
          amount
          currency
        }
        platformProductsLength {
          id
          lengthDisplayValue
          isNominal
          length {
            id
            displayValue
            actualLengthInches
            nominalLengthInches
          }
          platformProduct {
            id
            name
            standardUnitsCode
            nominalWidthInches
            actualWidthInches
            nominalThicknessInches
            actualThicknessInches
            actualLengthInches
            piecesPerBundle {
              value
              unit
            }
          }
        }
      }
    }
  }
}
    fragment QuoteTimelineRound on QuoteRound {
  roundNumber
  party
  authorName
  declined
  declineReason
  createdAt
  pickupPriceForTally {
    amount
    currency
  }
  deliveryPriceForTally {
    amount
    currency
  }
  items {
    pickupPrice {
      amount
      currency
    }
    deliveryPrice {
      amount
      currency
    }
    platformProductsLength {
      lengthDisplayValue
    }
  }
}`) as unknown as TypedDocumentString<
  GetQuoteByIdQuery,
  GetQuoteByIdQueryVariables
>;
export const MyQuotesDocument = new TypedDocumentString(`
    query MyQuotes($page: Int!, $size: Int!, $needsResponse: Boolean, $sort: [SortInput!]) {
  myQuotes(
    pageInput: {page: $page, size: $size}
    needsResponse: $needsResponse
    sort: $sort
  ) {
    paging {
      totalElements
      totalPages
      number
      size
    }
    content {
      id
      status
      needsSellerResponse
      createdAt
      leadTimeDays
      offeredPickupPriceForTally {
        amount
        currency
      }
      offeredDeliveryPriceForTally {
        amount
        currency
      }
      requestForQuote {
        id
        status
        tallyPlatformProduct {
          id
          name
        }
        items {
          id
          platformProductsLength {
            platformProduct {
              id
              name
            }
          }
        }
        buyingOrganization {
          id
          name
        }
      }
      items {
        id
      }
    }
  }
}
    `) as unknown as TypedDocumentString<MyQuotesQuery, MyQuotesQueryVariables>;
export const MyRequestForQuotesDocument = new TypedDocumentString(`
    query MyRequestForQuotes($page: Int!, $size: Int!, $needsResponse: Boolean, $archived: RequestForQuoteArchivedFilter, $filters: RequestForQuoteFiltersInput) {
  myRequestForQuotes(
    pageInput: {page: $page, size: $size}
    needsResponse: $needsResponse
    archived: $archived
    filters: $filters
  ) {
    paging {
      totalElements
      totalPages
      number
      size
    }
    content {
      id
      status
      createdAt
      createdByUserName
      tallyPlatformProduct {
        id
        name
      }
      items {
        id
        platformProductsLength {
          platformProduct {
            id
            name
          }
        }
      }
      quotes {
        id
        sellingOrganization {
          id
          name
          sellingOrganizationCode
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<
  MyRequestForQuotesQuery,
  MyRequestForQuotesQueryVariables
>;
export const MyRequestForQuoteFilterOptionsDocument = new TypedDocumentString(`
    query MyRequestForQuoteFilterOptions {
  myRequestForQuoteFilterOptions {
    products {
      id
      name
      code
    }
    sellers {
      id
      name
      sellingOrganizationCode
    }
    creators {
      id
      name
    }
    hasArchivedRequests
    hasSentRequests
  }
}
    `) as unknown as TypedDocumentString<
  MyRequestForQuoteFilterOptionsQuery,
  MyRequestForQuoteFilterOptionsQueryVariables
>;
export const UpsertRequestForQuoteDocument = new TypedDocumentString(`
    mutation upsertRequestForQuote($tallyPlatformProductId: ID, $leadTimeDays: Int, $shippingLocationId: ID, $pickupPriceForTally: MoneyInput, $deliveryPriceForTally: MoneyInput, $useTallyPrice: Boolean) {
  upsertRequestForQuote(
    tallyPlatformProductId: $tallyPlatformProductId
    leadTimeDays: $leadTimeDays
    shippingLocationId: $shippingLocationId
    pickupPriceForTally: $pickupPriceForTally
    deliveryPriceForTally: $deliveryPriceForTally
    useTallyPrice: $useTallyPrice
  ) {
    id
    leadTimeDays
    useTallyPrice
    shippingLocation {
      id
    }
  }
}
    `) as unknown as TypedDocumentString<
  UpsertRequestForQuoteMutation,
  UpsertRequestForQuoteMutationVariables
>;
export const AddRequestForQuoteItemsDocument = new TypedDocumentString(`
    mutation addRequestForQuoteItems($requestForQuoteId: ID!, $items: [RequestForQuoteItemInput!]!, $replace: Boolean) {
  addRequestForQuoteItems(
    requestForQuoteId: $requestForQuoteId
    items: $items
    replace: $replace
  ) {
    id
  }
}
    `) as unknown as TypedDocumentString<
  AddRequestForQuoteItemsMutation,
  AddRequestForQuoteItemsMutationVariables
>;
export const SubmitRequestForQuoteDocument = new TypedDocumentString(`
    mutation submitRequestForQuote($id: ID!, $sellerInvitations: [SellerInvitationInput!]!) {
  submitRequestForQuote(id: $id, sellerInvitations: $sellerInvitations) {
    id
    status
  }
}
    `) as unknown as TypedDocumentString<
  SubmitRequestForQuoteMutation,
  SubmitRequestForQuoteMutationVariables
>;
export const CreateRequestForQuoteFromBuyListDocument =
  new TypedDocumentString(`
    mutation createRequestForQuoteFromBuyList($buyListId: ID!, $items: [BuyListItemSelectionInput!]!, $tallies: [BuyListTallySelectionInput!]! = [], $sellerInvitations: [SellerInvitationInput!]!) {
  createRequestForQuoteFromBuyList(
    buyListId: $buyListId
    items: $items
    tallies: $tallies
    sellerInvitations: $sellerInvitations
  ) {
    id
    status
  }
}
    `) as unknown as TypedDocumentString<
    CreateRequestForQuoteFromBuyListMutation,
    CreateRequestForQuoteFromBuyListMutationVariables
  >;
export const CreateRequestForQuoteDocument = new TypedDocumentString(`
    mutation createRequestForQuote($shippingLocationId: ID!, $currency: Currency!, $leadTimeDays: Int, $items: [CreateRequestForQuoteItemInput!]!, $sellerInvitations: [SellerInvitationInput!]!) {
  createRequestForQuote(
    shippingLocationId: $shippingLocationId
    currency: $currency
    leadTimeDays: $leadTimeDays
    items: $items
    sellerInvitations: $sellerInvitations
  ) {
    id
  }
}
    `) as unknown as TypedDocumentString<
  CreateRequestForQuoteMutation,
  CreateRequestForQuoteMutationVariables
>;
export const AcceptQuoteDocument = new TypedDocumentString(`
    mutation acceptQuote($id: ID!) {
  acceptQuote(id: $id) {
    id
    status
    order {
      id
    }
  }
}
    `) as unknown as TypedDocumentString<
  AcceptQuoteMutation,
  AcceptQuoteMutationVariables
>;
export const AcceptQuoteItemsDocument = new TypedDocumentString(`
    mutation acceptQuoteItems($quoteItemIds: [ID!]!) {
  acceptQuoteItems(quoteItemIds: $quoteItemIds) {
    id
  }
}
    `) as unknown as TypedDocumentString<
  AcceptQuoteItemsMutation,
  AcceptQuoteItemsMutationVariables
>;
export const SubmitQuoteItemEditsDocument = new TypedDocumentString(`
    mutation submitQuoteItemEdits($quoteId: ID!, $input: SubmitQuoteItemEditsInput!) {
  submitQuoteItemEdits(quoteId: $quoteId, input: $input) {
    id
    status
    items {
      id
      status
      quantityInPieces
      piecesPerBundle
      offeredPickupPrice {
        amount
        currency
      }
      offeredDeliveryPrice {
        amount
        currency
      }
      platformProductsLength {
        id
        lengthDisplayValue
        length {
          id
          displayValue
          actualLengthInches
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<
  SubmitQuoteItemEditsMutation,
  SubmitQuoteItemEditsMutationVariables
>;
export const CounterQuoteDocument = new TypedDocumentString(`
    mutation counterQuote($quoteId: ID!, $input: SubmitQuoteItemEditsInput!) {
  counterQuote(quoteId: $quoteId, input: $input) {
    id
    status
  }
}
    `) as unknown as TypedDocumentString<
  CounterQuoteMutation,
  CounterQuoteMutationVariables
>;
export const AcceptCounterQuoteDocument = new TypedDocumentString(`
    mutation acceptCounterQuote($quoteId: ID!) {
  acceptCounterQuote(quoteId: $quoteId) {
    id
    status
  }
}
    `) as unknown as TypedDocumentString<
  AcceptCounterQuoteMutation,
  AcceptCounterQuoteMutationVariables
>;
export const DeclineQuoteDocument = new TypedDocumentString(`
    mutation declineQuote($quoteId: ID!, $reason: String) {
  declineQuote(quoteId: $quoteId, reason: $reason) {
    id
    status
  }
}
    `) as unknown as TypedDocumentString<
  DeclineQuoteMutation,
  DeclineQuoteMutationVariables
>;
export const ArchiveQuoteDocument = new TypedDocumentString(`
    mutation archiveQuote($quoteId: ID!) {
  archiveQuote(quoteId: $quoteId) {
    id
    status
  }
}
    `) as unknown as TypedDocumentString<
  ArchiveQuoteMutation,
  ArchiveQuoteMutationVariables
>;
export const ArchiveRequestForQuoteDocument = new TypedDocumentString(`
    mutation archiveRequestForQuote($id: ID!) {
  archiveRequestForQuote(id: $id) {
    id
    status
  }
}
    `) as unknown as TypedDocumentString<
  ArchiveRequestForQuoteMutation,
  ArchiveRequestForQuoteMutationVariables
>;
export const FulfillRequestForQuoteDocument = new TypedDocumentString(`
    mutation fulfillRequestForQuote($id: ID!) {
  fulfillRequestForQuote(id: $id) {
    id
    status
  }
}
    `) as unknown as TypedDocumentString<
  FulfillRequestForQuoteMutation,
  FulfillRequestForQuoteMutationVariables
>;
export const QuoteCommentsDocument = new TypedDocumentString(`
    query QuoteComments($quoteId: ID!) {
  quoteComments(quoteId: $quoteId) {
    id
    body
    authorName
    createdAt
    authorOrganization {
      id
      name
      sellingOrganizationCode
    }
  }
}
    `) as unknown as TypedDocumentString<
  QuoteCommentsQuery,
  QuoteCommentsQueryVariables
>;
export const PostQuoteCommentDocument = new TypedDocumentString(`
    mutation postQuoteComment($quoteId: ID!, $body: String!) {
  postQuoteComment(quoteId: $quoteId, body: $body) {
    id
  }
}
    `) as unknown as TypedDocumentString<
  PostQuoteCommentMutation,
  PostQuoteCommentMutationVariables
>;
export const ChooseQuoteContactsDocument = new TypedDocumentString(`
    mutation ChooseQuoteContacts($quoteId: ID!, $primaryContactUserId: ID!, $recipientUserIds: [ID!]!) {
  chooseQuoteContacts(
    quoteId: $quoteId
    primaryContactUserId: $primaryContactUserId
    recipientUserIds: $recipientUserIds
  ) {
    id
  }
}
    `) as unknown as TypedDocumentString<
  ChooseQuoteContactsMutation,
  ChooseQuoteContactsMutationVariables
>;
export const MySellerListsDocument = new TypedDocumentString(`
    query MySellerLists {
  mySellerLists {
    id
    name
    members {
      seller {
        id
        name
        sellingOrganizationCode
      }
      contacts {
        id
        firstName
        lastName
      }
    }
  }
}
    `) as unknown as TypedDocumentString<
  MySellerListsQuery,
  MySellerListsQueryVariables
>;
export const SaveSellerListDocument = new TypedDocumentString(`
    mutation SaveSellerList($id: ID, $name: String!, $members: [SellerListMemberInput!]!) {
  saveSellerList(id: $id, name: $name, members: $members) {
    id
  }
}
    `) as unknown as TypedDocumentString<
  SaveSellerListMutation,
  SaveSellerListMutationVariables
>;
export const DeleteSellerListDocument = new TypedDocumentString(`
    mutation DeleteSellerList($id: ID!) {
  deleteSellerList(id: $id)
}
    `) as unknown as TypedDocumentString<
  DeleteSellerListMutation,
  DeleteSellerListMutationVariables
>;
export const StartUfpInventoryRunDocument = new TypedDocumentString(`
    mutation StartUfpInventoryRun($input: StartUfpInventoryRunInput!) {
  startUfpInventoryRun(input: $input) {
    id
  }
}
    `) as unknown as TypedDocumentString<
  StartUfpInventoryRunMutation,
  StartUfpInventoryRunMutationVariables
>;
export const UfpInventoryRunDocument = new TypedDocumentString(`
    query UfpInventoryRun($id: ID!) {
  ufpInventoryRun(id: $id) {
    id
    status
    branchCodes
    weeksToLookBack
    apiVersion
    queuedAt
    startedAt
    finishedAt
    ufpHttpStatus
    failureDetail
  }
}
    `) as unknown as TypedDocumentString<
  UfpInventoryRunQuery,
  UfpInventoryRunQueryVariables
>;
export const UfpInventoryRunResultDocument = new TypedDocumentString(`
    query UfpInventoryRunResult($id: ID!) {
  ufpInventoryRunResult(id: $id) {
    locations {
      branchCode
      locationCode
      asOfTimestampUtc
      matchedLocations {
        id
        name
        organizationName
      }
      items {
        productCode
        description
        length
        outcome
        productName
        lengthName
        availablePcs
        inboundPcs
        onOrderPcs
        requestedPcs
        avgWeeklyUsagePcs
      }
    }
  }
}
    `) as unknown as TypedDocumentString<
  UfpInventoryRunResultQuery,
  UfpInventoryRunResultQueryVariables
>;
export const UfpInventoryRunRawResponseUrlDocument = new TypedDocumentString(`
    query UfpInventoryRunRawResponseUrl($id: ID!) {
  ufpInventoryRunRawResponseUrl(id: $id)
}
    `) as unknown as TypedDocumentString<
  UfpInventoryRunRawResponseUrlQuery,
  UfpInventoryRunRawResponseUrlQueryVariables
>;
export const GetAllUnitsDocument = new TypedDocumentString(`
    query GetAllUnits {
  units {
    code
    category
    name
  }
}
    `) as unknown as TypedDocumentString<
  GetAllUnitsQuery,
  GetAllUnitsQueryVariables
>;
export const TenantUsersDocument = new TypedDocumentString(`
    query tenantUsers {
  users {
    id
    externalId
    firstName
    lastName
    employeeId
    phoneNumber
    role
    status
    lastEditedAt
    lastEditedBy {
      id
      firstName
      lastName
    }
  }
}
    `) as unknown as TypedDocumentString<
  TenantUsersQuery,
  TenantUsersQueryVariables
>;
export const OrganizationBuyersDocument = new TypedDocumentString(`
    query organizationBuyers {
  users: buyListTeamCandidates {
    id
    firstName
    lastName
    status
  }
}
    `) as unknown as TypedDocumentString<
  OrganizationBuyersQuery,
  OrganizationBuyersQueryVariables
>;
export const CreateTenantUserDocument = new TypedDocumentString(`
    mutation createTenantUser($input: CreateTenantUserInput!) {
  createTenantUser(input: $input) {
    id
  }
}
    `) as unknown as TypedDocumentString<
  CreateTenantUserMutation,
  CreateTenantUserMutationVariables
>;
export const UpdateTenantUserDocument = new TypedDocumentString(`
    mutation updateTenantUser($userId: ID!, $input: UpdateTenantUserInput!) {
  updateTenantUser(userId: $userId, input: $input) {
    id
  }
}
    `) as unknown as TypedDocumentString<
  UpdateTenantUserMutation,
  UpdateTenantUserMutationVariables
>;
export const SetTenantUserRoleDocument = new TypedDocumentString(`
    mutation setTenantUserRole($userId: ID!, $role: UserRole!) {
  setTenantUserRole(userId: $userId, role: $role) {
    id
  }
}
    `) as unknown as TypedDocumentString<
  SetTenantUserRoleMutation,
  SetTenantUserRoleMutationVariables
>;
export const ChangeTenantUserTradeRoleDocument = new TypedDocumentString(`
    mutation changeTenantUserTradeRole($userId: ID!, $role: UserRole!) {
  changeTenantUserTradeRole(userId: $userId, role: $role) {
    id
    role
  }
}
    `) as unknown as TypedDocumentString<
  ChangeTenantUserTradeRoleMutation,
  ChangeTenantUserTradeRoleMutationVariables
>;
export const DeactivateTenantUserDocument = new TypedDocumentString(`
    mutation deactivateTenantUser($userId: ID!) {
  deactivateTenantUser(userId: $userId) {
    id
  }
}
    `) as unknown as TypedDocumentString<
  DeactivateTenantUserMutation,
  DeactivateTenantUserMutationVariables
>;
export const ReactivateTenantUserDocument = new TypedDocumentString(`
    mutation reactivateTenantUser($userId: ID!) {
  reactivateTenantUser(userId: $userId) {
    id
  }
}
    `) as unknown as TypedDocumentString<
  ReactivateTenantUserMutation,
  ReactivateTenantUserMutationVariables
>;
export const ResendTenantUserInviteDocument = new TypedDocumentString(`
    mutation resendTenantUserInvite($userId: ID!) {
  resendTenantUserInvite(userId: $userId) {
    id
  }
}
    `) as unknown as TypedDocumentString<
  ResendTenantUserInviteMutation,
  ResendTenantUserInviteMutationVariables
>;
export const MsrBuyerCodeCandidatesDocument = new TypedDocumentString(`
    query MsrBuyerCodeCandidates($organizationId: ID!) {
  organization(id: $organizationId) {
    id
    users {
      id
      firstName
      lastName
      employeeId
      status
    }
  }
}
    `) as unknown as TypedDocumentString<
  MsrBuyerCodeCandidatesQuery,
  MsrBuyerCodeCandidatesQueryVariables
>;
export const UpsertProductVehicleCapacityDocument = new TypedDocumentString(`
    mutation UpsertProductVehicleCapacity($platformProductLengthId: ID!, $transportVehicleId: ID!, $capacity: QuantityInput!) {
  upsertProductVehicleCapacity(
    platformProductLengthId: $platformProductLengthId
    transportVehicleId: $transportVehicleId
    capacity: $capacity
  ) {
    id
  }
}
    `) as unknown as TypedDocumentString<
  UpsertProductVehicleCapacityMutation,
  UpsertProductVehicleCapacityMutationVariables
>;
export const SellerImportColumnMappingsDocument = new TypedDocumentString(`
    query SellerImportColumnMappings {
  sellerImportColumnMappings {
    headerSignature
    mapping
  }
}
    `) as unknown as TypedDocumentString<
  SellerImportColumnMappingsQuery,
  SellerImportColumnMappingsQueryVariables
>;
export const RememberSellerImportColumnMappingDocument =
  new TypedDocumentString(`
    mutation RememberSellerImportColumnMapping($headerSignature: String!, $mapping: JSON!) {
  rememberSellerImportColumnMapping(
    headerSignature: $headerSignature
    mapping: $mapping
  ) {
    headerSignature
  }
}
    `) as unknown as TypedDocumentString<
    RememberSellerImportColumnMappingMutation,
    RememberSellerImportColumnMappingMutationVariables
  >;
export const ProposeSellerImportMappingDocument = new TypedDocumentString(`
    mutation ProposeSellerImportMapping($columns: [ImportMappingColumnInput!]!, $fields: [ImportMappingFieldInput!]!) {
  proposeSellerImportMapping(columns: $columns, fields: $fields)
}
    `) as unknown as TypedDocumentString<
  ProposeSellerImportMappingMutation,
  ProposeSellerImportMappingMutationVariables
>;
export const ImportSellerInventoryDocument = new TypedDocumentString(`
    mutation ImportSellerInventory($rows: [SellerImportRowInput!]!) {
  importSellerInventory(rows: $rows) {
    total
    imported
    failed {
      rowId
      messages
    }
  }
}
    `) as unknown as TypedDocumentString<
  ImportSellerInventoryMutation,
  ImportSellerInventoryMutationVariables
>;
export const InventoryImportLocationsDocument = new TypedDocumentString(`
    query InventoryImportLocations {
  locations {
    id
    code
    name
    facility {
      address {
        addressLine1
        city
        region
      }
    }
  }
}
    `) as unknown as TypedDocumentString<
  InventoryImportLocationsQuery,
  InventoryImportLocationsQueryVariables
>;
export const InventoryImportPlatformCatalogDocument = new TypedDocumentString(`
    query InventoryImportPlatformCatalog {
  platformProducts {
    id
    name
    category
    standardUnitsCode
    finishCode
    nominalThicknessInches
    nominalWidthInches
    actualThicknessInches
    actualWidthInches
    properties
    unitsPerTruckload
    lengths {
      id
      actualLengthInches
      nominalLengthInches
      displayValue
    }
  }
}
    `) as unknown as TypedDocumentString<
  InventoryImportPlatformCatalogQuery,
  InventoryImportPlatformCatalogQueryVariables
>;
